var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeco2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 52.2 112.3",
    style: {
      enableBackground: "new 0 0 52.2 112.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F4C1CE;}\n\t.st1{fill:#F1B1C0;}\n\t.st2{fill:#F2BDCB;}\n\t.st3{fill:#4D4946;}\n\t.st4{fill:#4C4845;}\n\t.st5{fill:#F2BCCA;}\n\t.st6{fill:#F5C9D4;}\n\t.st7{fill:#EFA6B7;}\n\t.st8{fill:#F5C6D2;}\n\t.st9{fill:#F1B0C0;}\n\t.st10{fill:#F1B5BE;}\n\t.st11{fill:#EFA8B9;}\n\t.st12{fill:#524E4B;}\n\t.st13{fill:#F1AEBF;}\n\t.st14{fill:#F1AEBE;}\n\t.st15{fill:#F1B6C6;}\n\t.st16{fill:#F4C4D0;}\n\t.st17{fill:#F1B2C2;}\n\t.st18{fill:#F2B7C2;}\n\t.st19{fill:#F6D2D6;}\n\t.st20{fill:#EFA4B6;}\n\t.st21{fill:#F4CBCE;}\n\t.st22{fill:#E7859B;}\n\t.st23{fill:#55524F;}\n\t.st24{fill:#F1B1C1;}\n\t.st25{fill:#F2B9C7;}\n\t.st26{fill:#F2B7C6;}\n\t.st27{fill:#EBB0BE;}\n\t.st28{fill:#F6CAD4;}\n\t.st29{fill:#55514E;}\n\t.st30{fill:#F1B9C2;}\n\t.st31{fill:#F2B9C8;}\n\t.st32{fill:#F2BBC9;}\n\t.st33{fill:#F2BFCB;}\n\t.st34{fill:#F2B7C5;}\n\t.st35{fill:#F6CDD6;}\n\t.st36{fill:#F4C3CF;}\n\t.st37{fill:#F1B4C3;}\n\t.st38{fill:#F3BFCC;}\n\t.st39{fill:#F2BFCC;}\n\t.st40{fill:#EEB4C2;}\n\t.st41{fill:#54504E;}\n\t.st42{fill:#F5C7D3;}\n\t.st43{fill:#F6CFD9;}\n\t.st44{fill:#F4C5D1;}\n\t.st45{fill:#F5C8D3;}\n\t.st46{fill:#F6CBD6;}\n\t.st47{fill:#F2BCC9;}\n\t.st48{fill:#F4C6D1;}\n\t.st49{fill:#EB9FA5;}\n\t.st50{fill:#F1B5C4;}\n\t.st51{fill:#F2B8C6;}\n\t.st52{fill:#F1BCC3;}\n\t.st53{fill:#EFA7B9;}\n\t.st54{fill:#F2B6C4;}\n\t.st55{fill:#F3C2CA;}\n\t.st56{fill:#E8889D;}\n\t.st57{fill:#F7DBE1;}\n\t.st58{fill:#F0ACBC;}\n\t.st59{fill:#EEABBB;}\n\t.st60{fill:#EE9FB3;}\n\t.st61{fill:#F4C2CF;}\n\t.st62{fill:#EFA3B5;}\n\t.st63{fill:#F0ACBD;}\n\t.st64{fill:#F1AFBF;}\n\t.st65{fill:#EEA7B9;}\n\t.st66{fill:#F4CBD5;}\n\t.st67{fill:#F0B3C2;}\n\t.st68{fill:#4F4A47;}\n\t.st69{fill:#585451;}\n\t.st70{fill:#EEA1B4;}\n\t.st71{fill:#514D4A;}\n\t.st72{fill:#F8D2DB;}\n\t.st73{fill:#F0B0C1;}\n\t.st74{fill:#F3C8CC;}\n\t.st75{fill:#F4CCD6;}\n\t.st76{fill:#F8D4DD;}\n\t.st77{fill:#EA8BA0;}\n\t.st78{fill:#F7D5DC;}\n\t.st79{fill:#F0AABB;}\n\t.st80{fill:#686462;}\n\t.st81{fill:#F5CDD2;}\n\t.st82{fill:#5A5855;}\n\t.st83{fill:#4E4A47;}\n\t.st84{fill:#6B6865;}\n\t.st85{fill:#EB96A8;}\n\t.st86{fill:#F3C4C7;}\n\t.st87{fill:#F1BAC7;}\n\t.st88{fill:#EEA3B4;}\n\t.st89{fill:#F6D0DA;}\n\t.st90{fill:#F6CFD8;}\n\t.st91{fill:#6E6B68;}\n\t.st92{fill:#EE9CB0;}\n\t.st93{fill:#EEA0B3;}\n\t.st94{fill:#F4CCD7;}\n\t.st95{fill:#ED9AAF;}\n\t.st96{fill:#F8D3DC;}\n\t.st97{fill:#EEB2C1;}\n\t.st98{fill:#F2C0CC;}\n\t.st99{fill:#F6D2DB;}\n\t.st100{fill:#EFB6C4;}\n\t.st101{fill:#F1ADBF;}\n\t.st102{fill:#F6CED8;}\n\t.st103{fill:#595552;}\n\t.st104{fill:#554D4B;}\n\t.st105{fill:#F2BBC8;}\n\t.st106{fill:#F5D2D9;}\n\t.st107{fill:#6F5C5D;}\n\t.st108{fill:#5D5A57;}\n\t.st109{fill:#F1B3C2;}\n\t.st110{fill:#EFBBC9;}\n\t.st111{fill:#EA8EA3;}\n\t.st112{fill:#F0ADBD;}\n\t.st113{fill:#F1AFC0;}\n\t.st114{fill:#5B5754;}\n\t.st115{fill:#494643;}\n\t.st116{fill:#F1B6BD;}\n\t.st117{fill:#F7D6DE;}\n\t.st118{fill:#F9E6EB;}\n\t.st119{fill:#EE9BAF;}\n\t.st120{fill:#E9899F;}\n\t.st121{fill:#F3C7CB;}\n\t.st122{fill:#EEACB4;}\n\t.st123{fill:#F3C4CA;}\n\t.st124{fill:#E9A8B7;}\n\t.st125{fill:#5E5957;}\n\t.st126{fill:#EFA9B6;}\n\t.st127{fill:#F6CCD6;}\n\t.st128{fill:#F1AFBE;}\n\t.st129{fill:#F4C1CD;}\n\t.st130{fill:#EFAABA;}\n\t.st131{fill:#EB90A4;}\n\t.st132{fill:#635F5C;}\n\t.st133{fill:#F5C7D2;}\n\t.st134{fill:#FAE9EB;}\n\t.st135{fill:#EEA9BA;}\n\t.st136{fill:#685858;}\n\t.st137{fill:#F0B4C3;}\n\t.st138{fill:#F1BAC8;}\n\t.st139{fill:#F2C0CE;}\n\t.st140{fill:#EEA6B8;}\n\t.st141{fill:#EE9EB2;}\n\t.st142{fill:#F9E3E7;}\n\t.st143{fill:#F1B6BE;}\n\t.st144{fill:#5C5654;}\n\t.st145{fill:#756364;}\n\t.st146{fill:#605C5A;}\n\t.st147{fill:#6A6765;}\n\t.st148{fill:#F0BCBE;}\n\t.st149{fill:#F1B4C2;}\n\t.st150{fill:#575350;}\n\t.st151{fill:#EC98AB;}\n\t.st152{fill:#F5D2D3;}\n\t.st153{fill:#F5CAD5;}\n\t.st154{fill:#F0B8C1;}\n\t.st155{fill:#EFABBB;}\n\t.st156{fill:#F0B4BA;}\n\t.st157{fill:#F6D0D9;}\n\t.st158{fill:#F9E5E9;}\n\t.st159{fill:#C3C1C1;}\n\t.st160{fill:#F5CED3;}\n\t.st161{fill:#705F60;}\n\t.st162{fill:#817E7C;}\n\t.st163{fill:#4B4744;}\n\t.st164{fill:#34302E;}\n\t.st165{fill:#F9E4E8;}\n\t.st166{fill:#F6D1DB;}\n\t.st167{fill:#6B5B5C;}\n\t.st168{fill:#F5C8D4;}\n\t.st169{fill:#5D5956;}\n\t.st170{fill:#676361;}\n\t.st171{fill:#F7D5DE;}\n\t.st172{fill:#F3BFC8;}\n\t.st173{fill:#6E6B69;}\n\t.st174{fill:#F1B5C3;}\n\t.st175{fill:#F0ADBE;}\n\t.st176{fill:#625E5B;}\n\t.st177{fill:#F7D9E0;}\n\t.st178{fill:#EB90A5;}\n\t.st179{fill:#F1B2C3;}\n\t.st180{fill:#F3BFCA;}\n\t.st181{fill:#F7D7DF;}\n\t.st182{fill:#F8D2DC;}\n\t.st183{fill:#686563;}\n\t.st184{fill:#6C6966;}\n\t.st185{fill:#7B7977;}\n\t.st186{fill:#6A6764;}\n\t.st187{fill:#F5CBD3;}\n\t.st188{fill:#83807F;}\n\t.st189{fill:#625E5C;}\n\t.st190{fill:#F6F6F6;}\n\t.st191{fill:#E5E5E4;}\n\t.st192{fill:#B7B5B4;}\n\t.st193{fill:#9A9797;}\n\t.st194{fill:#EAEAE8;}\n\t.st195{fill:#4F4C49;}\n\t.st196{fill:#5F5B58;}\n\t.st197{fill:#62605D;}\n\t.st198{fill:#817F7D;}\n\t.st199{fill:#F0ABBC;}\n\t.st200{fill:#DFDEDC;}\n\t.st201{fill:#E7B4C0;}\n\t.st202{fill:#ACAAA9;}\n\t.st203{fill:#7E7B79;}\n\t.st204{fill:#F1B2BE;}\n\t.st205{fill:#F1B8BF;}\n\t.st206{fill:#746666;}\n\t.st207{fill:#4F4A48;}\n\t.st208{fill:#54514E;}\n\t.st209{fill:#8E8C8A;}\n\t.st210{fill:#726F6D;}\n\t.st211{fill:#595653;}\n\t.st212{fill:#B7B4B3;}\n\t.st213{fill:#534F4C;}\n\t.st214{fill:#23201E;}\n\t.st215{fill:#66625F;}\n\t.st216{fill:#6E6967;}\n\t.st217{fill:#898684;}\n\t.st218{fill:#9A9997;}\n\t.st219{fill:#5C5855;}\n\t.st220{fill:#E6C8CF;}\n\t.st221{fill:#CAC9C7;}\n\t.st222{fill:#979694;}\n\t.st223{fill:#858382;}\n\t.st224{fill:#EB95A9;}\n\t.st225{fill:#484543;}\n\t.st226{fill:#615D5A;}\n\t.st227{fill:#4F4B48;}\n\t.st228{fill:#7B7875;}\n\t.st229{fill:#959391;}\n\t.st230{fill:#CDCCCB;}\n\t.st231{fill:#353230;}\n\t.st232{fill:#272422;}\n\t.st233{fill:#252220;}\n\t.st234{fill:#E8869D;}\n\t.st235{fill:#F8D1DA;}\n\t.st236{fill:#EFA3B7;}\n\t.st237{fill:#EEA8B9;}\n\t.st238{fill:#292624;}\n\t.st239{fill:#2E2B28;}\n\t.st240{fill:#5A5552;}\n\t.st241{fill:#EB9AAC;}\n\t.st242{fill:#EB97A9;}\n\t.st243{fill:#EA8DA1;}\n\t.st244{fill:#F9E0E7;}\n\t.st245{fill:#E9879C;}\n\t.st246{fill:#F9E0E5;}\n\t.st247{fill:#EA8BA1;}\n\t.st248{fill:#EC9DAF;}\n\t.st249{fill:#EEA2B4;}\n\t.st250{fill:#E8899E;}\n\t.st251{fill:#F9DDE4;}\n\t.st252{fill:#EFA1B5;}\n\t.st253{fill:#EFABB7;}\n\t.st254{fill:#F4CACC;}\n\t.st255{fill:#F2BCC2;}\n\t.st256{fill:#EC91A7;}\n\t.st257{fill:#DE627C;}\n\t.st258{fill:#E37990;}\n\t.st259{fill:#EB92A6;}\n\t.st260{fill:#E67E95;}\n\t.st261{fill:#E26E88;}\n\t.st262{fill:#E68097;}\n\t.st263{fill:#E57C94;}\n\t.st264{fill:#E78A9A;}\n\t.st265{fill:#7E5F60;}\n\t.st266{fill:#F7DBE0;}\n\t.st267{fill:#E07D8A;}\n\t.st268{fill:#BE818B;}\n\t.st269{fill:#E8889E;}\n\t.st270{fill:#FBE3E9;}\n\t.st271{fill:#EC99AC;}\n\t.st272{fill:#E06E83;}\n\t.st273{fill:#EFB0B8;}\n\t.st274{fill:#EB97AA;}\n\t.st275{fill:#F0B4BB;}\n\t.st276{fill:#F9E1E3;}\n\t.st277{fill:#F3C4C8;}\n\t.st278{fill:#F4C4CF;}\n\t.st279{fill:#FFFFFF;}\n\t.st280{fill:#EDACB5;}\n\t.st281{fill:#F7DBE2;}\n\t.st282{fill:#EFB1B5;}\n\t.st283{fill:#F1B8BB;}\n\t.st284{fill:#EA9DA1;}\n\t.st285{fill:#F8DFE0;}\n\t.st286{fill:#EFB5BA;}\n\t.st287{fill:#F0B3B9;}\n\t.st288{fill:#DB5B74;}\n\t.st289{fill:#EFA9BA;}\n\t.st290{fill:#7A7774;}\n\t.st291{fill:#65615F;}\n\t.st292{fill:#716D6C;}\n\t.st293{fill:#75726F;}\n\t.st294{fill:#E37E95;}\n\t.st295{fill:#F1ACBD;}\n\t.st296{fill:#E8869C;}\n\t.st297{fill:#ED97AC;}\n\t.st298{fill:#EB9BAD;}\n\t.st299{fill:#E3778E;}\n\t.st300{fill:#EFA8BA;}\n\t.st301{fill:#E88A9F;}\n\t.st302{fill:#E78198;}\n\t.st303{fill:#F9DFE5;}\n\t.st304{fill:#1E1B19;}\n\t.st305{fill:#E89EA1;}\n\t.st306{fill:#DD7B80;}\n\t.st307{fill:#F4CAD0;}\n\t.st308{fill:#F7D6DF;}\n\t.st309{fill:#EA8EA2;}\n\t.st310{fill:#E4768E;}\n\t.st311{fill:#E57A92;}\n\t.st312{fill:#E67D94;}\n\t.st313{fill:#F7DAE1;}\n\t.st314{fill:#ED99AD;}\n\t.st315{fill:#E57C92;}\n\t.st316{fill:#EE9DB1;}\n\t.st317{fill:#E3718A;}\n\t.st318{fill:#FCF2F4;}\n\t.st319{fill:#EA91A5;}\n\t.st320{fill:#EDA0B2;}\n\t.st321{fill:#E8899F;}\n\t.st322{fill:#F5C6D1;}\n\t.st323{fill:#F7CAD5;}\n\t.st324{fill:#E37E94;}\n\t.st325{fill:#EFAEBD;}\n\t.st326{fill:#E7849A;}\n\t.st327{fill:#F6D1D9;}\n\t.st328{fill:#FCF6F8;}\n\t.st329{fill:#F7D8DF;}\n\t.st330{fill:#EDACBB;}\n\t.st331{fill:#8F6E74;}\n\t.st332{fill:#EEA0B2;}\n\t.st333{fill:#F4C3D0;}\n\t.st334{fill:#E7869B;}\n\t.st335{fill:#E3778F;}\n\t.st336{fill:#ED9EB0;}\n\t.st337{fill:#F4C5D2;}\n\t.st338{fill:#E8939C;}\n\t.st339{fill:#4E4745;}\n\t.st340{fill:#E8859B;}\n\t.st341{fill:#EB96A6;}\n\t.st342{fill:#F0B4B9;}\n\t.st343{fill:#F3C7C9;}\n\t.st344{fill:#F4CACE;}\n\t.st345{fill:#F1B1BF;}\n\t.st346{fill:#EC9FB1;}\n\t.st347{fill:#E78B97;}\n\t.st348{fill:#EFAABD;}\n\t.st349{fill:#F0B3C3;}\n\t.st350{fill:#F5C5D1;}\n\t.st351{fill:#F5C4D0;}\n\t.st352{fill:#F4CFD2;}\n\t.st353{fill:#F0B3BF;}\n\t.st354{fill:#E7869C;}\n\t.st355{fill:#EC9AAC;}\n\t.st356{fill:#E57C93;}\n\t.st357{fill:#E37089;}\n\t.st358{fill:#DF657E;}\n\t.st359{fill:#ED95AB;}\n\t.st360{fill:#EEA2B6;}\n\t.st361{fill:#E68193;}\n\t.st362{fill:#F3C5D0;}\n\t.st363{fill:#EEA6B7;}\n\t.st364{fill:#E57991;}\n\t.st365{fill:#EA8FA2;}\n\t.st366{fill:#F1BAC6;}\n\t.st367{fill:#F2C7D2;}\n\t.st368{fill:#F4CAD5;}\n\t.st369{fill:#1E1C1A;}\n\t.st370{fill:#96777C;}\n\t.st371{fill:#5F5353;}\n\t.st372{fill:#514947;}\n\t.st373{fill:#E5A6B6;}\n\t.st374{fill:#D58899;}\n\t.st375{fill:#EFAABB;}\n\t.st376{fill:#E2748B;}\n\t.st377{fill:#777471;}\n\t.st378{fill:#F1BCCA;}\n\t.st379{fill:#F0B8BA;}\n\t.st380{fill:#F1BEC2;}\n\t.st381{fill:#E78197;}\n\t.st382{fill:#E3768D;}\n\t.st383{fill:#E98A9F;}\n\t.st384{fill:#E68399;}\n\t.st385{fill:#6F6061;}\n\t.st386{fill:#F2BCC6;}\n\t.st387{fill:#F1B5C0;}\n\t.st388{fill:#EC9CAE;}\n\t.st389{fill:#F0AFBE;}\n\t.st390{fill:#494542;}\n\t.st391{fill:#4A4643;}\n\t.st392{fill:#F7DCE1;}\n\t.st393{fill:#4B4643;}\n\t.st394{fill:#F7F8F8;}\n\t.st395{fill:#7B7876;}\n\t.st396{fill:#5A5754;}\n\t.st397{fill:#73706D;}\n\t.st398{fill:#7C7978;}\n\t.st399{fill:#F7CBD6;}\n\t.st400{fill:#EC93A7;}\n\t.st401{fill:#F9E1E7;}\n\t.st402{fill:#797674;}\n\t.st403{fill:#F9DEE4;}\n\t.st404{fill:#EFA8B7;}\n\t.st405{fill:#77595D;}\n\t.st406{fill:#E88BA0;}\n\t.st407{fill:#BE7988;}\n\t.st408{fill:#E7839A;}\n\t.st409{fill:#EEA3B5;}\n\t.st410{fill:#D67C90;}\n\t.st411{fill:#DF627C;}\n\t.st412{fill:#F3C2CE;}\n\t.st413{fill:#EBA2B3;}\n\t.st414{fill:#5C5250;}\n\t.st415{fill:#E06780;}\n\t.st416{fill:#5F4E4F;}\n\t.st417{fill:#1A1816;}\n\t.st418{fill:#E26E87;}\n\t.st419{fill:#DE6780;}\n\t.st420{fill:#C98B99;}\n\t.st421{fill:#8A6E73;}\n\t.st422{fill:#EEA1B5;}\n\t.st423{fill:#EEADAF;}\n\t.st424{fill:#EEA9AD;}\n\t.st425{fill:#E9949D;}\n\t.st426{fill:#F7D8E0;}\n\t.st427{fill:#EDA7B7;}\n\t.st428{fill:#CBCAC9;}\n\t.st429{fill:#EC9AAD;}\n\t.st430{fill:#EA94A8;}\n\t.st431{fill:#F3BECB;}\n\t.st432{fill:#767370;}\n\t.st433{fill:#E4758D;}\n\t.st434{fill:#E06A83;}\n\t.st435{fill:#EB95A8;}\n\t.st436{fill:#E27088;}\n\t.st437{fill:#A55F6C;}\n\t.st438{fill:#6E595B;}\n\t.st439{fill:#574A48;}\n\t.st440{fill:#F0AFBF;}\n\t.st441{fill:#E78499;}\n\t.st442{fill:#DF647E;}\n\t.st443{fill:#F2B8C7;}\n\t.st444{fill:#E2748C;}\n\t.st445{fill:#EA8FA3;}\n\t.st446{fill:#E68298;}\n\t.st447{fill:#E58197;}\n\t.st448{fill:#E0667F;}\n\t.st449{fill:#E0657F;}\n\t.st450{fill:#ED9FB1;}\n\t.st451{fill:#DC5E78;}\n\t.st452{fill:#DD768C;}\n\t.st453{fill:#EBAAB9;}\n\t.st454{fill:#E47D8C;}\n\t.st455{fill:#CD8A94;}\n\t.st456{fill:#E57890;}\n\t.st457{fill:#DA5C75;}\n\t.st458{fill:#DA556E;}\n\t.st459{fill:#DF637E;}\n\t.st460{fill:#E3758D;}\n\t.st461{fill:#DF637D;}\n\t.st462{fill:#EC9BAD;}\n\t.st463{fill:#E16D85;}\n\t.st464{fill:#EEA7B8;}\n\t.st465{fill:#725454;}\n\t.st466{fill:#E48397;}\n\t.st467{fill:#645150;}\n\t.st468{fill:#DF627D;}\n\t.st469{fill:#EB94A5;}\n\t.st470{fill:#EEAEB6;}\n\t.st471{fill:#735D5F;}\n\t.st472{fill:#E79497;}\n\t.st473{fill:#E5898C;}\n\t.st474{fill:#E5898D;}\n\t.st475{fill:#E88A9D;}\n\t.st476{fill:#F1BEC0;}\n\t.st477{fill:#E58E95;}\n\t.st478{fill:#EB9AAA;}\n\t.st479{fill:#E16B84;}\n\t.st480{fill:#DA5971;}\n\t.st481{fill:#E37A91;}\n\t.st482{fill:#E16C84;}\n\t.st483{fill:#F6D3DC;}\n\t.st484{fill:#F2D1D9;}\n\t.st485{fill:#E98AA0;}\n\t.st486{fill:#DA6F86;}\n\t.st487{fill:#EC9EB0;}\n\t.st488{fill:#9D8388;}\n\t.st489{fill:#E57A91;}\n\t.st490{fill:#BD959D;}\n\t.st491{fill:#E78A9F;}\n\t.st492{fill:#EEB7C4;}\n\t.st493{fill:#CE8493;}\n\t.st494{fill:#EA95A9;}\n\t.st495{fill:#FBE2E7;}\n\t.st496{fill:#EB94A8;}\n\t.st497{fill:#DE6D75;}\n\t.st498{fill:#EDA7AD;}\n\t.st499{fill:#604D4E;}\n\t.st500{fill:#665556;}\n\t.st501{fill:#5D4D4D;}\n\t.st502{fill:#886268;}\n\t.st503{fill:#D64B65;}\n\t.st504{fill:#655050;}\n\t.st505{fill:#E78298;}\n\t.st506{fill:#FCEBEE;}\n\t.st507{fill:#E9899E;}\n\t.st508{fill:#E36F88;}\n\t.st509{fill:#DC5C76;}\n\t.st510{fill:#E78399;}\n\t.st511{fill:#F0AEBE;}\n\t.st512{fill:#DD5E78;}\n\t.st513{fill:#EFA7BA;}\n\t.st514{fill:#DB556F;}\n\t.st515{fill:#97636C;}\n\t.st516{fill:#8F5F67;}\n\t.st517{fill:#85565E;}\n\t.st518{fill:#D07B8C;}\n\t.st519{fill:#7E6467;}\n\t.st520{fill:#524947;}\n\t.st521{fill:#E16882;}\n\t.st522{fill:#E0748B;}\n\t.st523{fill:#8A5A62;}\n\t.st524{fill:#C5808D;}\n\t.st525{fill:#876067;}\n\t.st526{fill:#855E65;}\n\t.st527{fill:#E57F94;}\n\t.st528{fill:#5F4C4C;}\n\t.st529{fill:#D17D84;}\n\t.st530{fill:#F0B1BB;}\n\t.st531{fill:#F4D1D3;}\n\t.st532{fill:#EC9CAF;}\n\t.st533{fill:#E3788E;}\n\t.st534{fill:#EC9DA5;}\n\t.st535{fill:#EA8FA4;}\n\t.st536{fill:#E26E85;}\n\t.st537{fill:#E67E94;}\n\t.st538{fill:#D8566D;}\n\t.st539{fill:#D2435C;}\n\t.st540{fill:#E26882;}\n\t.st541{fill:#DC7D91;}\n\t.st542{fill:#DE6079;}\n\t.st543{fill:#DB5771;}\n\t.st544{fill:#E68197;}\n\t.st545{fill:#E06881;}\n\t.st546{fill:#EB90A3;}\n\t.st547{fill:#E594A3;}\n\t.st548{fill:#E07E90;}\n\t.st549{fill:#D8546C;}\n\t.st550{fill:#E3738B;}\n\t.st551{fill:#E79BAC;}\n\t.st552{fill:#766D6C;}\n\t.st553{fill:#B8B6B6;}\n\t.st554{fill:#9E777E;}\n\t.st555{fill:#837C7B;}\n\t.st556{fill:#726968;}\n\t.st557{fill:#E78299;}\n\t.st558{fill:#E2788F;}\n\t.st559{fill:#F7DDE4;}\n\t.st560{fill:#E57D93;}\n\t.st561{fill:#E898AA;}\n\t.st562{fill:#E16F87;}\n\t.st563{fill:#B46B79;}\n\t.st564{fill:#A58D91;}\n\t.st565{fill:#936B72;}\n\t.st566{fill:#E89CAD;}\n\t.st567{fill:#E47C91;}\n\t.st568{fill:#E48D8D;}\n\t.st569{fill:#F1C1C1;}\n\t.st570{fill:#EEABB2;}\n\t.st571{fill:#F6D6D7;}\n\t.st572{fill:#E0727E;}\n\t.st573{fill:#EFB6B9;}\n\t.st574{fill:#E2758D;}\n\t.st575{fill:#E16E86;}\n\t.st576{fill:#DF627B;}\n\t.st577{fill:#E7879C;}\n\t.st578{fill:#E797A9;}\n\t.st579{fill:#D38495;}\n\t.st580{fill:#D1A5B1;}\n\t.st581{fill:#E37890;}\n\t.st582{fill:#DA536D;}\n\t.st583{fill:#9E6872;}\n\t.st584{fill:#554B49;}\n\t.st585{fill:#9C888B;}\n\t.st586{fill:#726565;}\n\t.st587{fill:#F7D9E1;}\n\t.st588{fill:#EEA6B5;}\n\t.st589{fill:#E7849B;}\n\t.st590{fill:#E6879D;}\n\t.st591{fill:#E06982;}\n\t.st592{fill:#765B5E;}\n\t.st593{fill:#C98C99;}\n\t.st594{fill:#E47E95;}\n\t.st595{fill:#E08499;}\n\t.st596{fill:#EB8EA4;}\n\t.st597{fill:#EEA5B6;}\n\t.st598{fill:#EB98AB;}\n\t.st599{fill:#DA617B;}\n\t.st600{fill:#F0B0BF;}\n\t.st601{fill:#E17C7E;}\n\t.st602{fill:#E68D93;}\n\t.st603{fill:#E78990;}\n\t.st604{fill:#F0B1C0;}\n\t.st605{fill:#F9DCE4;}\n\t.st606{fill:#E37B92;}\n\t.st607{fill:#E16A82;}\n\t.st608{fill:#DE627B;}\n\t.st609{fill:#705054;}\n\t.st610{fill:#DB5770;}\n\t.st611{fill:#D54761;}\n\t.st612{fill:#E38499;}\n\t.st613{fill:#D34962;}\n\t.st614{fill:#EB92A7;}\n\t.st615{fill:#704A4F;}\n\t.st616{fill:#D5526A;}\n\t.st617{fill:#DA627B;}\n\t.st618{fill:#E16B83;}\n\t.st619{fill:#A25564;}\n\t.st620{fill:#E1748B;}\n\t.st621{fill:#D55770;}\n\t.st622{fill:#E8A1B1;}\n\t.st623{fill:#DE7C91;}\n\t.st624{fill:#8E505B;}\n\t.st625{fill:#954854;}\n\t.st626{fill:#E4748B;}\n\t.st627{fill:#72565A;}\n\t.st628{fill:#A96F7A;}\n\t.st629{fill:#574A49;}\n\t.st630{fill:#B29399;}\n\t.st631{fill:#E57F95;}\n\t.st632{fill:#7A5F63;}\n\t.st633{fill:#EA95A8;}\n\t.st634{fill:#DC5D77;}\n\t.st635{fill:#EEA2B3;}\n\t.st636{fill:#E37A92;}\n\t.st637{fill:#DC5C74;}\n\t.st638{fill:#D65169;}\n\t.st639{fill:#C6344C;}\n\t.st640{fill:#514644;}\n\t.st641{fill:#5F4546;}\n\t.st642{fill:#DC5D76;}\n\t.st643{fill:#E68299;}\n\t.st644{fill:#E57D94;}\n\t.st645{fill:#E26F86;}\n\t.st646{fill:#EC98A7;}\n\t.st647{fill:#DC7D90;}\n\t.st648{fill:#90646A;}\n\t.st649{fill:#DC6E6D;}\n\t.st650{fill:#E8919A;}\n\t.st651{fill:#E57E94;}\n\t.st652{fill:#6B5657;}\n\t.st653{fill:#CD7487;}\n\t.st654{fill:#D2435D;}\n\t.st655{fill:#D77187;}\n\t.st656{fill:#735458;}\n\t.st657{fill:#624E4E;}\n\t.st658{fill:#DC5C75;}\n\t.st659{fill:#5B4A4A;}\n\t.st660{fill:#86535B;}\n\t.st661{fill:#784D53;}\n\t.st662{fill:#EA8FA5;}\n\t.st663{fill:#EEAAB8;}\n\t.st664{fill:#DEC3C9;}\n\t.st665{fill:#C6AAAE;}\n\t.st666{fill:#5F4D4E;}\n\t.st667{fill:#EFBECA;}\n\t.st668{fill:#997D81;}\n\t.st669{fill:#DD798F;}\n\t.st670{fill:#4A4543;}\n\t.st671{fill:#DC5E77;}\n\t.st672{fill:#DD617A;}\n\t.st673{fill:#DB5872;}\n\t.st674{fill:#E894A6;}\n\t.st675{fill:#E06680;}\n\t.st676{fill:#EC9DB0;}\n\t.st677{fill:#BD586D;}\n\t.st678{fill:#E3758C;}\n\t.st679{fill:#EA94A7;}\n\t.st680{fill:#EAA0A3;}\n\t.st681{fill:#EA91A1;}\n\t.st682{fill:#F1BBC5;}\n\t.st683{fill:#F5CBD2;}\n\t.st684{fill:#E16A83;}\n\t.st685{fill:#EC9BAE;}\n\t.st686{fill:#DD5F79;}\n\t.st687{fill:#EE9EB1;}\n\t.st688{fill:#C47687;}\n\t.st689{fill:#F0ACBB;}\n\t.st690{fill:#E3758A;}\n\t.st691{fill:#EFB6B7;}\n\t.st692{fill:#6E5453;}\n\t.st693{fill:#BB7077;}\n\t.st694{fill:#8D6669;}\n\t.st695{fill:#E29898;}\n\t.st696{fill:#604F4E;}\n\t.st697{fill:#E58598;}\n\t.st698{fill:#504846;}\n\t.st699{fill:#6D5255;}\n\t.st700{fill:#D56F85;}\n\t.st701{fill:#7A595E;}\n\t.st702{fill:#E498A8;}\n\t.st703{fill:#BA6B7B;}\n\t.st704{fill:#BE8F98;}\n\t.st705{fill:#E4A0AF;}\n\t.st706{fill:#D18898;}\n\t.st707{fill:#A2747B;}\n\t.st708{fill:#7A595D;}\n\t.st709{fill:#E4869B;}\n\t.st710{fill:#F1BECB;}\n\t.st711{fill:#524C49;}\n\t.st712{fill:#E27189;}\n\t.st713{fill:#EFB9B7;}\n\t.st714{fill:#ED9DB0;}\n\t.st715{fill:#594C4B;}\n\t.st716{fill:#DF6D85;}\n\t.st717{fill:#D74C65;}\n\t.st718{fill:#DB5C75;}\n\t.st719{fill:#ED9FB0;}\n\t.st720{fill:#D8516A;}\n\t.st721{fill:#D25D76;}\n\t.st722{fill:#C98593;}\n\t.st723{fill:#C05B70;}\n\t.st724{fill:#D97A8E;}\n\t.st725{fill:#DF647D;}\n\t.st726{fill:#8D6E73;}\n\t.st727{fill:#B97886;}\n\t.st728{fill:#725B5C;}\n\t.st729{fill:#776466;}\n\t.st730{fill:#AA6674;}\n\t.st731{fill:#D84F6A;}\n\t.st732{fill:#E36B84;}\n\t.st733{fill:#685959;}\n\t.st734{fill:#AA707C;}\n\t.st735{fill:#ED9DAF;}\n\t.st736{fill:#564949;}\n\t.st737{fill:#E98EA3;}\n\t.st738{fill:#6B5355;}\n\t.st739{fill:#EEA9B9;}\n\t.st740{fill:#E2748A;}\n\t.st741{fill:#6A5456;}\n\t.st742{fill:#E16E85;}\n\t.st743{fill:#EDA1B2;}\n\t.st744{fill:#B07983;}\n\t.st745{fill:#7F565C;}\n\t.st746{fill:#D64C65;}\n\t.st747{fill:#E26F87;}\n\t.st748{fill:#9B5C67;}\n\t.st749{fill:#E47F94;}\n\t.st750{fill:#D993A4;}\n\t.st751{fill:#5C4B4A;}\n\t.st752{fill:#8B7F7F;}\n\t.st753{fill:#F7D7DE;}\n\t.st754{fill:#DF6E85;}\n\t.st755{fill:#825A60;}\n\t.st756{fill:#DA5D76;}\n\t.st757{fill:#E27289;}\n\t.st758{fill:#846469;}\n\t.st759{fill:#735155;}\n\t.st760{fill:#4F4846;}\n\t.st761{fill:#705255;}\n\t.st762{fill:#5B494A;}\n\t.st763{fill:#EA96A8;}\n\t.st764{fill:#705356;}\n\t.st765{fill:#604A4B;}\n\t.st766{fill:#7F4B53;}\n\t.st767{fill:#E899AA;}\n\t.st768{fill:#DB6A81;}\n\t.st769{fill:#D95A73;}\n\t.st770{fill:#D74D66;}\n\t.st771{fill:#D03E57;}\n\t.st772{fill:#E3728B;}\n\t.st773{fill:#F1B8C6;}\n\t.st774{fill:#D28090;}\n\t.st775{fill:#E68196;}\n\t.st776{fill:#DA566F;}\n\t.st777{fill:#D64963;}\n\t.st778{fill:#DC5F79;}\n\t.st779{fill:#D64E68;}\n\t.st780{fill:#EA91A4;}\n\t.st781{fill:#E5859A;}\n\t.st782{fill:#F3CCCA;}\n\t.st783{fill:#EC9CAD;}\n\t.st784{fill:#E37C8D;}\n\t.st785{fill:#614A4C;}\n\t.st786{fill:#806266;}\n\t.st787{fill:#D78395;}\n\t.st788{fill:#EDAAB9;}\n\t.st789{fill:#5B4C4D;}\n\t.st790{fill:#EBAFBE;}\n\t.st791{fill:#F1B6C4;}\n\t.st792{fill:#A5656C;}\n\t.st793{fill:#E99BAB;}\n\t.st794{fill:#6D5557;}\n\t.st795{fill:#ECA8B9;}\n\t.st796{fill:#CB677B;}\n\t.st797{fill:#DD6E85;}\n\t.st798{fill:#5B4D4D;}\n\t.st799{fill:#EBA1B1;}\n\t.st800{fill:#81676A;}\n\t.st801{fill:#E28095;}\n\t.st802{fill:#E67F95;}\n\t.st803{fill:#D95A72;}\n\t.st804{fill:#DB6980;}\n\t.st805{fill:#D14F66;}\n\t.st806{fill:#DB677E;}\n\t.st807{fill:#EBA4B5;}\n\t.st808{fill:#CC677D;}\n\t.st809{fill:#DE647E;}\n\t.st810{fill:#544A48;}\n\t.st811{fill:#F0A2B5;}\n\t.st812{fill:#E3778D;}\n\t.st813{fill:#EFB8C7;}\n\t.st814{fill:#826C6F;}\n\t.st815{fill:#D84F68;}\n\t.st816{fill:#D44862;}\n\t.st817{fill:#EB96AA;}\n\t.st818{fill:#BC6F7E;}\n\t.st819{fill:#D2667B;}\n\t.st820{fill:#DE627D;}\n\t.st821{fill:#E47C93;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8,36.4c-0.6-0.2-0.9-0.5-1.1-1.1c0.1-0.1,0.2-0.3,0-0.4c0.2-1.5,0.7-2.2,3-2.2C10,32.8,10,32.9,10,33 c0-0.1,0-0.2,0.2-0.3c0.2,0,0.4,0,0.5,0.1c0.1,0.1,0.1,0.1,0.1,0.2c0,0.2,0.1,0.5,0,0.7c0,0.1-0.2,0-0.1,0.2 c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.1,0.1,0.2,0.2c0.2,0.2,0.5,0.1,0.7,0.2c0.3,0.1,0.6,0.2,0.9,0.3 c0.1,0,0.2,0.1,0.2,0.1c0.1,0.2,0,0.4-0.2,0.5c-0.1,0-0.1,0-0.2,0c-0.3,0-0.6-0.1-0.9,0.2c-0.2,0.3-0.5,0.4-0.9,0.4 c-0.3-0.2-0.7-0.1-0.9-0.4c-0.1-0.2-0.2-0.4-0.4-0.2c-0.2,0.2-0.4,0.4-0.6,0.6c-0.2,0.2-0.4,0.1-0.7,0c-0.3-0.2-0.2-0.6-0.5-0.7 c0-0.5,0.3-0.5,0.6-0.6c0.1,0,0.3,0.2,0.4,0C9,35,9,35,9,35c-0.1,0-0.1,0-0.1,0.1c-0.1,0.1-0.2,0.1-0.3,0c-0.6-0.2-0.8,0.1-0.7,0.7 C8,35.9,8.2,36.1,8,36.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.7,50c-0.3-0.3-0.5-0.8-0.9-1.1c0.2-0.5,0-0.8-0.4-1.1c-0.2-0.6-0.8-1-0.4-1.7c0.6-1,1.6-1.2,2.5-0.5 c0.5,0.4,1,0.8,1.3,1.4c0,0.3,0.2,0.6-0.2,0.8c-0.2,0.1-0.3,0-0.4-0.2c-0.1-0.4-0.2-0.7-0.6-0.9c-0.1-0.1-0.3-0.2-0.5-0.2 c0.2,0.4,1,0.6,0.3,1.3c-0.2,0-0.3,0-0.4-0.1c0-0.5-0.6-0.4-0.8-0.7c-0.1-0.1-0.2-0.1-0.3-0.2c0,0-0.1,0,0,0.1 c0.1,0.1,0.2,0,0.3,0.1c0.2,0.2,0.4,0.4,0.6,0.5c0.2,0.4,0.6,0.4,1,0.2c0.1,0,0.2,0,0.3,0.1c0.3,0.4,0.6,0.7,0.2,1.2 c-0.2,0.1-0.4,0.3-0.6,0c-0.1-0.2-0.1-0.3-0.4-0.3c-0.3,0.1-0.3,0.4-0.3,0.7c0,0.2-0.1,0.4-0.2,0.5C15.8,49.9,15.8,49.9,15.7,50z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M24.6,6.9c-0.5,1.8-0.7,3.6-1.9,5.2c-0.4,0.2-0.8,0.3-1.1,0c-0.1-0.1-0.1-0.3,0-0.4c0.3-0.4,0.3-1,0.9-1.1 c0.1,0.1,0.2,0.2,0.1,0.4c0,0.1,0,0.1-0.1,0.1c0.1,0,0.1,0,0.1-0.1c0.2-0.3,0-0.5,0-0.8c0-0.1,0-0.1,0-0.1c-0.1,0,0,0.2-0.1,0.2 c-0.8,0-0.5-0.9-1-1.2c0,0,0-0.1-0.1-0.1c0.2-0.3,0.1-0.7,0.4-0.9c0.2-0.1,0.3-0.2,0.6-0.2c0.6,0.1,1.1,0,1.4-0.5 c0-0.1,0.1-0.2,0.2-0.3C24.1,6.8,24.3,6.7,24.6,6.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M19.2,76.3c0,0.5-0.1,0.9-0.3,1.3c-0.5,1.1-1.2,2.2-1.3,3.5c0,0.2-0.2,0.3-0.3,0.5c-0.2,0.1-0.2,0.3-0.3,0.4 c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2,0,0.2c0,0.1,0,0.1,0,0.2c-0.1,0.2-0.3,0.4-0.4,0.7c0,0.1,0,0.1,0,0.2c-0.3,0.2-0.4-0.5-0.7-0.2 c0-0.1,0-0.2,0-0.3c0-0.1,0.1-0.1,0.1-0.2c0.1-0.2,0-0.5,0.1-0.6c0-0.1,0-0.1,0-0.2c0.1-0.1,0.1-0.3,0.2-0.5c0-0.1,0-0.1,0.1-0.2 c0.2-0.3,0.2-0.6,0.4-0.9c0.4-1.6,1.2-3.1,1.9-4.5C19,75.9,19.2,75.9,19.2,76.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M10.8,98.4c-0.2,1.1-0.2,2.2-0.4,3.2c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2,0-0.3-0.1 c-0.1,0-0.3,0-0.4,0c-0.8-0.1-0.4-0.6-0.4-1c0.3-1.3,0.8-2.6,1.4-3.8c0-0.1,0.1-0.2,0.1-0.4c0-0.1,0.1-0.2,0.2-0.3 c0-0.1,0.1-0.1,0.1-0.2l0,0c0.2-0.1,0.3,0,0.4,0.1c0,0.1,0.1,0.2,0.1,0.3c0,0.2,0.1,0.5,0,0.7c0,0.1,0,0.1-0.1,0.2 c0,0.1-0.1,0.1-0.2,0.1c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0-0.1-0.1-0.1-0.1s0,0.1,0,0.1c0.1,0,0.1,0,0.2,0 c0.1,0.1,0.1,0.1,0.1,0.2c0,0.1,0,0.2-0.1,0.4c0,0.1-0.1,0.1-0.1,0.2C10.7,98.3,10.7,98.4,10.8,98.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M22.4,12.7c0.5,0,0.8-0.6,1.3-0.4c-0.4,0.3,0,0.4,0.1,0.6c0.3,0.3,0.4,0.7,0.5,1c0.1,0.1,0.1,0.2,0.1,0.2 c0,0.1,0,0.3,0,0.4c-0.2,0.4-0.3,0.8-0.6,1.1c-0.4,0.3-0.7,0.6-1.1,0.9c-0.3,0-0.4-0.4-0.7-0.3c-0.1,0-0.2,0.1-0.4,0.2 c-0.1,0-0.3,0-0.4,0c-0.1-0.1-0.2-0.2-0.3-0.3c0-0.1,0-0.2,0-0.3c0.1-0.2,0.4-0.4,0.3-0.7c0-0.2,0-0.4,0-0.7c0-0.1,0.1-0.1,0.2-0.2 c0.1,0,0.2,0,0.2,0c0.1,0.1,0.2,0.3,0.3,0.4c0.1,0.1,0.1,0.1,0.2,0.1c0.2,0,0.3-0.2,0.4-0.3c0.1-0.4,0.1-0.8-0.2-1.1 c-0.1-0.1-0.2-0.2-0.3-0.3c0-0.1-0.1-0.2,0-0.3c0-0.1,0.1-0.2,0.2-0.2C22.3,12.7,22.4,12.7,22.4,12.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33,29.9c0.1,0,0.2,0,0.2,0c0.5,0.5,0.2,1,0.1,1.5c-0.2,0.3-0.2,0.7-0.6,0.9c-0.7,0.2-1.3,0.8-2.1,0.8 c-0.3,0-0.1,0.4-0.2,0.5c-0.1,0.1-0.1,0.1-0.2,0.2c-0.3,0-0.5-0.2-0.7-0.4c-0.1-0.2-0.1-0.3,0-0.5c0-0.1,0.1-0.2,0.1-0.2 c0.1-0.1,0.1-0.3,0.1-0.5c0.2-0.6,0.7-0.9,1.2-1.1c0.1,0,0.3,0.1,0.4-0.1c0.1-0.1,0.3-0.2,0.4-0.3c0.2-0.1,0.4-0.2,0.5-0.3 c0.1,0,0.1-0.1,0.2-0.1c0.2-0.1,0.3-0.2,0.3-0.3c0-0.1,0.1-0.1,0.2-0.2C32.8,29.8,32.9,29.8,33,29.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1.5,27.1c-0.3-0.2-0.6-0.4-0.9-0.7c-0.1-0.4,0.2-0.7,0.4-1c0.1,0,0.2-0.1,0.1-0.2c0-0.3,0.2-0.4,0.4-0.5 c0.2-0.1,0.4-0.1,0.6-0.2c0.1,0,0.2-0.1,0.2-0.1c0.1,0,0.2,0,0.3,0c0.2,0,0.3,0,0.5,0c0.1,0.2,0.3,0,0.4,0c0.1,0.1,0.2,0.2,0.3,0.3 c0.1,0.2,0,0.4,0,0.6c-1.2,0.5-0.7,1.4-0.6,2.3c0.1,0.3,0.1,0.6-0.1,0.9c-0.1,0.1-0.2,0.1-0.3,0c-0.1-0.6-0.9-0.7-1.1-1.3 C1.6,27.3,1.8,27,1.5,27.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M35.8,73.2c-0.4-0.1-0.8,0.5-1.3,0c0.2-0.5,0.6-0.9,0.4-1.5c0.5-0.8,1.4-1,2.1-1.2c0.4-0.1,0.7-0.2,1.1-0.3 c0.5-0.1,0.7,0.3,0.9,0.6c0,0.2-0.1,0.3-0.2,0.3c-0.6-0.1-0.8,0.3-1,0.7c-0.3,0.5-0.8,0.5-1.2,0.7C36.2,72.6,36,73,35.8,73.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M11.6,15.1c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1-0.4,0.4-0.6,0.4-1c0.3-0.4,0.5-0.7,1-0.8c0.3,0.1,0.2,0.4,0.2,0.6 c-0.1,0.1,0,0,0,0.1c-0.1,0.2-0.8,0.6,0.1,0.6c0.3,0.2,0.7,0.8,1.1-0.1c0,0-0.2,0-0.2,0c-0.3,0.8-0.7,0.2-1,0 C13,14.2,13,14,13,13.8c0-0.3,0-0.5,0.2-0.7c0.4-0.3,0.7,0.1,1.1,0.2c0.1,0,0.2,0.1,0.3,0.1c0.1,0.1,0.1,0.1,0.2,0.2 c0.1,0.1,0.1,0.2,0.2,0.4c0,0.1,0,0.2,0,0.3c0,0.2-0.1,0.4-0.1,0.7c0,0.6,0.4,0.8,0.9,1c0.1,0.2,0.2,0.4,0.2,0.6 c0,0.1-0.1,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.4,0c-0.1-0.3-0.2-0.1-0.3,0c-0.3,0-0.4-0.1-0.6-0.3c-0.1-0.2,0-0.5-0.4-0.4 c-0.3-0.2-0.6,0-0.9,0c-0.2,0-0.4-0.1-0.5,0c-0.1,0-0.2,0-0.2-0.1l0,0C12.5,15.3,12.3,15,11.6,15.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M8.9,41.5c-0.2-0.1-0.4-0.1-0.6-0.2c-0.1-0.4-1.1-0.6-0.2-1.2c0.1,0,0.2,0,0.2,0.1c0.1,0.1,0,0.2,0,0.2 c0,0,0.1,0,0.1-0.1c0-0.2-0.2-0.4-0.2-0.6c-0.3-0.5-0.3-1.1-0.4-1.6c-0.1-0.4,0.2-0.5,0.4-0.7c0.5-0.4,1.1-0.1,1.7-0.2 c0,0,0.1,0,0.1,0.1c0.1,0.1,0.2,0.3,0.2,0.5c0,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.3,0-0.4,0c-0.2,0-0.3,0-0.4,0.1c0,0.1-0.1,0.1-0.1,0.2 c-0.1,0.3-0.4,0.6,0.1,0.8c0.1,0,0.2,0,0.3,0c0.2,0,0.4,0.8,0.7,0.1c0.1,0,0.2-0.1,0.3,0c0.3,0.3,0.3,0.7,0.3,1.1 c0,0.1-0.1,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.1C10,40.7,9.7,40.9,9.4,41C9.2,41.1,9,41.4,8.9,41.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M44.8,43.3c0.5-1,1.4-0.9,2.3-0.8c0.5,0.1,0.8,0.5,0.7,1c-0.2,0.3-0.5,0.5-0.7,0.7c-0.3,0.2-0.6,0.3-0.9,0.4 c-0.4-0.1-0.5,0.3-0.8,0.3c-0.2,0-0.3,0-0.4-0.1c-0.1-0.1-0.2-0.2-0.2-0.4C44.7,44,44.8,43.7,44.8,43.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M8.2,37.4c0,0.2-0.4,0.2-0.3,0.5c0.4,0.6,0.1,1.3,0.5,1.9c-0.2,0.1-0.4-0.1-0.5,0.1c-0.1,0-0.3,0-0.4-0.1 c-0.4-0.3-0.3-0.7-0.4-1.3c-0.2,0.4-0.4,0.6-0.2,1.1c0.2,0.4,0.2,0.9-0.4,1c-0.6,0-0.6-0.5-0.8-0.9C5.4,39,5.9,38.4,6,37.7l0,0 c0.3-0.4,0.7-0.4,1.1-0.2C7.5,37.4,7.9,37.4,8.2,37.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M19.2,76.3c-0.1-0.2-0.3-0.3-0.5-0.3c0.6-1.8,1.3-3.7,2.2-5.4c0.2-0.3,0-0.6,0.2-0.9c0-0.1,0-0.1,0.1-0.2 c0-0.1,0.1-0.1,0.2-0.2c0.1,0,0.1-0.1,0.2-0.1c0.1,0.1,0.1,0.2,0,0.3c0,0,0,0.1,0,0.1c0.1,0.1,0.1,0.2,0,0.3c0,0.1,0,0.1,0,0.2 c-0.1,0.1-0.1,0.2-0.2,0.2c-0.4,1.6-0.8,3.1-1.5,4.5C19.6,75.4,19.9,76.1,19.2,76.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M26.5,20c0,0.1,0,0.1,0,0.2c-0.1,0.1-0.1,0.2-0.2,0.2c0,0.1,0,0.1,0,0.2c-0.3,0.1-0.4-0.1-0.6-0.3 c0.1,0.3,0.4,0.4,0.5,0.8c-0.4,0.6-0.5,1.3-1.1,1.7c-0.3,0.1-0.5,0.2-0.8-0.1c-0.1-0.2-0.1-0.5-0.1-0.7c0-0.3,0.6-0.7,0-1 c-0.2-0.1-0.4-0.3-0.5-0.5c0-0.1,0-0.2,0-0.3c0-0.1,0.1-0.2,0.1-0.2c0,0,0.1-0.1,0.1-0.1c0.1-0.1,0.2-0.1,0.2-0.1 c0.1,0,0.2,0,0.3,0c0.1,0.1,0.1,0.2,0.1,0.4c0,0.1-0.1,0.1-0.1,0.1c0.1,0.1,0.1,0,0.1,0c0.1-0.2,0.1-0.4,0.3-0.5 c0.4-0.3,0.9-0.2,1.3-0.2c0.3,0,0.4,0.2,0.4,0.4c-0.1,0.1-0.2,0.1-0.3,0.1C26.3,19.9,26.4,19.9,26.5,20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M38.6,64c-0.5-0.1-1,0.1-1.5-0.2c-0.1-0.1-0.1-0.1-0.2-0.2c0-0.1-0.1-0.2-0.1-0.4c0-0.2-0.1-0.3,0-0.5 c0.1-0.1,0.3-0.2,0.4-0.3c0.1-0.1,0.2-0.2,0.4-0.2c0.2-0.1,0.4,0,0.5,0c0.2,0.1,0.4,0.1,0.7,0.1c0.1,0,0.3,0,0.4,0 c0.2,0,0.4,0,0.6,0.1c0.1,0,0.2,0.1,0.3,0.1c0.3,0.3,0.6,0.5,0.8,0.9c0,0.2,0,0.3-0.1,0.4c-0.6,0-0.1,0.5-0.2,0.6 c-0.4,0.1-0.7-0.2-1.1-0.4C39.2,63.7,38.9,63.7,38.6,64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M33,49.1c-0.8,0-1.4-0.5-1.7-1.2c-0.1-0.2-0.1-0.4-0.2-0.6c-0.5-0.6-0.2-0.9,0.4-1.2c0.2,0.1,0.2,0.3,0.3,0.5 c0.1,1,0.6,1.4,1.6,0.9c0.3-0.1,0.6,0,0.6,0.4c0,0.1-0.1,0.1-0.1,0.2c0,0,0,0,0.1-0.1c0.3,0.1,0.7,0.2,1,0.1c0.2,0,0.3,0,0.4,0.1 c0.1,0.3-0.1,0.4-0.2,0.5c-0.6,0.2-1.3,0.4-1.9,0.4C33.1,49,33,49,33,49.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M11.2,36.8c0.4,0,0.8-0.5,1.1,0c0.2,0.4,0.2,0.8-0.1,1.3c-0.2,0.4-0.3,0.9-0.5,1.4c-0.1,0.4-0.2,0.7-0.6,0.9 c0,0-0.1,0-0.1,0c-0.3-0.2-0.3-0.6-0.5-0.9c0-0.1-0.1-0.2-0.1-0.3c0-0.1-0.1-0.2-0.1-0.3c0.1-0.3,0.4-0.6,0.3-1 c0-0.2,0-0.5,0.1-0.7C10.9,37.1,11.1,37,11.2,36.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M18.8,48c0.1,0.1,0.1,0.2,0.2,0.2c0.2,0.3,0.3,0.6,0.5,0.9c0,0.1,0,0.2,0,0.3c-0.1,0.1-0.1,0.1-0.2,0.2 c0,0-0.1,0-0.1,0c-0.2,0-0.4-0.2-0.5,0c-0.1,0.2,0.2,0.2,0.2,0.4c0.5,0.8-0.2,1.3-0.5,1.9c-0.6,0.1-1-0.5-1.5-0.7 c0-0.5,0.1-0.9-0.3-1.3c0-0.6,0.6-0.4,0.8-0.8c0.3-0.3,0.6-0.5,0.9-0.8c0.3,0.1,0.2-0.1,0.1-0.2C18.5,48,18.6,47.9,18.8,48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M50.8,47.8c-0.4,0.3-0.9,0.4-1.3,0.7c-0.8,0.1-1.4,0.6-1.9,1.1c-0.2,0.3-0.4,0.2-0.7,0.2 c-0.2-0.1-0.2-0.3-0.2-0.6c0-0.2,0.1-0.4,0.1-0.6c0.1-0.2,0.2-0.4,0.4-0.6c0.1,0,0.2-0.1,0.2-0.1c0.2-0.1,0.3-0.2,0.3-0.4 c0-0.1,0.1-0.2,0.1-0.3c0.1-0.2,0.2-0.4,0.3-0.5c0.2-0.2,0.5-0.4,0.8-0.3c0.4,0.1,0.3,0.5,0.4,0.8c0.1,0.1,0.2,0.2,0.3,0.4 C50.1,47.7,50.6,47.3,50.8,47.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M14.3,25.8c0-0.1,0-0.1,0-0.2c-0.1-0.1-0.1-0.2-0.2-0.2c-0.5-0.5-1-0.9-1.3-1.5c0,0,0.1-0.1,0.1-0.1 c0.1,0,0.3,0,0.4,0c0.2,0,0.4-0.1,0.6-0.2c0.1,0,0.2-0.1,0.2-0.1c0.3-0.1,0.3-0.3,0.2-0.6c-0.1-0.2-0.1-0.4,0.1-0.5 c0.2-0.1,0.4-0.1,0.5,0c0.1,0,0.2,0.1,0.2,0.1c0.1,0.1,0.2,0.3,0.3,0.5c0.1,0.2,0.2,0.3,0.2,0.5c-0.1,0.5,0.2,0.9,0,1.4 c-0.1,0.2-0.3,0.4-0.5,0.5c-0.2,0.2-0.5,0.3-0.7,0.4C14.4,25.9,14.3,25.9,14.3,25.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M45,44.8c0.1,0,0.3,0,0.4,0c0.1,0.1,0.2,0.2,0.2,0.4c0,0.2,0.1,0.5,0.1,0.7c0,0.1,0,0.2,0,0.3 c0,0.3-0.1,0.5,0.1,0.8C46,47,46,47,46,47.1c0,0.2-0.1,0.4-0.2,0.5c-0.1,0.1-0.2,0.2-0.3,0.2c-0.1,0.1-0.2,0.1-0.2,0.2 c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.2,0.1-0.3,0.1c-0.3,0-0.6,0-0.9-0.1c-0.1-0.1-0.1-0.2-0.1-0.3c0.2-0.4,0.6-0.3,0.9-0.5 c0.1-0.2,0.4-0.3,0.3-0.5c0,0,0,0,0,0c0,0.2-0.1,0.4-0.3,0.5c-0.1,0.1-0.1,0.1-0.2,0.1c-0.2-0.1-0.4-0.4-0.7-0.3 c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2-0.1-0.2-0.2c0-0.2,0-0.5,0.1-0.7c0.1-0.3,0.5-0.5,0.6-0.8c0-0.3-0.1-0.6,0.2-0.9 c0.4,0,0.2,0.6,0.6,0.5C44.8,44.9,44.9,44.8,45,44.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M25.4,57.9c0,0.1,0,0.3,0,0.4c-0.2,0.2-0.3,0.4-0.2,0.7c-0.1,1.1-0.5,1.3-1.8,0.6c-0.1-0.1-0.1-0.1-0.2-0.2 c-0.1-0.1-0.1-0.3,0-0.4c0-0.1,0.1-0.2,0.1-0.2c0,0,0-0.1,0.1-0.1c0.1-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.3,0-0.4 c0-0.3,0.1-0.5,0.2-0.8c0.1-0.1,0.1-0.3,0.2-0.4c0.3-0.1,0.5-0.1,0.8-0.1c0.2,0.1,0.3,0.2,0.4,0.4c0,0.1,0.1,0.2,0.1,0.2 c0,0.1,0,0.2,0.1,0.4C25.3,57.8,25.4,57.9,25.4,57.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M48.3,53.2c-0.1,0.1-0.3,0.2-0.4,0.2c-0.4-0.2-1,0.1-1.3-0.4c0,0-0.1,0.1-0.1,0.1s0.1,0,0.1,0 c0.1,0.1,0.3,0.2,0.4,0.3c0.1,0.1,0,0.3,0.2,0.4c0,0,0,0.1,0.1,0.1c-0.3,0.3-0.7,0.4-1.1,0.4c-0.4-0.2-0.4-0.7-0.8-0.9 c-0.1-0.1-0.1-0.2-0.1-0.3c0-0.1,0.2-0.2,0.1-0.2c-0.2,0-0.3,0.2-0.4,0.2c-0.3,0-0.5-0.1-0.5-0.4c0-0.2,0.1-0.3,0.2-0.4 c0.1-0.1,0.2-0.2,0.4-0.2c0.5-0.1,0.9-0.4,1.3-0.5c1.1-0.1,1.6,0.6,2.1,1.4C48.3,53,48.3,53.1,48.3,53.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M22.9,16.8c0.1,0,0.1,0,0.2,0.1c0.1,0.1,0.2,0.1,0.3,0.2c0,0.1,0.1,0.1,0.1,0.2c0.1,0.1,0.1,0.2,0.1,0.4 c0,0.1,0,0.2,0,0.3c0,0.3,0.1,0.8-0.3,0.9c-0.6,0.2-0.9-0.2-1.3-0.5c0-0.1-0.1-0.2,0-0.3c-0.1,0.1-0.1,0.2,0,0.3 c0.2,0.4,0.9,0.5,0.4,1.1c-0.4,0.5-0.8,0.6-1.3,0.2C21,19.4,21,19.4,21,19.3c0-0.1,0-0.3,0-0.4c0-0.1,0.2-0.1,0-0.2 c-0.1,0.1-0.2,0.1-0.4,0.1c-0.1,0-0.2-0.1-0.3-0.3c0-0.1,0-0.2,0-0.3c0.1-0.2,0.3-0.4,0.4-0.5c0.3-0.2,0.5-0.6,0.9-0.6 c0.4,0.2,0.6-0.2,0.8-0.4C22.7,16.7,22.8,16.7,22.9,16.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M8.8,100.7c0.1,0.4-0.1,1,0.7,0.7c0.1,0.1,0.1,0.1,0.1,0.2c0,0.1,0,0.1,0,0.2c0,0-0.1,0.1,0,0.1 c0.1,0,0.1-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1c0.1,0,0.1,0,0.2,0c0.2,0.3,0.2,0.6,0,0.8c0,0.4,0,0.9,0,1.3 c-0.2,0.1-0.4,0-0.6,0c-0.1,0-0.1,0-0.2,0c0,0.1-0.1,0.1,0,0.2c0,0.1,0.1,0.1,0.1,0.2c0,0.2,0,0.3-0.2,0.4c-0.1,0-0.2,0-0.3,0 c-0.2,0-0.3-0.2-0.4-0.4C8.1,103,8.6,101.9,8.8,100.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M7.1,32.7c-0.3,0.4-0.7,0.2-1.1,0.2c-0.1-0.1-0.3-0.1-0.4,0c-0.6,0-1-0.4-1.5-0.7c-0.3-0.3-0.2-0.6,0-0.8 c0.1-0.2,0.2-0.4,0.3-0.7c0.3-0.3,0.3-1.2,0.9-0.4c0,0,0,0.1,0,0.1s0-0.1,0-0.1c-0.1-0.4,0-0.6,0.4-0.6c0.2,0,0.4,0.1,0.5,0.2 c0.1,0.1,0.2,0.2,0.3,0.4c0.1,0.1,0.1,0.3,0,0.4c-0.2,0.4-0.7,0.5-0.9,0.9c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.2-0.1-0.3,0.1 c0,0,0.2,0.1,0.3,0.1C5.7,32,6,32.2,6.2,32C6.8,32,7.3,31.9,7.1,32.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M21.3,6c-0.2,1,0.1,2.1-0.8,2.8c-0.1-0.1-0.1-0.2-0.1-0.4c0.1-0.1,0.3-0.3,0.1-0.5c0,0,0,0,0,0 c0.1,0.1,0,0.3-0.1,0.4c-0.2,0.1-0.3,0-0.5-0.1c-0.1-0.2-0.2-0.4-0.3-0.6c-0.1-0.1-0.2-0.2-0.2-0.3c-0.1-0.2-0.2-0.3-0.3-0.5 c-0.4-1.3-0.4-1.3,0.9-1.2c0.1,0,0.3-0.1,0.4-0.1C21,5.4,21.1,5.7,21.3,6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M23.3,59.4c0.4-0.1,0.6,0.4,1.1,0.4c0.7-0.1,0.8-0.2,0.6-0.8c0.1-0.1,0.3-0.1,0.4,0c0.1,0.8-0.5,1.3-0.6,2 c0,0.3,0.2,0.7-0.3,0.8c-0.2,0-0.4,0-0.6-0.1c-0.1-0.3-0.2-0.2-0.4,0c-0.1,0-0.2,0-0.3,0c-0.1-0.1-0.1-0.1-0.2-0.2 C23,61.3,23,61.2,23,61.1C22.7,60.5,22.2,59.8,23.3,59.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M1.3,25.4c-0.3,0.3-0.2,0.9-0.6,1.1c-1.1-1.1-0.8-2.7,0.6-3.2c0.1,0,0.3,0.1,0.5,0.2C1.9,23.6,1.9,23.8,2,24 c0,0.1,0,0.3,0,0.4c0,0.1-0.1,0.1-0.1,0.2c0,0-0.1,0-0.1,0s0,0.1,0,0.1c0,0,0,0.1,0,0.1C1.6,25,1.3,25,1.3,25.4L1.3,25.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M13.4,10.8c-0.5-0.7-0.1-1.3,0.2-1.9c0.3,0.4,0.4-0.1,0.6-0.1c1-0.2,1.1,0.5,1.3,1.2c0.1,0.3,0.3,0.6,0.4,0.9 c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.2-0.4,0.3c-0.5,0.1-0.9,0-1.3-0.3C14,11,14,10.9,14,10.8c0.5-0.2-0.1-0.5,0-0.7 c0,0,0.1-0.1,0.1-0.1c0,0,0,0.1-0.1,0.1c-0.1,0.2-0.2,0.5-0.4,0.6C13.5,10.8,13.4,10.8,13.4,10.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M31,43.9c-0.2,0.3-0.1,0.7-0.4,0.9c-0.6,0.3-0.6-0.4-0.9-0.6c-0.1-0.1-0.1-0.1-0.2-0.2 c-0.3-0.2-0.5-0.5-0.6-0.8c0-0.2,0-0.4,0.1-0.6c0.2-0.3,0.8,0.3,0.8-0.4c0-0.1,0-0.3,0.1-0.4c0.6-0.1,1.1,0.1,1.5,0.4 c0.2,0.4,0.6,0.7,0,1.1h0c-0.2,0.1-0.4,0.1-0.6,0.3C30.6,43.8,31,43.8,31,43.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M28.7,68c0.2,0.2,0.3,0.4,0.4,0.7c0,0.1-0.1,0.2-0.1,0.3c-0.1,0.1-0.1-0.1-0.1,0c0,0,0.1,0,0.2,0 c0.1,0,0.1,0.1,0.2,0.2c0,0.3-0.1,0.7-0.3,1c-0.1,0.3-0.3,0.4-0.6,0.4c-0.5,0.1-1.2,0-1.2,0.9c-0.2,0-0.5,0-0.6-0.2 c-0.3-0.3-0.4-0.7-0.5-1c0-0.4,0.4-0.5,0.6-0.8c0.2-0.2,0.4-0.3,0.6-0.4c0.3-0.1,0.5,0.1,0.6,0.3c0.1-0.4-0.3-0.4-0.5-0.7 C27.5,68,28.3,68.4,28.7,68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M12.9,35.7c0.1-0.1,0.1-0.3,0.2-0.4c-0.4-0.4,0-0.8,0.2-1.1c0.1-0.1,0.2-0.2,0.3-0.3c0.4-0.3,0.5-1,1.3-0.7 c0.2,0.2,0.3,0.4,0.3,0.7c0,0.5-0.7,0.5-0.6,1c0.1,0.1,0.1,0.2,0.1,0.4c0,0.1,0,0.2,0,0.3c0.1,0.4,0.7,0.9-0.3,1 c-0.3,0-0.5,0.1-0.8,0.2C13.4,36.4,13.3,36,12.9,35.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M39,70.8c-0.4-0.1-0.6-0.4-0.9-0.7c0.8-0.7,1.8-0.5,2.7-0.3c0.6,0.1,0.8,0.8,0.4,1.3 c-0.1,0.2-0.3,0.3-0.5,0.5c-0.5,0.1-0.8-0.1-0.9-0.6c0.1-0.2,0.2-0.2,0.4-0.2c0,0,0.1-0.1,0.1-0.1s-0.1,0-0.1,0 c-0.3-0.1-0.5,0-0.8,0.1C39.2,71,39.1,71,39,70.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M29.1,45.2c0.2,0.8-0.3,1.2-0.7,1.8c-0.2,0.3-0.6,0.5-0.9,0.8c-0.5,0-0.4-0.5-0.5-0.8c0-0.6-0.6-1.3,0.3-1.8 c0.1,0,0.2-0.1,0.3,0c0.1,0.1,0.3,0.2,0.4,0c0.1-0.1,0.2-0.1,0.4-0.1c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0.1 C29,45.1,29.1,45.1,29.1,45.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M23.5,17.6c0-0.1,0-0.1,0-0.2c-0.1-0.1-0.1-0.2-0.2-0.2c0-0.1,0-0.1,0-0.2c-0.1,0-0.1-0.1-0.1-0.1 c0,0,0-0.1,0.1-0.1c1-0.4,1.4-0.3,1.8,0.4c0.4,0.6,0.2,1.2-0.5,1.8c-0.3,0.2-0.6,0.1-0.8-0.1C23.8,18.4,23.6,18,23.5,17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M20.5,5.6c-0.4,0.3-0.4,0.3-0.8,0.1c-0.2-0.1-0.3,0-0.5,0.1c-0.3,0.1-0.2,0.3,0,0.4c0.2,0.2,0.2,0.5,0.2,0.7 c-0.2,0.1-0.4,0-0.6-0.1c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1-0.1-0.1-0.2-0.1-0.4c0-0.1,0-0.1,0-0.2c-0.1-0.4,0.1-0.8-0.2-1.1 c0-0.1,0-0.1,0-0.2c0.1-0.3,0.2-0.6,0.4-0.9c0.2-0.1,0.4,0,0.5,0.2c0.1,0.2,0.1,0.4,0.1,0.6c0.3,0.1,0.1-0.2,0.2-0.3 C20.8,4,20.8,4,20.9,4.9C20.8,5.2,20.7,5.4,20.5,5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M10.8,96.3c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1-0.6,0.4-1,0.6-1.4c0.4-0.9,0.9-1.6,1.3-2.5 c0.1-0.1,0.2-0.1,0.2-0.1c0.2,0,0.4,0,0.5,0.1c-0.6,0.5-0.5,1.3-0.9,1.9c-0.1,0-0.1,0.1-0.1,0.2c0,0.1-0.1,0.1-0.1,0.2 c0,0.1-0.1,0.1-0.1,0.2c0,0,0,0.1-0.1,0.1c-0.1,0.1-0.2,0.3,0,0.4c0.1,0.2,0,0.3-0.2,0.4c-0.1,0-0.2,0-0.2,0.1c0,0.2,0,0.3-0.2,0.4 C11.1,96.2,11,96.4,10.8,96.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M48.3,53c-0.7-0.5-1.1-1.4-2.2-1.3c-0.1-0.2,0.1-0.4,0.1-0.6c0-0.2,0.1-0.3,0.2-0.5c0.1-0.1,0.2-0.2,0.3-0.3 c0.1-0.1,0.2-0.1,0.4-0.1c0.1,0,0.3,0,0.4,0c0.1,0.2-0.1,0.3-0.1,0.5c0,0.1,0,0.1-0.1,0.2c0.2,0,0.1-0.2,0.2-0.2 c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0.1,0.4,0.2,0.4,0.4c-0.1,0.6,0.2,0.8,0.6,1.1c0.4,0.4-0.2,0.6-0.2,0.9C48.6,52.9,48.4,52.9,48.3,53z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M14.4,36.2c0.1,0,0.4,0,0.4,0c0.2-0.3-0.2-0.1-0.2-0.2c-0.2-0.2-0.2-0.4,0.1-0.6c0.1-0.1,0.1-0.1,0.2-0.2 c0.1-0.2,0.1-0.4,0.2-0.6c0.3-0.2,0.5-0.1,0.7,0.1c0.1,0.1-0.1,0.6,0.3,0.3c0.2-0.1,0.4-0.4,0.7-0.3c0.1,0.1,0.1,0.2,0.1,0.4 c0,0.1-0.1,0.3-0.2,0.4c-0.1,0.1-0.2,0.2-0.3,0.3c0,0.5-0.6,0.6-0.7,1c-0.2,0.1,0,0.4-0.1,0.5c-0.5,0-1.1-0.1-1.5-0.4 C14,36.5,14.3,36.4,14.4,36.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M28.9,60.1c0.2-0.7,0.4-1.3,1.1-1.7c0.4-0.1,0.6,0.2,0.9,0.2c0.3,0.1,0.5,0.3,0.7,0.5 c0.2,0.2,0.4,0.3,0.4,0.5c-0.1,0.3,0,0.5,0,0.8c-0.1,0.1-0.2,0.2-0.3,0.3c-0.3,0.1-0.5,0-0.7-0.1c-0.3-0.2-0.2-0.6-0.5-0.8 C29.8,59.8,29.4,60.3,28.9,60.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M7.1,32.7c0-0.6-0.5-0.5-0.9-0.6c-0.3,0.1-0.5-0.1-0.5-0.4c0-0.6,0.8-0.4,0.9-0.9c0.1-0.1,0.1-0.1,0.2-0.1 c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.4,0.2c0.1,0,0.2,0,0.4,0.1c0.2,0,0.3,0,0.5,0c0,0,0.1,0,0.1,0c0.1,0,0.2,0.1,0.2,0.1 C9,31.4,9,31.5,8.9,31.6c-0.2,0-0.4,0.1-0.5,0.3C8.1,32.5,7.7,32.7,7.1,32.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M5.6,22.6c0-0.4,0.3-0.6,0.5-0.8c0.7-0.7,1.2-0.6,1.7,0.4c-0.1,0.2-0.2,0.4-0.3,0.6c-0.1,0.1-0.2,0.1-0.3,0.1 c-0.4,0.1-0.1,0.4-0.3,0.6c-0.2,0.1-0.4,0.3-0.3,0.6c-0.1,0.2-0.1,0.4-0.3,0.5c-0.2,0-0.4-0.1-0.5-0.3C5.4,23.6,5.6,23.1,5.6,22.6z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M6.9,5.8c0.4,0,0.9-0.3,1.3,0.2c0,0,0,0.1,0,0.1C8,6.4,7.9,6.6,7.8,6.8c-0.2,0.3-0.2,0.8-0.5,1 C7.1,7.9,7,7.6,7,7.6C7,7.8,7.3,7.9,7.3,8c0.1,0.4,0.2,0.8-0.4,0.6C6.5,8.3,6.4,7.7,6.1,7.3C5.8,7,6.2,6.7,6.3,6.4 C6.4,6.1,6.6,5.9,6.9,5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M18.3,54.9c0-0.6,0.5-0.8,0.9-1.1c0.1,0,0.2,0.1,0.3,0.1c0.8,0.3,1,0.9,0.7,1.7c-0.2,0.3-0.7,0.5-0.8,0.9 c-0.1,0.3-0.4,0.3-0.6,0.2c-0.1-0.1-0.3-0.2-0.5-0.3c-0.3-0.2-0.2-0.6-0.2-0.9c0.1-0.1,0.2-0.1,0.3-0.2c0.2-0.1,0.4,0.2,0.4,0.1 c0.2-0.3-0.1-0.4-0.3-0.5C18.4,55,18.4,55,18.3,54.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.3,7.1c-0.5-0.9,0.4-1.2,0.8-1.7c0.4-0.5,0.8-0.1,1.2,0.2c0.2,0.1,0.4,0.3,0.6,0.5C18.2,6.5,18,6.7,17.6,7 c-0.5,0.3-0.7-0.3-1-0.5c-0.4,0.1-0.6,0.5-1,0.7C15.5,7.2,15.4,7.2,15.3,7.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M25.4,57.9c-0.1,0-0.1,0-0.2,0c-0.2-0.2,0-0.5-0.2-0.6v0c-0.1-0.1-0.1-0.3-0.2-0.4c-0.3,0.2-0.6,0.2-0.9,0 c0,0-0.1,0-0.1,0c-0.4,0-0.6-0.2-0.7-0.6c0-0.1,0-0.2,0.1-0.3c0.1-0.2,0.2-0.2,0.4-0.4c0.1-0.1,0.2-0.3,0.3-0.4 c0.1-0.1,0.1-0.1,0.2-0.2c0.1,0,0.2-0.1,0.3-0.1c0.3,0.1,0.6,0.2,0.5,0.6c0,0.1-0.1,0.3-0.1,0.4c0.1-0.1,0-0.3,0.1-0.4 c0.2-0.2,0.1-0.8,0.7-0.5l0,0c0.1,0.1,0.1,0.3,0.2,0.4C25.7,56.3,25.4,57.1,25.4,57.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M18.8,56.6c0.2-0.1,0.5,0.2,0.5-0.3c0-0.5,0.2-0.8,0.8-0.6c0.1-0.1,0.2-0.1,0.3-0.2c0.2,0,0.4,0,0.6,0.2 c0.1,0.6-0.2,1.1-0.3,1.7c-0.2,0.3-0.5,0.4-0.7,0.6c-0.4,0.1-0.7,0-0.9-0.4c-0.1-0.4-0.3,0-0.5-0.1c0-0.3,0-0.6,0-0.8 C18.6,56.5,18.7,56.5,18.8,56.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M34.3,19.8c0.8-0.5,1.5-0.2,1.6,0.7c0,0.5,0.5,1,0,1.5c-0.6,0.3-0.8-0.2-1.2-0.4c-0.1-0.1-0.2-0.2-0.3-0.3 c-0.1-0.3-0.7-0.4-0.5-0.9c0.1-0.3,0.5,0,0.5-0.4C34.3,19.9,34.3,19.8,34.3,19.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M20.5,5.6c0-0.2-0.1-0.5,0.2-0.6c0.2-0.6,0.4-1.1-0.6-0.8c-0.2,0.1-0.4-0.1-0.5-0.3c-0.1-0.2,0-0.5,0-0.7 c0.1-0.2,0.2-0.3,0.4-0.3c0.1,0,0.2,0,0.3,0.1C20.4,3,20.6,3.1,20.7,3c0.2,0,0.4-0.2,0.6,0c0.3,1,0.4,2,0,3 C21,5.9,20.9,5.5,20.5,5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M25.6,23c0.4-0.3,0.8-0.6,1.3-0.2c0.1,0.3,0.1,0.5,0.4,0.2c0.3,0,0.5,0.3,0.7,0.4c0,0.1,0.1,0.2,0.1,0.3 c0,0.3-0.1,0.6-0.2,0.8c-0.1,0.1-0.1,0.1-0.2,0.1c-0.2,0-0.3-0.2-0.4-0.3c-0.1-0.1-0.3-0.2-0.5-0.2c-0.5-0.1-0.9,0.2-1.3,0.4 c-0.2,0.1-0.5,0.1-0.7,0c-0.2,0-0.3-0.1-0.4-0.1c-0.2-0.2-0.2-0.3-0.1-0.5c0,0,0.1-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1 c0.1,0,0.2,0,0.2,0c0.2,0.1,0.3,0,0.4-0.1c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.1,0,0.2,0.1c0.1,0,0.1-0.1,0.1-0.1c0-0.1,0-0.1,0-0.2 c0-0.1,0-0.1,0-0.2C25.5,23.1,25.6,23,25.6,23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M17,38.1c0.3,0,0.8,0.1,0.3-0.5c-0.1-0.1-0.1-0.2-0.1-0.4c0-0.5,0.4-0.3,0.6-0.4c0.1,0,0.2,0,0.3,0 c0.1,0,0.2,0.1,0.2,0.1c0.2,0.2,0.2,0.5,0.2,0.8c0,0.1-0.1,0.2-0.2,0.3c0,0.1-0.2,0.1-0.1,0.2c0,0.1-0.1,0,0.1,0 c0.1,0,0.1,0.1,0.2,0.2c0,0.1,0,0.2-0.1,0.2c-0.1,0.1-0.2,0.3-0.3,0.4c-0.2,0.4,0.1,0.9-0.3,1.3c-0.2,0.1-0.4,0.1-0.5,0.1 c-0.1,0-0.2-0.1-0.2-0.2c-0.1-0.2-0.2-0.4-0.4-0.5c-0.1-0.1-0.1-0.1-0.1-0.2C16.5,39,17.1,38.6,17,38.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M3.7,25.4c0-0.2,0-0.4,0-0.7c0.1-0.1,0.3-0.2,0.4-0.2c0.3,0.2,0.7,0.3,0.9,0.6c-0.1,0.1-0.2,0.1-0.3,0.2 c0.2,0,0.3,0,0.5,0c0.2,0.1,0.4,0.3,0.6,0.2c0,0,0.1,0.1,0.1,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c-0.1,0.2-0.1,0.3-0.2,0.4 c-0.1,0.1-0.2,0.3-0.2,0.4c0,0.1-0.1,0.2-0.2,0.4c-0.1,0.1-0.1,0.1-0.2,0.2c0,0-0.1,0-0.1,0.1c-0.1,0-0.2,0-0.3-0.1 c-0.1-0.1-0.1-0.2-0.1-0.4c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.1-0.1-0.2c-0.1,0-0.1,0.1,0,0.1c0.1,0.1-0.1,0.1,0,0.1 c0,0.1,0,0.3-0.1,0.4c-0.1,0-0.1,0-0.2,0c-0.2,0.1-0.2,0.8-0.6,0.2C3.5,26.7,3.7,26.1,3.7,25.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M29.1,42.6c0,0.2,0,0.4,0,0.6c0,0,0,0.1,0,0.1c0,0.1-0.1,0.2-0.1,0.2c0,0,0,0.1-0.1,0.1 c-0.1,0.2-0.2,0.5-0.6,0.5c-0.3,0-0.6-0.1-0.8-0.3c-0.3-0.3,0.3-0.6-0.1-0.9c0-0.2,0.1-0.4-0.1-0.5c-0.1-0.1-0.1-0.1-0.1-0.2 c0-0.1,0-0.2,0.1-0.2c0.2-0.1,0.4-0.2,0.6-0.3c0.1,0,0.2-0.1,0.2-0.1c0.1,0,0.2,0,0.4,0c0,0,0.1,0,0.1,0c0.3,0,0.6,0,0.9,0 c0.2,0.1,0.3,0.2,0.3,0.4C29.6,42.5,29.3,42.4,29.1,42.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M28.4,61.8c0-0.5,0.1-0.9,0.4-1.3c0.5,0,1,0,1.3,0.4c0,0.4,0,0.8,0,1.3c0,0.2-0.1,0.3-0.3,0.3 c-0.1,0-0.2,0.1-0.3,0.1c-0.3,0-0.5,0.2-0.7,0.4c-0.3,0.3-0.6,0.3-0.9-0.1c-0.1-0.3,0.1-0.4,0.2-0.6C28.4,62.1,28.5,62,28.4,61.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M23.3,59.4c-0.8,0.6-0.3,1.1,0,1.7c-0.1,0.1-0.2,0.2-0.2,0.2c0,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.1,0,0.2 c0,0.1,0,0.1,0,0.2c0,0,0,0.1,0,0.1c0,0.1,0,0.1-0.1,0.2c-0.1,0.1-0.3,0.2-0.4,0.2c-0.2-0.1-0.2-0.3-0.3-0.4c0-0.1,0-0.2-0.1-0.3 c-0.1,0.1-0.2,0.2-0.3,0.3c-0.3-0.4-0.6-0.8-0.6-1.3c0.2-0.2,0.4-0.4,0.7-0.1c0,0.1,0,0.2,0,0.2c0.1,0.1,0,0,0-0.1 c0-0.1,0.1-0.2,0.1-0.3c0.2-0.4,0-0.8,0.1-1.2c0.1-0.2,0.2-0.3,0.4-0.3c0.1,0,0.3,0,0.4,0.1C23.1,59.1,23.2,59.3,23.3,59.4 L23.3,59.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M26.7,73.9c-0.2,0.9-0.9,1.4-1.5,2.1c-0.2,0.3-0.4,0.6-0.7,0.8c-0.2-0.2-0.2-0.4-0.2-0.6 c0.7-0.9,1.4-1.7,2-2.6c0-0.1,0.1-0.2,0.2-0.2c0-0.1,0-0.1,0.1-0.2c0.1-0.1,0.3-0.1,0.4-0.3c0-0.1,0-0.1,0.1-0.1 c0.2,0,0.3,0,0.2,0.2c0,0.2,0.1,0.5-0.2,0.6C26.9,73.7,26.8,73.8,26.7,73.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M30.8,53.2c0-0.3,0.2-0.5,0.4-0.6c0.6-0.3,1.2-0.3,1.8-0.2c0.4,0.2,0.4,0.5,0.5,0.9c0,0.3-0.1,0.5-0.3,0.8 c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1-0.1-0.2-0.2-0.3-0.4c-0.6-0.9-0.6,0.3-0.9,0.2c-0.2,0.1-0.4,0.2-0.6,0.2c-0.2,0-0.4,0-0.6-0.2 c0-0.2,0-0.3,0-0.5C30.7,53.5,30.8,53.3,30.8,53.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M2.4,32c-0.5,0-0.9-0.2-1.1-0.6c0.2-0.3-0.1-0.5-0.2-0.6c0-0.1,0-0.3,0-0.4c0.4-1,1.4-0.8,2.2-1 c0.2,0,0.4,0,0.5,0.3c0.1,0.1,0.1,0.3,0.1,0.5c0,0.1-0.1,0.2-0.1,0.3c-0.3,0.2-0.6-0.1-0.9,0.1c-0.2,0-0.4,0-0.6-0.2 c0-0.1-0.1-0.1-0.1-0.1c0,0,0.1,0,0.1,0.1c0.1,0.2,0.3,0.3,0.3,0.5C2.6,31.3,2.5,31.7,2.4,32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M40.7,63.7c0-0.1,0-0.3,0-0.4c-0.1-0.4-0.4-0.6-0.7-0.8c-0.1-0.1-0.1-0.2,0-0.3c0.1-0.1,0.1-0.1,0.2-0.2 c0.2-0.1,0.3-0.1,0.5-0.2c0.2-0.1,0.4-0.2,0.7-0.2c0.1,0,0.2,0.1,0.2,0.2c0.1,0.2-0.2,0.7,0.4,0.6c0.4-0.1,0.6,0.1,0.3,0.5 c-0.1,0.6-0.5,1.1-1.1,1.3C41.2,64,41,64,40.8,63.8C40.8,63.8,40.7,63.8,40.7,63.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M17.3,42.4c-0.4,0.4-0.9,0.2-1.3,0.2c-0.3-0.1-0.6,0.1-0.9,0c-0.1,0-0.1-0.1-0.1-0.2c0-0.1,0.1-0.2,0.2-0.3 c0.1-0.1,0.2-0.2,0.2-0.2c0.1,0,0.1-0.1,0.1-0.2c0-0.1,0-0.1,0-0.1c0-0.1,0-0.2,0-0.2c0.2-0.2,0.3-0.2,0.6-0.1 c0.4,0.5,0.5-0.1,0.7-0.2c0.1-0.1,0.2-0.1,0.3-0.1c0.3,0,0.4-0.4,0.6-0.5c0.1,0,0.3,0,0.4,0c0.1,0.1,0.2,0.2,0.3,0.3 c0,0.1,0,0.2,0,0.3c-0.2,0.3-0.5,0.5-0.7,0.8C17.6,42.1,17.3,42.2,17.3,42.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M33.8,35.3c0,0.7-0.5,0.9-0.9,1.3c-0.4,0.3-0.8,0.5-1.4,0.4c-0.1,0-0.2-0.1-0.2-0.2c0-0.1,0-0.2,0-0.3 c0.2-0.3,0.4-0.5,0.7-0.8c0.2-0.2,0.5-0.3,0.7-0.4c0.3-0.2,0.2-0.6,0.4-0.8c0.1-0.1,0.3-0.1,0.4-0.1c0.1,0.1,0.2,0.2,0.3,0.3 C34,34.9,33.7,35.1,33.8,35.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M6.9,8.6c0.6,0,0.3-0.4,0.2-0.6C7.1,7.9,7,7.9,7.1,7.8c0,0,0-0.1,0.1-0.1c0.3-0.1,0.2-0.4,0.2-0.6 c0-0.3,0.1-0.4,0.4-0.4c0.2-0.1,0.3,0,0.4,0.2c0.1,0.1,0.1,0.3,0,0.4c0,0.2-0.3,0.4,0,0.6c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0.1,0.2,0.1 c0.1,0.1,0.1,0.2,0.2,0.3c0,0.1,0.1,0.1,0.1,0.2c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2,0.1c0.1,0,0.2,0.1,0.2,0.1 C9.5,8.8,9.5,8.9,9.6,9c0,0,0,0.1,0,0.1c0,0.1-0.1,0.1-0.2,0.2c0,0-0.1,0-0.1,0c-0.1,0-0.3,0-0.4,0c-0.1,0-0.2,0-0.2,0 c-0.2,0-0.3,0-0.5,0c-0.2-0.1-0.5,0-0.8-0.1C7.1,9.1,7,8.8,6.9,8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M12.7,13.1c-0.2,0.4-0.5,0.7-0.9,0.9c-0.5,0.2-0.6-0.2-0.7-0.5c0-0.3,0-0.7,0.2-1c0.1-0.9,0.8-0.6,1.3-0.6 C13.7,12.6,13.7,12.6,12.7,13.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M31.9,33.8c0.2,0,0.4,0,0.6,0c0.1,0.2,1.1-0.1,0.5,0.7c-0.3,0.4-0.8,0.5-1.2,0.8c-0.3,0.3-0.5,0.9-1.1,0.6 c-0.9-0.4-0.9-0.7-0.2-1.5c0.2-0.2,0.4-0.3,0.6-0.3c0.1,0,0.2,0,0.3,0.1c0,0,0.1,0,0.1,0s0-0.1,0-0.1c0-0.2,0.1-0.3,0.2-0.4 C31.8,33.8,31.9,33.8,31.9,33.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M9.1,23.9c0.4,0.5,0.1,1,0.2,1.5c0,0,0,0.1,0,0.1c-0.1,0.3,0.3,0.2,0.3,0.3c0.2,0.2,0.3,0.5,0.3,0.8 c0,0.1,0,0.2-0.1,0.3c-0.3,0.2-0.5-0.1-0.7-0.1c-0.2,0-0.3,0.1-0.5,0.2c-0.2,0-0.4-0.1-0.5-0.3C7.8,25.8,8,25,8.3,24.2 C8.6,24.1,8.8,24,9.1,23.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M21.3,3c-0.2,0.1-0.4,0.2-0.7,0.2c-0.2,0-0.3-0.1-0.3-0.3c0-0.1-0.1-0.2-0.1-0.3c0-0.2,0-0.4-0.1-0.6 c0-0.4-0.2-0.6-0.5-0.7c-1.3,0-1.3,0-1.2-1C18.7,0.1,18.9,0,19.2,0c0.1,0.1,0.2,0.2,0.4,0.2c0.7,0.4,0.9,1.2,1.5,1.8 c-0.1,0.3-0.2,0.6,0,0.8C21.2,2.9,21.3,2.9,21.3,3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M11.9,23.4c-0.3-0.3-0.6-0.6-0.8-0.9c-0.2-0.3-0.5-0.6-0.3-1c0.4-0.1,0.5-0.5,0.8-0.7c0.5,0,0.6,0.4,0.9,0.6 c0,0.1,0.1,0.2,0.1,0.3c0,0.4-0.2,0.8-0.4,1.2c0,0.1-0.1,0.2-0.1,0.3C12.1,23.3,12,23.3,11.9,23.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M23.9,15.7c-0.1-0.5,0.2-0.9,0.4-1.3c0.1-0.1,0.2-0.2,0.3-0.3c0.4-0.5,0-1.2,0.6-1.6c0.8,0.2,0.8,0.7,0.5,1.3 c-0.3,0.5-0.6,1-0.9,1.5C24.6,15.7,24.3,15.7,23.9,15.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M47,50.2c0,0.1-0.1,0.2-0.2,0.2c-0.2-0.1-0.5,0-0.7-0.2c-0.2-0.3-0.1-0.5,0.1-0.8c0.2-0.1,0.2-0.2,0-0.3 c-0.2-0.2-0.3-0.5-0.6-0.6c-0.2-0.1-0.3-0.2-0.4-0.4c0-0.1,0-0.2,0.1-0.3l0,0c0.1-0.1,0.3-0.1,0.4-0.2c0.1-0.1,0.2-0.3,0.2-0.4 C46,47.1,46,47,46.1,47c0.5,0.1,0.7,0.4,1,0.8c0,0.1,0,0.3-0.1,0.4c-0.1,0.2-0.1,0.3-0.1,0.5c0,0.1,0,0.3,0.1,0.4 c0,0.2,0,0.4,0,0.6C47,49.9,47,50,47,50.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M18.5,48.4c-0.3,0.4-0.6,0.7-1.1,0.9c-0.2-0.1-0.3-0.2-0.2-0.4c0.2-0.4-0.1-0.7-0.2-1.1 c0-0.1,0.1-0.2,0.2-0.3c0.1,0,0.2,0,0.2,0.1c0.3,0.3,0.3,0,0.3-0.2c0-0.2-0.1-0.3,0.1-0.4c0.4,0.3,0.8,0.6,0.9,1.1 C18.6,48.1,18.5,48.2,18.5,48.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M17.2,40c0,0.1,0,0.1,0,0.2c-0.1,0.2-0.3,0.3-0.4,0.5c-0.1,0.1-0.2,0.2-0.3,0.2c-0.1,0-0.2,0-0.3-0.1 c-0.3-0.3-0.4-0.7-0.8-0.9c-0.4-0.3-0.9,0-1.3-0.2c0,0-0.1-0.1-0.1-0.1c0.6-0.4,1.1-0.7,1.7-1.1c0.5,0.3,1,0.4,1.1,1.1l0,0 C16.9,39.8,17.2,39.8,17.2,40z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M30.2,33.8c0-0.5-0.2-1,0.6-0.9c0.4,0,0.9-0.1,1.2-0.5c0.1-0.2,0.4-0.4,0.6-0.1c0.2,0.3,0,0.6-0.2,0.9 c-0.1,0.2-0.3,0.4-0.4,0.6l0,0c-0.1,0.1-0.2,0.1-0.4,0.1c-0.3-0.1-0.5-0.1-0.8,0c-0.1,0-0.3,0-0.4,0C30.3,33.9,30.2,33.9,30.2,33.8 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M2.8,30.4c0.3-0.7,0.6-0.1,0.9,0c0.1,0.1,0.1,0.2,0.1,0.3c-0.3,0.5,0.4,1.1-0.1,1.7c-0.5,0.1-0.9-0.1-1.3-0.2 c-0.4-0.5,0.1-0.9,0.2-1.3c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0.1-0.2C2.7,30.4,2.8,30.4,2.8,30.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M44.4,59.6c0,0.2,0,0.3-0.2,0.4c-0.2,0.1-0.5,0.2-0.7,0c0-0.2,0.1-0.5-0.3-0.3c-0.1,0-0.2,0.1-0.4,0.1 c-0.1,0-0.2,0.1-0.3,0.2c-0.2,0.1-0.3,0.3-0.5,0.3c-0.1,0-0.2-0.1-0.3-0.2c0-0.1-0.1-0.2-0.1-0.2c-0.1-0.2-0.2-0.4-0.3-0.6 c0-0.1,0.1-0.2,0.1-0.2c0.3-0.2,0.3-0.6,0.6-0.8c0.3-0.1,0.5-0.1,0.6,0.3c0.1,0.2,0.1-0.1,0.2,0c0.3,0,0.5-0.2,0.7-0.2 c0.3,0.2,0.3,0.6,0.6,0.7C44.3,59.2,44.5,59.4,44.4,59.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M14.4,42.6c-0.6-0.3-0.9-0.8-1.3-1.2c-0.4-0.4-0.1-0.8,0.2-1.2c0.2-0.1,0.4-0.1,0.6,0c0.4,0.3,0.6,0.6,0,0.9 c-0.1,0-0.2,0-0.4,0c0.1,0,0.2,0,0.2,0c0.3-0.1,0.5,0.4,0.9,0.1c0.2-0.1,0.3,0.2,0.2,0.4c0,0.1-0.1,0.2-0.2,0.3 c-0.1,0.1-0.2,0.2-0.2,0.3C14.6,42.5,14.5,42.5,14.4,42.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M28.7,68c0,0.3,0.1,0.8-0.6,0.5c-0.3-0.1-0.5-0.2-0.7,0.1c0.1,0.2-0.1,0.3-0.2,0.4c0,0.3-0.1,0.4-0.4,0.4 c-0.3-0.4,0.1-0.7,0.1-1c0-0.3-0.3-0.3-0.4-0.6c-0.1-0.3,0-0.6,0.3-0.8c0.1-0.1,0.3-0.1,0.4,0c0.2,0.2,0.4,0.5,0.8,0.1 c0,0,0.1,0,0.1-0.1C28.4,67.4,28.6,67.6,28.7,68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M26.7,67.2c-0.1,0.3-0.1,0.6-0.2,0.9c0,0-0.1,0.1-0.1,0.1c-0.2,0.1-0.3,0.3-0.3,0.5c-0.1,0.1-0.1,0.1-0.2,0.2 c-0.3,0.1-0.5,0.5-0.7,0.7c-0.6-0.4-0.6-1.1-0.8-1.7c0.1-0.1,0.1-0.3,0.3-0.3c0.2-0.1,0.4-0.1,0.6,0c0.1,0,0.2,0.1,0.2,0.1 c0,0,0.1,0.1,0.1,0.1c0,0.1,0,0.1,0,0.1c-0.1,0,0-0.1-0.1,0c0,0.1,0,0.1,0.1,0c0.1-0.2-0.1-0.2-0.1-0.4c0.2-0.3,0.6-0.4,0.9-0.4 C26.5,67,26.6,67,26.7,67.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M48.3,57.9c-0.2,0.4-0.6,0.5-0.9,0.4c-0.3,0-0.5-0.2-0.8,0c-0.2-0.2-0.5-0.5-0.7-0.7c0-0.1-0.1-0.2,0-0.3 c0.3-0.3,0.7-0.6,1.2-0.4c0.1,0.1,0.1,0.3,0.1,0.5c0.3-0.3,0.5-0.9,1.1-0.6l0,0c0.1,0.1,0.1,0.1,0.2,0.2 C48.4,57.4,48.6,57.7,48.3,57.9L48.3,57.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M31.5,36.6c0,0.1,0,0.1,0,0.2c0.2,0.3,0,0.5-0.2,0.6c-0.1,0.1-0.1,0.1-0.2,0.2c-0.3,0.3-0.3,0.8-0.7,1.1 c-0.1,0.1-0.1,0.1-0.2,0.2c0,0-0.1,0-0.1,0.1c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.1-0.3-0.1-0.4c0-0.2,0.1-0.3,0.2-0.5 c0.1-0.2,0.1-0.4,0.1-0.6c0-0.1,0-0.3,0.1-0.4c0.1-0.1,0.2-0.2,0.3-0.3c0,0,0-0.1,0-0.1s-0.1,0-0.1,0c-0.1,0-0.1,0.1-0.2,0.1 c-0.3,0.2-0.6,0.3-0.7-0.2c0.1-0.4,0.3-0.7,0.7-0.8c0.4,0,0.8,0.3,1.1,0.4C31.4,36.3,31.3,36.5,31.5,36.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M20,3c-0.2,0-0.3,0-0.4,0.2c0,0-0.1,0.1-0.1,0.1c-0.5,0.3-0.7-0.5-1.2-0.4C18.2,3,18.2,3,18.1,3 c-0.1,0-0.3,0.1-0.4,0c0-0.1,0-0.3,0-0.4c-0.1-0.4,0.3-0.5,0.4-0.7c0.3-0.3,0.8-0.5,1.2-0.5c0.1,0,0.2,0.1,0.2,0.2 c0,0.1,0,0.2,0,0.3c0-0.1,0.1-0.1,0.2-0.2c0.1,0,0.2,0.1,0.2,0.1C19.9,2.2,20,2.6,20,3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M35.8,27.6c0,0.3,0,0.6-0.3,0.7c-0.7,0.2-1.3,0.7-2.1,0.8c0,0-0.1-0.1-0.1-0.1c0-0.3,0.1-0.5,0.2-0.7 c0.2-0.3,0.4-0.6,0.6-0.8c0.2-0.2,0.3-0.4,0.6-0.4c0.4,0,0.5,0.5,0.9,0.4C35.6,27.5,35.7,27.5,35.8,27.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M30.6,56.8c-0.2-0.3,0-0.6,0-0.9c0.2-0.2,0.5-0.2,0.8-0.2c0.5-0.1-0.1-0.2,0-0.4c0-0.1,0-0.2,0.1-0.3 c0.2-0.2,0.3-0.4,0.6-0.3c0.8,0.4,0.3,1.3,0.6,1.8c0,0.1,0,0.2-0.1,0.3c0,0-0.1,0.1-0.1,0.1c-0.1,0.1-0.2,0.1-0.3,0.1 c-0.3,0-0.5,0-0.7-0.2C31.3,56.8,30.9,57,30.6,56.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M36.4,27.3c-0.1,0-0.1,0-0.2,0c-0.4,0.1-0.6-0.2-0.8-0.4c-0.6-0.8,0.1-1.2,0.6-1.5c1.2,0,1.2,0,0.9,1.3 C36.6,26.8,36.5,27,36.4,27.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M19.8,42.4c-0.4-0.3-0.6-0.7-1.1-0.9c0-0.1,0-0.2,0-0.3c0.2-0.3,0.5-0.5,0.8-0.7c0.1-0.1,0.2-0.2,0.4-0.2 c0.1,0,0.4,0.1,0.4,0.2c-0.3,0.8,0.3,0.3,0.5,0.4c0.2,0,0.3,0.1,0.4,0.2c0.3,0.7-0.4,0.7-0.7,1.1C20.3,42.3,20.1,42.6,19.8,42.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M25.2,69.6c-0.1-0.7,0.2-1,0.9-0.9c0.1,0.1,0.3,0.2,0.3,0.1c0.2-0.3,0.4-0.5,0.7-0.3 c-0.1,0.4-0.4,0.7-0.4,1.1c0.1,0.5-0.5,0.3-0.6,0.6c-0.2,0.2-0.4,0.2-0.6,0l0,0c-0.1-0.1-0.1-0.3-0.2-0.4 C25.2,69.7,25.2,69.6,25.2,69.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M34.9,71.7c0.3,0.2,0.5,0.4,0.3,0.8c-0.2,0.3-0.4,0.6-0.7,0.8c-0.2,0-0.4,0-0.6,0c-0.4-0.1-0.4-0.4-0.2-0.6 C34,72.2,34.3,71.7,34.9,71.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M18.3,51.9c0-0.1,0-0.2,0-0.3c0.3-0.5,0.4-1.1,0.4-1.6c-0.1-0.4,0.3-0.3,0.4-0.4h0c0.1-0.1,0.1-0.1,0.2-0.2h0 c0.1-0.1,0.1-0.2,0.2-0.2c0.5,0.3,0.3,0.7,0.1,1.1C19.4,50.9,19,51.5,18.3,51.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st62",
    d: "M6.5,40.7c0.4-0.4,0.5-0.8,0-1.2c-0.1-0.1-0.4-0.3-0.2-0.3c0.5-0.1,0.3-0.8,0.8-0.9c0.4,0.4,0.2,1.1,0.5,1.6 c0.2,0.6-0.1,1-0.7,1.1C6.7,40.9,6.6,40.9,6.5,40.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M36.4,72.3c0.3-0.4,1-0.1,1.3-0.6c0.3,0.1,0.5,0.4,0.9,0.2c0.2-0.1,0.5-0.2,0.7,0c0.1,0.3,0,0.5-0.3,0.6 c-0.8,0.3-1.6,0.4-2.4,0.6C36.4,73,36.8,72.5,36.4,72.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M38,65.7c0.2,0.2,0.4,0.5,0.4,0.9c-0.3,0.4-0.7,0.5-1.2,0.6c-0.2,0.1-0.4,0.1-0.6,0.2c-0.3,0-0.5-0.1-0.7-0.3 c0-0.1-0.1-0.2-0.1-0.3c0-0.1,0.1-0.2,0.1-0.3c0.5-0.1,0.8-0.2,0.7-0.8c0-0.1,0-0.2,0-0.3c0.2-0.3,0.3-0.5,0.7-0.4l0,0 c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2,0.1,0.2C37.9,65.6,37.9,65.6,38,65.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M28,23.5c-0.3,0.1-0.4-0.3-0.6-0.4c-0.1,0-0.1-0.1-0.1-0.1c0,0,0-0.1,0.1-0.1c0.2-0.1,0.4,0.3,0.7,0 c0.4-0.3,0.3-1.2,1.1-1c0.1,0,0.3,0,0.4,0.1c0.1,0.1,0.1,0.2,0.1,0.3c0,0.2,0,0.5-0.1,0.7c0,0.3,0.1,0.6-0.1,0.8 c-0.4,0.2-0.8,0-1.2-0.1C28.3,23.5,28.1,23.5,28,23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M30.6,56.8c0.4-0.1,0.7-0.4,1.1,0c-0.3,0.6,0.6,0.2,0.5,0.6c0,0.3-0.1,0.5-0.3,0.6c-0.5,0-0.7,0.5-1.2,0.5 c-0.2-0.1-0.3-0.3-0.2-0.5c0-0.1,0-0.1,0-0.2l0,0C30.3,57.6,30.3,57.2,30.6,56.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M49.3,47.4c-0.1,0-0.3,0-0.3-0.2c0-0.2,0.4-0.4,0.1-0.6c-0.3-0.2-0.5,0.1-0.7,0.3c-0.2,0.1-0.2,0.4-0.4,0.5 c-0.1-0.1-0.2-0.2-0.2-0.4c0-0.1,0-0.3,0.1-0.4c0.1-0.2,0.3-0.4,0.3-0.7c0.1-0.3,0.3-0.4,0.6-0.4c0.5-0.2,0.7,0,0.8,0.4 c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0.1,0.3,0.1,0.4C49.8,46.9,49.7,47.2,49.3,47.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M15.7,36.8c-0.3-0.4-0.9-0.8,0.2-0.6c0.4,0,0-0.6,0.4-0.7c0.1-0.1,0.1-0.1,0.2,0c0,0.1,0.1,0.1,0.1,0.2 c0-0.1,0-0.1-0.1-0.2c0-0.1,0-0.1,0-0.2c0.1-0.1,0.1-0.1,0.2-0.2c0.2-0.2,0.3-0.3,0.6-0.3c0.1,0.1,0.1,0.1,0.2,0.2 c0,0.1,0,0.2,0,0.3c-0.1,0.3-0.2,0.5-0.3,0.8c-0.2,0.3,0,0.8-0.2,1.1c-0.1,0-0.3,0-0.4,0C16.4,36.9,16,37,15.7,36.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M34.3,53.6c0.5,0.2,0.4,0.7,0.4,1.1c0.1,0.1,0.1,0.2,0.1,0.2c0,0.1,0,0.2-0.1,0.2c-0.1,0-0.2,0-0.2,0 c-0.2-0.1-0.1,0.1-0.2,0.1c-0.6,0.7-1-0.2-1.5-0.1c-0.1-0.1-0.1-0.1-0.1-0.2c0-0.2,0.2-0.4,0.3-0.6c0.1-0.1,0.1-0.1,0.2-0.2 c0.2-0.2,0.4-0.4,0.7-0.5C34,53.6,34.1,53.6,34.3,53.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M12.5,25.6c0.6,0.2,1,0.7,1.7,0.4c0.1-0.1,0.3-0.1,0.4-0.3c0.1,0,0.2,0,0.3,0c0.1,0.1,0.2,0.2,0.2,0.3 c0,0.1,0,0.2-0.1,0.2c-0.2,0.2-0.5,0.1-0.7,0.4c-0.3,0.9-0.3,0.9-0.8,0.6c-0.4-0.7-0.8-0.7-1.4-0.2c-0.1,0-0.2,0.1-0.3,0.1 c-0.1-0.1-0.3-0.1-0.3-0.3c0-0.1,0-0.2,0-0.3c0.3-0.3,0.5-0.5,0.7-0.9C12.4,25.7,12.4,25.6,12.5,25.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M35.1,53.8c0.1-0.3,0.1-0.6,0.2-0.9c0.2-0.2,0.4-0.1,0.6,0c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0,0.1,0.1,0.2,0.2 c0.1,0.1,0.3,0.1,0.4,0.1c0.3,0,0.7-0.2,1,0.1c0.1,0.4-0.1,0.6-0.3,0.9c-0.2,0.1-0.4,0.1-0.5,0.1c-0.2,0-0.3,0-0.5-0.1 c-0.1,0-0.2,0-0.3,0.1c-0.1,0-0.2,0-0.2,0c-0.1,0-0.1-0.1-0.2-0.2C35.6,54.2,35.3,54,35.1,53.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M9.7,25.2c0.6-1.4,0.8-1.5,1.9-1.1c0,0.5-0.5,0.2-0.7,0.3c-0.2,0.1-0.2,0.2-0.2,0.4c0,0.1-0.1,0.2-0.1,0.2 c-0.1,0.2,0.2,0,0.2,0.1c0.1,0.1,0.2,0.3,0.2,0.4c-0.1,0.5-0.4,0.7-0.9,0.8C9.7,26,9.5,25.7,9.7,25.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M29.7,39c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c0,0,0.1,0.1,0.1,0.1 c0,0,0.1,0.1,0.2,0c0.1-0.2,0.1-0.5,0.3-0.6c0.1-0.1,0.3,0,0.4,0.1c0,0.6-0.2,1.2-0.9,1.4c-0.3,0.1-0.6,0.4-0.6,0.8 C30.1,41,30,41,29.9,41c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1-0.4-0.2-0.9-0.2-1.3C29.5,39.1,29.6,39,29.7,39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M23.1,46.9c0-0.2,0-0.4,0-0.6c0.2-0.3,0-0.6,0.2-0.9c0-0.3,0-0.6,0.1-0.9c0.2-0.3-0.1-0.7,0.2-0.9 c0.1,0,0.2,0,0.2,0.1c0.1,0.2,0.2,0.5,0.2,0.8c0,0.1,0,0.2,0,0.3c0,0.2-0.1,0.3-0.1,0.5c0,0.2,0,0.3,0.1,0.4c0.1,0,0.1,0.1,0.2,0.2 c0.1,0.1,0.1,0.2,0.1,0.4c0,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.1,0.1-0.2,0.2c0,0-0.1,0.1-0.1,0.1c-0.1,0.1-0.2,0.3-0.2,0.4 c0,0.2,0,0.3,0,0.5c0,0,0,0.1,0,0.1c0,0.1-0.1,0.2-0.1,0.2c-0.1,0-0.2,0-0.3,0c0,0-0.1,0-0.1-0.1C23,48,23,47.9,23,47.8 C23,47.5,22.9,47.2,23.1,46.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M35.3,48.2c-0.1,0-0.3,0-0.4,0c-0.1-0.1-0.1-0.2-0.1-0.3c0.2-0.5,0.4-1,1.1-0.9c0-0.3-0.9-0.6-0.2-1.2 c0.4,0.4,0.6,0.8,0.8,1.3c0.1,0.4,0.1,0.8-0.3,1C35.9,48.4,35.6,47.8,35.3,48.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M33.4,45.4c0.6-0.1,1.2,0.1,1.7,0.4c0,0.2-0.1,0.4-0.1,0.6c-0.2,0.2,0,0.4,0,0.6c0,0.1,0,0.3-0.1,0.4 c-0.1,0.3-0.3,0.5-0.6,0.5c-0.4-0.1-0.4-0.4-0.5-0.6c-0.1-0.3,0-0.6,0-0.9c0-0.2-0.1-0.3-0.2-0.4c-0.1-0.1-0.2-0.1-0.3-0.2 C33.3,45.6,33.3,45.5,33.4,45.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M20.3,42c0.2-0.4,0.9-0.3,0.9-0.9c0,0,0.1-0.1,0.1-0.1c0.1-0.1,0.3-0.2,0.5-0.2c0.1,0,0.3,0.1,0.3,0.2 c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2-0.1,0.3c0,0.1-0.1,0.2-0.2,0.2c-0.3,0.2-0.6,0.3-0.7-0.2 c0.1-0.1,0.1-0.3,0.3-0.1c-0.2-0.2-0.2,0.1-0.2,0.1c-0.1,0.5,0,1.1-0.6,1.4c-0.3-0.1-0.5-0.3-0.7-0.6C20.1,42.4,20.5,42.3,20.3,42z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M21.8,17.2c-0.3,0.2-0.6,0.5-0.8,0.7c-0.2-0.1-0.3-0.2-0.4-0.4c0-0.2,0-0.4,0.1-0.6c0.2-0.3,0.4-0.4,0.8-0.5 c0.1,0,0.3,0,0.4,0c0.1-0.1,0.1-0.1,0.2-0.2c0.7-0.6,0.6,0.2,0.9,0.4c0,0.1,0,0.1,0,0.2c-0.1,0-0.2,0-0.3,0c0,0-0.1,0-0.1,0 c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0-0.1,0.1-0.2,0.1C21.9,17.1,21.8,17.2,21.8,17.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M24.6,67.6c-0.1,0.1-0.1,0.1-0.2,0.2c-0.2-0.6,0.3-1.8,0.9-2.2c0.7-0.4,1.2,0,1.7,0.4 c-0.1,0.2-0.3,0.3-0.5,0.3c-0.5-0.1-1-0.1-1.1,0.6C25.1,67.2,24.8,67.4,24.6,67.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M21.6,68.9c-0.1-0.9-0.1-1.9,0.2-2.8c0.1-0.1,0.2-0.2,0.3,0c0.1,1.1,0.2,2.2-0.4,3.2 C21.6,69.2,21.7,69,21.6,68.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M21.6,55.3c0.3,0.1,0.4,0.3,0.4,0.7c0.1,0,0.1,0.1,0.1,0.2c0,0.1,0,0.1,0,0.1c-0.4,0.2-0.4,0.4-0.2,0.7 c0,0.5-0.2,0.9-0.5,1.2c-0.1,0.1-0.3,0.1-0.5,0c-0.2-0.1-0.4-0.4-0.3-0.6c0.1-0.6,0.2-1.2,0.5-1.8C21.1,55.5,21.3,55.4,21.6,55.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st70",
    d: "M22.2,6.6c0-0.1,0-0.1,0-0.2c0.1-0.1,0.1-0.2,0.2-0.2c0-0.1,0-0.1,0-0.2c0.3-0.2,0.6-0.5,0.8-0.8 c0.3,0,0.6-0.2,0.9,0.2c0.2,1,0.2,1-1.2,1.4C22.4,7,22.4,7,22.2,6.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M20.3,9.2c0.3,0.3,0.5,0.5,0.8,0c0.1-0.1,0.2-0.1,0.3,0c0.1,0.3,0,0.5-0.1,0.7c-0.2,0.5-0.1,1.1-0.5,1.6 c-0.1,0.1-0.2,0.1-0.3,0.2c-0.2,0.1-0.4,0-0.6-0.1c-0.4-0.7,0.3-1.3,0.2-1.9c0-0.1,0-0.3,0.1-0.4C20.2,9.3,20.2,9.3,20.3,9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M3.3,29.5c-0.1,0.2-0.3,0.3-0.4,0.3c-0.7-0.3-1.2,0.3-1.7,0.6c0.2-1.1,0.6-1.5,1.5-1.7 C2.8,29,3,29.2,3.3,29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M22.2,6.6c0.4,0.5,0.4-0.2,0.7-0.2c0.2,0.5,1.1-0.2,1.1,0.6c0,0.1,0,0.1,0,0.2c-0.4,0.3-1.1,0.3-1.5,0.6 c-0.2,0-0.4,0-0.7,0C21.8,7.5,21.6,6.9,22.2,6.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M8.4,108.3c-0.2-0.6-0.4-1.2,0-1.7c0.5-0.3,0.6,0.2,0.8,0.4c0.1,0.1,0.2,0.1,0.3,0.1c0.2,0,0.5-0.2,0.4,0.2 c0,0.1,0,0.2,0,0.4c0,0.1-0.1,0.2-0.2,0.3C9.6,108,9.5,108,9.4,108c-0.2,0-0.2,0.1-0.2,0.2c-0.1,0.1-0.1,0.1-0.2,0.2 C8.7,108.5,8.5,108.5,8.4,108.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M28,62.9c0.4,0.2,0.7-0.1,1-0.3c0.2-0.3,0.4-0.5,0.7-0.1c0.1,0.5,0.3,1,0.4,1.5c-0.2,0.8-0.5,0.4-0.9,0.1 c-0.3-0.4-0.9-0.3-1.2-0.8C28,63.2,28,63,28,62.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st72",
    d: "M9.7,7.3c0.5,0.4,0.8,1,0.9,1.6c0.1,0.4,0.4,0.8,0.6,1.2c-0.1,0.1-0.2,0.1-0.4,0.1c-0.3-0.1-0.5-0.4-0.7-0.6 c0-0.1-0.1-0.1-0.1-0.2c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.2c0-0.1-0.1-0.2-0.2-0.2C9.7,8.6,9.5,8.5,9.3,8.4C9,7.8,9.2,7.5,9.7,7.3 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M34.7,47.1c0.1-0.1,0.1-0.1,0.2-0.2c0.1-0.1,0-0.3,0-0.4c-0.2-0.3-0.1-0.5,0.2-0.7c0.2,0,0.4,0,0.6,0 c-0.3,0.5,0.4,0.8,0.4,1.3c-0.8-0.4-0.7,0.7-1.2,0.8c-0.2-0.1-0.1-0.3-0.1-0.4c0-0.1,0.1-0.2,0.1-0.3 C34.8,47.3,34.7,47.2,34.7,47.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st73",
    d: "M34.7,21.3c0.4,0.1,0.6,0.7,1.1,0.6c0,0.1,0.2,0.3,0,0.4c-0.3,0.3-1.1,0-1,0.8c0,0.1,0.1,0.3,0.1,0.4 c0.1,0.1,0.1,0.2,0.1,0.3c-0.1,0.2-0.3,0.3-0.5,0.2c-0.1,0-0.2-0.1-0.3-0.1c-0.1-0.1-0.1-0.2-0.2-0.2c-0.1-0.3-0.2-0.7-0.2-1 c0-0.3,0.1-0.5,0.3-0.8c0-0.1,0.1-0.1,0.2-0.2C34.4,21.5,34.6,21.4,34.7,21.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st74",
    d: "M45.7,58.1c-0.4-0.1-0.8-0.3-1.3-0.2c0,0-0.1,0-0.1,0c-0.1,0-0.2-0.1-0.2-0.1c-0.1-0.1-0.1-0.2,0-0.4 c0.2-0.2,0.3-0.4,0.5-0.6c0.2-0.1,0.5-0.1,0.7-0.2c0.1,0,0.3,0.1,0.3,0.2c0.2,0.2,0.1,0.5,0.3,0.7l0,0C46.1,57.8,46,58,45.7,58.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M19.6,59.2C19.2,59,19,58.6,19,58.1c0.3-0.3,0.6,0.1,1,0c0.3,0.1,0.6,0.1,0.8,0.1c0.2,0.1,0.3,0.3,0.3,0.5 c0,0.3-0.1,0.5-0.3,0.7c-0.2,0.2-0.4,0.3-0.7,0.1c0-0.1,0-0.1,0-0.2C19.9,59.4,19.9,59.1,19.6,59.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M14,11c0.5,0,1,0.3,1.5,0.2c0.1,0.1,0.1,0.3,0.1,0.4c-0.8,0-0.3,0.6-0.4,1c-0.1,0.2-0.3,0.2-0.5,0.2 c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.2-0.1-0.4-0.1c-0.1,0-0.3-0.1-0.4-0.1c-0.1-0.1-0.2-0.2-0.1-0.3c0-0.1,0-0.3,0-0.4 c0,0,0-0.1,0.1-0.1c0.1-0.2,0.2-0.3,0.3-0.5C13.9,11,14,11,14,11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M24.4,22c0,0.3,0,0.6,0,0.9c0.1,0.1,0.2,0.3,0.2,0.4c-0.1,0.1-0.2,0.3-0.2,0.4l0,0c-0.1,0.1-0.1,0.2-0.2,0.3 c-0.1,0.1-0.1,0.2-0.2,0.4c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0-0.2,0-0.3,0.1c-0.3,0-0.6,0.1-0.8-0.1c-0.1-0.1-0.1-0.2-0.1-0.3 c0-0.2,0.1-0.3,0.2-0.4c0.3-0.2,0.5-0.4,0.7-0.7C23.9,23,23.6,22.1,24.4,22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M9.7,7.3C9.6,7.6,9.1,7.9,9.5,8.4c0,0.2-0.1,0.3-0.2,0.4c-0.1,0-0.1,0-0.2,0C8.9,8.6,8.7,8.3,8.7,8 c0-0.4-0.2,0.1-0.3,0C8.3,8,8.3,8,8.2,8C8,7.8,8,7.6,8.1,7.4c0.1-0.2,0.3-0.3,0.2-0.6c0-0.2,0-0.5,0.2-0.6c0,0,0.1,0,0.1,0 C8.9,6.7,9.5,6.8,9.7,7.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M31,21.5c0.4,0.2,0.5,0.7,0.9,1.1c0.1,0.1,0.1,0.1,0.1,0.2c0,0.1,0,0.2,0,0.4c0,0.1-0.1,0.2-0.1,0.2 c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.2-0.1,0.6-0.5,0.4c-0.2-0.1-0.2-0.3-0.3-0.5c-0.1-0.4-0.1-0.7-0.2-1.1c0-0.1,0-0.2,0-0.3 c0-0.2,0.1-0.4,0.2-0.5C30.9,21.6,31,21.6,31,21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M38.1,50.4c0.2-0.5,0.5-0.9,0.9-1.3c0.4,0.1,0.4-0.3,0.6-0.5c0.3,0,0.4,0.1,0.4,0.3c0.1,0.2,0.1,0.4,0.1,0.6 c-0.2,0.3-0.4,0.5-0.7,0.5c-0.1,0,0.1,0.1,0.1,0.2c-0.2,0.4-0.5,0.5-0.9,0.5c-0.2,0-0.3,0-0.5-0.1C38.1,50.6,38.1,50.5,38.1,50.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M35.1,67.6c-1.1-0.3-1.9-1-2.8-1.5c0.2-0.2,0.4-0.2,0.7-0.3c0.3,0,0.5-0.1,0.8,0c0.2,0.1,0.3,0.3,0.5,0.5 c0.2,0.3,0.5,0.4,0.8,0.6C35.1,67.2,35.3,67.4,35.1,67.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M31.9,22.8c0-0.1,0-0.2,0-0.2c0.1,0,0.1,0,0.2,0c0.4-0.1,0.4-0.9,1.1-0.6c0.1,0.1,0.2,0.1,0.3,0.2 c0.2,0.1,0.4,0.2,0.5,0.4c-0.1,0.4,0.2,0.7,0.2,1.1c-0.1,0.1-0.1,0.1-0.2,0.1c-0.2,0-0.3,0-0.5,0c-0.1,0-0.2,0-0.2-0.1 c-0.1-0.1-0.2-0.2-0.3-0.3c-0.2-0.3-0.6-0.3-0.9-0.5C32,22.9,32,22.9,31.9,22.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M16.8,39.6C16.8,39.6,16.8,39.6,16.8,39.6C16,40,17,38.9,16.3,39.1c-0.6,0.2-0.5-0.2-0.5-0.6 c0.4-0.3,0.8-0.5,1.3-0.4c0.2,0.3,0.5,0.5,0,0.8C16.8,39,16.8,39.4,16.8,39.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M47.8,43.9c0.4,0.6,0.1,1.3,0.3,1.9c0,0,0,0.1-0.1,0.1c-0.1,0.1-0.2,0.2-0.4,0.2c-0.2,0-0.4,0-0.6-0.1 c-0.2-0.1-0.7,0-0.4-0.5c0.2-0.2,0.6-0.3,0.5-0.8c0-0.2-0.1-0.5,0.1-0.7C47.4,43.9,47.6,43.8,47.8,43.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M25.2,12.5c-0.4,0.6,0.1,1.4-0.4,1.9c-0.2-0.1,0-0.6-0.4-0.4l0,0c-0.2-0.4-0.2-0.9-0.5-1.3 c-0.1-0.2,0-0.3,0.1-0.4C24.4,12.2,24.8,12.2,25.2,12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M11.4,12.5c0,0.3,0,0.7,0,1c0,0.3,0.1,0.5,0.4,0.5c0.4,0.6-0.3,0.6-0.4,0.9C10.6,14,10.6,13.4,11.4,12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M12.5,21.5c-0.5,0-0.5-0.6-0.8-0.7c-0.1,0-0.2-0.1-0.2-0.2c0-0.1,0-0.3,0-0.4c0.1-0.2,0.3-0.3,0.5-0.3 c0.1,0,0.2,0,0.3,0.1c0.1,0.2,0.2,0.3,0.2,0.5c0-0.2-0.2-0.4,0-0.6c0.2-0.1,0.4-0.1,0.6,0c0.3,0.3,0.2,0.7,0.2,1 C13.1,21.3,13,21.6,12.5,21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M9.1,23.9c0,0.5-0.3,0.5-0.7,0.5c-0.1-0.1-0.3-0.2-0.4-0.3C8,23.9,8,23.8,8,23.7c0-0.1-0.1-0.2-0.1-0.2 c0-0.1-0.1-0.2-0.1-0.3c0-0.2,0-0.4,0-0.6c0.1-0.2,0.1-0.4,0.4-0.3C8.5,22.8,9.2,23.1,9.1,23.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M9.7,17.4c0.5-1.4,0.9-1.7,2-1.3c-0.1,0.2-0.2,0.5-0.3,0.7c-0.2,0.3-0.6,0.4-1,0.6 C10.2,17.5,9.9,17.6,9.7,17.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st78",
    d: "M33,34.4c0.4-0.6-0.4-0.3-0.4-0.6c0.4,0,0.9,0,1.3,0c0.4,0.1,0.6,0.5,1.1,0.4c-0.5,0.3-0.7,0.7-1.1,1.1 c-0.9-0.2,0-0.4,0-0.6c0-0.1,0-0.3-0.2-0.2c-0.1,0-0.3,0-0.4,0c0,0-0.1,0.1-0.1,0.1C33,34.5,33,34.5,33,34.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st79",
    d: "M30.2,60.9c-0.4-0.1-1,0-1.3-0.4c0-0.1,0-0.3,0-0.4c0.5-0.1,0.9-0.7,1.5-0.4c0,0.2,0,0.3,0,0.5 c0,0.1,0.1,0.3,0.1,0.4c0,0.1,0,0.3-0.1,0.4C30.3,61,30.3,61,30.2,60.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M10,107.3c-0.3-0.4-0.3,0.3-0.5,0.2c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1-0.1-0.1-0.2-0.1-0.3 c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1-0.1-0.1-0.2-0.2-0.3c0-0.1,0-0.3,0-0.4c0.1-0.1,0.1-0.1,0.2-0.2 c0.1-0.1,0.2-0.2,0.3-0.2c0.2-0.1,0.4-0.2,0.7,0c0.2,0.1,0.2,0.3,0,0.5c-0.1,0-0.1,0.1-0.2,0.2c0,0.1,0,0.2,0.1,0.2 C9.8,106.5,10.3,106.9,10,107.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M27.2,71.5c-0.1-0.3-0.5-0.3-0.4-0.7c0-0.1,0.1-0.4,0.2-0.3c0.5,0.3,0.9-0.3,1.4-0.1c0,0.1,0.1,0.2,0.1,0.2 c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.1,0.2-0.2,0.4c-0.2,0.2-0.3,0.5-0.6,0.6C27.4,71.8,27.2,71.7,27.2,71.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M42,45.2c0.2,0,0.4,0,0.6,0c0.4,0.2,0.7,0.5,0.7,0.9c0.1,0.2,0,0.4-0.1,0.6c0,0.1-0.1,0.2-0.1,0.2 c-0.1,0-0.2,0-0.3,0c-0.1-0.1-0.2-0.1-0.3-0.2c-0.2-0.1-0.3-0.2-0.5-0.3c-0.2-0.1-0.5-0.2-0.6-0.5c0-0.1,0.1-0.2,0.1-0.2 C41.7,45.6,41.9,45.5,42,45.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M13.2,20c-0.2,0-0.4,0-0.6,0c-0.1,0.1-0.3,0.1-0.4,0l0,0c-0.2-0.6-0.6-0.2-0.9-0.2c-0.1,0-0.1,0-0.2,0 c-0.2-0.3-0.1-0.5,0.1-0.7c0.4-0.3,0.5-0.7,0.7-1c0.2-0.1,0.4,0,0.5,0.1c0,0.3,0.1,0.5,0.4,0.7c0.2,0.3,0.4,0.6,0.5,1 C13.2,19.9,13.2,20,13.2,20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st82",
    d: "M10.2,110.7c0,0.2,0,0.4,0,0.6c0.1,0.5-0.2,0.7-0.5,0.9c-0.4,0.3-0.6,0-0.8-0.3c-0.3-0.6,0.3-0.8,0.6-1.1 C9.7,110.7,9.9,110.5,10.2,110.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M30.2,39.2C30.1,39.1,30,39,30,39l0,0c0.1-0.1,0.1-0.1,0.2-0.2c0.2-0.4,0.2-1,0.8-1.1c0,0.4,0.3,0.4,0.5,0.7 c0.1,0.1,0.4,0.2,0.2,0.4l0,0c-0.1,0-0.3,0-0.4,0c-0.2,0.2-0.3,0.5-0.6,0.4c-0.1,0-0.1,0-0.2,0C30.3,39.3,30.2,39.3,30.2,39.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M23.9,7.1c-0.1-0.2-0.2-0.5-0.5-0.2c-0.6,0.4-0.5-0.1-0.5-0.4c0.4-0.2,0.8-0.1,1.2-0.2c0.1-0.3,0-0.6,0.1-0.9 c0.5,0.4,0.4,1,0.4,1.5C24.3,6.9,24.1,7,23.9,7.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M16.6,6.2C16.7,6.3,17.2,6,17,6.5c-0.1,0.3,0.3,0.3,0.5,0.3c0,0.1,0,0.2,0,0.3c-0.3,0.3-0.6,0.6-1,0.9 c-0.3,0.1-0.6,0.1-0.9,0.1c0,0-0.1,0-0.1,0c0,0-0.1-0.1-0.1-0.1c0-0.3,0-0.6,0-0.9c0.1,0,0.1,0,0.2,0C16.1,7.1,16.3,6.6,16.6,6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M33.2,22.2c-0.1,0-0.4-0.2-0.4,0c-0.1,0.4-0.4,0.4-0.7,0.4c0.3-0.7,0.6-1.3,1.1-1.9c0.5-0.3,0.6,0.1,0.7,0.5 c0,0.1,0,0.2-0.1,0.3C33.6,21.6,33.3,21.9,33.2,22.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M14.8,86.5c0-0.1,0-0.2,0.1-0.3c0.1-0.1,0.1-0.3,0.2-0.5c0-0.1,0-0.1,0.1-0.2c0.1-0.1,0-0.3,0.2-0.4l0,0 c0.1-0.1,0.2-0.1,0.2-0.3l0,0c0.2-0.1,0.1-0.3,0.2-0.4l0,0c0.1-0.1,0.1-0.1,0.2-0.1c0.1,0,0.2,0,0.2,0.1c0,0,0,0.1,0.1,0.1 c0,0,0,0.1,0,0.1c0,0.1,0,0.2,0,0.4c0,0.1,0,0.2,0,0.3c0,0.1-0.1,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.2,0.2c0,0.1-0.1,0.1-0.1,0.1l0,0 c-0.1,0.2-0.3,0.3-0.4,0.5l0,0c-0.2,0.2-0.1,0.4-0.1,0.6c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.3,0.3-0.5,0.1c-0.1-0.1-0.1-0.3,0-0.4 c0-0.1,0-0.1,0-0.2C14.8,86.7,14.9,86.6,14.8,86.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M39.2,47.2c0.1-0.2,0.2-0.5,0.4-0.7c0.1-0.1,0.2-0.1,0.4-0.1c0.1,0,0.2,0,0.3,0.1c0.2,0.1,0.5,0.1,0.7,0.3 c0,0.1,0,0.2,0,0.2c-0.1,0-0.1,0-0.2,0c0,0.1,0.2,0.1,0.2,0.2c0.1,0.1,0.1,0.3,0,0.4c-0.2,0.2-0.5,0.2-0.7,0.5 c-0.1,0-0.2,0.1-0.3,0.1c-0.3,0-0.5-0.1-0.7-0.4c-0.1-0.1,0.2-0.2,0-0.3C39.3,47.4,39.3,47.2,39.2,47.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st84",
    d: "M9.5,110.9c0,0.5-0.7,0.5-0.6,1.1c-0.4-0.6-0.9-1.2-0.5-2c0.2,0.3,0.3-0.2,0.4-0.1c0.1,0,0.3,0,0.4,0 c0.1,0.1,0.1,0.1,0.1,0.2c0,0.1-0.1,0.2-0.2,0.3c0,0-0.1,0.1-0.1,0c0,0.1,0,0.1,0.1,0.1c0.1,0,0.1,0.1,0.1,0.1 C9.4,110.7,9.5,110.8,9.5,110.9C9.5,110.8,9.5,110.9,9.5,110.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.3,40.9c0.3-0.2,0.6-0.5,1.1-0.4c0.1,0.1,0.1,0.2,0.2,0l0,0c0.2-0.2,0.4-0.2,0.6,0l0,0c-0.2,0.6-0.6,1-1.3,1 C9.7,41.3,9,41.6,9.3,40.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M33.2,66.1c-0.3,0-0.6,0-0.9,0c-0.3,0-0.6-0.2-0.9-0.1c-0.3-0.6,0.1-0.9,0.5-1.1C32.7,65,33.3,65.1,33.2,66.1 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M37.1,63.5c0,0.1,0,0.1,0,0.2c-0.1,0-0.1,0-0.2,0c-0.1,0.1-0.2,0.1-0.2,0.2c-0.1,0.2-0.1,0.4,0,0.6 c0.1,0.2,0,0.4-0.2,0.5c-0.1,0-0.2,0-0.3,0c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1-0.2,0-0.5-0.2-0.7c-0.1-0.1-0.2-0.2-0.2-0.3 c0.1-0.2-0.1-0.5,0.1-0.7c0.2-0.1,0.4-0.1,0.5-0.1c0.2,0,0.4,0.1,0.5,0.2C36.8,63.2,36.9,63.4,37.1,63.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st86",
    d: "M45,45.2c-0.1,0.2-0.2,0.4-0.5,0.3c-0.2-0.1-0.4-0.2-0.3-0.4c0.1-0.2,0-0.3-0.1-0.5c0-0.5,0.2-1,0.7-1.3 c0.5,0.3-0.1,0.8,0.2,1.1C44.7,44.6,44.8,44.9,45,45.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M28.4,44.1c0.3-0.1,0.1-0.5,0.5-0.7c0.2,0.3,0.6,0.3,0.9,0.4l0,0c0,0.4,0.3,0.7,0.2,1.1l0,0 c-0.1,0.1-0.3,0.1-0.4,0.2c-0.1,0-0.3,0-0.4,0c-0.1,0-0.2,0-0.2,0c-0.1-0.1-0.3-0.2-0.4-0.4C28.4,44.6,28.2,44.4,28.4,44.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st88",
    d: "M32.8,29.9c0,0.1,0,0.1,0,0.2c-0.1,0.2-0.3,0.3-0.4,0.4l-0.1,0l-0.1,0c-0.2,0.2-0.4,0.3-0.6,0.4 c-0.1,0.2-0.3,0.2-0.4,0.2c0,0-0.1-0.1-0.1-0.1c0,0,0-0.1,0-0.1c0.1-0.1,0.1-0.1,0-0.2c0,0,0,0-0.1,0c-0.1,0-0.1-0.1-0.1-0.2 c0-0.1,0-0.2,0.1-0.2c0.2-0.1,0.4-0.2,0.6-0.3c0.2-0.1,0.4-0.2,0.6-0.3c0.2-0.1,0.3-0.3,0.4-0.5c0.1-0.1,0.1-0.1,0.2-0.2 c0.1-0.1,0.3-0.2,0.5-0.2c0.1,0,0.3,0,0.4,0.1l0.1,0c-0.2,0.2-0.2,0.5-0.5,0.6C32.9,29.8,32.8,29.9,32.8,29.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M29.3,20.9c0.3-0.5,0.7-0.8,1.3-0.6c0.4,0.1,0.5,0.5,0.4,0.8C30.4,21.5,29.8,21.6,29.3,20.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st90",
    d: "M35.4,52.5c0.1-0.5,0.1-1,0.6-1.3c0.2-0.1,0.2,0,0.3,0.1c0.1,0-0.2,0.3,0.1,0.1c0.1-0.1,0.2-0.1,0.2-0.2 c0.3-0.1,0.6-0.1,0.9-0.1c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.1,0.1,0.2,0.2c0,0.2-0.1,0.4-0.3,0.4c-0.1,0-0.2,0-0.3,0 c-0.1,0-0.2,0-0.2,0c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.3,0.2-0.4,0.2c-0.1,0-0.2,0-0.3,0C36,52.3,35.8,52.7,35.4,52.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M16.6,49.9c0.8,0.5,0.8,0.6,0.2,1.3C16.3,51,16,50.5,15.7,50l0,0C16,49.7,16.3,49.7,16.6,49.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M10.2,110.7c-0.2,0.1-0.5,0.1-0.7,0.2l0,0c-0.1-0.1-0.1-0.1-0.2-0.2l0,0c-0.1,0-0.1-0.1-0.1-0.2 c0.1-0.1,0.2-0.1,0.2-0.2c0-0.1,0-0.1,0-0.2c0-0.1-0.1-0.2-0.2-0.3c-0.1-0.1-0.3-0.1-0.4-0.3c0-0.1,0-0.2,0-0.4 c0.1-0.1,0.2-0.2,0.3-0.2c0.1-0.1,0.2-0.1,0.3-0.2c0.4-0.1,0.4,0.2,0.4,0.5c0,0.1-0.1,0.3,0.1,0.4C10.3,110,10.5,110.3,10.2,110.7z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st92",
    d: "M11.2,16.8c0-0.3,0-0.7,0.5-0.7c0.2,0,0.5,0,0.6,0.2c0.2,0.4,0.4,0.8-0.1,1.2C11.6,17.7,11.4,17.3,11.2,16.8z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "M37.1,67c0.4-0.1,0.8-0.3,1.3-0.4c-0.1,0.9-0.3,1.1-1.3,1.3c-0.1-0.1-0.1-0.2-0.2-0.3 C36.8,67.3,36.9,67.1,37.1,67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M37.5,51.5c-0.4,0-0.7,0-1.1,0c-0.1,0.1-0.1,0.1-0.2,0c-0.1-0.1-0.1-0.1-0.2-0.2c0.1-0.9,0.8-0.6,1.3-0.6 C37.5,50.8,37.7,51.1,37.5,51.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M39,70.8c0.1,0,0.3,0,0.4,0c0.2-0.1,0.3,0,0.4,0.2c0.3,0.2,0.6,0.4,0.9,0.6c-0.1,0.3-0.4,0.2-0.6,0.2 c-0.3,0-0.6-0.2-1-0.1c-0.2,0-0.4,0.1-0.5-0.1c-0.2-0.3,0-0.5,0.2-0.7C38.9,71,38.9,70.9,39,70.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M42.4,62.9c0-0.3-0.1-0.4-0.4-0.2c-0.2,0.1-0.5,0.4-0.7,0c-0.3-0.4,0.2-0.4,0.2-0.7c0-0.1,0-0.1,0-0.2 c0-0.2,0-0.2,0.2-0.2C42.1,61.9,43,62.1,42.4,62.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M20.3,55.8l-0.1,0l-0.1,0c0.1-0.7,0.1-1.5-0.9-1.7c0.7-0.8,1.2,0,1.7,0.2c0.1,0,0.2,0.1,0.2,0.2 c0,0.4-0.2,0.8-0.6,1C20.4,55.6,20.4,55.7,20.3,55.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M29.3,20.9c0.5,0.3,1.1,0.2,1.7,0.2c0,0.1,0,0.3,0,0.4c0,0.1,0,0.2,0,0.2c-0.1,0.1-0.2,0.1-0.3,0.1 c-0.4-0.2-0.7-0.2-1.1,0c-0.2,0-0.4-0.1-0.6,0c-0.2,0-0.3-0.1-0.4-0.3C28.8,21.2,29,21,29.3,20.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st95",
    d: "M35.1,67.6c-0.1-0.2-0.2-0.4-0.2-0.7c0.1-0.5,0.2-1,0.8-1.1c0.2,0.1,0.3,0.2,0.3,0.4 c-0.1,0.2-0.3,0.3-0.1,0.5c0,0.1,0,0.1,0,0.2c0,0.2,0,0.4-0.1,0.6c0,0.1-0.1,0.1-0.2,0.2C35.5,67.8,35.3,67.9,35.1,67.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st96",
    d: "M19.4,1.5c-0.5-0.2-0.8,0.4-1.3,0.4C18,1.9,18,1.8,18,1.7c0-0.1,0-0.2,0-0.3c0-0.1,0-0.1,0-0.2 c0.1-0.1,0.1-0.1,0-0.2c0-0.3,0.1-0.5,0.4-0.6c0.1,0.1,0.2,0.2,0.2,0.3c-0.2,0.6,0.1,0.6,0.5,0.4c0.3-0.2,0.6-0.5,0.6,0.1 C19.7,1.5,19.6,1.6,19.4,1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M26.7,48.4c-0.1,0.1-0.1,0.1-0.2,0.2c-0.2,0.1-0.4,0.1-0.6,0.1c-0.1,0-0.2-0.1-0.2-0.2 c-0.1-0.2-0.2-0.4-0.4-0.5c-0.1-0.2-0.2-0.4-0.5-0.5c-0.1-0.1-0.1-0.1-0.2-0.2c0-0.1,0-0.2,0.1-0.3c0.1-0.1,0.3-0.2,0.5-0.3 c0.1,0,0.3,0,0.4,0.1c0.3,0.3,0.4,0.8,0.9,0.9c0.1,0.1,0.2,0.1,0.2,0.2C26.9,48.2,26.8,48.3,26.7,48.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M22.8,43.1c-0.2,0.8-0.9,0.3-1.3,0.4c-0.3-0.5-0.2-0.9,0.3-1.1c0.1-0.1,0.2-0.1,0.3-0.1 C22.6,42.3,22.7,42.8,22.8,43.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "M50.8,44.8c1.1,0,1.5,0.4,1.3,1.3c-0.2,0.2-0.4,0.2-0.7,0.2c-0.3-0.1-0.3-0.4-0.3-0.7 c-0.1-0.1-0.1-0.2-0.2-0.3C50.9,45.1,50.8,45,50.8,44.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M9.1,36.4c0-0.4,0.2-0.7,0.5-0.9c0.2-0.1,0.4-0.5,0.7-0.3c0.3,0.2,0,0.5-0.1,0.7c0.1,0.1,0.1,0.3,0,0.4 C9.8,36.4,9.4,36.4,9.1,36.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M22,42.4c-0.5,0.2-0.4,0.6-0.4,1.1c-0.3,0.1-0.5-0.2-0.8-0.2c0.1-0.5,0.3-1,0.6-1.5l0,0 c0,0.6,0.3,0.4,0.6,0.2C22.1,42.1,22.1,42.3,22,42.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M10.8,32.3c0-0.1-0.1-0.2-0.2-0.2c-0.1-0.2,0.1-0.3,0.2-0.3c0.1,0,0.2,0,0.2,0c0.1,0,0.2,0,0.4,0 c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.2-0.1,0.2-0.1c0.1,0,0.2,0.1,0.3,0.2c0.1,0.1,0.3,0.2,0.5,0.2c0.1,0.1,0.2,0.1,0.4,0.2 c0.1,0.1,0.1,0.1,0.2,0.2c0.1,0.1,0.1,0.3,0,0.4c-0.1,0.1-0.1,0.1-0.2,0.1c-0.1,0-0.3,0-0.4,0c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.2,0 c-0.1,0-0.2-0.1-0.4-0.1c-0.1,0-0.2,0-0.3,0c-0.2,0-0.5,0-0.7-0.1C10.9,32.4,10.8,32.4,10.8,32.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M30.6,54c0.2,0,0.4,0,0.6,0c0.3,0.1,0.4,0.3,0.5,0.5c0,0.1,0,0.2,0,0.3c-0.1,0.1-0.1,0.3-0.3,0.3 c-0.2,0.1-0.3,0.5-0.7,0.4C30.5,55.1,30.6,54.6,30.6,54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st101",
    d: "M6.9,40.9c0.2-0.4,0.5-0.7,0.7-1.1c0.1,0,0.3,0,0.4,0c0.2,0.1,0.3,0.2,0.2,0.4c-0.4,0-0.5,0.2-0.2,0.5 c0.2,0.2,0.4,0.3,0.2,0.5C7.8,41.2,7.3,41.2,6.9,40.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st102",
    d: "M51.3,46.1c0.3,0,0.6,0,0.9,0c-0.4,0.4-0.7,0.9-1.1,1.3c-0.3,0.1-0.5-0.2-0.7-0.3c-0.1-0.1-0.2-0.3-0.2-0.5 c0-0.1,0.1-0.1,0.2-0.2c0.1,0,0.2-0.1,0.4-0.1c0.1,0,0.2-0.1,0.3-0.1C51.1,46.1,51.2,46.1,51.3,46.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M15.3,10.1c-0.1,0-0.1-0.1-0.1-0.1c0.1-0.7-0.2-1.1-0.9-1.1c0-0.5,0.3-0.7,0.6-0.8c0.1,0,0.3,0,0.4,0l0,0 c0.1,0.1,0.2,0.1,0.3,0.3c0,0.1,0,0.2,0,0.3c0,0.5,0,0.9-0.2,1.4C15.4,10,15.4,10,15.3,10.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M8.9,105.7c0,0.1,0,0.3,0,0.4c-0.1,0.1-0.2,0.1-0.3,0l0,0c-0.2-0.2-0.4-0.4-0.2-0.8l0-0.1 c-0.1-0.2-0.1-0.4,0-0.5c0-0.1,0-0.1,0-0.2c0.1-0.1,0.3,0,0.5,0c0.1,0,0.2-0.1,0.4-0.1c0.2-0.1,0.4-0.1,0.5,0 c0.1,0,0.2,0.1,0.2,0.2c0,0.2,0,0.3-0.1,0.4c0,0,0,0.1,0,0.1c-0.3,0-0.5,0.1-0.7,0.2c-0.1,0-0.2,0-0.4,0 C8.9,105.6,8.8,105.7,8.9,105.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M23.3,42.6c0-0.1-0.1-0.1-0.1-0.2C22.9,42,23,41.6,23,41.1c0-0.1,0-0.2,0-0.3c0-0.1,0.1-0.2,0.1-0.3 c0.2-0.2,0.3-0.3,0.6-0.2c0.6,0.5,0.1,1,0.2,1.6c0,0.3,0,0.6-0.2,0.8C23.6,42.7,23.5,42.8,23.3,42.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M43.5,59.9c0.1,0.3,0.4,0.2,0.6,0.2c-0.1,0.2-0.3,0.2-0.4,0.2c0,0.1-0.3,0-0.2,0.2c-0.4,0.3-0.9,0.3-1.3,0.4 c-0.1-0.1-0.1-0.1-0.1-0.2c0-0.2,0.2-0.4,0.3-0.5c0-0.1,0.1-0.1,0.2-0.1c0.2-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0.1-0.2 c0.1,0,0.3,0,0.4,0C43.3,59.5,43.4,59.7,43.5,59.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M8.6,9c0.1,0,0.1,0,0.2,0C9,9.2,9,9.4,9.3,9.2l0,0C9.4,9.2,9.4,9.1,9.5,9l0,0C9.7,8.8,9.9,8.8,10.1,9 c0.1,0.1,0.1,0.2,0,0.3h0C10,9.6,10,10.1,10,10.5c-0.1,0.2-0.3,0.2-0.5,0.1c-0.2,0-0.3,0-0.4-0.2C8.9,9.9,8.1,9.7,8.6,9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M5.8,24.1c0.1,0.1,0.3,0.1,0.4,0.2c0.2,0.2,0.4,0.4,0.5,0.7c0,0.8-0.5,0.5-0.9,0.4c-0.3-0.4-0.5-0.8-0.4-1.3 C5.6,24,5.7,24,5.8,24.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M26.5,66.3c0.1-0.2,0.2-0.2,0.4-0.2c0.3,0.3,0.7,0.4,0.9,0.8c0,0-0.1,0.1-0.1,0.1c-0.2,0.1-0.4,0.1-0.6,0.1 c-0.1,0-0.3,0-0.4,0c-0.1,0-0.3,0-0.4,0C26,66.8,26.1,66.5,26.5,66.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M10.8,25.4c-0.1-0.1-0.1-0.1-0.2-0.2c0,0-0.1-0.1,0-0.1c0,0,0-0.1,0-0.1l0,0c0.2-0.2,0.6-0.3,0.9-0.4 c0.2,0,0.4,0,0.6,0.2c0.1,0,0.2,0.1,0.2,0.2c-0.2,0.3-0.1,0.6-0.1,0.9c-0.1,0.6-0.4,0.6-0.8,0.3C11.2,26,11.1,25.6,10.8,25.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M22.8,62.2c0-0.1,0-0.1,0-0.2c0-0.2,0.1-0.3,0.3-0.4c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0 c0.1-0.1,0.3-0.1,0.4,0c0.2,0,0.5-0.1,0.6,0.2C24.1,62.5,23.5,62.5,22.8,62.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M31.5,46.7c0-0.2,0-0.4,0-0.7c0.1-0.2,0.3-0.2,0.4-0.2c1.2,0.1,1.3,0.3,0.9,1.2 C32.3,47.1,31.9,46.9,31.5,46.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M48.3,56.8c-0.5,0-0.7,0.3-0.9,0.8c-0.1,0.2-0.2,0.3-0.4,0.3c-0.3-0.1-0.1-0.3-0.1-0.4c0-0.2,0-0.4,0-0.6 c0,0,0-0.1,0.1-0.1c0-0.1,0.1-0.1,0.1-0.2c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.3-0.1,0.4-0.1C48.1,56.3,48.3,56.5,48.3,56.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M13.6,12c0.1,0.1,0.2,0.1,0.2,0.2c0.1,0.1,0.2,0.3,0.1,0.4c0,0.3-0.4,0.3-0.6,0.4c-0.1,0.2-0.2,0.4-0.2,0.6 c-0.1,0.1-0.1,0.1-0.2,0c0-0.2,0.1-0.5-0.2-0.6c0-0.1,0-0.3,0.1-0.3c0.5-0.2,0.5-0.4,0.1-0.7c-0.1-0.1-0.1-0.2-0.2-0.3 C13,11.9,13.3,12,13.6,12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M29.3,63.9c0.2-0.2,0.4,0.8,0.7,0c0.1-0.1,0.1-0.1,0.2-0.1c0.1,0.1,0.1,0.1,0.2,0.2c0,0.1,0.1,0.2,0.1,0.2 c0,0,0,0.1,0,0.1c0,0.1,0,0.2-0.1,0.2c-0.1,0.1-0.1,0.1-0.2,0.1c-0.1,0-0.3,0.1-0.4,0.1c-0.2,0-0.5,0.1-0.7-0.1 c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1-0.2-0.3-0.4-0.2-0.6C28.8,63.7,29.1,63.8,29.3,63.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M33.2,52.5c-0.7,0-1.3,0-1.9,0c1-0.6,1.8-0.7,2.4-0.2c0,0.1-0.1,0.2-0.2,0.3C33.3,52.6,33.2,52.6,33.2,52.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M31.9,65c-0.2,0.3-0.5,0.5-0.5,1c-0.2,0.2-0.4,0.4-0.6,0.6c-0.2-0.2-0.1-0.3,0-0.5c0-0.1,0.2-0.2,0-0.4 c-0.1-0.3-0.1-0.6,0.1-0.9c0.2-0.1,0.4-0.2,0.6-0.2c0.1,0,0.2,0.1,0.3,0.1C32,64.8,32,64.9,31.9,65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M34.1,32.1c-0.1,0.6-0.6,0.8-1.1,1.1c-0.6-0.5,0.2-1,0.1-1.5c0.1-0.1,0.2-0.2,0.4-0.2c0.2,0,0.3,0.1,0.4,0.2 C34,31.8,34.1,31.9,34.1,32.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M24.8,55.5c-0.1-0.3-0.3-0.4-0.6-0.4c0.1-0.3,0.1-0.5-0.2-0.8c0.7-0.1,1.4-0.1,1.5,0.8 C25,55,25.2,55.7,24.8,55.5L24.8,55.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M20.9,54.2c-0.3,0-0.7,0.1-1-0.2c-0.3-0.3-0.5-0.1-0.8,0c0-0.1,0-0.1,0-0.2C20,53.1,20.4,53.2,20.9,54.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M32.8,46.9c0.3-0.8-0.4-0.8-0.9-1.1c0.2-0.3,0.4-0.2,0.7-0.2c0.3,0.1,0.4-0.1,0.6-0.2c0.1,0,0.1,0,0.2,0 c0,0.1,0,0.1,0,0.2c0.1,0.1,0.1,0.2,0.1,0.3c-0.1,0.4,0,0.9-0.3,1.3c-0.1,0.1-0.3,0.2-0.4,0.2C32.6,47.3,32.6,47.1,32.8,46.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M13,91.3c-0.2-0.6,0.5-0.9,0.4-1.5c0.4-0.1,0.4,0.2,0.6,0.4c-0.1,0.5-0.2,1-0.5,1.3c0,0-0.1,0-0.1,0 c-0.1,0-0.1,0-0.2-0.1C13.1,91.4,13,91.4,13,91.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M6,37.7c0.1,0.4,0.4,1-0.2,1.2c-0.5,0.3,0.2,0.7-0.2,0.9C5.2,39,5.3,38.3,6,37.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M34.5,23.5c0-0.2,0-0.4,0-0.5c0-0.6,0.3-0.8,0.9-0.6c0.1,0.1,0.3,0,0.4,0c0,0.2,0,0.3-0.2,0.4 c-0.3,0.2-0.4,0.7-0.8,0.7C34.6,23.6,34.6,23.5,34.5,23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st110",
    d: "M23.9,55.3c0,0.2,0,0.3-0.2,0.4c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.3,0.1c-0.1,0-0.1,0.1-0.2,0.1 c-0.5,0.1-0.3-0.6-0.7-0.7c0-0.1,0-0.1,0-0.2c-0.2-0.3-0.1-0.5,0.2-0.6c0.1,0,0.1,0,0.2,0c0.3,0.3,0.9,0.1,1.1,0.6 C24,55.2,24,55.3,23.9,55.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M9.7,17.4c0.2-0.1,0.4-0.2,0.7-0.2c0.2,0.2,0.2,0.4,0.3,0.6c0,0.4-0.1,0.8-0.5,1.1 C9.8,18.5,9.4,18.1,9.7,17.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M11.6,15.1c0.1,0,0.2-0.1,0.3-0.1c0.3,0,0.5-0.5,0.8-0.1c0.3,0.4,0,0.6-0.2,0.9c0,0.1,0,0.1,0,0.2 C12.2,15.6,11.7,15.6,11.6,15.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st111",
    d: "M17.1,37.2c-0.2-0.4-0.1-0.8,0-1.2c0.9-0.2,1,0.4,0.9,1.1c-0.1,0.4-0.5-0.1-0.7,0.2 C17.2,37.2,17.1,37.2,17.1,37.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st112",
    d: "M10.1,18.9c0-0.4,0.3-0.7,0.2-1.1c0.7,0.2,0.6,0.8,0.9,1.3c-0.1,0.2-0.2,0.4-0.2,0.6 C10.6,19.6,10.1,19.5,10.1,18.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st113",
    d: "M3.3,29.5c-0.5-0.1-0.8-0.3-0.6-0.8c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0 c0.1,0,0.2,0.1,0.3,0.1c0.3,0.2,0.6,0.2,0.9,0.5c0.1,0.1,0.1,0.2,0.1,0.3c-0.2,0.4-0.3,0.7-0.7,0.2C3.6,29.5,3.4,29.5,3.3,29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M11,37.2c0,0.3,0,0.6,0,0.9c-0.2,0.1-0.1,0.6-0.5,0.4c-0.3-0.1-0.5-0.3-0.4-0.6l0,0c0.1-0.3-0.1-0.5-0.2-0.6 l0,0c0.2-0.2,0.4-0.3,0.7-0.4C10.7,37,10.9,37.1,11,37.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M10,105.2c0-0.2,0-0.3,0-0.5c-0.1-0.1-0.1-0.1-0.2,0c-0.2,0-0.4,0-0.6,0c-0.1,0-0.1-0.1-0.1-0.1 c0,0,0-0.1,0.1-0.1c0.3-0.1,0-0.3,0-0.4c0.1-0.2,0.3-0.3,0.4-0.4c0.2,0,0.4,0.1,0.6,0.2C10.1,104.2,10.3,104.7,10,105.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st115",
    d: "M14,90.2c-0.3,0-0.4-0.3-0.6-0.4c0.1-0.3,0.2-0.6,0.2-0.9c0.1-0.1,0.1-0.1,0.2-0.2l0,0 c0.2-0.1,0.4-0.1,0.5,0c0,0.1-0.1,0.1-0.1,0.2c-0.1,0.1,0,0.2,0,0.2C14.5,89.6,14.1,89.9,14,90.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M29.3,63.9c-0.7-0.1-0.5,0.3-0.4,0.7c-0.7-0.2-0.8-0.7-0.8-1.3C28.5,63.5,29,63.4,29.3,63.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st116",
    d: "M47,53.6c-0.2-0.4-0.9-0.3-0.9-0.9c0.1,0,0.1-0.1,0.1-0.1c0,0,0-0.1-0.1-0.1c0.7-0.4,0.3,0.6,0.8,0.6 c0.3,0,0.9-0.5,1,0.3c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.1-0.3,0-0.5,0.1C47.1,53.7,47,53.7,47,53.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st117",
    d: "M47.6,49.5c0.5-0.6,0.9-1.4,1.9-1.1c0,0.1,0,0.2,0,0.2C48.9,48.9,48.3,49.4,47.6,49.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M40.1,48c0.1,0,0.1,0,0.2,0c0.1-0.1,0.1-0.1,0.2,0c0.1,0.3,0,0.5,0.1,0.8c0,0,0,0.1,0,0.1 c0,0.1,0,0.2-0.1,0.2c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.3-0.1-0.4-0.2c0-0.2,0-0.3-0.2-0.4c-0.2,0.2-0.4,0.2-0.6,0 c0-0.1,0-0.3,0-0.4C39.3,47.9,39.7,48,40.1,48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st118",
    d: "M23.9,49.1c-0.1,0-0.1,0-0.2,0c-0.1-0.1-0.1-0.1-0.1-0.2c0.1-0.3,0.1-0.5,0-0.8c0-0.1,0-0.2,0-0.3 c0-0.1,0-0.2,0-0.3c0.1-0.1,0.2-0.1,0.2-0.1c0.2,0.1,0.4,0.2,0.5,0.4c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0,0.2,0.1,0.2,0.1 c0.2,0.1,0.4,0.3,0.2,0.6c-0.3,0.3-0.6,0.4-1,0.4C24.1,49.2,24,49.2,23.9,49.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M18.8,3.9c0,0.4,0,0.7-0.5,0.9c-0.3-0.2-0.2-0.6-0.4-0.9C18.2,3.5,18,3,18.3,2.7c0.5,0,0.4,0.4,0.6,0.7 C18.9,3.6,18.9,3.7,18.8,3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st119",
    d: "M5.8,25.4c0.2-0.2,0.9,0.3,0.9-0.4c0,0,0-0.1,0-0.1c0.1-0.1,0.1-0.1,0.2-0.2c0,0,0.1,0,0.1,0 c0.1,0,0.3,0.1,0.4,0.2c0.8,0.4,0.5,0.7-0.1,0.9c-0.3,0.1-0.7,0.1-1,0.2c-0.1,0-0.2,0-0.3,0c0,0-0.1,0-0.1-0.1 c-0.1-0.1-0.1-0.2-0.1-0.2l-0.1,0C5.8,25.5,5.8,25.5,5.8,25.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M11,31.9c-0.2,0-0.3,0-0.4,0.2c-0.1,0-0.2-0.1-0.2-0.2c-0.1-0.1-0.1-0.2-0.2-0.2l0,0 c-0.1-0.1-0.1-0.1-0.1-0.2c-0.1-0.2-0.4-0.2-0.3-0.5c0.2-0.2,0.5-0.3,0.8-0.3c0.2,0,0.4,0.1,0.6,0.1c0.1,0,0.2,0,0.3,0.1 c0,0,0.1,0.1,0.1,0.1c0,0,0.1,0.1,0.1,0.1c0,0.1,0,0.2-0.1,0.3C11.3,31.5,10.9,31.5,11,31.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M33.2,31.6c0.2,0.5-0.5,1-0.2,1.5c-0.2,0-0.4,0-0.6,0c-0.1-0.3,0.1-0.6,0.2-0.9c0.4-0.2,0-0.9,0.6-0.9 C33.2,31.5,33.3,31.5,33.2,31.6C33.2,31.6,33.2,31.6,33.2,31.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st120",
    d: "M42.2,60.7c0,0.1,0,0.1,0,0.2c-0.1,0-0.1,0-0.2,0c-0.2,0.1-0.4,0.1-0.6,0c-0.2,0-0.4-0.1-0.6-0.2 c-0.1-0.1-0.3-0.2-0.4-0.3c-0.2-0.2-0.5-0.5-0.3-0.8c0.3-0.4,0.6,0,0.9,0.1c0.2,0.2,0.4,0.1,0.6,0.2c0.1,0.1,0.1,0.2,0.2,0.2 C42.2,60.4,42.1,60.6,42.2,60.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "M45.2,54.5c0.2,0.1,0.3,0.3,0.5,0.4c0,0.4-0.2,0.7-0.4,1c-0.2,0.2-0.4,0.3-0.7,0.2c-0.1-0.1-0.2-0.2-0.2-0.4 c0-0.1,0-0.3,0.1-0.4c0-0.1,0-0.3,0.1-0.4c0-0.1,0-0.2,0-0.3c0-0.1,0.1-0.2,0.1-0.2c0.1-0.1,0.1-0.1,0.2-0.1 C45.1,54.4,45.2,54.4,45.2,54.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st122",
    d: "M44,57.5c0.1,0.1,0.1,0.1,0.2,0.2c0.1,0.1,0.1,0.2,0.2,0.2l0,0c0,0.1,0,0.1,0,0.2c-0.1,0.3-0.1,0.6-0.2,0.9 c0,0.1-0.1,0.1-0.2,0.2c-0.6-0.1-0.4-0.5-0.4-0.9c0,0,0-0.1,0-0.1c-0.1-0.1-0.2-0.3-0.2-0.4c0,0,0-0.1,0-0.1c0-0.1,0-0.2,0.1-0.2 c0.2-0.1,0.4-0.1,0.5,0C43.9,57.4,43.9,57.5,44,57.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M3.7,32.3c0-0.2,0.1-0.6-0.1-0.7c-0.6-0.4,0-0.7,0.1-1c0.6,0,0.4,0.6,0.6,0.9c-0.1,0.3-0.3,0.5-0.2,0.8 C4,32.3,3.8,32.3,3.7,32.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M23.9,55.1c-0.3-0.3-0.9-0.1-1.1-0.6c0.4-0.1,0.7-0.1,1.1-0.2c0.2,0.3,0.4,0.1,0.7,0.2 c-0.1,0.3-0.4,0.3-0.5,0.6v0C24.1,55.2,24,55.2,23.9,55.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "M47.8,56.2c-0.1,0.2-0.3,0.2-0.4,0.2c-1.2,0.1-1.2,0-1.2-1c0,0,0.1-0.1,0.1-0.1c0.1,0,0.3,0,0.4,0 c0,0.1,0.1,0.2,0.2,0.2C47.3,55.7,47.7,55.8,47.8,56.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st124",
    d: "M23.2,40.9c0,0.5,0,1,0,1.5c-0.2,0.1-0.2,0.3-0.3,0.4c-0.3-0.1-0.3-0.5-0.4-0.8c0-0.2-0.1-0.3-0.1-0.5 c0-0.1,0-0.2,0.1-0.3C22.6,41,22.9,40.8,23.2,40.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M14.9,8c-0.2,0.3-0.4,0.6-0.6,0.8c-0.2,0.3-0.4,0.3-0.7,0C13.9,8.3,14,7.6,14.9,8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M20,58.3c-0.4,0.1-0.7-0.2-1.1-0.2c-0.2-0.2-0.3-0.4-0.4-0.6c0.2-0.1,0.1-0.4,0.4-0.6c0.2,0.5,0.3,1,0.9,1 C20,58,20.1,58.1,20,58.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "M28.8,70.1c-0.1-0.4,0.2-0.7,0.3-1c0-0.1,0.1-0.2,0.2-0.2c0.4-0.2,0.1-0.9,0.7-0.9C30,68,30,68,30,68 c0,0.1,0,0.1,0,0.2c0,0.1-0.1,0.1-0.1,0.1c0,0,0,0,0.1,0c0,0,0,0.1,0,0.1c-0.2,0.4-0.4,0.8-0.7,1.3c-0.1,0.1-0.1,0.3-0.2,0.4l0,0 c-0.1,0.1-0.1,0.1-0.2,0.1C28.9,70.2,28.8,70.2,28.8,70.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M48.9,51.9c0,0-0.1,0-0.1,0c-1.1,0-1.1,0-0.5-1.1C48.7,51,48.8,51.4,48.9,51.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "M22.4,55.3c0.3-0.1,0.7-0.5,0.5,0.3c-0.1,0.4,0.2,0.1,0.4,0.1c0.1,0,0.1,0.1,0.1,0.1c0,0,0,0.1-0.1,0.1 c0,0.1,0,0.1,0,0.2c-0.1,0.1-0.2,0.3-0.4,0.3c-0.1,0-0.3,0-0.4,0c-0.1-0.1-0.2-0.2-0.3,0c-0.1,0-0.2-0.1-0.2-0.3c0-0.1,0-0.2,0-0.2 c0.1,0,0.2,0,0.2,0C22.4,55.8,22.3,55.5,22.4,55.3L22.4,55.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M20.3,55.3c0.4-0.2,0.7-0.4,0.8-0.9c0.2,0.3,0.5,0.5,0.5,0.8c-0.1,0.2-0.2,0.4-0.4,0.5c0,0-0.1,0-0.1-0.1 C20.7,55.6,20.4,55.6,20.3,55.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st102",
    d: "M30.8,55.5c0.2-0.1,0.4-0.3,0.7-0.4c0,0,0.1,0.1,0.1,0.1c0,0-0.1,0.1-0.1,0.1c0.1,0.3,0.5,0.1,0.6,0.4 c-0.4,0.3-0.9,0.5-1.4,0.3C30.6,55.8,30.6,55.6,30.8,55.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st128",
    d: "M50.8,44.8c0.1,0.1,0.1,0.3,0.2,0.4c-0.4,0.3-0.5,1-1.1,1.2c-0.2,0-0.3,0-0.4-0.1c0-0.1,0-0.1,0-0.2 c0.4-0.4,0.1-0.9,0.4-1.3C50.3,44.8,50.6,44.8,50.8,44.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M28.2,42c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2-0.1-0.3-0.1c-0.1-0.1-0.3-0.2-0.4-0.3c-0.1-0.1-0.1-0.1-0.1-0.2 c-0.1-0.2-0.1-0.5,0.2-0.5c0.2,0,0.4,0.1,0.5,0.2c0.2,0.1,0.4,0.1,0.7,0.1c0.1,0,0.3,0,0.4,0c0.1,0,0.2,0.1,0.3,0.1 c0,0,0.1,0.1,0.1,0.1c-0.1,0.3-0.5,0.1-0.7,0.4l0,0C28.6,41.9,28.4,41.8,28.2,42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M24.1,49.1c0.3-0.4,0.8-0.1,1.1-0.4c0,0,0.1,0,0.1,0c0.2,0,0.3-0.1,0.5,0l0,0c0.2,0.1,0.3,0.2,0.2,0.4 c-0.3,0.1-0.5,0.5-0.9,0.4C24.8,49.6,24.5,49.4,24.1,49.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M50.4,46.9c0.4-0.1,0.4,0.3,0.7,0.4c-0.1,0.1-0.2,0.3-0.2,0.4c-0.4-0.2-0.6,0.1-0.9,0.1 c-0.4,0.1-0.1-0.2-0.1-0.3C49.7,47.1,50,47,50.4,46.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M36.4,72.3c0.2,0,0.8-0.2,0.3,0.4c-0.1,0.1-0.1,0.3-0.1,0.4c-0.3,0-0.6,0-0.9,0C35.7,72.7,36,72.5,36.4,72.3z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st117",
    d: "M33.8,31.9c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1-0.1-0.1-0.2-0.1-0.3c0.1-0.3,0.3-0.5,0.5-0.7 c0.3-0.1,0.5,0,0.7,0.2c0.1,0.2,0.2,0.3,0.2,0.5c0,0.2,0,0.3-0.2,0.4C34.4,31.7,34.1,32,33.8,31.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M21.6,12c0.4,0,0.7-0.3,1.1,0c0,0.3-0.1,0.4-0.2,0.7l0,0c-0.1,0.1-0.1,0.1-0.2,0.1C22.1,12.9,22,13,21.9,13 c-0.1,0-0.2,0-0.2-0.1c-0.2-0.2-0.3-0.4-0.2-0.6C21.4,12.2,21.5,12.1,21.6,12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M39.9,46.3c0.1-0.5,0.4-0.8,0.9-0.9c0.1,0,0.3,0,0.4,0c0.2,0.1,0.4,0.1,0.3,0.4l0,0c-0.2,0.2-0.2,0.5-0.5,0.7 c-0.3-0.6-0.5,0.2-0.8,0l0,0C40,46.4,39.9,46.4,39.9,46.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st129",
    d: "M50,44.8c0,0.5,0.4,1.1-0.4,1.3c0-0.4-0.2-0.6-0.7-0.7C49.2,45.1,49.6,45,50,44.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st130",
    d: "M14.5,47.8c0.6-0.3,0.6,0.2,0.8,0.5c0.2,0.3,0,0.5-0.4,0.6C14.6,48.6,14.4,48.2,14.5,47.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M35.1,53.8c0.5,0,0.8,0.1,0.8,0.6c-0.1,0.2-0.3,0.4-0.5,0.4c-0.2,0-0.4,0-0.6-0.2 C34.9,54.4,35,54.1,35.1,53.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M17.5,7.1c0-0.1,0-0.1,0-0.2C17.7,6.6,18,6.4,17.9,6c0.2,0.1,0.4,0.2,0.6,0.2c0.1,0,0.2,0.1,0.2,0.2 c-0.1,0.1-0.1,0.3-0.1,0.4c-0.3,0.4-0.6,0.5-1.1,0.3C17.5,7.2,17.5,7.1,17.5,7.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M11.2,19.8c0.1-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4-0.2,0.6-0.1c0.2,0.2-0.1,0.4-0.1,0.7c-0.2,0.1-0.4,0.3-0.7,0.2 C11.2,20.1,11.2,20,11.2,19.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "M41.6,60.7c0.1,0.1,0.3,0.1,0.4,0.2c-0.1,0.2-0.2,0.4-0.2,0.6c-0.1,0.1-0.1,0.1-0.2,0.2l-0.1,0l-0.1,0 c-0.1-0.1-0.3-0.1-0.4-0.2c-0.2-0.2-0.6-0.3-0.5-0.7c0.1-0.1,0.3-0.1,0.4-0.1C41.1,60.8,41.4,60.9,41.6,60.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M33.2,52.5c0.1,0,0.1,0,0.2,0c0.3-0.2,0.3,0.1,0.4,0.2c0.3,0.2,0.4,0.5,0.4,0.9c-0.1,0.1-0.1,0.1-0.2,0.2 c-0.2-0.2-0.5-0.2-0.6-0.4C33.3,53.1,33.1,52.8,33.2,52.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M36,25.4c0,0.2-0.1,0.4-0.3,0.5c-0.5,0.3-0.4,0.6-0.2,1c0.1,0.1,0.1,0.3,0,0.5C35,27.4,35,27,34.9,26.7 c0-0.1,0-0.2,0-0.3c0-0.1,0-0.3,0.1-0.4c0-0.1,0.1-0.2,0.1-0.2c0,0,0.1-0.1,0.1-0.1c0.1-0.1,0.3-0.1,0.4-0.2l0,0 c0.1-0.1,0.2-0.1,0.2,0C35.9,25.4,35.9,25.4,36,25.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M8.6,9c0.1,0.3-0.3,0.9,0.5,0.7c0.2-0.1,0.3,0.1-0.1,0.6c-0.3,0-0.6-0.2-0.8-0.4c0-0.2-0.2-0.4,0-0.6 C8.3,9.2,8.5,9.1,8.6,9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st132",
    d: "M24.1,77.1c-0.4,0.3-0.7,0.6-1.1,0.9c-0.1,0.1-0.2,0.1-0.2,0c0.1-0.8,1-1,1.3-1.7 C24.4,76.6,24.3,76.8,24.1,77.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st62",
    d: "M33.6,31.4c0,0.1,0,0.1,0,0.2c-0.1,0-0.3,0-0.4,0c0-0.1,0-0.1,0-0.2c-0.2-0.5,0.2-1,0-1.5c0.1,0,0.1,0,0.2,0 c0.1,0.1,0.3,0.2,0.4,0.4C34.1,30.8,33.8,31.1,33.6,31.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st96",
    d: "M18.3,54.9c0.3,0,0.6-0.1,0.9,0.1c-0.1,0.7-0.5,0.9-1.1,0.6C18.1,55.3,18.2,55.1,18.3,54.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st133",
    d: "M5.8,24.1c-0.1,0-0.3,0-0.4,0C5.3,23.6,5,23,5.6,22.6c0.1,0.2,0.6,0.3,0.2,0.7C5.5,23.5,5.9,23.8,5.8,24.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M31.2,37.4c0.1-0.2,0.2-0.4,0.2-0.6c0.5,0.1,1-0.1,1.5-0.2C32.5,37.2,31.9,37.4,31.2,37.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M43.3,46.3c-0.2-0.4-0.4-0.7-0.7-1.1c0.5-0.2,0.8,0.5,1.3,0.2c0.1,0.4-0.3,0.6-0.4,0.9 C43.4,46.4,43.4,46.4,43.3,46.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st135",
    d: "M12.1,24.7c-0.2,0-0.4,0-0.7,0c-0.7,0.2-0.9,0-0.6-0.6c0.3-0.1,0.6,0.3,0.9,0C11.9,24.2,12.1,24.4,12.1,24.7 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "M27.5,71.9c0-0.4,0.4-0.6,0.5-0.9c0-0.1,0.1-0.1,0.1-0.2l0,0c0.2,0,0.3,0,0.3,0.3c0,0.6-0.5,0.9-0.9,1.2l0,0 C27.7,72.2,27.6,72.1,27.5,71.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M26.1,21.1c-0.4-0.2-0.7-0.6-1-0.9c0.8-0.7,0.8,0.5,1.2,0.5C26.3,20.8,26.3,21,26.1,21.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st137",
    d: "M34.9,54.7c0.2,0,0.4,0,0.7,0c0.2,0.1,0.4,0.2,0.5,0.5c0,0.1,0,0.2-0.1,0.3c-0.2,0.2-0.5,0.3-0.8,0.3 c-0.1,0-0.2,0-0.3-0.1c-0.2-0.2,0-0.5-0.2-0.7c0-0.1,0-0.2,0-0.3C34.8,54.7,34.8,54.7,34.9,54.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M23.3,48c0.1,0,0.1,0,0.2,0c0.2,0.1,0.2,0.3,0.2,0.5c0,0.1,0,0.2,0,0.3c0,0.1-0.1,0.3-0.1,0.4 c0,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.2,0-0.3-0.1c-0.2-0.2-0.4-0.4-0.5-0.7c-0.1-0.2-0.2-0.5,0.1-0.7c0.1-0.1,0.2-0.1,0.2,0l0,0 c0.1,0.1,0,0.3,0.1,0.5C23.1,48.3,23.1,48.2,23.3,48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st138",
    d: "M39.2,71.7c0.4-0.4,0.6,0,0.9,0.2c-0.3,0.4-0.6,0.6-1.1,0.6c0.1-0.2,0.2-0.4,0.2-0.6 C39.1,71.9,39.1,71.8,39.2,71.7C39.2,71.7,39.2,71.7,39.2,71.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st139",
    d: "M37.5,51.5c-0.1-0.3-0.1-0.6-0.2-0.9c0.3-0.1,0.5-0.2,0.9-0.2c0,0.1,0,0.1,0,0.2c0.1,0.1,0.1,0.2,0.1,0.4 c-0.1,0.2-0.2,0.4-0.4,0.5C37.8,51.5,37.6,51.5,37.5,51.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M25.4,70.2c0.2,0,0.4,0,0.6,0c0.4,0.3,0.5,0.6,0.4,1.1C25.8,71.3,25.8,70.5,25.4,70.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M36.4,65c0.1-0.1,0.1-0.3,0.2-0.4c0.1,0.1,0.1,0.1,0.2,0.2c0.2,0.2,0.1,0.4,0,0.7c0,0.1,0,0.1,0,0.2 c0.2,0.2,0.1,0.4-0.1,0.5c-0.2,0.1-0.5,0.1-0.6-0.2c0-0.1-0.1-0.2,0-0.3C36.1,65.4,36.2,65.2,36.4,65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st141",
    d: "M38.6,64c-0.2-0.9,0.7-0.2,0.9-0.6c0.4,0.2,0,0.4,0,0.6c-0.1,0.2-0.3,0.2-0.4,0.2c-0.1-0.1-0.1-0.1-0.2,0 C38.7,64.1,38.6,64.1,38.6,64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M12.1,17.4c0.4-0.3,0.1-0.7,0.2-1.1c0.4,0.2,0.6,0.5,1.1,0.5c0,0,0,0.1,0.1,0.1c0,0.1-0.1,0.2-0.1,0.2 c-0.2,0.1-0.4,0.2-0.5,0.4c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.2-0.1-0.2-0.1C12,17.6,12,17.5,12.1,17.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M28.7,21.5c0.1,0.1,0.3,0.1,0.4,0.2c0.1,0,0.1,0.1,0.1,0.1c0,0,0,0.1-0.1,0.1c0,0.1,0,0.4-0.2,0.3 c-0.5-0.3-0.5-0.1-0.5,0.3c0,0.4-0.1,0.4-0.4,0.3C28.3,22.4,28.1,21.8,28.7,21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st142",
    d: "M20.1,59.6c0.2,0,0.4-0.1,0.6-0.2c0.3,0,0.5,0.1,0.6,0.4c0,0.2,0,0.3,0,0.5c0,0.1-0.1,0.2-0.2,0.2 C20.6,60.4,20.3,60,20.1,59.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st143",
    d: "M41.4,45.9c-0.1-0.2-0.3-0.2-0.4-0.2c-0.1-0.1-0.1-0.3,0-0.4c0.2,0,0.4,0,0.6,0c0.1,0.1,0.1,0.1,0.2,0l0,0 c0.1-0.1,0.1-0.1,0.2,0l0,0C42.5,46.1,41.7,45.8,41.4,45.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st144",
    d: "M23.3,42.6c0.1,0,0.2,0,0.3,0c0.4,0.3,0.4,0.7,0.1,1.1c-0.4,0.2-0.1,0.7-0.4,0.9 C23.3,43.9,23.3,43.3,23.3,42.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M21.8,62c0-0.2,0-0.4,0-0.6c0.1-0.3,0.2-0.2,0.4,0c0.1,0.1,0.1,0.3,0.1,0.4c0,0.2,0.1,0.5,0.1,0.7l0,0 c-0.1,0.1-0.3,0.1-0.4,0C21.9,62.3,21.8,62.2,21.8,62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M23,51.8c-0.2,0.1-0.1,0.3-0.2,0.5c-0.2,0.2-0.3,0.5-0.5,0c0-0.4,0-0.9,0.1-1.3c0.2-0.1,0.4,0,0.5,0.2 C23.1,51.4,23.3,51.6,23,51.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st79",
    d: "M33.8,21.3c-0.2-0.3-0.2-0.7-0.7-0.7c0.2-0.3,0.4-0.5,0.7-0.6c0,0,0,0.1,0.1,0.1c0,0,0,0.1-0.1,0.1 c-0.1,0.5,0.8,0.3,0.6,0.9C34.1,20.8,34.1,21.5,33.8,21.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M35.4,52.5c0.2-0.1,0.5-0.2,0.7-0.5c0.1-0.2,0.3-0.2,0.4,0c0,0.4,0,0.8-0.4,1.1c-0.2-0.1-0.4-0.2-0.6-0.2 C35.4,52.8,35.4,52.7,35.4,52.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st147",
    d: "M14.3,88.7c-0.2,0-0.4,0-0.5,0c0.1-0.4,0.4-0.8,0.6-1.1c0.3,0.2,0.4,0.4,0.2,0.7 C14.7,88.6,14.6,88.7,14.3,88.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M45.2,53.2c0.9-0.1,0.5,0.7,0.8,1.1c-0.1,0-0.1,0-0.2,0C45.3,54.1,44.9,53.9,45.2,53.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M35.8,67.6c0-0.2-0.1-0.5,0.2-0.6c0.2,0.1,0.4,0.2,0.6,0.2c0.1,0.2,0.1,0.4,0,0.7c-0.2,0.3-0.4-0.1-0.7,0 C35.9,67.7,35.8,67.7,35.8,67.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M30,45c-0.4-0.3-0.5-0.6-0.2-1.1c0.2,0.1,0.4,0.3,0.4,0.5c0,0.3,0.2,0.3,0.4,0.3C30.5,45.1,30.2,45,30,45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M14.4,42.6c0-0.1,0-0.3,0-0.4c0.1-0.1,0.1-0.1,0.2-0.2c0.1-0.1,0.1-0.1,0.2-0.2c0.2-0.2,0.4-0.2,0.6,0l0,0 c0,0,0.1,0.1,0,0.1s0,0.1,0,0.1c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.1-0.1,0.1-0.2,0.2c0,0.1,0,0.1,0,0.2 C14.9,42.6,14.7,42.6,14.4,42.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st149",
    d: "M4.1,24.5c-0.1,0.2-0.3,0.2-0.4,0.2c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1,0.1-0.1,0.1-0.2,0c-0.2,0-0.4,0.4-0.6,0 c0,0,0-0.1,0-0.1c-0.1-0.1-0.1-0.2,0-0.3c0.3-0.2,0.6,0.1,0.8,0.1c0.1,0,0.2,0,0.2,0.1C3.9,24.3,4,24.3,4.1,24.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M34.7,23.5c0.3-0.2,0.4-0.7,0.9-0.6c-0.1,0.3,0.1,0.6-0.2,0.9c-0.1,0.1-0.3,0.1-0.4,0l-0.1,0l-0.1,0 C34.6,23.6,34.6,23.6,34.7,23.5C34.7,23.5,34.7,23.5,34.7,23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st150",
    d: "M16.1,84.4c-0.1,0-0.1,0-0.2,0c-0.1-0.4-0.2-0.7,0-1.1c0.3-0.3,0.4,0.1,0.6,0.2c0,0.1,0,0.1,0.1,0.2 c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0.1-0.1,0.2-0.2,0.2C16.4,84.4,16.3,84.4,16.1,84.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st151",
    d: "M9.7,25.2c0.1,0.4,0.1,0.8,0.4,1.1c0.1,0.1,0.1,0.2,0.1,0.3c-0.1,0.2-0.3,0.3-0.5,0.1 c-0.1-0.3-0.2-0.6-0.2-0.9c-0.1-0.1-0.1-0.1-0.1-0.2c0-0.1,0-0.2,0.1-0.2C9.6,25.3,9.6,25.2,9.7,25.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "M45.2,53.2c-0.1,0.5,0.2,0.9,0.6,1.1c-0.1,0.4-0.5-0.1-0.7,0.2c-0.1,0-0.1,0-0.2,0c-0.3-0.4-0.4-0.8-0.3-1.3 C44.9,53.1,45.1,53,45.2,53.2L45.2,53.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st102",
    d: "M18.7,41.3c0,0.1,0,0.1,0,0.2c-0.2,0.2-0.6,0.1-0.9,0.4c0,0-0.1,0.1-0.1,0.1c0,0-0.1-0.1-0.1-0.1 c0.1-0.4,0.1-0.8,0.6-0.9c0.1-0.1,0.1-0.1,0.2-0.1c0.1,0,0.1,0.1,0.2,0.2C18.7,41.3,18.7,41.3,18.7,41.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M27.2,46.9c0.4,0.2,0,0.7,0.4,0.9c-0.1,0.2-0.2,0.4-0.4,0.4c-0.1-0.1-0.3,0-0.4-0.2l0,0 C26.4,47.5,26.8,47.2,27.2,46.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M40.1,48c-0.3,0.2-0.7,0.2-1,0.2c0.1-0.4,0.1-0.7,0.2-1.1c0.1,0.1,0.1,0.1,0.2,0.2c0.1,0,0.1,0.1,0.1,0.1 c0,0,0,0.1-0.1,0.1C39.5,47.9,40,47.7,40.1,48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M18.1,1.7c0,0.1,0,0.1,0,0.2c0.1,0.4-0.3,0.4-0.4,0.7c-0.4-0.5,0-0.9,0.2-1.3c0.1-0.1,0.1-0.1,0.2,0 c0,0.1,0,0.1,0,0.2C18.2,1.5,18.2,1.6,18.1,1.7C18.1,1.7,18.1,1.7,18.1,1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M22.6,49.9c0-0.3,0-0.6,0.1-0.8c0.3-0.1,0.4,0.2,0.5,0.4c0,0.1,0,0.2-0.1,0.3c0,0.1,0,0.3,0,0.4 c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.3-0.4,0.2C22.5,50.5,22.5,50.2,22.6,49.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st138",
    d: "M33.6,31.4c0-0.4,0.3-0.7,0-1.1c0.1-0.3,0.5-0.2,0.6-0.4c0.1,0,0.1,0,0.2,0c0.4,0.5-0.1,0.7-0.4,0.8 C34.1,31.1,33.9,31.3,33.6,31.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M9.5,10.5c0.2,0,0.3,0,0.4-0.2c0.3-0.1,0.5-0.1,0.8,0c0.2,0.2,0.3,0.4,0.1,0.6C10.3,11,9.8,11,9.5,10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st154",
    d: "M45.7,58.1c0.1-0.2,0.2-0.4,0.2-0.7c0.4,0.2,0.7,0.3,0.6,0.8C46.2,58.3,45.9,58.5,45.7,58.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M31,64.8c0.1,0.3,0,0.6-0.2,0.8c-0.1,0-0.2-0.1-0.3-0.2c-0.1-0.2-0.2-0.4-0.4-0.4l0,0c-0.1,0-0.1-0.1-0.1-0.2 c0-0.1,0.1-0.2,0.1-0.2c0.1,0,0.1,0,0.2,0c0.1-0.1,0.2-0.1,0.3-0.2c0.2,0,0.3,0,0.4,0.1C31.1,64.7,31.1,64.7,31,64.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M39,48.7c0.2,0,0.4,0,0.6,0c0,0.2,0,0.4-0.1,0.6c-0.3,0.4-0.5,0.3-0.6-0.2C39,48.9,39,48.8,39,48.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M8.2,9.2c0,0.2,0.4,0.4,0,0.6C8.1,9.8,8.1,9.8,8,9.7C7.9,9.6,7.8,9.5,7.8,9.5c-0.2,0-0.3,0-0.4-0.2 C7.6,9.2,7.9,8.8,8.2,9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M40.5,64.4c-0.2-0.2-0.5-0.4-0.6-0.9c0.3-0.1,0.6,0.2,0.8,0.3v0c0.2,0.2,0.2,0.4,0,0.6 C40.6,64.4,40.6,64.4,40.5,64.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st155",
    d: "M20.5,8.4c0,0.1,0,0.3,0,0.4c-0.1,0.1-0.1,0.3-0.2,0.4l-0.1,0c-0.1,0.1-0.2,0.1-0.3,0 c-0.2-0.1-0.3-0.2-0.4-0.4c0-0.4,0.2-0.6,0.5-0.8C20.2,8.2,20.3,8.3,20.5,8.4L20.5,8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st156",
    d: "M45.2,55.8c0-0.3,0.1-0.7,0.4-0.9c0.2,0,0.4,0,0.4,0.2c0,0.2-0.1,0.3-0.1,0.4C45.8,55.8,45.7,56.5,45.2,55.8 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st157",
    d: "M6.9,5.8C6.8,6.1,6.6,6.3,6.3,6.4C6.2,6.2,5.9,6.1,5.7,5.8C6.2,5.9,6.5,5.6,6.9,5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st101",
    d: "M5.2,25.4c-0.1,0.2-0.2,0.2-0.4,0.3c-0.3,0.2-0.5,0.1-0.5-0.2c-0.1-0.4,0.2-0.2,0.4-0.3c0.1,0,0.2,0,0.3,0 C5.1,25.2,5.1,25.3,5.2,25.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M9.9,109.4c-0.1-0.1,0.3-0.5-0.2-0.4c-0.1,0.1-0.2,0.1-0.3,0c0-0.1-0.1-0.2-0.1-0.3c0-0.2,0.1-0.3,0.3-0.3 c0.5-0.3,0.6,0.1,0.7,0.4c0,0.2,0,0.5-0.2,0.7C10.1,109.5,10,109.5,9.9,109.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M35.3,48.2c0.3-0.5,0.6-0.2,0.9,0c-0.2,0.5-0.7,0.4-1.1,0.4C35.2,48.5,35.3,48.4,35.3,48.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st158",
    d: "M11.4,20.6c0.1,0.1,0.1,0.1,0.2,0.2c-0.3,0.2,0,1.1-0.9,0.7C10.9,21.1,11.2,20.9,11.4,20.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M8.6,106.2c0.1,0,0.2,0,0.3,0c0.1,0.1,0.1,0.1,0.2,0.2c0.1,0.1,0.1,0.2,0.2,0.2l0,0c0.1,0.1,0,0.3,0.1,0.5 c0,0.1,0,0.2-0.1,0.2c-0.3,0-0.6,0.1-0.5-0.4c0-0.2-0.2-0.2-0.4-0.2C8.5,106.4,8.5,106.3,8.6,106.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st79",
    d: "M12.1,25.8c-0.3-0.4-0.4-0.7,0.2-0.9c0.1,0.2,0.2,0.4,0.2,0.6c0,0.1,0,0.2,0,0.2C12.4,25.9,12.2,26,12.1,25.8 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M34.9,24.3c0.3,0.2,0.7,0.4,0.4,0.9c-0.1,0.1-0.2,0.1-0.3,0.2c-0.2,0-0.3,0-0.4-0.1c-0.1-0.2-0.1-0.4-0.1-0.6 C34.7,24.4,34.8,24.3,34.9,24.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st159",
    d: "M22.4,52.3c0.2,0.2,0.3,0,0.5,0l0,0c0.1,0.1,0.1,0.3,0.2,0.4c0,0.2-0.2,0.4-0.4,0.5c-0.2,0.2-0.3,0-0.4-0.2 C22.2,52.8,22.1,52.5,22.4,52.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "M44,59.2c0-0.1,0-0.1,0-0.2c0.2-0.2,0.1-0.7,0.6-0.4c0.1,0.4,0.3,0.8-0.2,1.1C44.3,59.4,44.2,59.3,44,59.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st96",
    d: "M24.4,19.8c-0.1,0-0.1,0-0.2,0c-0.1,0.1-0.1,0.1-0.2,0.2l0,0c-0.1,0.1-0.2,0.1-0.3,0 c-0.1-0.2-0.2-0.4-0.1-0.7c0.1-0.2,0.2-0.3,0.3-0.3c0.2,0,0.3,0,0.5,0.1c0,0.1,0,0.3,0,0.4C24.4,19.6,24.4,19.7,24.4,19.8 C24.4,19.8,24.4,19.8,24.4,19.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M9.3,40.9c-0.1,0.5,0.5,0.3,0.6,0.6c-0.3,0-0.7,0-1,0C8.9,41.2,8.7,40.8,9.3,40.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.4,22.8c0,0.1,0,0.1,0,0.2c-0.1,0.2,0.2,0.6-0.3,0.5c-0.4-0.1-0.5-0.4-0.1-0.7 C27.1,22.8,27.2,22.8,27.4,22.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M3.5,24.3c-0.3,0.1-0.6-0.4-0.9,0c0,0,0.1,0.1,0,0.1c0,0,0,0.1,0,0.1l0,0c-0.1,0-0.1,0-0.2,0 c-0.3-0.3-0.2-0.6,0-0.8c0.4,0,0.7,0.3,1.1,0.4C3.5,24.2,3.5,24.2,3.5,24.3C3.5,24.3,3.5,24.3,3.5,24.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.1,49.1c0.4,0,0.7,0.3,1.1,0.4c-0.6,0.5-0.9,0-1.3-0.4C24,49.1,24.1,49.1,24.1,49.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st161",
    d: "M22.7,41.9c0.3,0.2,0.1,0.6,0.2,0.9c0,0.1,0,0.1-0.1,0.2c-0.4-0.1-0.3-0.5-0.6-0.7c-0.2-0.1-0.1-0.2-0.1-0.3 C22.2,41.8,22.5,42,22.7,41.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "M10.4,108.7c-0.2-0.1-0.3-0.5-0.6-0.2c-0.1,0-0.1-0.1-0.2-0.1c-0.1-0.1-0.3-0.2-0.3-0.3c0-0.1,0-0.2,0.1-0.2 c0.1,0,0.3,0,0.4,0c0.1-0.1,0.3,0,0.5,0C10.5,108.1,10.3,108.4,10.4,108.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st84",
    d: "M21.9,65c-0.4-0.4,0.1-0.9,0-1.3c0.1-0.1,0.1-0.1,0.2,0c0,0.4,0,0.9,0,1.3C22.1,65.1,22,65.1,21.9,65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M34,30.8c0.2-0.3,0.5-0.4,0.4-0.8c0.1,0,0.2,0.1,0.2,0.2c0.2,0.2,0.5,0.2,0.6,0.4c0,0.1-0.1,0.2-0.2,0.2 C35,30.9,34.9,31,34.7,31C34.5,30.9,34.3,30.8,34,30.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st96",
    d: "M15.7,36.8c0.4-0.1,0.8-0.3,0.9,0.4c-0.3,0-0.6,0-0.9,0C15.7,37.1,15.5,36.9,15.7,36.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st163",
    d: "M24.1,77.1c-0.2-0.3,0.1-0.5,0-0.8c0-0.1,0.1-0.1,0.2-0.1c0.3,0.1,0.2,0.4,0.2,0.6 C24.5,77.1,24.3,77.1,24.1,77.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st164",
    d: "M13,91.3c0.1,0,0.1,0,0.2,0c0.1,0.1,0.1,0.1,0.1,0.2c0,0,0.1,0,0.1,0c0,0.2,0,0.5-0.2,0.6 c-0.2,0-0.3,0.2-0.5,0c-0.1-0.3,0.1-0.4,0.2-0.7C12.9,91.4,12.9,91.4,13,91.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M31,43.9c-0.4-0.1-0.7-0.2-0.9-0.5c0.3-0.3,0.5,0,0.8,0.1c0.2,0,0.3,0,0.2,0.2C31,43.8,31,43.8,31,43.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st165",
    d: "M10.8,11c0-0.2-0.1-0.4-0.2-0.6c0,0,0-0.1,0-0.1c0,0,0.1-0.1,0.1-0.1c0,0,0.1,0,0.1,0c0.1,0,0.3,0,0.4,0 C11.2,10.4,11.4,10.9,10.8,11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M18.3,4.9C19,5.2,18.9,5.6,18.5,6C18.2,5.7,18.4,5.3,18.3,4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st166",
    d: "M10.1,31.4c0,0.1,0,0.2,0,0.2c-0.4,0.1-0.7,0.4-1.1,0c0-0.2,0.1-0.3,0.3-0.4C9.6,31.3,9.9,31.3,10.1,31.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st167",
    d: "M28.5,71.1c0-0.1-0.1-0.2-0.3-0.3c0-0.1,0-0.3,0.1-0.4c0.2,0,0.3-0.2,0.5-0.3c0,0,0.1,0.1,0.1,0.1 c0.1,0.2,0.1,0.4-0.1,0.6C28.7,70.9,28.6,71,28.5,71.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M2.4,23.7c0,0.3,0,0.6,0,0.8l0,0c-0.3,0.1-0.3-0.2-0.5-0.3c-0.1,0-0.1-0.1-0.2-0.1c0-0.2,0-0.4,0-0.6 C2,23.5,2.2,23.6,2.4,23.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "M36.6,67.8c-0.1-0.2-0.2-0.4,0-0.7c0.1-0.2,0.2-0.2,0.4-0.2c0,0.2,0,0.4,0,0.6c-0.1,0.1-0.1,0.2-0.2,0.2 C36.8,67.8,36.7,67.8,36.6,67.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st169",
    d: "M21.4,79.7c-0.1,0.1-0.3,0.3-0.4,0.4c0,0-0.1,0-0.1,0c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.5,0.4-0.5,0.6-0.7 C21.5,79.4,21.5,79.5,21.4,79.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M36.4,27.3c-0.1-0.2-0.3-0.4-0.1-0.6c0.1-0.1,0.4,0,0.6,0C36.8,27,36.7,27.2,36.4,27.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st170",
    d: "M30.8,66.1c0,0.2,0,0.3,0,0.5c-0.1,0.2,0.1,0.5-0.2,0.6c-0.1-0.1-0.2-0.1-0.2-0.2 C30.3,66.6,30.5,66.3,30.8,66.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st79",
    d: "M40.7,64.4c0-0.2,0-0.4,0-0.6c0.3,0,0.6-0.1,0.6,0.4C41.2,64.2,41,64.4,40.7,64.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "M30.6,58.1c0.1,0.2,0.2,0.3,0.2,0.5c0.1,0,0.1,0.1,0.1,0.1c0,0,0,0.1-0.1,0.1c-0.4,0.1-0.6-0.3-0.9-0.4 C30.1,58.1,30.4,58.1,30.6,58.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st172",
    d: "M47.8,43.9c-0.2,0.1-0.4,0.2-0.6,0.2c-0.1,0.1-0.1,0.1-0.2,0c0-0.6,0.6-0.4,0.8-0.6 C47.8,43.6,47.8,43.8,47.8,43.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M8.8,110c-0.1,0-0.3,0.6-0.4,0c0-0.3,0-0.7,0.1-1c0.1-0.1,0.2-0.1,0.2,0c0.1,0.1,0.1,0.2,0.1,0.4 c0,0.2,0.1,0.3,0.1,0.5C9,109.9,8.9,110,8.8,110z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st173",
    d: "M22.2,53c0.1,0.1,0.3,0.1,0.4,0.2c-0.1,0.4-0.3,0.7-0.2,1.1c0,0-0.1,0.1-0.1,0.1c0,0-0.1,0-0.1-0.1 C22.2,53.8,22.1,53.4,22.2,53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M13.4,10.8c0.1,0,0.1,0,0.2,0c0.1-0.1,0.3-0.1,0.4,0c0,0.1,0,0.1,0,0.2l0,0c-0.2,0.2-0.2,0.5-0.4,0.6l0,0 C13.3,11.4,13.4,11.1,13.4,10.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st157",
    d: "M34.3,29.9c-0.1,0.3-0.3,0.4-0.6,0.4c-0.2-0.1-0.2-0.2-0.2-0.4C33.7,29.9,34,29.9,34.3,29.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st174",
    d: "M10.1,36.4c0-0.1,0-0.3,0-0.4c0.4,0,0.7,0,0.8,0.4C10.7,36.4,10.4,36.4,10.1,36.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M7.1,37.4c-0.4,0-0.8,0-1.1,0.2C6.4,37.1,6.7,37,7.1,37.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "M8,36.4c-0.1-0.2-0.1-0.4-0.2-0.6c0.1-0.1,0.1-0.1,0.2,0c0.2-0.1,0.5-0.3,0.3,0.2c0,0.1,0.1,0.3,0.1,0.4 C8.3,36.4,8.1,36.4,8,36.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st176",
    d: "M22.6,49.9c0.1,0.3-0.1,0.6,0.2,0.9c0.1,0.1,0.2,0.2,0.2,0.3c0,0.1-0.1,0.1-0.2,0.1 c-0.1-0.1-0.2-0.1-0.3-0.2C22.5,50.7,22.4,50.3,22.6,49.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M11.9,36c0.1-0.7,0.5-0.5,0.9-0.2c-0.1,0.2-0.3,0.2-0.4,0.2c-0.1,0-0.1,0-0.2,0L12,36L11.9,36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M25.4,59c-0.1,0-0.3,0-0.4,0c-0.3-0.5,0-0.6,0.4-0.7C25.4,58.6,25.4,58.8,25.4,59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st177",
    d: "M1.5,27.1c0-0.2-0.1-0.6,0.2-0.5c0.4,0.1,0.1,0.5,0,0.8C1.7,27.3,1.6,27.2,1.5,27.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M23.3,5.2C23.2,5.7,22.9,6,22.4,6C22.6,5.6,22.9,5.4,23.3,5.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M1.1,30.8c0.3,0,0.5,0.1,0.6,0.4c0.1,0.2-0.2,0.3-0.3,0.3C1.2,31.2,1.1,31,1.1,30.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M8.2,22.4C8,22.5,8,22.6,8,22.8c-0.3,0.2-0.3-0.5-0.6-0.2c0-0.3,0.1-0.4,0.4-0.4C8,22.2,8.1,22.2,8.2,22.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M17.7,3c0.1-0.1,0.3-0.1,0.4-0.2c0.1,0.3,0.4,0.7-0.2,0.9C17.6,3.5,17.7,3.2,17.7,3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st178",
    d: "M21.1,60.5c0-0.1,0-0.1,0-0.2c0.3-0.2,0.5-0.3,0.8-0.1c0.1,0.2,0.1,0.3,0,0.5l0,0c-0.1,0-0.1,0.1-0.2,0 c-0.2-0.3-0.4,0.1-0.7,0C21.1,60.6,21.1,60.6,21.1,60.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M19.6,49.1c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1-0.4-0.4-0.7-0.4-1.1C19.4,48.4,19.4,48.8,19.6,49.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M25.4,23.7c-0.1,0-0.3,0-0.4,0c-0.1,0.1-0.2,0.1-0.2,0c0.1-0.2,0.2-0.4,0.4-0.4c0.1-0.1,0.3-0.1,0.4,0l0,0 c0.1,0.1,0.1,0.3,0,0.4l0,0C25.6,23.7,25.5,23.7,25.4,23.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st101",
    d: "M11.9,23.4c0-0.2,0-0.3,0.2-0.4c0.4,0.1,0.7,0.3,0.6,0.8l0,0C12.3,23.9,12.2,23.6,11.9,23.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st179",
    d: "M14.4,36.2c0,0.3-0.1,0.5-0.2,0.7c-0.1,0-0.1,0-0.2,0c-0.1-0.1-0.1-0.1-0.2-0.2l0,0 C13.8,36.1,14.1,36.2,14.4,36.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M33.8,31.9c0.3,0,0.5-0.7,0.8,0c-0.2,0.1-0.4,0.3-0.6,0.2C34,32,33.9,31.9,33.8,31.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M34.9,24.3c-0.1,0.1-0.2,0.2-0.2,0.2c0,0-0.1,0-0.1-0.1c0-0.1-0.1-0.1-0.1-0.2c0-0.1-0.1-0.1-0.1-0.2 c0-0.1,0-0.1,0.1-0.2c0.2,0,0.3,0,0.4-0.2c0.1,0,0.3,0,0.4,0C35.2,23.9,35.1,24.1,34.9,24.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M13.4,16.8c-0.1-0.1-0.1-0.3-0.2-0.4c-0.1-0.1-0.1-0.1-0.1-0.2c0-0.1,0-0.1,0-0.1c0.2-0.1,0.4-0.2,0.6-0.1 c0.3,0.1,0.2,0.4,0.2,0.6c0,0.1-0.1,0.2-0.3,0.3C13.5,16.9,13.4,16.9,13.4,16.8L13.4,16.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.5,43.3c0.3-0.4,0-0.7,0-1.1C32,42.7,32,42.9,31.5,43.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M24.4,19.8c0-0.1,0-0.1,0-0.2c0.1,0,0.3,0,0.4,0c-0.2,0.2,0.4,0.9-0.4,0.6l0,0C24.4,20.1,24.4,19.9,24.4,19.8z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M17.9,3.6c0.3-0.2,0.2-0.6,0.2-0.9l0,0c0.1-0.1,0.1-0.1,0.2,0c-0.1,0.4,0.3,0.9-0.4,1.1 C17.9,3.8,17.9,3.7,17.9,3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "M11,37.2c-0.3,0-0.4-0.1-0.4-0.4c0.2,0,0.4,0,0.6,0C11.2,37,11.2,37.2,11,37.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M29.7,40.7c0.1,0.1,0.1,0.1,0.2,0.2C30,41,30,41,30,41.1c0,0.1,0,0.1-0.1,0.1c-0.1,0.2-0.3,0.2-0.4,0.2 c-0.1-0.1-0.1-0.1-0.1-0.2c0-0.1,0-0.2,0-0.3C29.5,40.7,29.6,40.6,29.7,40.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.3,42c0.4,0.4,0.2,0.6-0.2,0.6c-0.1-0.1-0.1-0.1-0.2-0.2C20,42.3,20.2,42.2,20.3,42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31,43.7c-0.1-0.1-0.1-0.2-0.2-0.2c0-0.6,0.4-0.3,0.6-0.2C31.4,43.5,31.2,43.6,31,43.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M19.6,0.2c0,0.2,0,0.4-0.3,0.4c-0.3-0.1-0.2-0.3-0.2-0.5C19.4,0,19.5,0,19.6,0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st180",
    d: "M48.3,45.8c0.4,0.3,0.3,0.6-0.2,0.7c-0.2-0.2-0.2-0.4,0-0.6l0.1,0C48.1,45.8,48.2,45.9,48.3,45.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M26.1,49.1c-0.1-0.1-0.1-0.3-0.2-0.4c0.2-0.1,0.4-0.1,0.7,0C26.5,48.9,26.4,49.1,26.1,49.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st176",
    d: "M23.1,49.5c-0.1-0.2-0.2-0.3-0.4-0.4c0-0.1,0-0.3,0-0.4c0.2,0.2,0.5,0.4,0.6,0.6c0,0,0.1,0.1,0.1,0.1 c0,0,0,0.1-0.1,0.1C23.2,49.6,23.1,49.6,23.1,49.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st181",
    d: "M10.4,32.7c-0.3,0.1-0.1,0.5-0.3,0.7C9.9,33.2,10,33,9.9,32.7c0.1-0.2,0.3-0.2,0.4-0.2 C10.4,32.6,10.4,32.6,10.4,32.7C10.4,32.7,10.4,32.7,10.4,32.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M34.7,31c0.1-0.2,0.3-0.2,0.5-0.2c0,0.2,0,0.5-0.2,0.6C34.7,31.3,34.7,31.2,34.7,31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M44.6,58.6c-0.3,0-0.4,0.3-0.6,0.4c0-0.4,0-0.7,0.4-0.9C44.4,58.3,44.5,58.4,44.6,58.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st182",
    d: "M35.3,30.6c-0.3,0-0.7,0-0.6-0.4C35,30.1,35.3,30.1,35.3,30.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M28.4,61.8c0.2,0.1,0.5,0.2,0.4,0.4c-0.1,0.2-0.4-0.1-0.6,0C28.2,62,28.2,61.9,28.4,61.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st183",
    d: "M22.2,63.7c-0.1,0-0.1,0-0.2,0c-0.2-0.3,0-0.6,0.3-0.8C22.5,63.3,22.1,63.5,22.2,63.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M36.8,65.5c0-0.2,0-0.4,0-0.7c0.2,0,0.5-0.1,0.6,0.2C37.3,65.2,37.1,65.3,36.8,65.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st184",
    d: "M27.2,73c-0.1-0.1-0.1-0.2-0.2-0.2c0.1-0.3,0-0.8,0.6-0.4l0,0c0,0.1,0,0.1-0.1,0.2c0,0.1-0.1,0.2-0.2,0.2 C27.3,72.9,27.2,73,27.2,73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st185",
    d: "M21.4,79.7c0-0.2,0-0.3,0-0.5c0-0.1,0.1-0.2,0.2-0.2c0,0,0.1,0,0.1-0.1c0,0,0.1,0.1,0.1,0.1 C21.7,79.3,21.8,79.7,21.4,79.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M24.6,23.2c-0.2-0.1-0.2-0.3-0.2-0.4c0.2-0.1,0.4-0.1,0.7,0C24.9,23,24.8,23.2,24.6,23.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st150",
    d: "M16.8,80.5c0,0.3,0.2,0.8-0.4,0.9C16.5,81.1,16.5,80.7,16.8,80.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st150",
    d: "M16.8,82.3c0-0.3,0.1-0.6,0.5-0.6c-0.1,0.3,0.1,0.6-0.3,0.9C17,82.4,16.9,82.3,16.8,82.3L16.8,82.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st186",
    d: "M16,83.3c0,0.4,0,0.7,0,1.1c-0.1,0-0.2,0-0.2,0c0-0.4-0.2-0.9,0.2-1.3C15.9,83.2,16,83.2,16,83.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st150",
    d: "M10.6,98c0.2-0.1,0.2-0.3,0.2-0.4c-0.1,0-0.1-0.1-0.1-0.1c0,0,0.1-0.1,0.1-0.1c0.1,0,0.1,0,0.2,0 c0.1,0.4,0,0.7-0.2,1.1c-0.1,0-0.1,0-0.2,0C10.5,98.3,10.5,98.1,10.6,98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M35.6,27.3c0-0.1,0-0.3,0-0.4c0.2,0.1,0.4,0.3,0.7,0.4c-0.1,0.2-0.2,0.2-0.4,0.2c-0.1,0-0.2,0-0.2,0 C35.5,27.5,35.5,27.5,35.6,27.3C35.5,27.4,35.5,27.3,35.6,27.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st112",
    d: "M21.1,2.8c-0.6-0.3-0.3-0.5,0-0.8C21.1,2.2,21.1,2.5,21.1,2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M24.4,19.2c-0.1,0-0.3,0-0.4,0c-0.2-0.1-0.3-0.2-0.2-0.4c0.3,0.1,0.6,0.1,0.8,0.2 C24.5,19,24.4,19.1,24.4,19.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st187",
    d: "M47.8,50.4c-0.1,0.2-0.2,0.2-0.4,0.2c-0.1,0.1-0.1,0.1-0.2,0c0.1-0.1,0.1-0.3,0.2-0.4 C47.6,50.2,47.7,50.2,47.8,50.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M17.3,42.4C17,42,17,42,17.7,42l0,0c0.1,0,0.1,0.1,0.1,0.1c0,0,0,0.1-0.1,0.1l0,0c-0.1,0.1-0.1,0.1-0.2,0.2 C17.4,42.4,17.3,42.4,17.3,42.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M8.4,108.3c0.2,0,0.4,0,0.7,0c0,0,0,0.1,0.1,0.1c0,0.1-0.1,0.2-0.1,0.2c-0.1,0.1-0.2,0.1-0.3,0.2 c-0.1,0-0.2,0-0.2-0.1C8.4,108.6,8.2,108.5,8.4,108.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "M22.6,54.5c-0.1,0.2-0.1,0.4-0.2,0.6c-0.4-0.1-0.3-0.4-0.2-0.7c0-0.1,0.1-0.1,0.1-0.1l0.1-0.1 C22.5,54.3,22.6,54.4,22.6,54.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.9,12.3c0,0.1,0,0.3,0,0.4c0,0,0,0.1,0,0.1c0,0-0.1,0.1-0.1,0.1c0,0-0.1,0-0.1,0c-0.6-0.2-0.2-0.4,0-0.6 C23.8,12.3,23.9,12.3,23.9,12.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st150",
    d: "M10.8,96.3c0.2-0.1,0.3-0.1,0.5-0.2c0.1,0.2-0.1,0.4-0.1,0.6c-0.2,0-0.3-0.1-0.4-0.2 C10.8,96.4,10.8,96.3,10.8,96.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st170",
    d: "M16,85.5c0.1-0.1,0.1-0.1,0.2-0.2c0,0,0.1,0,0.1-0.1c0,0,0.1,0,0.1,0.1c0,0.4-0.3,0.6-0.6,0.6 c0-0.1,0-0.2,0-0.2C15.8,85.6,15.9,85.6,16,85.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st190",
    d: "M17,84.6c0,0.1-0.1,0.2-0.2,0.2c-0.1,0.1-0.2,0.1-0.3,0.1c-0.2,0-0.3-0.1-0.3-0.3c0-0.1,0-0.2,0.1-0.3 c0.1-0.1,0.3-0.1,0.4-0.1C16.9,84.4,16.9,84.5,17,84.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st191",
    d: "M16.8,84.4c-0.2,0-0.3,0-0.5,0c-0.1,0-0.1-0.1-0.1-0.1c0-0.1,0-0.1,0-0.1c0.1-0.1,0.2-0.2,0.3-0.2 c0.1,0.1,0.3,0.2,0.5,0.1c0.1,0,0.2,0,0.2,0.1c-0.1,0.1-0.2,0.1-0.2,0.2C17,84.5,16.9,84.5,16.8,84.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st144",
    d: "M23.1,48c-0.1,0-0.2,0-0.2,0c0.1-0.4-0.1-0.8,0.2-1.1C23.1,47.3,23.1,47.6,23.1,48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st192",
    d: "M30.4,67.4c0,0.1,0.3,0.3,0,0.4c-0.1,0.1-0.1,0.1-0.2,0c-0.1-0.2-0.3-0.4,0-0.6 C30.3,67.2,30.3,67.3,30.4,67.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M13.2,16.1c0,0.1,0,0.1,0,0.2c-0.1-0.1-0.3-0.2-0.4-0.2c-0.1,0-0.1-0.1-0.1-0.1c0,0,0-0.1,0.1-0.1 c0.1-0.2,0.3-0.2,0.4,0C13.2,16,13.3,16,13.2,16.1C13.2,16.1,13.2,16.1,13.2,16.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M30.2,65c0.2,0,0.3-0.2,0.5,0c0.2,0.2,0,0.3,0,0.5C30.4,65.4,30.2,65.2,30.2,65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M30.2,64.8c0,0.1,0,0.1,0,0.2c-0.4-0.1-0.8,0.2-1.1-0.2c0.3,0,0.6,0,0.9,0C30,64.7,30.1,64.7,30.2,64.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st193",
    d: "M20.7,80.5c-0.1,0.3-0.4,0.3-0.6,0.4l0,0c0-0.3,0-0.5,0.4-0.5C20.5,80.4,20.6,80.4,20.7,80.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st150",
    d: "M16.6,83.3c0-0.3,0.1-0.5,0.4-0.7C17.1,83,16.8,83.2,16.6,83.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st194",
    d: "M16.3,84.5c0.1,0.1,0.1,0.3,0.3,0.3c0,0,0.1,0.1,0,0.1c0,0,0,0.1-0.1,0.1c-0.1,0.1-0.2,0.2-0.2,0.2l0,0 c-0.1-0.1-0.2-0.2-0.3-0.3c0-0.1,0-0.3,0.1-0.4l0,0C16.2,84.6,16.3,84.5,16.3,84.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st147",
    d: "M14.7,87.4c0.1-0.1,0.3-0.1,0.4-0.2c0,0,0.1,0,0.1,0.1c0,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.1,0,0.2 c-0.1,0.1-0.1,0.2-0.3,0.3c-0.2,0-0.2-0.1-0.2-0.3C14.6,87.6,14.6,87.6,14.7,87.4C14.6,87.5,14.6,87.5,14.7,87.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st195",
    d: "M14.7,87.6c0,0.1,0.1,0.2,0.2,0.2c0.1,0,0.1,0.1,0.1,0.1c0,0,0,0.1-0.1,0.1c0,0.1-0.1,0.2-0.2,0.2 c-0.1-0.2-0.2-0.5-0.2-0.7l0,0C14.5,87.5,14.6,87.5,14.7,87.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st196",
    d: "M12.9,91.5c0,0.3-0.1,0.5-0.2,0.7c-0.1,0-0.2,0-0.3,0C12.5,91.8,12.7,91.6,12.9,91.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M12.3,94.3c0,0.3-0.1,0.5-0.4,0.7c-0.2-0.2-0.2-0.3,0-0.5l0,0c0.1-0.1,0.2-0.1,0.2-0.2l0,0 C12.1,94.3,12.2,94.3,12.3,94.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M10.8,96.5c0.1,0.1,0.2,0.1,0.4,0.2c0.1,0.2,0.1,0.4-0.1,0.5C10.9,96.9,10.8,96.7,10.8,96.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st197",
    d: "M10.1,102.5c0-0.3,0-0.6,0-0.8c0.1,0,0.1,0,0.2,0C10.3,101.9,10.4,102.3,10.1,102.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M8.9,104.9c-0.1-0.1-0.3-0.1-0.4-0.2c0-0.1,0-0.3,0-0.4c0.1,0.1,0.3,0.1,0.4,0.2C9,104.6,9,104.7,8.9,104.9z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M8.4,105.4c0.1,0.3,0.1,0.5,0.2,0.8C8.1,106.1,8.2,105.8,8.4,105.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M10.8,32.3c0.1,0,0.2,0,0.2,0c0.2,0.2,0.2,0.4,0.1,0.6c-0.1,0.1-0.2,0.1-0.3,0l0,0c-0.1-0.1-0.2-0.3-0.2-0.4 C10.6,32.4,10.7,32.4,10.8,32.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M10.6,32.5c0.2,0.1,0.2,0.3,0.2,0.4c-0.2,0-0.3,0-0.4-0.2c0-0.1,0-0.1,0-0.2C10.4,32.5,10.5,32.5,10.6,32.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st198",
    d: "M23,51.8c0-0.2-0.1-0.4-0.3-0.6l0.1,0c0-0.1,0.1-0.1,0.2-0.1c0.1,0,0.1,0,0.2,0.1 C23.3,51.5,23.3,51.7,23,51.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M19.6,59.2c0-0.1,0-0.2,0.1-0.3c0.3,0.1,0.3,0.3,0.4,0.5C19.9,59.4,19.7,59.4,19.6,59.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st199",
    d: "M13.8,40.5c-0.1-0.1-0.3-0.1-0.4-0.2c0.1-0.2,0.2-0.4,0.4-0.4c0,0,0.1,0.1,0.1,0.1c0.1,0.1,0.1,0.2,0.1,0.4 C13.9,40.3,13.9,40.4,13.8,40.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st200",
    d: "M23.1,50.2c0.5,0.1,0.5,0.3,0.2,0.6c0,0-0.1,0-0.1-0.1c-0.1-0.1-0.1-0.2-0.2-0.3C23,50.3,23,50.2,23.1,50.2 L23.1,50.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M33.2,45.4c-0.2,0.2-0.3,0.6-0.6,0.2C32.7,45.6,32.9,45.4,33.2,45.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st144",
    d: "M23.3,45.4c0,0.3,0.1,0.6-0.2,0.9C23.1,46,23.1,45.7,23.3,45.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st201",
    d: "M22.4,55.3c0.2,0.3,0.2,0.5-0.2,0.7C22.2,55.7,22.1,55.5,22.4,55.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M6.9,34.9c0.2,0,0.5,0,0.5,0.1c0,0.2-0.3,0.2-0.5,0.3C6.9,35.2,6.9,35,6.9,34.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M9.3,31.4c-0.1,0.1-0.2,0.2-0.2,0.2c-0.1,0-0.1,0-0.2,0c0-0.1,0-0.3,0-0.4c0,0,0.1-0.1,0.1-0.1 C9.2,31.1,9.4,31.1,9.3,31.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M37.5,65.5c0-0.1,0-0.3,0-0.4c0.3,0.1,0.4,0.3,0.5,0.6c-0.1,0-0.2,0-0.2,0C37.6,65.6,37.5,65.6,37.5,65.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st202",
    d: "M22.1,66.1c-0.1,0-0.2,0-0.3,0c0-0.2,0-0.4,0.2-0.4C22.3,65.8,22.1,66,22.1,66.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M21.1,69.7c0,0.3,0.1,0.6-0.2,0.9C20.9,70.3,20.8,70,21.1,69.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st203",
    d: "M20.7,80.5c-0.1,0-0.2,0-0.3,0c0.1-0.1-0.2-0.4,0.2-0.4c0.1,0,0.2-0.1,0.3-0.1c0,0,0,0.1,0,0.1 C20.8,80.3,20.8,80.4,20.7,80.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st204",
    d: "M48.3,53c0.1-0.2,0.2-0.2,0.4-0.2c-0.1,0.2-0.2,0.4-0.4,0.4C48.3,53.1,48.3,53,48.3,53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M30.8,53.2c0.3,0.3,0,0.3-0.2,0.4C30.6,53.4,30.6,53.3,30.8,53.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st205",
    d: "M47,55.5c-0.1,0.1-0.1,0.3-0.3,0.2c-0.1-0.1,0-0.2,0.1-0.3C46.9,55.4,46.9,55.4,47,55.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M43.5,60.5c-0.1,0-0.3,0-0.3-0.2c0-0.1,0.3,0,0.5-0.1C43.7,60.4,43.6,60.4,43.5,60.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M31.7,38.7c-0.1-0.1-0.1-0.3-0.2-0.4C31.7,38.4,32,38.4,31.7,38.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st206",
    d: "M22,62.4c0.1,0,0.3,0,0.4,0c0,0.3-0.3,0.2-0.4,0.2C21.9,62.6,21.9,62.5,22,62.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M30.4,67.4c-0.1,0-0.2-0.1-0.2-0.2c0.1-0.1,0.1-0.1,0.2-0.2c0.1,0.1,0.2,0.1,0.2,0.2 C30.5,67.2,30.5,67.3,30.4,67.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M26.7,48c0.2,0,0.3,0,0.4,0.2c-0.1,0.1-0.3,0.1-0.4,0.2C26.7,48.3,26.7,48.2,26.7,48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M29.3,68.9c-0.1,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1-0.1-0.1-0.1c0,0,0-0.1,0.1-0.1 c0.1-0.1,0.1-0.1,0.2-0.2C29.1,68.7,29.2,68.8,29.3,68.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st208",
    d: "M21.6,68.9c0.2,0.1,0.2,0.3,0.2,0.4c0,0.1-0.1,0.2-0.2,0.3c0-0.1,0-0.2,0-0.3C21.6,69.2,21.6,69,21.6,68.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M28.9,70.8c0-0.2,0-0.4,0.1-0.6c0.1,0,0.1,0,0.2,0C29.1,70.4,29.2,70.7,28.9,70.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "M45.9,55.3c0.1-0.1,0.2-0.1,0.2-0.2c0.1,0,0.2,0.1,0.2,0.2l0,0c-0.1,0.1-0.2,0.3-0.5,0.2 C45.8,55.5,45.8,55.4,45.9,55.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st209",
    d: "M21.7,78.6c0.1-0.1,0.2-0.4,0.4-0.3c0.1,0.1,0,0.2-0.1,0.3C21.9,78.7,21.8,78.7,21.7,78.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st210",
    d: "M21.7,78.6c0.1,0,0.2,0,0.3,0c0,0.2,0,0.4-0.2,0.5c0,0,0-0.1-0.1-0.1c-0.1,0-0.1-0.1-0.1-0.2 C21.5,78.7,21.6,78.6,21.7,78.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st211",
    d: "M23.7,49.3c0,0.3,0,0.5-0.4,0.4c-0.1,0-0.1-0.1-0.1-0.1c0,0,0-0.1,0.1-0.1l0,0c0.1-0.1,0.1-0.1,0.2-0.2 l0.1,0C23.6,49.2,23.7,49.2,23.7,49.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st150",
    d: "M16.2,82.2c0,0.2,0.1,0.5-0.1,0.6C16.1,82.7,16,82.4,16.2,82.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st212",
    d: "M17.7,83.3c0,0.2,0,0.3-0.2,0.4c0,0-0.1-0.1-0.1-0.1c0,0,0.1-0.1,0.1-0.1c0-0.2,0-0.4,0.2-0.4 C17.8,83.2,17.7,83.3,17.7,83.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M17.3,84.2c-0.1,0-0.1,0-0.2,0c-0.1-0.1-0.1-0.1-0.1-0.2c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.1,0,0.2,0 c0,0,0.1,0,0.1,0C17.4,83.9,17.3,84.1,17.3,84.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st213",
    d: "M15.3,86.4c0-0.2,0.2-0.4,0.4-0.5C15.7,86.2,15.6,86.3,15.3,86.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st213",
    d: "M15.1,87c0-0.2-0.1-0.5,0.2-0.6c0,0.2,0,0.4,0,0.6C15.3,87.1,15.2,87.1,15.1,87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st214",
    d: "M11.9,94.5c0,0.2,0,0.3,0,0.5c0,0.1,0,0.1,0,0.2C11.5,95,11.6,94.7,11.9,94.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st215",
    d: "M10.4,96.5c0,0.2,0,0.3-0.2,0.4c0-0.2,0-0.5,0.2-0.6c0,0,0.1,0.1,0.1,0.1C10.4,96.4,10.4,96.4,10.4,96.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M29.7,42.2c-0.1-0.1-0.1-0.3-0.2-0.4c0.1,0,0.3,0,0.4,0c0,0.1,0,0.3,0,0.4C29.9,42.2,29.8,42.2,29.7,42.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M47.2,53.6c0.2-0.3,0.3,0,0.4,0c-0.1,0.2-0.3,0.2-0.4,0.2l0,0C47.1,53.8,47.1,53.7,47.2,53.6 C47.1,53.6,47.2,53.6,47.2,53.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st215",
    d: "M10.2,107.9c-0.1,0.3-0.3,0-0.5,0c0.1-0.1,0.2-0.1,0.3-0.2C10.1,107.7,10.2,107.7,10.2,107.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M33.8,52.7c-0.1-0.1-0.3-0.1-0.4-0.2c0.1-0.1,0.2-0.1,0.2-0.2C33.8,52.4,33.8,52.6,33.8,52.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M33.8,20c0.1-0.2,0.3-0.2,0.4-0.2l0,0C34.3,20.2,34.1,20.2,33.8,20L33.8,20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M5.6,32.9c0.1-0.2,0.3-0.2,0.4,0C5.9,32.9,5.8,32.9,5.6,32.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M25.6,23.2c-0.1,0-0.3,0-0.4,0c0.1-0.2,0.2-0.2,0.4-0.2C25.6,23.1,25.6,23.2,25.6,23.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M23.2,51.2c-0.1,0-0.2,0-0.2,0c-0.1-0.2-0.1-0.4,0.2-0.4l0,0C23.3,50.9,23.3,51.1,23.2,51.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M29.5,45.2c0.1-0.2,0.3-0.2,0.4-0.2C29.9,45.2,29.7,45.2,29.5,45.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M24.8,23.7c0.1,0,0.2,0,0.2,0c-0.1,0.2-0.3,0.3-0.4,0C24.6,23.7,24.7,23.7,24.8,23.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M14,25.4c0-0.1,0.1-0.1,0.2-0.1c0.1,0.1,0,0.2,0.1,0.3C14.2,25.5,14.1,25.5,14,25.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M18.1,1.3c-0.1,0-0.1,0-0.2,0c0-0.1,0.1-0.2,0.2-0.2C18.3,1.1,18.3,1.2,18.1,1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st216",
    d: "M23,52.7c-0.2-0.1-0.2-0.3-0.2-0.4C23.1,52.4,23.1,52.6,23,52.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st217",
    d: "M21.9,65c0.1,0,0.1,0,0.2,0c0,0.1,0.1,0.3-0.1,0.4C22,65.4,21.9,65.2,21.9,65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M40.9,45.2c0,0.1,0,0.3,0,0.4c-0.1-0.1-0.1-0.1-0.2-0.2C40.8,45.3,40.8,45.2,40.9,45.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st218",
    d: "M30.1,67.8c0.1,0,0.1,0,0.2,0c0,0.1,0,0.2-0.2,0.2c-0.1,0.1-0.1,0.1-0.2,0.1c0-0.1,0-0.1,0-0.2 C30,67.9,30,67.8,30.1,67.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st219",
    d: "M29.9,68.1c0.1,0,0.2-0.1,0.2-0.1c0,0.2,0,0.4-0.2,0.5l-0.1-0.1c0,0,0-0.1,0-0.1 C29.9,68.2,29.9,68.2,29.9,68.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M8.2,6c0.2,0,0.3,0,0.4,0.2l0,0C8.4,6.4,8.2,6.3,8.2,6L8.2,6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st220",
    d: "M23.7,49.3c-0.1,0-0.1,0-0.2,0c0-0.1,0-0.3,0-0.4c0,0,0.1-0.1,0.1-0.1c0,0,0.1,0.1,0.1,0.1 c0,0.1,0,0.1,0,0.2C23.7,49.2,23.7,49.2,23.7,49.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M21.3,9.2c-0.1,0-0.1,0-0.2,0c0-0.2,0-0.3,0.2-0.4l0,0C21.5,9,21.5,9.1,21.3,9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M25.2,69.8c0.2,0.1,0.2,0.3,0.2,0.4C25.2,70.1,25.2,69.9,25.2,69.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M29.1,70.2c0-0.2,0-0.4,0.2-0.4C29.3,69.9,29.3,70.1,29.1,70.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M18.8,56.6c-0.1,0-0.2,0-0.2,0c-0.1-0.1-0.1-0.2-0.2-0.2C18.5,56.4,18.7,56.4,18.8,56.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M39.9,46.3c0.1,0.1,0.2,0.1,0.2,0.2c-0.1,0-0.3,0-0.4,0C39.7,46.4,39.8,46.4,39.9,46.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M17.7,42.2c0-0.1,0-0.1,0-0.2c0.1,0,0.2,0,0.2,0C18.1,42.3,17.8,42.1,17.7,42.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M26.9,72.9c0,0.2-0.2,0.3-0.4,0.3C26.6,73,26.8,73,26.9,72.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st221",
    d: "M22.9,77.9c0.1,0,0.1,0,0.2,0c-0.1,0.1-0.2,0.2-0.3,0.1C22.7,78,22.8,78,22.9,77.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st150",
    d: "M16.4,81.6c0,0.2,0,0.4-0.2,0.5C16.2,81.8,16.2,81.7,16.4,81.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.1,36c0.1-0.2,0.1-0.2,0.2,0C12.2,36.1,12.2,36.1,12.1,36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st222",
    d: "M17,83.9c0,0.1,0,0.2,0.1,0.2c-0.2,0-0.4,0-0.4-0.2l0,0c0.1-0.1,0.1-0.1,0.2-0.1 C16.9,83.9,16.9,83.9,17,83.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st170",
    d: "M15.7,84.4c0,0.2,0,0.4-0.2,0.4C15.5,84.6,15.6,84.5,15.7,84.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st170",
    d: "M15.3,85.1c0,0.2,0,0.3-0.2,0.4C15.1,85.3,15.1,85.1,15.3,85.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st213",
    d: "M15.1,85.7c0,0.2,0,0.4-0.2,0.5C14.9,85.9,14.8,85.7,15.1,85.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st213",
    d: "M14.7,87c0,0.2,0,0.3,0,0.5l0,0c-0.1,0.1-0.1,0.1-0.2,0C14.5,87.2,14.5,87.1,14.7,87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st213",
    d: "M14.9,88.1c0-0.1,0-0.1,0-0.2c0.1-0.1,0.1-0.2,0.2-0.2C15.1,87.8,15.1,88,14.9,88.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M26.5,20c-0.1,0-0.2,0-0.2-0.1c0-0.2,0.2-0.1,0.2-0.1C26.5,19.9,26.5,19.9,26.5,20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M25.6,55.5c-0.2-0.1-0.2-0.3-0.2-0.4C25.6,55.2,25.6,55.4,25.6,55.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M8.4,104.8c0,0.2,0,0.4,0,0.5C8.2,105.2,8.2,105,8.4,104.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M14.7,25.8C14.6,26,14.4,26,14.2,26c0-0.1,0-0.1,0-0.2c0.1,0,0.1,0,0.2,0C14.5,25.8,14.6,25.8,14.7,25.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M8.4,108.7c0.1,0,0.1,0,0.2,0c0.1-0.1,0.2,0,0.3,0c0,0,0,0.1,0,0.1c0,0,0,0.1-0.1,0.1c-0.1,0.1-0.2,0-0.2,0 H8.5l-0.1,0C8.4,108.9,8.4,108.8,8.4,108.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M26.3,20.5c0-0.1,0.1-0.2,0.2-0.2C26.5,20.4,26.4,20.4,26.3,20.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M13.8,36.6c0.1,0.1,0.1,0.1,0.2,0.2C13.9,36.8,13.8,36.7,13.8,36.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M3.5,24.3c0-0.1,0-0.1,0-0.2c0.1,0,0.2,0.1,0.2,0.2C3.6,24.3,3.5,24.3,3.5,24.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M35.1,25.2c0.1,0,0.1,0,0.2,0c0,0.1,0,0.1,0,0.2c0,0-0.1,0.1-0.1,0.1C35.1,25.4,35.1,25.3,35.1,25.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M35.8,25.4c-0.1,0-0.2,0-0.2,0C35.6,25.2,35.7,25.2,35.8,25.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M9.5,25.4c0,0.1,0,0.2,0,0.2c-0.2,0.1-0.3,0-0.2-0.2l0,0C9.4,25.4,9.4,25.4,9.5,25.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M35.5,25.4c0,0.1-0.1,0.2-0.2,0.2c0,0-0.1-0.1-0.1-0.1c0,0,0-0.1,0-0.1l0,0C35.4,25.4,35.5,25.4,35.5,25.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M42,45.2c-0.1,0-0.1,0-0.2,0C41.9,45,41.9,45,42,45.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M17.5,42.4c0.1-0.1,0.1-0.1,0.2-0.2C17.6,42.3,17.6,42.4,17.5,42.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M33,49.1c0.1-0.1,0.1-0.1,0.2,0l-0.1,0L33,49.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st223",
    d: "M23.3,49.5c0,0.1,0,0.1,0,0.2c-0.1,0-0.1,0.1-0.2,0.1c0-0.1,0-0.2,0-0.3C23.1,49.5,23.2,49.5,23.3,49.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M29.5,41.1c0,0.1,0,0.1,0,0.2c-0.1,0-0.1,0-0.2,0c0,0,0,0,0,0C29.3,41.1,29.3,41.1,29.5,41.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M30,41.1c0-0.1,0-0.2,0-0.2c0.1,0,0.1,0,0.2,0C30.1,41,30,41.1,30,41.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M36.6,63.9c0.1-0.1,0.2-0.1,0.2-0.2C36.8,63.8,36.7,63.9,36.6,63.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M38.8,64.1c0.1-0.1,0.1-0.1,0.2,0C38.9,64.1,38.9,64.1,38.8,64.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st224",
    d: "M32.8,29.9c0.1-0.1,0.1-0.1,0.2-0.2c0,0.1,0,0.1,0,0.2C32.9,29.9,32.8,29.9,32.8,29.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M41.8,45.2c-0.1,0.2-0.1,0.2-0.2,0C41.7,45.2,41.7,45.2,41.8,45.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st225",
    d: "M22.4,54.3c0,0-0.1,0.1-0.1,0.1c0-0.1,0-0.1,0-0.2C22.3,54.3,22.3,54.3,22.4,54.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st62",
    d: "M27.8,67c0.1,0,0.2,0.1,0.2,0.2l0,0C27.8,67.2,27.7,67.2,27.8,67L27.8,67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M35.8,67.6c0.1,0.1,0.1,0.1,0.2,0.2c-0.1,0-0.1,0-0.2,0C35.8,67.7,35.8,67.7,35.8,67.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M36.8,67.8c0.1-0.1,0.1-0.1,0.2-0.2c0,0.1,0,0.1,0,0.2C37,67.8,36.9,67.8,36.8,67.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M10.1,31.6c0.1,0,0.2,0.1,0.2,0.2C10.3,31.8,10.2,31.7,10.1,31.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M13.8,39.8c0-0.1,0.1-0.2,0.2-0.2l0,0C14.1,39.8,14,39.9,13.8,39.8L13.8,39.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M21.3,69.4c-0.1,0.1-0.1,0.1-0.2,0.2C21.2,69.4,21.2,69.4,21.3,69.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M21.6,70c0-0.1,0-0.2,0-0.3C21.7,69.8,21.7,69.9,21.6,70z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M21.3,70.4c0-0.1,0.1-0.2,0.2-0.2C21.5,70.3,21.5,70.4,21.3,70.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st226",
    d: "M27.4,72.8c0.1-0.1,0.1-0.2,0.2-0.2C27.6,72.7,27.5,72.8,27.4,72.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M26.5,73.4c-0.1,0.1-0.1,0.1-0.2,0.2C26.3,73.5,26.4,73.5,26.5,73.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M26.7,73.9c0-0.1,0.1-0.2,0.2-0.3C26.9,73.7,26.8,73.8,26.7,73.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M22.4,6.2c0,0.1-0.1,0.2-0.2,0.2C22.2,6.3,22.3,6.2,22.4,6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st227",
    d: "M21.6,78.8c0.1,0,0.1,0.1,0.1,0.2c-0.1,0-0.1,0-0.2,0C21.6,79,21.6,78.9,21.6,78.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M20.9,80c-0.1,0-0.2,0-0.3,0.1c0-0.1,0.1-0.1,0.1-0.2C20.8,79.9,20.8,80,20.9,80z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "M20,81c0,0.1,0,0.1-0.1,0.2c0,0-0.1-0.1-0.1-0.1C19.9,81,20,81,20,81L20,81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M7.8,9.5C7.9,9.5,8,9.6,8,9.7C7.9,9.6,7.8,9.5,7.8,9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st228",
    d: "M17.7,83.3c0-0.1,0-0.1,0-0.2c0.1,0,0.2,0,0.1,0.1C17.8,83.3,17.7,83.3,17.7,83.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st219",
    d: "M17.4,83.8c-0.1,0-0.1,0-0.2,0c0.1-0.1,0.2-0.2,0.3-0.2C17.4,83.6,17.4,83.7,17.4,83.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st229",
    d: "M16.8,84.4c0.1,0,0.1,0,0.2,0c0,0.1,0,0.1,0,0.2C16.9,84.6,16.8,84.5,16.8,84.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st170",
    d: "M15.5,84.8c0,0.1-0.1,0.2-0.2,0.3C15.3,84.9,15.4,84.8,15.5,84.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st230",
    d: "M16.6,85c0-0.1,0-0.1,0-0.2c0.1,0,0.1,0,0.2,0C16.8,84.9,16.7,85,16.6,85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st213",
    d: "M14.8,86.5c0,0.1,0,0.2-0.1,0.3C14.7,86.6,14.7,86.5,14.8,86.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st231",
    d: "M15.1,87c0.1,0,0.2,0,0.2,0c0,0.1,0,0.2,0,0.2c-0.1,0.1-0.2,0.1-0.2,0l0,0C15.1,87.1,15.1,87.1,15.1,87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st213",
    d: "M15.1,87.2c0.1,0,0.2,0,0.2,0c0,0.2-0.1,0.2-0.2,0.3C15.1,87.4,15.1,87.3,15.1,87.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st163",
    d: "M14.5,87.4c0.1,0,0.1,0,0.2,0c0,0.1,0,0.1,0,0.2c-0.1,0-0.1,0-0.2,0C14.5,87.6,14.5,87.5,14.5,87.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M13.8,88.7c-0.1,0.1-0.1,0.1-0.2,0.2C13.6,88.8,13.7,88.7,13.8,88.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M14.2,89.1c-0.2,0-0.2-0.1,0-0.2C14.2,89,14.2,89.1,14.2,89.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st232",
    d: "M12.3,94.3L12.3,94.3l-0.2,0c0-0.1,0.1-0.2,0.3-0.2C12.3,94.2,12.3,94.2,12.3,94.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st233",
    d: "M11.4,95.6c0-0.1,0-0.3,0.2-0.1C11.6,95.6,11.5,95.6,11.4,95.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st215",
    d: "M10.6,96c0,0.1,0,0.2,0,0.2l-0.1,0.1l-0.1,0l0,0C10.4,96.1,10.4,96.1,10.6,96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M12.7,15.9c0,0.1,0,0.1,0,0.2c-0.1,0-0.2-0.1-0.2-0.2C12.6,15.9,12.7,15.9,12.7,15.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M48.5,57.1c-0.1-0.1-0.1-0.1-0.2-0.2C48.4,56.9,48.4,56.9,48.5,57.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st234",
    d: "M23.3,16.8c0,0.1,0,0.1,0,0.2c-0.1-0.1-0.1-0.1-0.2-0.2C23.1,16.8,23.2,16.8,23.3,16.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M9.7,105.9c0-0.1,0.1-0.2,0.3-0.2c0,0.1,0,0.1-0.1,0.2C9.9,106,9.8,106,9.7,105.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M9.7,105.9c0.1,0,0.1,0,0.2,0c0,0.1,0,0.1,0,0.2C9.8,106.1,9.7,106.1,9.7,105.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st227",
    d: "M9.9,109.4c0.1,0,0.2,0,0.3,0c0,0.1,0,0.1,0,0.2C10.1,109.5,10,109.5,9.9,109.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M11,34.7c-0.2-0.1-0.2-0.3-0.2-0.4c0-0.3,0.1-0.5,0.4-0.5c0.8-0.1,1.1,0.3,1,1.1c0,0-0.1,0.1-0.1,0.1 C11.6,35.5,11.3,34.9,11,34.7L11,34.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M11.2,33.8c-0.1,0.1-0.3,0.3-0.4,0.4c-0.2-0.1-0.2-0.3-0.2-0.4l0,0c0.1,0,0.2-0.2,0.2-0.2 c-0.4-0.3-0.1-0.4,0.1-0.6c0.1,0,0.2,0,0.2,0c0.1-0.1,0.2-0.1,0.3-0.1c0.3,0.1,0.4,0.3,0.4,0.5C11.7,33.7,11.4,33.7,11.2,33.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st157",
    d: "M12.9,35.3c-0.3-0.1-0.8,0.2-0.9-0.4l0,0c0.2-0.2,0-0.6,0.4-0.7c0.4-0.1,0.5,0.2,0.6,0.5 C13,34.9,13.1,35.1,12.9,35.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M8,35.7c-0.1,0-0.1,0-0.2,0c-0.4-0.5,0.1-0.8,0.1-1.3c0.4,0.1,0.6,0.4,0.8,0.6l0,0C8.4,35.2,8,35.3,8,35.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st151",
    d: "M12.9,35.3c0-0.2,0-0.4,0-0.6c-0.1-0.2,0-0.4,0.2-0.5c0.2-0.1,0.3-0.1,0.4,0.1c-0.2,0.4-0.5,0.6-0.4,1.1 C13.1,35.3,13,35.3,12.9,35.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M9.1,34.9c0,0.2,0,0.5-0.3,0.5c-0.2,0-0.2-0.2-0.2-0.3l0,0c0.1-0.1,0.1-0.1,0.2-0.2C8.9,34.8,9,34.8,9.1,34.9 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st235",
    d: "M9.1,34.9c-0.1,0-0.1,0-0.2,0c0.1-0.2,0.2-0.2,0.4-0.2c0.1,0,0.1,0.1,0.1,0.1C9.3,34.8,9.2,34.8,9.1,34.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M9.2,34.3c0-0.1-0.1-0.1,0-0.2c0,0,0.1-0.1,0.2-0.1c0.1,0,0.1,0.1,0,0.2C9.3,34.3,9.2,34.3,9.2,34.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M8.1,33.5c0.1,0,0.1,0.1,0.2,0.1c0.1,0.1,0,0.2-0.1,0.2c-0.1,0-0.1,0-0.2-0.1C8,33.6,8.1,33.5,8.1,33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M10.6,33.8C10.5,33.8,10.5,33.7,10.6,33.8C10.5,33.7,10.5,33.7,10.6,33.8C10.6,33.7,10.6,33.8,10.6,33.8 L10.6,33.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st79",
    d: "M17.2,47.6c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0-0.1,0-0.2,0c-0.2,0.1-0.3,0-0.2-0.2c-0.1-0.5-0.1-0.9-0.7-1 c-0.2,0-0.3-0.2-0.3-0.4c0.1-0.2,0.2-0.1,0.3-0.1c0.3,0.2,0.7,0,0.9,0.3c0,0.2,0.2,0.3,0.3,0.4c0.1,0.2,0.1,0.3,0.1,0.5 C17.2,47.5,17.2,47.5,17.2,47.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st79",
    d: "M16.6,49.9c-0.3,0-0.6,0-0.9,0c0-0.2,0-0.3,0.2-0.4c0.1-0.1,0.2-0.2,0.3-0.2c0.1-0.1,0.2-0.2,0.3-0.3 c0.1-0.1,0.2-0.2,0.3-0.1c0.1,0.3,0.3,0,0.4,0c0.1,0.1,0.1,0.3,0.2,0.4c-0.1,0.3,0,0.7-0.5,0.4C16.8,49.6,16.7,49.8,16.6,49.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M16.4,49.5c-0.1,0-0.3,0-0.4,0c-0.3-0.5-0.4-1,0.4-1.1c0.3,0.3-0.1,0.6,0.1,0.8 C16.5,49.4,16.5,49.4,16.4,49.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M16.4,49.3c-0.4-0.3,0.1-0.6,0-0.9c0.2,0,0.3-0.2,0.5-0.1c0.3,0.2,0,0.4-0.1,0.6c-0.1,0.1-0.1,0.1-0.2,0.2 C16.5,49.2,16.5,49.3,16.4,49.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st199",
    d: "M15.7,47.6c-0.3-0.1-0.4-0.3-0.4-0.6l0,0c0.4,0.1,1-0.1,0.9,0.6C16,47.7,15.9,47.7,15.7,47.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st199",
    d: "M15.3,46.9c-0.1,0.1-0.2,0.2-0.5,0.4c0-0.4-0.2-0.6-0.4-1C15,46.3,15.1,46.6,15.3,46.9L15.3,46.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st236",
    d: "M17,47.1c0-0.2-0.5-0.3-0.2-0.6c0.5,0.2,0.7,0.5,0.6,1.1c-0.1,0-0.1,0-0.2,0l0,0 C17.1,47.5,17.2,47.3,17,47.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M15.7,47.6c0.1,0,0.3,0,0.4,0c0.1,0,0.3,0,0.4,0c0.1,0.1,0.1,0.1,0.2,0.2C16.4,48.2,16,48.1,15.7,47.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st237",
    d: "M15.9,45.5c0,0.1,0.2,0.1,0.2,0.2c0,0.1-0.1,0.1-0.2,0.1c-0.1,0-0.2-0.1-0.2-0.2 C15.6,45.5,15.7,45.5,15.9,45.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M21.3,9.2c0-0.1,0-0.3,0-0.4c0.1,0.2,1-0.2,0.6,0.6c-0.1,0.1,0.3,0.4,0.5,0.7c0.1,0.1,0.1,0.3,0,0.4 c-0.6,0.1-0.3,0.9-0.8,1.1c-0.1-0.6-0.4-1.1-0.4-1.7C21.1,9.7,21.3,9.5,21.3,9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M21.1,9.9c0.4,0.5,0.6,1.1,0.4,1.7c0,0.1,0,0.3,0,0.4c0,0.1,0,0.1,0,0.2c-0.1,0.2-0.3,0.4-0.6,0.4 c-0.5-0.2-0.4-0.6-0.3-1C20.8,11,20.8,10.4,21.1,9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M22.4,8c0.3-0.6,0.9-0.7,1.5-0.6c0,1-0.9,0.4-1.2,0.7C22.7,8,22.5,8,22.4,8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M22.4,10.5c0-0.1,0-0.3,0-0.4c0-0.2,0-0.5,0-1c0.4,0.6,0.3,1.1,0.5,1.5c0.1,0.3-0.3,0.3-0.5,0.4l0,0 C22.4,10.8,22.4,10.7,22.4,10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M22.4,11c0,0.1,0,0.1,0,0.2c0,0.1,0.3,0.3-0.1,0.4c-0.1,0-0.2-0.2-0.1-0.3C22.3,11.1,22.4,11,22.4,11L22.4,11z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st150",
    d: "M16.8,82.3c-0.1,0.1-0.1,0.1-0.2,0.2c0,0,0-0.1-0.1-0.1C16.6,82.3,16.7,82.3,16.8,82.3L16.8,82.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st197",
    d: "M9.5,101.9c0-0.1,0-0.1,0-0.2c0.1-0.1,0.1-0.1,0.2,0c0.1,0,0.1,0,0.2,0c0,0.1,0,0.1,0,0.2 c-0.1,0.1-0.1,0.1-0.2,0.2l0,0C9.5,102.1,9.4,102.1,9.5,101.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st238",
    d: "M10.6,98c0,0.1,0,0.3,0,0.4C10.3,98.3,10.3,98.1,10.6,98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st239",
    d: "M10.1,99.5c-0.1-0.1-0.2-0.1-0.1-0.3c0.1,0,0.1,0.1,0.2,0.1C10.2,99.3,10.2,99.4,10.1,99.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st213",
    d: "M9.7,100.1C9.7,100.1,9.6,100.2,9.7,100.1c-0.1,0.1-0.1,0.1-0.1,0C9.5,100.1,9.6,100,9.7,100.1 C9.6,100.1,9.6,100.1,9.7,100.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M10.4,96.3c0.1,0,0.1,0,0.2,0c-0.1,0.1-0.1,0.1-0.2,0.2C10.4,96.4,10.4,96.4,10.4,96.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M10.4,97.3c0.1-0.2,0.1-0.2,0.2,0C10.5,97.4,10.4,97.4,10.4,97.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st169",
    d: "M10.4,97.3c0.1,0,0.1,0,0.2,0l0,0c0.1,0,0.1,0.1,0.1,0.1c0,0,0,0.1-0.1,0.1C10.5,97.5,10.4,97.4,10.4,97.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M10.6,97.5c0-0.1,0-0.1,0-0.2c0.1,0,0.1,0,0.2,0c0,0.1,0,0.1,0,0.2C10.7,97.5,10.6,97.5,10.6,97.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st240",
    d: "M10.1,99.5c0-0.1,0-0.1,0-0.2C10.3,99.4,10.3,99.4,10.1,99.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st184",
    d: "M9.7,101.6c-0.1,0-0.1,0-0.2,0c0-0.1,0-0.1,0-0.2C9.6,101.4,9.7,101.5,9.7,101.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M22,15.1c0-0.1,0-0.1,0-0.2c-0.1-0.1-0.1-0.3-0.2-0.4l0,0c0-0.5,0.2-0.8,0.6-1.1c0.3,0,0.7,0.1,0.5,0.4 c-0.1,0.3,0.2,0.6-0.1,0.9C22.6,14.9,22.4,15.2,22,15.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M22.4,13.3c-0.2,0.4-0.3,0.8-0.6,1.1c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2-0.1-0.3-0.3c0-0.1,0-0.2,0-0.3 c0.1-0.4,0.2-0.7,0.5-1c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0.1,0.2,0.2C22.3,13.2,22.3,13.3,22.4,13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M21.4,14.2c0.1,0.1,0.1,0.1,0.2,0.2c0,0.3,0,0.6,0,0.9c0.1,0.4-0.4,0.3-0.4,0.6c0,0.1,0,0.1,0,0.2 c-0.1,0.1-0.2,0-0.3-0.1C20.5,15.3,20.8,14.7,21.4,14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M23.9,12.7c0.8,0.2,0.3,0.9,0.4,1.3c-0.1,0-0.4,0.1-0.4,0c0.3-0.5-0.3-0.7-0.3-1.1l0,0 C23.8,12.8,23.9,12.8,23.9,12.7L23.9,12.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M20.9,16.1c0.1,0,0.1,0,0.2,0c0.1,0.1,0.1,0.1,0.2,0.2c-0.1,0.3-0.3,0.4-0.6,0.4 C20.5,16.5,20.4,16.2,20.9,16.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M22,15.1c0.3-0.1,0.6-0.3,0.9-0.4c0,0.4-0.3,0.5-0.5,0.7C22,15.6,22,15.2,22,15.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M24.4,14c0.2,0,0.3-0.4,0.4-0.3c0.1,0.2,0.1,0.5,0.1,0.7c-0.1,0-0.3,0-0.4,0C24.4,14.3,24.4,14.1,24.4,14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M21.1,15.9c-0.1-0.4,0.3-0.4,0.4-0.6C21.7,15.6,21.7,15.6,21.1,15.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st181",
    d: "M22.2,13.1C22.1,13,22.1,13,22,12.9c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.1,0.1,0,0.1c0,0,0,0.1-0.1,0.1 C22.2,13,22.2,13,22.2,13.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M21.8,14.4c0.2,0.1,0.2,0.3,0.2,0.4C21.8,14.8,21.8,14.6,21.8,14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M22,16.1c0,0.1-0.1,0.2-0.2,0.2C21.8,16.2,21.9,16.2,22,16.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st241",
    d: "M29.5,32.9c-0.1,0.1-0.1,0.3-0.2,0.4c0.2,0.3,0.1,0.6,0.1,0.8c0,0.1-0.1,0.3-0.2,0.3c-0.2,0.1-0.3,0-0.5,0.1 c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.2-0.1c-0.2-0.1-0.2,0.1-0.2,0.2c0,0.1,0,0.3,0,0.4c-0.1,0.1-0.1,0.1-0.2,0.1 c-0.3-0.1-0.4-0.2-0.5-0.5c-0.1-0.3-0.2-0.6,0-0.9c0.1-0.2,0.2-0.3,0.3-0.4c0.1-0.1,0.2-0.2,0.3-0.2c0.1,0,0.1-0.1,0-0.1 c-0.1-0.1,0.1-0.1,0-0.1c0-0.1,0-0.2,0-0.3c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.3,0c0.1,0,0.2-0.1,0.3-0.2 c0.1-0.1,0.2-0.1,0.3-0.2c0.1,0,0.1,0,0.2,0c0.1,0.1,0.2,0.2,0.2,0.3c0,0.1,0.1,0.1,0.1,0.2C29.4,32.8,29.5,32.9,29.5,32.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st242",
    d: "M30.8,33.8c0.2-0.3,0.4-0.3,0.7,0c0.1,0.2,0,0.3-0.2,0.4c-0.2,0.1-0.4,0.3-0.6,0.2c-0.4,0.5-0.8,0.7-1.2,0 c0-0.1,0-0.3,0.1-0.4c0-0.2,0.4,0.2,0.2-0.2c0.1-0.1,0.1-0.2,0.3-0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0 C30.5,34,30.7,33.9,30.8,33.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st243",
    d: "M29.3,32.7c-0.2-0.1-0.2-0.3-0.2-0.4c0,0,0-0.1,0-0.1c0-0.1,0.1-0.2,0.1-0.4c0.1-0.2,0.2-0.3,0.4-0.3 c0.1,0,0.2-0.1,0.3-0.2c0.1-0.1,0.2-0.2,0.3-0.2c0.2-0.1,0.3-0.4,0.7-0.3c0.1,0,0.1,0,0.2,0c0,0,0.1,0.1,0,0.1c0,0,0,0.1,0,0.1l0,0 c-0.1,0.1-0.1,0.2-0.2,0.2c-0.5,0.4-1.1,0.7-1.3,1.3C29.5,32.6,29.4,32.7,29.3,32.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M29.7,34c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.1-0.1,0.1-0.2,0c-0.3-0.3,0-0.6,0-0.9c0.3,0,0.5,0.1,0.6,0.4 C29.9,33.9,29.8,33.9,29.7,34L29.7,34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st178",
    d: "M31.5,31c0.1-0.3,0.3-0.4,0.6-0.4C32,30.9,31.8,31,31.5,31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st244",
    d: "M32.3,30.6c0-0.3,0.2-0.4,0.4-0.4C32.8,30.4,32.6,30.6,32.3,30.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st241",
    d: "M29.3,32.7c0-0.1,0.1-0.2,0.2-0.2c0.2,0.1,0.2,0.1,0,0.2C29.4,32.8,29.4,32.8,29.3,32.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st178",
    d: "M30.8,31.2c0.1-0.1,0.1-0.1,0.2-0.2c0,0.1,0,0.1,0,0.2C31,31.4,30.9,31.4,30.8,31.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st245",
    d: "M29.3,32.7c0.1,0,0.1,0,0.2,0c0,0.1,0,0.1,0,0.2C29.4,32.9,29.3,32.8,29.3,32.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M3.7,25.4c0.4,0.7,0.1,1.4,0.2,2.1c-0.1,0.1-0.2,0.1-0.3,0c-0.2-0.5-0.4,0.1-0.6,0c-0.5-0.4-0.1-1-0.3-1.5 C2.5,25.6,3.2,25.3,3.7,25.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M3,27.6c0.1-0.1,0.1-0.1,0.1-0.3c-0.1-0.2,0-0.4,0.2-0.5c0.3,0,0.3,0.2,0.3,0.4c0,0.1,0,0.2,0,0.3 c0.1,0.1,0.2,0.2,0.3,0.3C4.1,28,4.4,28,4.6,28.2c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.3,0.1-0.4,0.2c-0.4,0-0.7,0.1-1.1,0l0,0 C3,28.3,3,27.9,3,27.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M2,24.1c0.4-0.1,0.1,0.5,0.4,0.4c0,0.6-0.4,0.3-0.6,0.2l0,0c-0.1,0-0.1-0.1-0.1-0.1c0,0,0-0.1,0.1-0.1v0 C1.9,24.4,1.8,24.2,2,24.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st96",
    d: "M1.3,25.4c0.1,0,0.2-0.2,0.4,0c0,0,0,0.1,0,0.2C1.5,25.6,1.4,25.5,1.3,25.4L1.3,25.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st246",
    d: "M3.3,24.5c0.1,0,0.1,0,0.2,0c0,0.1,0.1,0.3-0.1,0.3C3.3,24.8,3.3,24.6,3.3,24.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M38.8,71.1c0,0.2-0.1,0.4-0.2,0.6c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.2c0,0,0,0.1,0,0.1 c-0.6,0.5-0.6-0.2-0.9-0.4C37.9,71.2,38.1,70.8,38.8,71.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M35.9,72.1c0-0.2,0-0.3,0.1-0.3c0.1-0.2-0.1-0.6,0.4-0.6c0.1,0,0.2,0,0.2,0.1c0.2,0.3-0.1,0.4-0.2,0.6 C36.2,71.9,36.2,72,35.9,72.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st247",
    d: "M14.7,16.4c0.2,0.1,0.4,0.2,0.6,0.2c0.1-0.1,0.2-0.1,0.2,0c0,0.1,0.1,0.2,0.2,0.2c0.1-0.1,0.2-0.1,0.3-0.1 c0.2,0.1,0.3,0.2,0.3,0.4c0.1,0.3,0,0.6-0.1,0.8c-0.1,0.1-0.3,0.2-0.5,0.2c-0.2,0-0.3,0-0.5,0c-0.6-0.1-1-0.4-1.4-0.9 c-0.1-0.4,0.1-0.7,0.3-0.9C14.4,16.2,14.5,16.2,14.7,16.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st96",
    d: "M15.7,15.9c-0.8,0-1.2-0.4-1.1-1.1c0.2-0.1,0.2-0.4,0.5-0.5c0.2,0,0.4,0.1,0.5,0.2c0.2,0.2,0.2,0.5,0.3,0.8 c0,0.1,0,0.3-0.1,0.4C15.8,15.9,15.8,15.9,15.7,15.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st248",
    d: "M16.2,17c-0.1-0.1-0.2-0.1-0.2-0.2c-0.1-0.1-0.1-0.1-0.2-0.2c0-0.2,0-0.4,0-0.6l0,0c0,0,0.1-0.1,0.1-0.1 c0,0,0.1,0,0.1,0c0.1,0,0.2,0.1,0.2,0.1c0.4-0.3,0-0.8,0.4-1c0.1-0.1,0.2-0.1,0.3-0.1c0.2,0.1,0.3,0.2,0.3,0.3 c0.1,0.5-0.1,1-0.2,1.5c-0.1,0.2-0.1,0.4-0.3,0.5c-0.1,0.1-0.2,0.1-0.3,0.1C16.3,17.3,16.3,17.1,16.2,17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st235",
    d: "M13.2,14.4c0.8,0.2,0.8,0.2,0.9-0.6c0.6,0.4,0.3,0.9,0,1.5C13.8,14.9,13.3,14.8,13.2,14.4L13.2,14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M13.4,13.1c0.1-0.1,0.3-0.3,0.4-0.4c0.1-0.1,0.3-0.1,0.5,0c0.2,0.3,0.4,0.5,0.2,0.9 C14,13.7,13.8,13.1,13.4,13.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M13.2,16.1c0-0.1,0-0.1,0-0.2c0.4-0.1,0.7-0.9,1.1,0c-0.1,0.2-0.2,0.3-0.4,0.2C13.6,16.1,13.4,16.1,13.2,16.1 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M13.8,16.1c0.1-0.1,0.3-0.1,0.4-0.2c0.6-0.3,0.4,0.2,0.4,0.4c-0.1,0-0.3,0-0.4,0c-0.1,0.1-0.2,0.3-0.4,0.2 C13.5,16.4,13.8,16.3,13.8,16.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M12.9,13.8c0.1,0,0.1,0,0.2,0c0,0.2,0,0.4,0,0.6l0,0c-0.2-0.1-0.6,0.2-0.7-0.2C12.4,14,12.6,13.8,12.9,13.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st249",
    d: "M14.5,13.5c-0.1-0.3-0.2-0.6-0.2-0.8c0,0,0-0.1,0-0.1c0-0.1,0.1-0.1,0.2-0.1c0.1,0,0.1,0,0.2,0 c0.1,0.2,0.2,0.3,0.2,0.5c0,0.2,0,0.3-0.1,0.4c0,0-0.1,0.1-0.1,0.1C14.6,13.5,14.5,13.5,14.5,13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M15.1,14.4c0,0.3-0.1,0.5-0.4,0.5c0-0.2-0.1-0.5,0.2-0.7c0.1-0.1,0.1-0.1,0.2,0 C15.2,14.2,15.2,14.3,15.1,14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M15.5,16.6c-0.1,0-0.1,0-0.2,0c0-0.1-0.2-0.3,0-0.3C15.5,16.2,15.5,16.4,15.5,16.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st250",
    d: "M15.1,14.2c-0.1,0-0.1,0-0.2,0c0-0.1,0-0.1,0-0.2c0,0,0-0.1-0.1-0.1c0,0,0.1-0.1,0.1-0.1 C15.2,13.8,15.2,14,15.1,14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st224",
    d: "M14.7,13.8c0-0.1,0-0.1,0-0.2l0,0c0.1-0.1,0.2-0.1,0.2,0c0,0.1,0,0.2,0,0.2l0,0 C14.8,13.8,14.7,13.8,14.7,13.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M14.7,13.8c0.1,0,0.1,0,0.2,0c0,0.1,0,0.1,0,0.2C14.8,13.9,14.7,13.8,14.7,13.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st251",
    d: "M15.7,16.6c0.1,0,0.2,0.1,0.2,0.2l-0.1,0l-0.1,0C15.7,16.7,15.7,16.6,15.7,16.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M10.1,37.9c0.2,0.4,0.4,0.8,0.9,0.2c0,0.4,0,0.6-0.4,1.1c-0.1,0.1-0.1,0.1-0.2,0c-0.1,0-0.1,0-0.2,0 c-0.3,0-0.6-0.1-0.9,0c-0.1,0-0.1,0-0.2,0c0,0-0.1-0.1-0.1-0.1c-0.1-0.1-0.1-0.3-0.1-0.4c0-0.2,0.1-0.4,0.2-0.5l0,0 c0.2-0.2,0.4-0.3,0.6-0.2C9.9,37.9,10,37.9,10.1,37.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st252",
    d: "M10.4,39.2c0.1,0,0.1,0,0.2,0l0,0c0.1,0.1,0.1,0.1,0.2,0.2c0.1,0.4,0.3,0.7,0.4,1.1c-0.2,0-0.4,0-0.6,0 C10.5,40,10.3,39.6,10.4,39.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M9.3,39.2c0.3-0.1,0.6-0.6,0.9,0c0,0.2,0,0.5,0,0.7C9.6,39.9,9.6,39.4,9.3,39.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st130",
    d: "M9.1,38.1c0,0.2,0,0.4,0,0.6c-0.1,0.1-0.1,0.3,0,0.4l0,0c0,0.2,0.2,0.3,0.1,0.5C8.5,39.1,8.4,38.8,9.1,38.1z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M8.2,40.3C8.1,40.1,8.1,40,8,39.8c0-0.1-0.2-0.3,0-0.4c0.2-0.1,0.2,0.3,0.5,0.4c0,0.2,0.4,0.4,0,0.6 c-0.1,0.1-0.1,0.1-0.2,0C8.2,40.4,8.2,40.3,8.2,40.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st130",
    d: "M9.7,37.9c-0.2,0.1-0.4,0.2-0.6,0.2c0-0.2-0.1-0.5,0.2-0.5C9.4,37.6,9.6,37.7,9.7,37.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M9.9,37.3c0.5,0.1,0.6,0.3,0.2,0.6C10.1,37.7,9.9,37.5,9.9,37.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M10.6,40.5c0,0.1,0.2,0.3,0,0.3c-0.2,0.1-0.2-0.2-0.2-0.3C10.4,40.5,10.5,40.5,10.6,40.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st101",
    d: "M8.2,40.5c0.1,0,0.1,0,0.2,0C8.3,40.6,8.3,40.6,8.2,40.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st253",
    d: "M47,44.1c0.1,0,0.1,0,0.2,0c0.1,0.2,0.1,0.4,0,0.6c0.1,0.4-0.3,0.2-0.4,0.3c-0.3,0-0.5,0-0.6-0.4 c0,0,0-0.1,0-0.1C46.2,44.1,46.7,44.4,47,44.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st254",
    d: "M45.5,45.2c0-0.1,0-0.3,0-0.4c0.2-0.1,0.3-0.5,0.6-0.2l0,0c0.1,0.2,0.2,0.5,0,0.7 C45.9,45.2,45.7,45.3,45.5,45.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st254",
    d: "M45,45.2c-0.6-0.5-0.6-0.6,0-0.9c0,0.1,0,0.3,0,0.4C45,44.9,45,45.1,45,45.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st255",
    d: "M46.3,43.9c-0.1,0-0.3-0.1-0.3-0.3c0,0,0.1-0.1,0.2-0.1c0.1,0,0.2,0.1,0.2,0.2 C46.5,43.8,46.4,43.9,46.3,43.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M24.4,22c-0.4,0.3-0.2,0.8-0.4,1.2c-0.1,0.2-0.2,0.3-0.5,0.4c-0.3,0-0.6,0.2-0.9,0.1c-0.2-0.2-0.1-0.5,0-0.7 c0-0.1,0.1-0.2,0.1-0.3c0.1-0.1,0.2-0.2,0.3-0.3c0.4-0.1,0.4-0.4,0.5-0.7c0.1-0.3,0-0.7,0.6-0.7c0.2,0.2,0.5,0,0.8,0.1 C25,21.5,24.6,21.7,24.4,22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st256",
    d: "M24.1,20.9c-0.5,0.3-0.3,0.9-0.4,1.3c-0.1,0.6-0.4,0.3-0.7,0.2c-0.1-0.1-0.2-0.2-0.2-0.3 c-0.1-0.2-0.2-0.4-0.3-0.6c-0.1-0.2-0.1-0.4,0.1-0.6c0.1-0.1,0.2,0,0.4,0c0.1,0,0.2-0.1,0.3-0.2c0.1-0.1,0.3-0.2,0.4-0.2 C23.9,20.5,24.1,20.7,24.1,20.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st257",
    d: "M23.7,20.4c-0.1,0.2-0.3,0.2-0.4,0.2c0,0,0-0.1-0.1-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0.1-0.1 c0.1-0.1,0.1-0.1,0.2-0.2c0.1,0,0.2,0,0.2,0.1C23.7,20.3,23.7,20.4,23.7,20.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st258",
    d: "M23.7,20.2c-0.1,0-0.1,0-0.2,0c-0.1-0.1-0.1-0.2,0-0.3c0.1-0.1,0.2-0.1,0.3,0c0.1,0,0.1,0,0.2,0 C23.9,20.1,23.8,20.2,23.7,20.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M24.4,20.2C24.3,20.3,24.3,20.3,24.4,20.2C24.3,20.3,24.3,20.3,24.4,20.2C24.3,20.2,24.3,20.2,24.4,20.2 L24.4,20.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st259",
    d: "M23.9,20c0-0.1,0.1-0.2,0.2-0.2C24.1,19.9,24,20,23.9,20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st260",
    d: "M38.8,62.4c-0.2,0-0.5,0.1-0.7-0.2c-0.4-0.2-0.3-0.8-0.7-1c-0.3-0.1-0.6-0.1-0.8-0.3c-0.1-0.2-0.1-0.3,0-0.5 c0.1-0.2,0.2-0.3,0.4-0.3c0.4-0.2,0.9-0.1,1.4-0.1c0.3,0,0.5,0.1,0.7,0.3c0.1,0.1,0.2,0.3,0.2,0.4c0,0.3-0.3,0.6-0.3,0.9 C38.9,61.9,39,62.2,38.8,62.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "M38.8,62.4c0-0.3-0.2-0.6,0-0.9c0.1-0.1,0.2-0.2,0.4-0.2c0.3,0,0.6-0.1,1-0.2c0.1,0,0.2,0,0.3,0.1 c0.1,0,0.2,0.1,0.2,0.1c0.1,0.1,0.1,0.1,0.1,0.2c-0.1,0.4-0.5,0.3-0.7,0.6c0,0.1,0,0.1,0,0.2c-0.1,0.1-0.1,0.1-0.2,0l0,0 c-0.2-0.1-0.4-0.3-0.6,0C39.1,62.4,38.9,62.4,38.8,62.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st178",
    d: "M36.6,60.9c0.3,0,0.6-0.1,0.9,0.2c0.1,0.1,0.1,0.1,0.2,0.2c0,0.1,0,0.3,0,0.4c0,0.2-0.1,0.3-0.2,0.4 c0,0.1-0.1,0.2-0.2,0.2c-0.2,0-0.3,0-0.5-0.1c-0.1-0.1-0.2-0.2-0.2-0.3c0-0.1,0-0.2,0-0.3C36.6,61.5,36.5,61.2,36.6,60.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st247",
    d: "M36.6,63.3c-0.1-0.1-0.3-0.1-0.4-0.2c-0.2-0.1-0.4-0.3-0.4-0.6c0-0.1,0.1-0.2,0.1-0.3 c0.1-0.1,0.2-0.1,0.3-0.1c0.3,0,0.5,0.1,0.7,0.3c0.1,0.1,0.1,0.2,0,0.3c0.1,0.1,0.1,0.3,0.2,0.4C36.9,63.2,36.9,63.5,36.6,63.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st261",
    d: "M37.5,61.4c0-0.1,0-0.1,0-0.2c0.1,0,0.4-0.2,0.4,0.1c0,0.4,0.2,0.7,0.2,1c-0.2,0-0.4,0-0.6,0 c0-0.1,0-0.3,0-0.4C37.6,61.6,37.6,61.5,37.5,61.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M39.9,62.5c0.1,0,0.1,0,0.2,0c0.5,0.1,0.8,0.3,0.7,0.9C40.4,63.1,40.1,62.8,39.9,62.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st262",
    d: "M39.2,62.4C39.2,62.3,39,62,39.1,62c0.2-0.2,0.3,0.1,0.4,0.1c0.1,0.1,0.3,0.2,0.4,0.3 C39.6,62.4,39.4,62.4,39.2,62.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M36.9,62.6c0-0.1,0-0.1,0-0.2c-0.1-0.1-0.1-0.1,0-0.1c0,0,0-0.1,0.1-0.1c0.2,0,0.3,0,0.4,0.2 C37.2,62.6,37,62.7,36.9,62.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M39.3,63c-0.1-0.1-0.2-0.1-0.2-0.2c0-0.1,0.1-0.2,0.2-0.1c0.1,0.1,0.1,0.2,0.2,0.2C39.5,63,39.4,63,39.3,63z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st263",
    d: "M36.6,63.3c0.1-0.1,0.3-0.1,0.4-0.2c0,0.1,0,0.3,0,0.4C36.9,63.5,36.7,63.5,36.6,63.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M32.8,46.9c0,0.4,0.2,0.3,0.4,0.2c0-0.1,0.1-0.1,0.1-0.2c0.1-0.1,0.1-0.2,0.1-0.3c0-0.2,0.1-0.3,0.2-0.5 c0-0.1,0.1-0.1,0.2-0.2c0.1,0,0.2,0,0.2,0.1c0.4,0.4-0.1,0.7,0,1.1c0.1,0.2-0.1,0.6,0.3,0.6c0.5,0.1,0.3-0.3,0.4-0.6 c0.1,0,0.1,0,0.2,0c0,0,0.1,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0.2,0,0.4,0,0.6c0,0.1,0,0.1,0,0.2c-0.5,0.5-0.8,0-1.1-0.2 c-0.1-0.5-0.3-0.6-0.6-0.2c-0.5,0.7-1-0.3-1.5,0.1c0,0-0.1-0.3,0-0.4c0.3-0.4-0.1-0.5-0.3-0.8C31.9,46.7,32.4,46.7,32.8,46.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M33.9,48c-0.1,0.3-0.1,0.6-0.4,0.5c-0.4-0.1-0.1-0.3,0.1-0.4C33.6,48.1,33.7,48.1,33.9,48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M10.8,39.4c-0.1,0-0.2-0.1-0.2-0.2C10.6,39.3,10.7,39.3,10.8,39.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M19.2,49.5c-0.1,0.1-0.3,0.3-0.4,0.4c-0.2,0-0.5,0.2-0.6,0c-0.2-0.4,0.2-0.7,0.4-1 C18.8,49.1,18.9,49.5,19.2,49.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M18.6,48.5C18.6,48.5,18.6,48.5,18.6,48.5C18.6,48.5,18.6,48.5,18.6,48.5C18.6,48.5,18.6,48.5,18.6,48.5 C18.6,48.5,18.6,48.5,18.6,48.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M19.4,49.3c-0.1,0.1-0.1,0.1-0.2,0.2C19.3,49.4,19.3,49.4,19.4,49.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M50.4,46.9c-0.1,0.3-0.6,0.3-0.6,0.7c-0.2,0-0.3,0-0.4-0.2c0.1-0.3,0.3-0.6,0.4-0.9c0.1-0.1,0.1-0.1,0.2-0.1 c0.1,0,0.2,0,0.2,0.1C50.3,46.6,50.3,46.8,50.4,46.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st264",
    d: "M48,46.9c0,0.1,0,0.3,0,0.4c0,0.1,0,0.1,0,0.2c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0-0.2,0-0.3,0 c-0.2-0.1-0.4-0.2-0.4-0.4c-0.1-0.2,0-0.4,0.1-0.6C47.6,46.5,47.8,46.6,48,46.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st265",
    d: "M46.8,48.2c0-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.2-0.1,0.3,0c0,0,0.1,0.1,0.1,0.1c-0.1,0.2-0.2,0.4-0.2,0.6 c0,0.1-0.1,0.1-0.2,0.1C46.8,48.6,46.9,48.4,46.8,48.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st266",
    d: "M47.8,47.6c0.1,0,0.1,0,0.2,0c0,0.7,0,0.7-0.4,0.4c0,0,0-0.1-0.1-0.1c0,0,0-0.1,0.1-0.1 C47.7,47.7,47.8,47.6,47.8,47.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st267",
    d: "M47,48.6c0.1,0,0.1,0,0.2,0c-0.1,0.2-0.1,0.3-0.2,0.5c-0.2-0.1-0.4-0.2-0.4-0.4C46.7,48.5,46.8,48.5,47,48.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st268",
    d: "M47.6,47.8c0,0.1,0,0.1,0,0.2c-0.1,0-0.1,0-0.2,0c0,0,0,0,0,0C47.3,47.8,47.4,47.7,47.6,47.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st269",
    d: "M15.5,23.5c-0.1-0.1-0.1-0.3-0.2-0.4c-0.1-0.1,0-0.3-0.2-0.4l0,0c-0.3-0.3-0.3-0.6-0.2-0.9 c0.1-0.1,0.1-0.2,0.2-0.2c0.8,0.5,1.8,0.9,2.1,2c0,0.2,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0c0.2,0.1,0.3,0.2,0.3,0.4c0,0.2-0.1,0.4,0,0.6 c0,0.1-0.1,0.2-0.2,0.3c-0.1,0-0.1,0.1-0.2,0.1c0,0.1,0,0.1,0.1,0.2c0.4,0.3,0.8,0.5,0.8,1.1c0,0.2,0,0.3-0.1,0.4 c-0.1,0.1-0.2,0.2-0.4,0.2c-0.2,0-0.5,0-0.4,0.3c0,0.2,0.1,0.4,0.1,0.7c-0.2,0.5,0.4,1,0,1.5c-0.2,0.1-0.5,0.2-0.8,0.1 c-0.5-0.2-0.8-0.5-1-0.9c-0.3,0,0.5-0.4-0.1-0.3c-0.3,0-0.5-0.2-0.5-0.5c0.2-0.5,0.6-0.9,1-1.1c0.2-0.1,0.4-0.2,0.5-0.5 c0-0.4-0.3-0.7-0.6-0.9c-0.1-0.1-0.1-0.1-0.2-0.2c0,0-0.1-0.1-0.1-0.1c-0.1-0.1-0.1-0.1-0.2-0.2c0,0-0.1-0.1-0.1-0.1 C15.7,24.1,15.4,23.8,15.5,23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M14.5,22.6c-0.2,0.1-0.2,0.1,0,0.2c0.1,0.4-0.2,0.6-0.4,0.9l0,0c-0.1,0.1-0.2,0.1-0.3,0.1 c-0.5-0.1-1-0.3-1.3-0.8c0-0.1,0-0.2,0.1-0.3c0.2-0.3,0.5-0.5,0.9-0.3c0.1,0.2,0.2,0.4,0.1,0.5c0.1-0.2,0.1-0.5-0.2-0.7 c0-0.1,0-0.2,0-0.3c0.1-0.2,0.2-0.3,0.4-0.3c0.3-0.1,0.6-0.1,0.8,0C15.1,21.9,15.2,22.3,14.5,22.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M14.5,22.6c0.3-0.3,0.6-0.6,0-0.9c-0.2-0.3-0.5-0.6-0.3-1.1c0.2-0.1,0.4,0,0.6,0.1c0.2,0.2,0.5,0.4,0.4,0.8 c0,0.4,0,0.7,0,1.1C14.9,22.6,14.7,22.6,14.5,22.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.5,22.8c0.3,0.5,1,0.4,1.3,0.9c-0.2,0.1-0.4,0.3-0.6,0.2c-0.1,0-0.3,0-0.4,0c-0.2-0.3-0.4-0.6-0.6-0.8l0,0 C12.2,22.9,12.3,22.7,12.5,22.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st270",
    d: "M15.1,25.4c0-0.3,0.1-0.4,0.4-0.4c0.3-0.1-0.1-0.7,0.4-0.6l0,0c0.1,0.1,0.1,0.1,0.2,0.2l0,0 c0.2,0.3,0.2,0.6,0,0.9c-0.2,0.1-0.4,0.1-0.6,0.1C15.4,25.6,15.2,25.5,15.1,25.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st166",
    d: "M14,23.7c-0.1-0.4,0.3-0.6,0.4-0.9c0.3,0.3,0.3,0.6,0.1,0.9C14.4,24,14.2,23.7,14,23.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st96",
    d: "M16,24.3c-0.3,0.1-0.1,0.5-0.4,0.6c0.3-0.5-0.5-1,0-1.5C15.7,23.8,15.8,24,16,24.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st271",
    d: "M15.1,25.4c0.1,0,0.3,0,0.4,0c0.1,0.2,0.1,0.3,0,0.5c-0.2,0.1-0.4,0.1-0.7-0.1l-0.1,0l-0.1,0 c-0.1,0-0.1,0-0.2,0C14.4,25.4,14.8,25.4,15.1,25.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st137",
    d: "M13.2,23.9c0.2-0.1,0.4-0.2,0.6-0.2c0.1,0,0.1,0,0.2,0c-0.2,0.2-0.4,0.3-0.6,0.5 C13.2,24.3,13.2,24,13.2,23.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M15.1,22.6c0.4,0,0.3,0.2,0.2,0.4C15.1,22.9,15.1,22.8,15.1,22.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st272",
    d: "M45.2,48c0.1,0.1,0.3,0.1,0.4,0.2c0.4,0.3,0.2,0.5-0.1,0.7c-0.2,0.1-0.5,0.2-0.5,0.6c0,0.1-0.1,0.3-0.2,0.4 c-0.1,0.1-0.2,0.1-0.2,0.1c0,0-0.1,0-0.1,0c-0.3,0-0.6,0.1-0.8-0.2c-0.1-0.2-0.1-0.4,0-0.6c0.2-0.6,0.5-1,1.1-1.2 c0.1,0,0.1,0,0.2,0C45.1,47.9,45.2,47.9,45.2,48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st273",
    d: "M45.5,45.2c0.1,0,0.3-0.3,0.4,0c0.3,0.2,0.7-0.3,0.9,0.2c0,0.1,0,0.2,0,0.3c-0.1,0.5,0.3,0.1,0.4,0.2 c0.1,0.3,0,0.5-0.1,0.7c-0.1,0-0.2,0.1-0.3,0.1c-0.2-0.1-0.5-0.3-0.7-0.3c-0.1,0-0.2-0.1-0.2-0.2c0-0.1-0.1-0.2-0.1-0.2 C45.4,45.7,45.5,45.4,45.5,45.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st274",
    d: "M44.8,48c-0.3,0.4-0.7,0.8-0.9,1.3c-0.3,0.1-0.3-0.1-0.4-0.3c0-0.3-0.2-0.3-0.4-0.5c-0.1-0.2,0-0.4,0.1-0.6 c0.1-0.1,0.3-0.1,0.4,0C44.1,48,44.5,48,44.8,48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st275",
    d: "M44.4,47.4c0.1,0,0.1,0,0.2,0l0,0c-0.2,0.3-0.5,0.4-0.9,0.4c0,0-0.1,0-0.1,0c-0.2,0-0.3-0.1-0.4-0.3 c0-0.1,0-0.2,0-0.4c0.1-0.1,0.2-0.1,0.3-0.2c0.1,0,0.1,0,0.2,0C44.1,46.8,44.2,47.2,44.4,47.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M45.9,46.1c0.3,0.1,0.8-0.2,0.9,0.4c0,0,0.1,0.1,0.1,0.1c0,0.1,0,0.1,0,0.1c-0.1,0-0.1,0.1-0.2,0.1 c-0.1,0-0.2,0.1-0.3,0.2c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0-0.1,0-0.2,0c0-0.1,0-0.1,0-0.2C45.7,46.6,45.7,46.4,45.9,46.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st276",
    d: "M44.8,46.7c0.2,0,0.4,0,0.4,0.3c-0.1,0.3-0.3,0.4-0.6,0.4l0,0C44.6,47.1,44.7,46.9,44.8,46.7L44.8,46.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "M44.8,46.7c-0.2,0-0.5,0-0.3-0.4c0.1-0.2,0.2-0.3,0.4-0.2C45.1,46.4,44.8,46.5,44.8,46.7L44.8,46.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st277",
    d: "M45.9,46.1c0,0.3,0,0.6,0,0.9c-0.7-0.1-0.3-0.5-0.2-0.9C45.7,46,45.8,46,45.9,46.1L45.9,46.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st278",
    d: "M44.4,47.4c-0.2-0.1-0.4-0.3-0.6-0.4C44.3,46.5,44.3,47.1,44.4,47.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st279",
    d: "M43.3,46.3c0.1,0,0.1,0,0.2,0c0,0.3-0.1,0.4-0.2,0.6c-0.1,0.1-0.1,0.1-0.2,0C43.1,46.7,43.2,46.5,43.3,46.3z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st278",
    d: "M43.1,46.9c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.1-0.1,0.1-0.2,0 C43,47.1,43,47,43.1,46.9L43.1,46.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st280",
    d: "M45.7,47.6c-0.1,0.2-0.2,0.2-0.4,0.2C45.3,47.6,45.5,47.6,45.7,47.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st281",
    d: "M43.7,48c-0.1,0-0.3,0-0.4,0c0,0,0-0.1-0.1-0.1c0-0.1,0.1-0.2,0.1-0.2c0.1,0,0.3,0,0.4,0.1l0,0 C43.7,47.9,43.7,47.9,43.7,48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st280",
    d: "M45.2,48c-0.1,0-0.1,0-0.2,0c0.1-0.1,0.2-0.1,0.2-0.2C45.2,47.9,45.2,47.9,45.2,48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M45.9,46.1c-0.1,0-0.1,0-0.2,0c0-0.1,0-0.1,0-0.2C45.8,45.9,45.9,46,45.9,46.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M22.4,56.4c0.1,0,0.3,0,0.4,0c0.2,0.1,0.3,0.2,0.4,0.4c0.2,0.2,0.5,0.3,0.7,0.5c-0.1,0.3-0.3,0.5-0.2,0.9 c-0.2,0.2-0.4,0.3-0.6,0.3c-0.4-0.1-0.6-0.4-0.7-0.8c0-0.1,0-0.2,0-0.3C22.3,57,22.1,56.7,22.4,56.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M23.1,58.3c0.2-0.1,0.4-0.2,0.6-0.2c0,0.1,0,0.3,0,0.4c-0.1,0.1-0.1,0.1-0.2,0.2l0,0 c-0.1,0.1-0.1,0.1-0.2,0.1c-0.1,0-0.2,0-0.3,0c-0.1,0-0.1-0.1-0.2-0.2C22.8,58.5,22.9,58.4,23.1,58.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "M23.9,57.3c-0.4,0-0.7,0-0.9-0.4c0.3-0.2,0.6-0.1,0.9,0l0,0C23.9,57,23.9,57.1,23.9,57.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M22.9,58.8c0.1,0,0.1,0,0.2,0c0,0.1,0.1,0.1,0.2,0.1c0,0,0,0.1,0,0.1c0,0.1,0,0.3,0,0.4 c-0.1-0.1-0.3-0.1-0.4-0.2C22.8,59.1,22.7,59,22.9,58.8C22.8,58.8,22.8,58.8,22.9,58.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M25,57.3c0.3,0.1,0.2,0.4,0.2,0.6C24.9,57.8,25,57.5,25,57.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M24.8,56.8c0.2,0.1,0.2,0.2,0.2,0.4C24.8,57.2,24.8,57,24.8,56.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M23.5,58.8c0.1-0.1,0.1-0.1,0.2-0.2C23.7,58.7,23.6,58.7,23.5,58.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M23.3,58.8c0.1,0,0.1,0,0.2,0c-0.1,0.1-0.1,0.1-0.2,0.2l0,0C23.2,58.9,23.2,58.9,23.3,58.8 C23.2,58.8,23.3,58.8,23.3,58.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st282",
    d: "M46.3,51c0.5,0.4-0.2,0.4-0.2,0.6c-0.4,0.2-0.8,0.6-1.3,0.4c0,0,0-0.1-0.1-0.1c0-0.2,0.1-0.3,0.2-0.4 c0.2-0.2,0.3-0.4,0.6-0.5C45.8,51,46,50.8,46.3,51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st283",
    d: "M44.8,53.2c0.3,0.4,0.2,0.9,0.2,1.3c-0.1,0-0.1,0-0.2,0c0,0-0.1-0.1-0.1-0.1c-0.1-0.1-0.1-0.2-0.1-0.2 c-0.1-0.3-0.3-0.3-0.5-0.3c-0.2,0-0.2-0.1-0.3-0.3c-0.1-0.2-0.1-0.4,0-0.6c0-0.1,0.1-0.2,0.1-0.3c0.1-0.2,0.3-0.3,0.5-0.2 c0.1,0.2,0.2,0.3,0.4,0.4C44.9,53,44.9,53.1,44.8,53.2C44.9,53.2,44.8,53.2,44.8,53.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st284",
    d: "M44.4,52.5c-0.1,0.1-0.3,0.1-0.4,0.2c-0.2,0.1-0.4,0-0.5-0.2c-0.1-0.2-0.1-0.4,0-0.6 c0.1-0.2,0.2-0.3,0.5-0.4c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.2,0.3,0.3c0,0.1,0,0.2-0.1,0.3C44.5,52.4,44.5,52.5,44.4,52.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st285",
    d: "M44.8,53.2c0-0.1,0-0.1,0-0.2c0-0.6,0.5-0.4,0.9-0.5c0.3-0.1,0.2,0.2,0.2,0.3c-0.1,0.2-0.5,0.1-0.6,0.4 C45.1,53.2,45,53.2,44.8,53.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st286",
    d: "M47.2,53.6c0,0.1,0,0.1,0,0.2c-0.1,0-0.2,0-0.3-0.1c-0.1,0,0-0.1,0.1-0.1C47,53.6,47.1,53.6,47.2,53.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st282",
    d: "M44.6,52.3c0-0.1,0-0.1,0-0.2c0.1-0.1,0.1-0.1,0.2,0l0,0C44.7,52.2,44.7,52.3,44.6,52.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st287",
    d: "M46.1,52.5c0.2,0.1,0.2,0.1,0,0.2C46.1,52.7,46.1,52.6,46.1,52.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st259",
    d: "M23.7,18.7c0.1,0.1,0.1,0.3,0.2,0.4c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.1-0.1,0.1-0.2,0.2 c-0.2,0.1-0.4,0.1-0.6,0.2c-0.2,0.1-0.4,0.1-0.5,0.3c-0.2,0.2-0.1,0.4-0.1,0.6c-0.2,0.4-0.4,0.7-0.9,0.7c-0.1,0-0.2-0.1-0.3-0.1 c-0.1-0.1-0.2-0.2-0.2-0.4c-0.1-0.2-0.2-0.5-0.1-0.8c0-0.3,0.1-0.5,0.4-0.6c0.3,0.2,0.7,0.4,1,0c0.2-0.2,0.6-0.5-0.1-0.6 c-0.4-0.1-0.1-0.5-0.2-0.7c0.1-0.1,0.1-0.1,0.2,0c0.1,0.1,0.3,0.2,0.4,0.3c0.8,0.5,0.8,0.4,0.9-0.5c0-0.1,0.1-0.2,0.2-0.2 c0.1,0,0.1,0.1,0.2,0.1C24.4,18.2,24.4,18.2,23.7,18.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M20.7,17.4c0.1,0.2,0.2,0.3,0.2,0.5c-0.1,0.2-0.2,0.3-0.4,0.4c-0.3,0.2-0.5,0.1-0.7-0.1 c-0.1-0.1-0.1-0.2-0.1-0.3C19.9,17.5,20.3,17.4,20.7,17.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st288",
    d: "M21.8,17.2c0-0.1,0-0.1,0-0.2c0.1-0.2,0.3-0.1,0.4-0.2l0,0c0.1-0.1,0.3-0.1,0.4,0l0,0c0,0.3-0.2,0.5-0.4,0.7 C21.9,17.7,21.8,17.5,21.8,17.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M21.1,18.7c0,0.1,0,0.3,0,0.4c-0.2,0.2-0.2,0.9-0.6,0.2c-0.1-0.2,0-0.4,0.2-0.6c0.1-0.2,0.3-0.2,0.4-0.2 C21.2,18.6,21.2,18.6,21.1,18.7C21.2,18.7,21.2,18.7,21.1,18.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st289",
    d: "M20.7,19.4c0.3,0.3,0.2-0.3,0.4-0.2c0,0.1,0,0.1,0,0.2c-0.1,0.2-0.2,0.4-0.2,0.7c-0.3,0.1-0.5-0.1-0.5-0.4 c0-0.1,0-0.2,0.1-0.3C20.5,19.3,20.6,19.3,20.7,19.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M19.8,18.1c0.2,0.1,0.4,0.2,0.6,0.2c0,0.1,0,0.1,0,0.2c-0.1,0.1-0.1,0.2-0.2,0.3c-0.2,0-0.3-0.1-0.5-0.2 C19.7,18.4,19.7,18.3,19.8,18.1C19.8,18.1,19.8,18.1,19.8,18.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st139",
    d: "M20.3,18.7c0.1-0.1,0.1-0.1,0.2-0.2c0.1,0.1,0.1,0.1,0.2,0.2c0,0.2,0,0.4,0,0.7c-0.1,0-0.1,0-0.2,0 c-0.2-0.1-0.3-0.2-0.3-0.4C20.2,18.9,20.2,18.8,20.3,18.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st259",
    d: "M21.1,18.7c0-0.1,0-0.1,0-0.2c0,0,0.1-0.1,0.1-0.1C21.4,18.6,21.3,18.7,21.1,18.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st234",
    d: "M23.3,17.2c0.1,0.1,0.1,0.2,0.2,0.2C23.4,17.4,23.3,17.3,23.3,17.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st234",
    d: "M22,18.1c-0.1,0-0.1,0-0.2,0C21.8,17.9,21.9,17.9,22,18.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st290",
    d: "M9.5,103.6c0,0.3-0.1,0.4-0.4,0.4l0,0c-0.1-0.1-0.1-0.3,0-0.4C9.2,103.3,9.3,103.6,9.5,103.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M9.5,101.9c0.1,0.1,0.1,0.1,0.2,0.2c-0.1,0.2-0.2,0.3-0.3,0.3c-0.1,0-0.2-0.2-0.2-0.3 C9.2,101.8,9.4,101.9,9.5,101.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M9.1,103.6c0,0.1,0,0.3,0,0.4C8.8,103.9,8.8,103.7,9.1,103.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st292",
    d: "M8.9,104.9c0-0.1,0-0.3,0-0.4c0.1,0,0.1,0,0.2,0c0,0.1,0,0.1,0,0.2C9,104.7,8.9,104.8,8.9,104.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st293",
    d: "M9.7,102.1c0-0.1,0.1-0.2,0.2-0.2C9.9,102,9.8,102,9.7,102.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M5.2,30.6c0-0.1,0-0.3-0.1-0.3c-0.3-0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.2-0.3,0.2c-0.2-0.2-0.2-0.4-0.2-0.6 c0-0.3,0.1-0.5,0.3-0.7c0.1-0.1,0.2-0.1,0.3-0.2c0.1,0,0.2,0,0.3,0c0.2,0,0.4,0,0.6,0.2c0.1,0.1,0.1,0.3,0,0.4 c-0.6,0-0.1,0.4-0.2,0.6C5.5,30.7,5.3,30.7,5.2,30.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st243",
    d: "M6.9,30.8l-0.1,0l-0.1,0c-0.1,0.1-0.1,0.1-0.2,0c0-0.1,0-0.3,0-0.4c0.3-0.4,0.7-0.7,1.1-0.9 c0.1,0,0.2,0,0.3,0.1c0.2,0.4-0.1,0.9,0.1,1.3c0,0.2,0,0.3-0.2,0.4c-0.2,0.1-0.4,0.2-0.4-0.2C7.2,30.9,7.1,30.8,6.9,30.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st157",
    d: "M4.5,30.1c0,0.2,0,0.4,0,0.6c0,0.2,0.1,0.5-0.2,0.6c-0.6,0-0.2-0.8-0.6-0.9c0-0.1,0-0.1,0-0.2 c0-0.1,0-0.1,0-0.2C4,30.1,4.3,29.9,4.5,30.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st294",
    d: "M7.6,29.5C7.4,30,7,30.3,6.5,30.4c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1-0.1-0.1-0.2,0-0.3 C6.6,29.6,7,29.2,7.6,29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M5.4,32.1c-0.9,0.2-0.7-0.3-0.6-0.8c0.4,0,0.5,0.4,0.8,0.3C5.7,31.9,5.6,32,5.4,32.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st78",
    d: "M5.4,32.1c0.1-0.1,0.1-0.3,0.2-0.4l0,0c0.1-0.1,0.1-0.1,0.2,0c0.1,0.2,0.2,0.4,0.4,0.4 C6,33.1,5.7,32.2,5.4,32.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M5.8,31.6c-0.1,0-0.1,0-0.2,0c-0.1-0.7,0.6-0.5,0.9-0.9c0.1,0,0.1,0,0.2,0C6.8,31.4,6.1,31.3,5.8,31.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M5.2,30.6c0.1,0,0.3,0,0.4,0c0,0.3-0.1,0.5-0.4,0.4C5,30.9,5.2,30.7,5.2,30.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st243",
    d: "M6.3,29.9c0,0.1,0,0.2,0,0.2C6.1,30.1,6,30,5.8,29.9c0-0.1,0-0.3,0-0.4c0.1,0,0.1,0,0.2-0.1 C6.2,29.5,6.4,29.6,6.3,29.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st274",
    d: "M20.1,8.2c0,0.4-0.3,0.6-0.4,0.9c0,0-0.1,0.1-0.1,0.1c-0.4,0-0.5-0.3-0.5-0.6c0-0.1,0-0.2-0.1-0.3 c-0.1-0.5-0.2-0.9-0.2-1.4c0,0,0-0.1,0.1-0.1c0.2,0,0.4,0.1,0.6,0.2c0.1,0.1,0.1,0.3,0.2,0.4c0.2,0-0.1,0.4,0.2,0.2 C20.1,7.7,20,7.9,20.1,8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st295",
    d: "M20.1,6.8c0-0.2,0.1-0.3,0.3-0.4c0.2,0,0.4,0,0.5,0.2c0,0.1,0,0.3-0.2,0.2C20.5,6.8,20.2,7.2,20.1,6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st296",
    d: "M19.8,7.5c0,0.2,0,0.4-0.3,0.5c-0.2-0.3,0.2-0.5,0.1-0.8C19.7,7.4,19.8,7.4,19.8,7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M20.5,8.4c0-0.2,0-0.4,0.1-0.5C20.8,8.1,20.7,8.2,20.5,8.4L20.5,8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M23.9,61.6c-0.1,0-0.3,0-0.4,0c0-0.2,0-0.4,0.3-0.4c0.1,0,0.4-0.2,0.4,0.1C24.2,61.4,24,61.5,23.9,61.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M22.6,61.6c0.1-0.1,0.1-0.1,0.2-0.2c0.1-0.1,0.3-0.1,0.4,0c0,0.1,0,0.1,0,0.2l0,0 C23.1,61.7,22.9,61.8,22.6,61.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st297",
    d: "M23.3,60.2c0,0.1,0,0.2-0.1,0.2c-0.1,0-0.1-0.1-0.1-0.2c0-0.1,0.1-0.1,0.1-0.2C23.2,60,23.2,60.1,23.3,60.2z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M23.3,61.4c-0.1,0-0.3,0-0.4,0c0.1-0.2,0.3-0.2,0.4-0.2C23.3,61.2,23.3,61.3,23.3,61.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M2,24.1c0,0.2,0,0.3-0.2,0.4c0-0.1,0-0.3,0-0.4C1.8,24.1,1.9,24.1,2,24.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1.7,24.5c0,0.1,0,0.1,0,0.2c-0.1,0-0.3,0-0.3-0.1C1.5,24.5,1.6,24.6,1.7,24.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M15.3,10.1c0-0.1,0-0.1,0-0.2c0.2-0.2,0.3-0.5,0.7-0.5c0.3,0.2,0.4,0.4,0.5,0.7c-0.1,0.4-0.2,0.7-0.7,0.6 C15.5,10.6,15.4,10.3,15.3,10.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st259",
    d: "M15.7,10.8c0.3-0.1,0.5-0.4,0.6-0.6c0.1,0,0.1,0,0.2,0c0.3,0.2,0.3,0.5,0.3,0.9c0,0.1-0.1,0.2-0.1,0.3 c-0.1,0.1-0.3,0.1-0.4,0.1c-0.2-0.1-0.4-0.2-0.5-0.4C15.7,10.9,15.7,10.8,15.7,10.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M15.7,11c0.2,0,0.4,0,0.4,0.2c0.1,0.1,0.1,0.2,0,0.3C16,11.7,16,12.2,15.5,12c-0.1-0.1-0.1-0.3,0-0.4 c0-0.1,0-0.3,0-0.4C15.6,11.1,15.7,11,15.7,11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "M14,10.8c-0.1,0-0.3,0-0.4,0c0-0.3,0.1-0.5,0.4-0.6l0,0C13.8,10.3,14.8,10.5,14,10.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st102",
    d: "M14,10.1c0.1-0.2,0.2-0.3,0.3-0.4c0.2-0.1,0.4,0,0.4,0.2c0,0.2-0.2,0.1-0.3,0.1C14.3,10.1,14.2,10.1,14,10.1 L14,10.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M29.7,42.2c0.1,0,0.1,0,0.2,0c0.3,0.2,0.3,0.5,0.1,0.7c-0.2,0.3-0.4-0.1-0.6-0.2c-0.1,0-0.3-0.1-0.4-0.1 C29.2,42.3,29.4,42.2,29.7,42.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st101",
    d: "M29.7,43.9c-0.4,0.1-0.9,0.3-0.9-0.4l0,0c0.1-0.1,0.2-0.1,0.2-0.2l0,0C29.3,43.5,29.5,43.7,29.7,43.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.2,69.1c0.1-0.1,0.1-0.3,0.2-0.4c0.8-0.1,0.7,0.6,0.9,1.1C27.5,70.1,27.7,69,27.2,69.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M28.9,68.9c0,0.1,0,0.1,0,0.2c-0.2,0-0.4,0-0.5-0.1C28.5,68.9,28.7,68.9,28.9,68.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st298",
    d: "M15.1,33.8c-0.1-0.2-0.2-0.4-0.2-0.6c0,0,0.1-0.1,0.1-0.1c0.1,0,0.2-0.1,0.2-0.1c0.2,0,0.3-0.1,0.5-0.1 c0.1,0,0.2,0,0.3,0c0.1,0,0.3,0.1,0.4,0.2c0.2,0.1,0.3,0.3,0.4,0.5c0,0.1,0,0.2,0,0.3c-0.1,0.4-0.3,0.8-0.8,0.8 C15.5,34.6,15.2,34.3,15.1,33.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M15.1,33.8c0.8,1,1.1,0.9,1.5-0.2c0.3-0.1,0.4,0.2,0.5,0.4c0,0.1,0,0.2,0,0.3c-0.1,0.1-0.2,0.2-0.2,0.3 c0,0,0,0.1-0.1,0.1c-0.2,0.1-0.3,0.5-0.6,0.4c-0.1,0-0.1-0.1-0.2-0.1c-0.1,0-0.1-0.1-0.1-0.1c0-0.1-0.1-0.1-0.1-0.2 c-0.2,0.1-0.4-0.3-0.7,0c-0.2,0.2,0,0.5-0.2,0.6c-0.1,0-0.1,0-0.2,0c0-0.1,0-0.1,0-0.2c-0.1-0.1-0.1-0.1-0.2-0.2 c-0.3-0.1-0.5-0.3-0.1-0.6C14.6,34.1,14.9,34.1,15.1,33.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st242",
    d: "M14.9,33.2c-0.7-0.2-0.6,0.7-1.1,0.8c-0.2-0.2-0.3-0.5-0.3-0.8c0-0.1,0-0.3,0-0.4c0-0.1,0.1-0.1,0.2-0.2 c0.2,0,0.3,0,0.5-0.1c0-0.1,0.1-0.1,0.1-0.2c0-0.1,0.1-0.1,0.2-0.2c0.1,0,0.2,0,0.2,0c0.1,0.1,0.2,0.1,0.3,0.2c0,0.1,0,0.2,0,0.2 C15,32.8,15,33,14.9,33.2L14.9,33.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st299",
    d: "M13.6,33.2c0.3,0.2,0.2,0.6,0.2,0.8c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0-0.3,0-0.4,0c0,0-0.1-0.1-0.1-0.1 c-0.1-0.3,0.1-0.5,0.2-0.8C13.3,33.3,13.4,33.2,13.6,33.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M14.4,34.9c0.1,0.1,0.1,0.1,0.2,0.2C14.6,35,14.5,34.9,14.4,34.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M39.9,71.1c-0.1-0.1-0.3-0.1-0.4-0.2c0.4-0.7,0.7-0.1,1.1,0l0,0C40.4,71.1,40.1,71,39.9,71.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st300",
    d: "M40.5,70.8c0-0.2,0-0.4,0.3-0.3c0,0,0.1,0,0.1,0.1C40.9,70.8,40.7,70.8,40.5,70.8L40.5,70.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M27.2,46.9c0.1,0.4-0.5,0.6-0.4,1.1c-0.9,0.1-0.9-0.5-1.1-1.1c0,0,0.1-0.1,0.1-0.1c0.1-0.1,0.6-0.1,0.2-0.4 c-0.3-0.1-0.6-0.2-0.8-0.5c0-0.5,0.5-0.5,0.8-0.7c0.1,0,0.2-0.1,0.3-0.1c0.1,0,0.3,0,0.4,0c0.1,0,0.2,0,0.3,0 c0.2,0,0.3,0.1,0.4,0.2c-0.2,0.4-0.6,0.8-0.1,1.2C27.4,46.5,27.2,46.8,27.2,46.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st301",
    d: "M27.4,45.2c-0.1,0-0.3,0-0.4,0c-0.1-0.1-0.1-0.1-0.2,0c-0.1,0-0.3,0-0.4,0c-0.1-0.2-0.1-0.5-0.1-0.8 c0-0.1,0.1-0.1,0.2-0.2c0.2,0,0.3-0.1,0.4-0.2c0.1-0.1,0.2-0.2,0.3-0.3c0.2-0.1,0.4,0,0.5,0.1c0.3,0,0.6,0.1,0.8,0.2 c0.1,0.2,0.2,0.4,0.2,0.6c0.1,0.1,0.1,0.3,0,0.4c-0.1,0-0.1,0-0.2,0c-0.2-0.2-0.4-0.4-0.6,0c-0.1,0-0.2,0-0.2,0 C27.5,45.2,27.4,45.2,27.4,45.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st302",
    d: "M27.8,45.2c0-0.2-0.4-0.5,0-0.6c0.4-0.1,0.6,0.2,0.6,0.6c-0.1,0-0.3,0-0.4,0C27.9,45.3,27.9,45.3,27.8,45.2z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M27.8,45.2c0.1,0,0.1,0,0.2,0c0,0.2,0.1,0.5-0.2,0.5c-0.4,0-0.2-0.3-0.3-0.5C27.7,45.2,27.7,45.2,27.8,45.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st302",
    d: "M28.7,45.2c0-0.1,0-0.3,0-0.4c0.2,0.1,0.2,0.2,0.2,0.4l-0.1,0L28.7,45.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M19.6,3.6C19.7,3.8,19.8,4,20.1,4c1.1-0.1,1.1,0,0.6,1c0-0.7,0-0.7-1.1-0.4c-0.2,0-0.2,0.4-0.4,0.2 c-0.4-0.2,0-0.4,0-0.6c0-0.2,0-0.5,0.2-0.7c0.1,0,0.2,0,0.3,0C19.7,3.5,19.7,3.6,19.6,3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M19.4,3.4c0,0.2,0.1,0.5-0.2,0.6C19,4,18.9,3.9,18.8,3.9c0-0.1,0-0.3,0-0.4C19,3.3,19.2,3.3,19.4,3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M19.2,4.7c0.2,0.1,0.1-0.5,0.4-0.2c0,0.2,0.1,0.5-0.1,0.7C19.3,5.1,19.3,4.9,19.2,4.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st303",
    d: "M18.5,6.7c0.1-0.1,0.1-0.1,0.2-0.2c0,0.1,0,0.1,0,0.2l0,0C18.7,6.8,18.6,6.7,18.5,6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st304",
    d: "M12.1,94.3c0,0.1-0.1,0.2-0.2,0.2C11.9,94.4,12,94.3,12.1,94.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st305",
    d: "M44.4,51.9c-0.2,0-0.3,0-0.4-0.2c-0.1-0.1-0.1-0.1-0.1-0.2c0-0.1,0-0.3,0-0.4c0-0.1,0-0.2,0.1-0.3 c0.1-0.1,0.2-0.1,0.2-0.1c0.2-0.1,0.5-0.1,0.7-0.1c0.1,0,0.2,0,0.3,0c0.4,0.1,0.9-0.2,1.3,0c-0.1,0.1-0.1,0.3-0.2,0.4 c-0.3,0.1-0.6,0.1-0.9,0.2c-0.2,0-0.4,0.1-0.5,0.2C44.8,51.5,44.7,51.8,44.4,51.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st306",
    d: "M46.5,50.6c-0.5,0.2-1,0.3-1.5,0.2c-0.1-0.1-0.2-0.1-0.2,0c-0.3,0-0.6,0-0.8,0c0-0.5,0.5-0.5,0.7-0.7 c0.1,0,0.2-0.1,0.3-0.1c0.2,0,0.3,0.1,0.5,0.1c0.2,0,0.3,0,0.5,0c0,0,0.1,0,0.1,0c0.2,0,0.5-0.1,0.6,0.2 C46.7,50.4,46.6,50.5,46.5,50.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st307",
    d: "M47.2,50.6c0.1,0,0.1,0,0.2,0c0,0.1,0,0.1,0,0.2c0,0.3-0.1,0.5-0.4,0.6c-0.2,0-0.2-0.1-0.3-0.2 C46.6,50.7,47,50.8,47.2,50.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st308",
    d: "M16.2,34.9c0,0.1,0,0.1,0,0.2c-0.2,0.2-0.4,0.5-0.7,0.2c-0.4-0.4,0.2-0.4,0.3-0.6c0.1,0,0.1,0,0.2,0 C16,34.7,16.1,34.8,16.2,34.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M17.5,34.9c-0.2,0.1-0.4,0.2-0.6,0.2c0-0.1,0-0.3,0-0.4l0,0c0.1-0.1,0.1-0.3,0.2-0.4v0 c0.3-0.2,0.5-0.1,0.6,0.1C17.8,34.6,17.7,34.8,17.5,34.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "M14.9,35.3c0-0.2-0.1-0.5,0.2-0.6C15.1,34.9,15.2,35.2,14.9,35.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M16.6,35.5c-0.1,0-0.1,0-0.2,0c0.1-0.1,0.1-0.1,0.2-0.2C16.6,35.4,16.6,35.4,16.6,35.5L16.6,35.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st309",
    d: "M31.7,60.5c0.1-0.1,0.1-0.1,0.2-0.2c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0.1-0.2c0.1-0.1,0.1-0.2,0.2-0.3 c-0.1,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2-0.1c-0.1-0.1-0.3-0.3-0.4-0.4c0.1-0.4,0.4-0.4,0.8-0.4c0.1,0,0.2,0,0.3,0.1 c0.1,0.1,0.1,0.1,0.2,0.2c0,0.1,0.1,0.2,0.1,0.3c0,0.2,0.1,0.4,0.1,0.7c0,0.1,0,0.2,0,0.4c0.3,0.2,0.7-0.1,1,0.2 c0.2,0.2,0.1,0.5,0,0.7c-0.1,0.2-0.2,0.4-0.3,0.6c-0.1,0.2-0.3,0.5-0.4,0.7c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0-0.2,0-0.3-0.1 c-0.1-0.1-0.1-0.2-0.1-0.2c0-0.2,0-0.4,0.1-0.5c0.1-0.1,0.2-0.2,0-0.3c-0.2-0.2-0.4-0.1-0.6-0.1c-0.1,0-0.2-0.1-0.2-0.2 c-0.1-0.1-0.1-0.3-0.1-0.4C31.5,60.8,31.5,60.7,31.7,60.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st310",
    d: "M32.3,59c-0.3,0-0.6,0.1-0.9,0.2c-0.2-0.1-0.4-0.3-0.6-0.4c0-0.1,0-0.1,0-0.2c0.3-0.2,0.6-0.6,1.1-0.4 c0,0,0.1,0,0.1-0.1c0,0,0.1,0,0.1,0c0.2,0.1,0.3,0.3,0.3,0.5C32.5,58.7,32.4,58.9,32.3,59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st236",
    d: "M31.7,60.5c0,0.2,0,0.4,0,0.7c-0.4,0.5-0.6,0.3-0.9-0.1c0-0.1-0.1-0.2-0.1-0.3c0,0,0-0.1,0-0.1 c0,0,0.1-0.1,0.1-0.1C31.1,60.5,31.4,60.5,31.7,60.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M30.2,60.3c0-0.2-0.1-0.5,0.2-0.6c0.3-0.1,0.5-0.2,0.4,0.2c0,0.2,0,0.4,0,0.6h0c0,0-0.1,0.1-0.1,0.1 c0,0-0.1,0-0.1,0C30.5,60.4,30.3,60.4,30.2,60.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M31.9,59.6c0.1,0,0.1,0,0.2,0c0.1-0.1,0.1-0.1,0.2,0c-0.1,0.1-0.1,0.3-0.2,0.4c-0.1,0.1-0.1,0.1-0.2,0.2l0,0 C31.4,60.1,31.4,59.9,31.9,59.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st311",
    d: "M7.8,31.2c0-0.1,0-0.3,0-0.4c-0.1-0.4,0.2-0.4,0.4-0.5c0.1,0,0.2,0,0.3,0c0.2,0.1,0.3,0.3,0.3,0.5 c0,0.2-0.1,0.3-0.2,0.4l0,0c-0.2,0.1-0.5,0-0.6,0.2C7.9,31.4,7.8,31.3,7.8,31.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st178",
    d: "M8,31.4c0.1-0.6,0.4-0.3,0.6-0.2C8.5,31.5,8.2,31.4,8,31.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st178",
    d: "M8.6,31.2c0-0.1,0-0.3,0-0.4c0.1-0.1,0.2-0.2,0.3-0.3c0.1,0,0.2,0,0.2,0.1c0.1,0.3-0.1,0.4-0.3,0.6l0,0 C8.8,31.2,8.7,31.2,8.6,31.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st312",
    d: "M6.9,30.8c0.3-0.3,0.3,0,0.4,0.2C7.2,31,7,31,6.9,30.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st133",
    d: "M6.7,25c-0.5,0-0.4-0.3-0.4-0.6c0-0.2,0-0.3,0.2-0.4c0.1-0.1,0.2,0,0.3,0.1c0.1,0-0.1,0.1,0,0.2 c0,0,0.1-0.1,0.1-0.1C6.9,24,7,23.9,7,23.9c0.1-0.1,0.1-0.3,0.2-0.4c0.1-0.1,0.1-0.1,0.2-0.1c0.2,0,0.4,0,0.5,0.1l0,0 c0.1,0.1,0.1,0.2,0.2,0.2c0,0.1,0,0.1,0,0.2c-0.4,0.2,0.3,1.4-0.8,1c-0.1-0.1-0.3-0.3-0.5-0.1l0,0C6.8,24.8,6.8,24.9,6.7,25L6.7,25 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st308",
    d: "M8,23.5c-0.2,0-0.4,0-0.6,0c-0.1,0.1-0.2,0.1-0.3,0c-0.1-0.2-0.1-0.4-0.1-0.6c0,0,0.1-0.1,0.1-0.1 c0.1-0.1,0.1-0.1,0.2-0.2c0.3-0.3,0.4,0.1,0.6,0.2C8,23,8,23.2,8,23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st308",
    d: "M6.7,23.5c0-0.5-0.1-1,0.2-1.4c0.3,0.3,0.2,0.6,0.2,0.8l0,0C7,22.9,7,23.1,7,23.3c0,0.1,0,0.2-0.1,0.2 C6.8,23.5,6.8,23.5,6.7,23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M6.7,23.5c0.1,0,0.1,0,0.2,0c0.2,0.2,0.2,0.4,0,0.6l0,0c-0.1,0.1-0.1,0.1-0.2,0C6.6,24,6.6,24,6.5,23.9 C6.4,23.7,6.3,23.4,6.7,23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M8.2,6c0.1,0.2,0.2,0.2,0.4,0.2C8.5,6.5,8.5,6.7,8.4,6.9C8.3,7,8.1,7,8,6.9C7.9,6.8,7.8,6.7,7.8,6.7 C7.8,6.4,7.7,6,8.2,6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M7.1,7.7c0,0.1,0,0.1,0,0.2C7,7.9,6.9,7.7,6.9,7.6C6.9,7.5,7,7.4,7,7.5C7.1,7.6,7.1,7.6,7.1,7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M16.6,6.2c0.2,0.8-0.4,0.9-0.9,1.2c-0.1,0-0.2-0.2-0.2-0.3C15.8,6.7,16.1,6.3,16.6,6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M24.8,55.5c0.4,0.5,0.4,0.5-0.6,1C24.2,56.1,24.4,55.7,24.8,55.5L24.8,55.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M23.9,56.8c-0.3,0-0.6,0-0.9,0c-0.2-0.1-0.2-0.3-0.2-0.4c0.1-0.2,0.3-0.2,0.4-0.2 C23.2,56.7,23.8,56.5,23.9,56.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st110",
    d: "M23.3,56c0-0.1,0-0.1,0-0.2l0,0c0.1-0.1,0.3-0.1,0.4,0l0,0C23.6,56,23.5,56,23.3,56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M23.9,55.1c0.1,0,0.1,0,0.2,0c-0.1,0.1-0.1,0.1-0.2,0.2C23.9,55.3,23.9,55.2,23.9,55.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M20,58.3c-0.1-0.1-0.1-0.3-0.2-0.4c0-0.5,0.3-0.4,0.6-0.4c0.1-0.1,0.1-0.1,0.2,0c0,0.2,0.1,0.4,0.2,0.6 c0,0.1-0.1,0.2-0.2,0.2C20.5,58.4,20.3,58.7,20,58.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M20.7,57.5c-0.1,0-0.1,0-0.2,0c-0.1-0.6,0.1-1.2,0.4-1.7c0.1-0.1,0.1-0.1,0.2,0l0,0 C21.2,56.4,20.9,56.9,20.7,57.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st199",
    d: "M21.1,55.8c-0.1,0-0.1,0-0.2,0c-0.2,0-0.4,0-0.6,0c0-0.1,0-0.3,0-0.4C20.5,55.5,20.9,55.5,21.1,55.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st313",
    d: "M19.8,56.5C19.8,56.6,19.8,56.6,19.8,56.5c0,0.2,0,0.2-0.1,0.1C19.6,56.6,19.7,56.6,19.8,56.5 C19.7,56.6,19.7,56.6,19.8,56.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M33.8,20c0.2,0,0.3,0,0.4-0.2c0.2,0,0.6,0.1,0.5,0.3c-0.2,0.5-0.6,0.2-0.9,0.1C33.8,20.2,33.8,20.1,33.8,20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st314",
    d: "M33.8,21.3c0.2-0.1,0.3-0.5,0.6-0.2c0.1,0.1,0.1,0.1,0.2,0.2c0,0.2,0,0.3-0.2,0.4c-0.1-0.1-0.2-0.1-0.3-0.1 c-0.1,0-0.2,0-0.2-0.1C33.8,21.5,33.7,21.4,33.8,21.3L33.8,21.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M35.4,20.1C35.4,20.1,35.4,20.2,35.4,20.1c-0.2,0-0.2,0-0.1-0.1C35.3,20.1,35.4,20,35.4,20.1 C35.4,20.1,35.4,20.1,35.4,20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st96",
    d: "M20,3c-0.7-0.3-0.4-0.8-0.2-1.3c0.4-0.2,0.5,0.2,0.6,0.4c0,0.2,0,0.4,0,0.6c-0.1,0.1-0.1,0.1-0.1,0.2 c0,0-0.1,0-0.1,0C20.2,3,20.1,3,20,3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M20.5,3c0.1,0.1,0.1,0.1,0.2,0.2c-0.4,0.4-0.4,0.1-0.4-0.2l0,0C20.3,2.9,20.4,2.9,20.5,3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M19.6,3.6c0-0.1,0-0.1,0-0.2c-0.1,0-0.1-0.1-0.1-0.1c0,0,0.1-0.1,0.1-0.1v0C19.9,3.4,19.9,3.5,19.6,3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st315",
    d: "M25.4,24.3c0.4-0.4,0.9-0.5,1.5-0.4c0.1,0.1,0.3,0.1,0.4,0.2c0.1,0.1,0.1,0.3,0.2,0.4 c0.1,0.1,0.1,0.2,0.1,0.3c-0.3,0.2-0.1,0.3,0.1,0.4c0.1,0.1,0.2,0.2,0.2,0.3c0,0.1,0,0.2,0,0.3c-0.1,0.5-0.3,1-0.7,1.2 c-0.1,0-0.2,0.1-0.3,0.1c-0.3-0.1-0.5-0.2-0.8-0.3c-0.1-0.1-0.2-0.2-0.3-0.3c-0.4-0.5-1.1,0.1-1.4-0.4c-0.1-0.1-0.1-0.2-0.1-0.3 c0-0.1,0-0.2,0.1-0.3c0.2-0.2,0.6-0.3,0.6-0.7c0-0.1,0-0.2,0-0.3C25.2,24.4,25.3,24.4,25.4,24.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M27.1,27.1c0.2-0.4,0.6-0.8,0.7-1.3c0.1-0.1,0.2-0.2,0.4-0.2c0.1-0.1,0.1,0.2,0.2,0c-0.1,0-0.1-0.1-0.1-0.2 c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1-0.2-0.3-0.3-0.1-0.6c0-0.3-0.1-0.6,0.2-0.9c0.1,0,0.1,0.1,0.1,0.2 c0,0,0.1,0.1,0.1,0.1s0.1-0.1,0.1-0.1c0.1,0,0.2,0,0.2,0.1c0.2,0.2,0.5,0.2,0.7,0.1c0.1,0,0.3,0,0.4,0c0.1,0,0.1,0.1,0.2,0.2 c0,0.1,0,0.2,0,0.2c-0.1,0.2,0,0.3,0,0.5c0,0.3-0.1,0.5-0.1,0.8c-0.1,0.2-0.1,0.3-0.3,0.5c-0.1,0.1-0.3,0.2-0.5,0.2 c-0.3,0-0.3,0.2-0.4,0.4c-0.3,0.6-0.7,0.7-1.3,0.5C27.2,27.2,27.2,27.2,27.1,27.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st316",
    d: "M25.2,24.5c0,0.1,0,0.1,0,0.2c0,0.2-0.2,0.4-0.3,0.5c-0.1,0.1-0.2,0.1-0.2,0.2c-0.1,0.1-0.2,0.1-0.3,0.1 c-0.3,0-0.6-0.1-0.8-0.4c-0.1-0.2,0-0.4,0.1-0.6c0-0.1,0.1-0.2,0.2-0.2c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1s0-0.1,0-0.1 c0,0,0.1,0,0.1,0c0.1,0,0.3,0,0.4,0C24.7,24.5,25.1,24.3,25.2,24.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st317",
    d: "M27.8,24.5c0.1,0.2,0.3,0.4,0.4,0.7c0,0.2-0.1,0.5-0.4,0.4c-0.1-0.1-0.1-0.2-0.2-0.2 c-0.1-0.1-0.1-0.1-0.1-0.2c0.1,0,0.1-0.1,0.1-0.1c0,0,0-0.1,0-0.1c0-0.1,0-0.3,0-0.4C27.7,24.5,27.7,24.5,27.8,24.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M25.2,24.5c-0.2,0-0.5,0.1-0.7-0.2c0.3,0,0.6,0,0.9,0C25.4,24.4,25.3,24.5,25.2,24.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st318",
    d: "M23.9,24.3c0-0.2,0-0.3,0.2-0.4c0.1-0.1,0.1-0.1,0.2,0c-0.1,0.1-0.1,0.3-0.2,0.4l0,0 C24.1,24.4,24,24.4,23.9,24.3L23.9,24.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st319",
    d: "M28,23.9c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.2c0.1-0.1,0.1-0.1,0.2-0.2c0.2,0.2,0.2,0.4,0,0.6l0,0 C28.2,24,28.1,24,28,23.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M25.6,23.7c0-0.1,0-0.3,0-0.4C25.9,23.4,25.9,23.5,25.6,23.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M27.4,24.1c-0.2,0-0.3,0-0.4-0.2C27.1,23.9,27.3,23.9,27.4,24.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M25.4,23.7c0.1,0,0.1,0,0.2,0C25.6,23.8,25.5,23.8,25.4,23.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st320",
    d: "M17.9,37c-0.1-0.5-0.2-1-0.9-1.1c0.1-0.2,0.2-0.5,0.4-0.7c0.1,0.1,0.2,0.2,0.4,0.3c-0.1-0.2-0.2-0.4-0.2-0.6 c0.2-0.5,0.5-0.7,0.9-0.7c0.4,0.1,0.9,0,1.2,0.3c0.2,0.5-0.1,0.9-0.4,1.2c-0.5,0.2-0.2,1-0.8,1.1c-0.1,0.1-0.3,0.1-0.4,0.2 C18,37,18,37,17.9,37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M18.3,36.8c0.1-0.4,0.8-0.5,0.4-1.1c0,0,0-0.3,0.2-0.3c0.1,0,0.2,0.2,0.3,0.3c0.3,0.2,0.3,0.5,0.5,0.8 c0.1,0.1,0.2,0.2,0.2,0.4c0,0.1-0.1,0.2-0.1,0.2c-0.4,0.1-0.5,0.3-0.3,0.7c-0.2,0.4-0.5,0.3-0.8,0.2c0,0-0.1-0.1-0.1-0.1 c-0.1-0.3-0.3-0.5-0.2-0.9C18.3,37,18.2,36.9,18.3,36.8C18.3,36.8,18.3,36.8,18.3,36.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st151",
    d: "M18.1,38.8c0.1-0.2,0.2-0.2,0.4-0.2c0,0,0.1,0,0.1,0c0.2,0,0.3,0.1,0.4,0.2c0.2,0.2,0.2,0.3,0.3,0.5 c0.1,0.2,0.3,0.3,0.3,0.6c-0.1,0.3-0.4,0.5-0.5,0.8c-0.2,0.2-0.4,0.2-0.7,0.1C17.7,40.3,18.4,39.4,18.1,38.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st321",
    d: "M18.1,38.8c0.2,0.3,1.1,0.4,0.2,1c-0.4,0.2,0.4,0.6,0.3,1c0,0.2,0,0.3-0.2,0.2c-0.1-0.1-0.1-0.1-0.2-0.2 c-0.1-0.1-0.3-0.2-0.2-0.4C18.1,39.8,17.5,39.2,18.1,38.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M17.9,40.3c0.1,0.1,0.1,0.3,0.2,0.4c-0.1,0-0.3,0-0.4,0c-0.3-0.2-0.6,0.4-0.9,0c-0.3-0.6,0.2-0.4,0.4-0.4 C17.5,40.3,17.7,40.3,17.9,40.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st322",
    d: "M17.2,40c-0.3,0-0.4-0.1-0.4-0.4C17,39.7,17.6,39.4,17.2,40z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M18.5,38.5c0-0.1,0-0.1,0-0.2c0,0,0.1-0.1,0.1-0.1c0.3-0.1,0.5-0.1,0.8,0c0.1,0.1,0.1,0.3,0.1,0.4 c-0.1,0.1-0.2,0.1-0.3,0.1C19,38.6,18.7,38.7,18.5,38.5L18.5,38.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M18.3,38.1c0.1-0.1,0.1-0.2,0.2-0.2l0,0c0.1,0.1,0.1,0.1,0.1,0.2c0,0.1-0.1,0.2-0.1,0.2l0,0 c-0.1,0-0.1,0-0.2,0C18.3,38.3,18.3,38.2,18.3,38.1C18.3,38.1,18.3,38.1,18.3,38.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st323",
    d: "M18.3,36.8c0,0.1,0,0.1,0,0.2c-0.1,0-0.1,0-0.2,0C18.1,36.9,18.2,36.8,18.3,36.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st318",
    d: "M18.3,38.1c0,0.1,0,0.1,0,0.2C18.2,38.3,18.1,38.2,18.3,38.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st324",
    d: "M5.2,27.1c0-0.1,0-0.3,0-0.4c0.2-0.2,0.5-0.2,0.5-0.5c0-0.1,0-0.3,0.1-0.4l0,0c0.1-0.1,0.1-0.1,0.2,0l0,0 c0.1,0.1,0.2,0.2,0.2,0.4c0,0.2,0,0.5,0,0.7c0,0.2-0.1,0.3-0.1,0.5c0,0.2,0.2,0.4,0.2,0.6c-0.1,0.1-0.2,0.2-0.3,0.3 c-0.2,0-0.4,0-0.6-0.1c-0.2-0.1-0.2-0.3-0.2-0.5c0-0.1,0.1-0.2,0.2-0.3c0.1,0,0.1-0.1,0-0.1c0,0,0,0,0,0c-0.1,0.1,0-0.1,0,0.1 c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0-0.2,0-0.2,0C5,27.6,4.9,27.5,5,27.3l0,0C5,27.3,5.1,27.2,5.2,27.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M5,27.3c0.1,0.1,0.1,0.1,0.2,0.2c0.2,0.3,0.2,0.6,0,0.8c-0.2,0.2-0.4,0-0.6-0.2c-0.3-0.1-0.6,0.1-0.9-0.2 c0.4-0.2,0.5-0.5,0.6-0.9c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0.1,0.2,0.2C4.8,27.3,4.9,27.3,5,27.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M4.3,27.1c0,0.5,0.1,0.9-0.6,0.9c0-0.1,0-0.3,0-0.4c0.1,0,0.1,0,0.2,0c0.4-0.2,0.1-0.7,0.3-0.9 C4.4,26.8,4.3,27,4.3,27.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st199",
    d: "M4.8,27.3c-0.1-0.1-0.1-0.1-0.2-0.2c0-0.2,0-0.4,0-0.6c0.1-0.1,0.1-0.1,0.2,0l0,0c0.1,0.1,0.1,0.3,0,0.4 C4.8,27,4.8,27.2,4.8,27.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st325",
    d: "M5.8,26.3c-0.1,0.3-0.3,0.4-0.6,0.4c0.1-0.2,0.2-0.4,0.4-0.4C5.7,26.2,5.8,26.2,5.8,26.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M4.8,26.9c0-0.1,0-0.3,0-0.4C5,26.6,5,26.8,4.8,26.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st101",
    d: "M5.8,26.3c-0.1,0-0.1,0-0.2,0c0-0.2,0-0.3,0.2-0.4C5.8,26,5.8,26.1,5.8,26.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st326",
    d: "M6.1,25.8c-0.1,0-0.1,0-0.2,0c0-0.1,0-0.1,0-0.2C5.9,25.7,6,25.8,6.1,25.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M5.2,27.1C5.1,27.2,5,27.3,5,27.3C5,27.3,5.1,27.2,5.2,27.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M4.8,26.5c-0.1,0-0.1,0-0.2,0C4.6,26.3,4.7,26.3,4.8,26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M27.6,43.9c-0.2,0-0.4,0-0.6,0C26.9,44,26.8,44,26.7,44c-0.1-0.1-0.2-0.2-0.3-0.3c0-0.1,0-0.3,0-0.4 c0.2-0.1,0.2-0.3,0.2-0.4c0-0.2,0.1-0.4,0.3-0.5c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.2,0.1,0.2,0.1l0,0c0.2,0.2,0.3,0.4,0.2,0.6 c0.2,0.2,0.4,0.3,0.5,0.5C28,43.8,27.5,43.4,27.6,43.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st327",
    d: "M27.6,43.1c-0.1-0.2-0.2-0.4-0.2-0.6c0.2,0,0.5-0.1,0.6,0.2C28,42.9,27.8,43,27.6,43.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st279",
    d: "M27.8,41.8c0.1,0.1,0.2,0.1,0.2,0.2c-0.2,0.3-0.4,0.2-0.7,0.2c0,0,0-0.1,0-0.1 C27.4,41.8,27.6,41.8,27.8,41.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st328",
    d: "M28.2,42c0.1-0.2,0.2-0.2,0.4-0.2C28.6,42,28.4,42,28.2,42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M29.1,43.3c-0.1,0.1-0.1,0.1-0.2,0.2C28.9,43.4,29,43.3,29.1,43.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st271",
    d: "M29.9,62.4c0.1-0.1,0.2-0.1,0.2-0.2c0.1-0.3,0.4-0.4,0.6-0.6c0.1-0.1,0.2-0.2,0.4-0.2c0.2,0,0.4-0.1,0.5,0.1 l0,0c0.3,0.3,0.3,0.7,0.2,1.1c-0.2,0.3-0.4,0.4-0.8,0.5C30.7,63,29.8,63.6,29.9,62.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st259",
    d: "M29.9,62.4c0.1,0.8,0.7,0.4,1.1,0.4c0.1,0.1,0.1,0.2,0,0.3c-0.2,0.4-0.5,0.7-0.9,0.8c-0.1,0-0.1,0-0.2,0 c-0.2-0.5-0.6-0.9-0.2-1.5C29.8,62.4,29.9,62.4,29.9,62.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st329",
    d: "M30.8,61.8c-0.1,0.3-0.4,0.3-0.6,0.4c-0.3-0.4-0.5-0.8,0-1.3c0.1,0,0.1,0,0.2,0c0,0,0.1,0.1,0.1,0.1 C30.7,61.3,30.8,61.5,30.8,61.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st330",
    d: "M23.1,58.3c-0.1,0.1-0.1,0.3-0.2,0.4l0,0c-0.1,0.1-0.1,0.2-0.2,0.2c-0.1,0.1-0.2,0.1-0.4,0.2 c0,0-0.1,0-0.1-0.1c-0.2-0.4-0.1-0.9-0.1-1.4c0-0.1,0-0.2,0.1-0.3c0.1-0.1,0.1-0.1,0.2-0.1C22.7,57.7,22.7,58.1,23.1,58.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st331",
    d: "M22,60.7c0-0.1,0-0.3-0.1-0.4c-0.4-0.3-0.3-0.7,0-1.1c0.1-0.1,0.2-0.1,0.3,0l0.1,0 C22.2,59.7,22.7,60.3,22,60.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M22.6,61.6c0.2,0,0.4,0,0.6,0c-0.1,0.2-0.2,0.4-0.4,0.4l0,0c-0.1-0.1-0.1-0.2-0.2-0.2 C22.6,61.7,22.6,61.7,22.6,61.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st332",
    d: "M22.6,59c0.1-0.1,0.1-0.1,0.2-0.2c0,0.1,0,0.3,0,0.4C22.8,59.1,22.7,59.1,22.6,59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st206",
    d: "M22.3,61.8c-0.1-0.1-0.1-0.3-0.1-0.4C22.4,61.5,22.4,61.6,22.3,61.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st331",
    d: "M21.8,60.7c0.1,0,0.1,0,0.2,0C21.9,60.8,21.9,60.9,21.8,60.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M22.6,61.8c0.1,0.1,0.1,0.1,0.2,0.2C22.7,62,22.7,61.9,22.6,61.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M31.7,54.7c-0.3-0.1-0.3-0.4-0.4-0.6c0.1-0.2,0.3-0.2,0.4-0.2c0.5,0.1,0.8-0.7,1.3-0.2c0,0.1,0,0.3,0,0.4 c0.1,0,0.1,0.1,0.1,0.1c0,0.1,0,0.1,0,0.1c-0.1,0.1-0.3,0.1-0.4,0.2c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0.1-0.1,0.2-0.2,0.3 c0,0-0.1,0-0.1,0.1c-0.1,0.1-0.3,0.3-0.4,0.4c-0.1-0.1-0.2-0.1-0.2-0.2l0,0C31.5,55,31.6,54.8,31.7,54.7L31.7,54.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M33,53.6c-0.3,0-0.6,0-0.8,0.2c-0.2,0.2-0.4,0.2-0.5,0c0.1-0.1,0.2-0.2,0.3-0.3C32.4,52.7,32.4,52.7,33,53.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M33.4,53.4c0.3,0,0.6,0,0.6,0.4c-0.3,0.1-0.5,0.5-0.9,0.4c-0.1,0-0.1-0.1-0.1-0.1c0,0,0-0.1,0.1-0.1 C33.2,53.8,33.1,53.5,33.4,53.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M33.2,54c0,0.1,0,0.1,0,0.2l0,0c-0.1,0.1-0.1,0.1-0.2,0c0-0.1,0-0.1,0-0.2C33,54,33.1,54,33.2,54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st333",
    d: "M4.5,30.1c-0.3,0-0.6,0.2-0.9,0c0-0.1,0-0.3,0-0.4C4,30,4.1,29.6,4.3,29.5c0.1-0.1,0.3-0.1,0.4,0 C4.8,29.8,4.6,29.9,4.5,30.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st308",
    d: "M2.8,30.4c0,0.1,0,0.1,0,0.2c-0.1,0.1-0.1,0.1-0.2,0.2l0,0c-0.5,0-0.4-0.3-0.4-0.6h0 C2.4,30.1,2.6,30.3,2.8,30.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M2.2,30.1C2.1,30.1,2.1,30.1,2.2,30.1C2.1,30,2.1,30,2.2,30.1C2.2,30.1,2.2,30.1,2.2,30.1L2.2,30.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st334",
    d: "M40.1,62.2c-0.1-0.5,0.5-0.3,0.6-0.6c0.1-0.1,0.3-0.1,0.4,0c0.1,0.1,0.1,0.1,0.2,0.2 C41.2,61.9,41,62,40.7,62c-0.1,0.1-0.3,0.1-0.4,0.2C40.2,62.2,40.2,62.2,40.1,62.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st335",
    d: "M40.3,62.2c0.1-0.2,0.3-0.2,0.4-0.2C40.6,62.2,40.5,62.2,40.3,62.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M13.8,40.5c0-0.1,0-0.1,0-0.2c0.1-0.2,0.3-0.2,0.5-0.1c0.1,0,0.2,0.1,0.2,0.2c0.1,0.2,0.2,0.5,0.5,0.6 c0.3,0.1,0.5,0,0.8,0.2c0.1,0.1,0.1,0.1,0.2,0.2c0,0,0,0.1-0.1,0.1c-0.3,0-0.4,0.1-0.4,0.4c-0.2,0-0.4,0-0.6,0c0-0.1,0.1-0.5,0-0.3 c-0.5,0.5-0.7-0.2-1.1-0.1c-0.1,0-0.1-0.1-0.1-0.1c0,0,0-0.1,0.1-0.1c0.2,0,0.4-0.1,0.4-0.3C14.2,40.5,14,40.5,13.8,40.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st117",
    d: "M16.4,40.9c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0c0.1,0,0.1,0.1,0.1,0.2c0,0.4-0.3,0.7-0.6,1 c-0.4-0.2-0.3-0.5-0.3-0.7l0,0c0.1,0,0.1-0.1,0.1-0.2c0,0,0-0.1,0-0.1c0-0.1,0.1-0.1,0.2-0.1C16.3,40.9,16.4,40.9,16.4,40.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st79",
    d: "M16.8,40.7c0.3,0.1,0.6-0.4,0.9,0c-0.2,0.1-0.2,0.3-0.2,0.5c0,0.1-0.1,0.3-0.2,0.2c-0.2,0-0.2-0.2-0.2-0.3 c-0.1-0.1-0.3-0.1-0.4-0.2l0,0C16.7,40.8,16.7,40.8,16.8,40.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st336",
    d: "M18.3,40.9c0.1-0.1,0.1-0.1,0.2-0.2c0.2,0,0.5,0.1,0.6-0.2c0,0,0.1,0,0.1-0.1c0.1,0,0.2,0.1,0.3,0.2 c0,0,0,0.1,0,0.1c-0.1,0.4-0.6,0.5-0.9,0.7l0,0c-0.1-0.1-0.2-0.1-0.2-0.2c-0.1,0-0.1,0-0.2,0C18.3,41,18.3,41,18.3,40.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M16.6,40.9c0.2,0,0.3,0,0.4,0.2c-0.1,0-0.1,0-0.2,0C16.7,41,16.7,41,16.6,40.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M15.1,42.4c0-0.1,0.1-0.2,0.2-0.2C15.2,42.3,15.2,42.3,15.1,42.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M15.5,42c0-0.1,0-0.1,0-0.2C15.7,41.8,15.7,41.9,15.5,42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M29.3,34.2c0.1,0,0.1,0,0.2,0c0.2,0.8,0.7,0.3,1.1,0.2c0,0.4-0.2,0.6-0.6,0.7c0.6,0.3,1.2,0.9,1.6-0.1 c0.3,0.1,0.4,0.4,0.4,0.6c-0.2,0.3-0.2,0.6-0.6,0.6c-0.1,0.1-0.1,0.1-0.2,0c-0.3-0.3-0.7-0.4-1.1-0.4c-0.3-0.2-0.7,0.3-0.9-0.1 c0.1-0.4-0.4-0.3-0.5-0.6c-0.1-0.4,0-0.6,0.4-0.8C29.2,34.4,29.2,34.3,29.3,34.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M32.1,35.7c-0.3-0.1-0.4-0.3-0.4-0.6c0.4-0.2,0.8-0.5,1.3-0.6l0,0c0.2,0.4,0.2,0.7,0,1.1 C32.7,35.5,32.4,35.6,32.1,35.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M33,35.5c0-0.4,0-0.7,0-1.1c0.1,0,0.1,0,0.2,0C33.1,34.8,33.4,35.2,33,35.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M33.6,34.4c0-0.1,0-0.3,0.1-0.3c0.1,0,0.3,0.3,0.1,0.5C33.8,34.6,33.7,34.5,33.6,34.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M31.3,36.4c0.1,0,0.1,0,0.2,0c0,0.1,0,0.1,0,0.2C31.4,36.6,31.3,36.5,31.3,36.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M8.4,8C8.6,7.7,8.8,7.4,9,7.1c0.2,0.6-0.4,1.2,0,1.7c-0.1,0-0.1,0-0.2,0C8.8,8.7,8.7,8.7,8.6,8.6 c0-0.1,0-0.1,0-0.2C8.5,8.3,8.6,8.1,8.4,8L8.4,8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M10.1,9C9.9,9,9.7,9,9.5,9C9.4,9,9.4,8.9,9.3,8.8c0-0.2,0-0.3,0.2-0.4c0.2,0,0.4,0.1,0.6,0.2 c0.1,0.1,0.1,0.2,0.2,0.2c0,0.1,0,0.1,0,0.2C10.3,9.1,10.2,9.1,10.1,9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M8.2,7.3c0,0.2,0,0.4,0,0.6c0,0.2-0.1,0.4-0.3,0.4C7.6,8.3,7.7,8.1,7.8,8C7.8,7.8,7.9,7.5,8,7.3 C8.1,7.2,8.1,7.2,8.2,7.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M8.2,7.3c-0.1,0-0.1,0-0.2,0C8,7.2,8,7,8,6.9c0.1,0,0.3,0,0.4,0C8.5,7.1,8.6,7.3,8.2,7.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st90",
    d: "M9.3,9.2C8.9,9.6,8.9,9.3,8.9,9C9,9.1,9.1,9.2,9.3,9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M8.4,8C8.6,8,8.6,8.2,8.6,8.4C8.4,8.3,8.4,8.1,8.4,8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M8.6,8.6c0.1,0.1,0.1,0.1,0.2,0.2C8.7,8.8,8.7,8.7,8.6,8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M9.5,9C9.4,9.1,9.4,9.2,9.3,9.2C9.4,9.2,9.4,9.1,9.5,9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M12.5,13c-0.3,0.1-0.5,0-0.7-0.2c0,0,0.1-0.2,0.1-0.2C12.2,12.4,12.4,12.6,12.5,13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st96",
    d: "M31.2,34.2c0.1-0.1,0.2-0.3,0.2-0.4c0.1,0,0.3,0,0.4,0c-0.1,0.2-0.2,0.4-0.2,0.6l0,0 C31.5,34.4,31.3,34.4,31.2,34.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st72",
    d: "M31.7,34.4c0.1,0,0.2,0,0.3,0.1c0,0,0,0.1-0.1,0.1C31.8,34.6,31.7,34.5,31.7,34.4L31.7,34.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st326",
    d: "M6.3,25.8c0.3-0.4,0.7-0.1,1.1-0.2c0.1,0,0.2,0.1,0.4,0.2c0.1,0.1,0.2,0.2,0.2,0.3c0.2,0.1,0.2,0.4,0.3,0.6 c0.1,0.1,0.3,0.1,0.4,0.2c0.2,0,0.4,0,0.5,0.1c0.2,0.2,0.4,0.5,0.6,0.8c0,0.4-0.3,0.7-0.5,1c-0.1,0.1-0.2,0.2-0.3,0.3 c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.2-0.1C8.4,29,8.3,29,8.3,28.9c-0.1-0.2-0.3-0.3-0.4-0.5c0-0.1-0.1-0.2-0.1-0.3 c0-0.8-0.2-1.5-1-1.8c-0.1,0-0.2-0.1-0.3-0.1C6.4,26.1,6.3,26,6.3,25.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M8.2,26.7c-0.3-0.1-0.3-0.4-0.4-0.6c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1-0.1-0.1-0.1-0.2-0.2 c0.1-0.2,0.4-0.2,0.5-0.3c-0.1-0.2-0.4-0.1-0.5-0.3c-0.1,0-0.1-0.1-0.1-0.1c0,0,0-0.1,0.1-0.1c0.3,0.1,0.6,0.3,0.5-0.2 c0-0.3,0.1-0.5,0.3-0.6c0.1,0.1,0.1,0.3,0.2,0.4c-0.1,0.2,0.2,0.4-0.1,0.7C7.9,25.5,8.5,26.1,8.2,26.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M9.7,26.7c0.2,0,0.3,0,0.4-0.2c0.4-0.5,0.6-0.1,0.7,0.2c0,0.1,0,0.2-0.1,0.3c-0.1,0.2-0.3,0.3-0.5,0.4 c-0.2,0.1-0.3,0.1-0.5,0c-0.2-0.1-0.3-0.3-0.1-0.5C9.7,26.8,9.7,26.8,9.7,26.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M9.7,26.9c0,0.2,0,0.3,0.2,0.4c0.1,0.2,0,0.3-0.1,0.4c0,0-0.1,0-0.1,0.1c-0.4,0-0.5-0.4-0.7-0.6 c-0.2-0.2-0.2-0.4,0-0.7C9.4,26.4,9.5,26.8,9.7,26.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M9.3,25.4c0.1,0.1,0.1,0.1,0.2,0.2c0,0.1,0,0.1,0,0.2c-0.3-0.1-0.5,0.3-0.8,0.1C8.7,25.5,9.1,25.5,9.3,25.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M9.1,26.5c0,0.2,0,0.4,0,0.7c-0.2,0-0.3,0-0.4-0.2C8.6,26.6,8.8,26.5,9.1,26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st337",
    d: "M20.5,2.1C20.3,2,20,1.9,19.8,1.7l-0.1,0l-0.1,0c-0.1,0.1-0.1,0.1-0.2,0c0-0.1,0-0.1,0-0.2 c0.1-0.1,0.3-0.1,0.4-0.2C20.2,1.4,20.6,1.6,20.5,2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M20.5,3c-0.1,0-0.1,0-0.2,0c0.1-0.1,0.1-0.1,0.2-0.2C20.5,2.9,20.5,2.9,20.5,3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st259",
    d: "M13.6,21.7c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.1-0.2,0.2-0.4,0.1c-0.2-0.1-0.4-0.2-0.5-0.3c0-0.1,0-0.1,0-0.2 c0.3-0.1,0.5-0.4,0.7-0.7c0.1-0.1,0.2-0.1,0.3-0.1C14.2,21,14.1,21.3,13.6,21.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M12.5,21.7c0.2,0,0.3,0,0.4,0.2c-0.1,0.3-0.3,0.6-0.4,0.9l0,0c-0.1,0.1-0.3,0.1-0.4,0.2 C12,22.5,12.3,22.1,12.5,21.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M24.8,15.3c-0.2,0-0.4,0-0.3-0.3c0-0.1,0.2-0.3,0.2-0.2C24.8,14.9,24.8,15.1,24.8,15.3L24.8,15.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st267",
    d: "M45.1,49.5c-0.4-0.4-0.4-0.6,0.2-0.8c0.3-0.1,0.7-0.1,0.4-0.5c0.6,0,0.6,0.5,0.7,0.9c0,0,0,0.1-0.1,0.1 c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0.1-0.3,0.1C45.2,49.6,45.1,49.6,45.1,49.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st338",
    d: "M46.1,47.1c0-0.1,0-0.1,0-0.2c0.1-0.1,0.2-0.2,0.4-0.2c0.1,0,0.1,0,0.2,0c0.3,0.1,0.2,0.5,0.4,0.7 c0.1,0.1,0.3,0.1,0.4,0.2c0,0,0.1,0.1,0,0.1c0,0.1,0,0.1,0,0.1l0,0c-0.1,0-0.2,0.1-0.2,0.2c-0.1,0-0.3,0-0.4,0 C46.7,47.7,46.4,47.4,46.1,47.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st267",
    d: "M46.3,49.3c-0.1,0.3-0.1,0.6-0.2,0.9l0,0c-0.2,0.1-0.4,0.1-0.6,0.1c-0.1,0-0.2,0-0.3,0 c-0.1-0.1-0.1-0.1-0.1-0.2c0-0.1,0.1-0.3,0.2-0.3c0.2-0.1,0.4-0.1,0.6-0.3c0.1-0.1,0.1-0.1,0.2-0.1C46.3,49.2,46.3,49.3,46.3,49.3z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st339",
    d: "M47,48.6c-0.1,0-0.3,0-0.4,0c0.1-0.1,0.2-0.3,0.2-0.4C47,48.3,47,48.5,47,48.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M46.3,49.1c0.1,0,0.1,0.1,0.1,0.1c0,0-0.1,0-0.1,0.1l0,0C46.3,49.3,46.2,49.2,46.3,49.1 C46.3,49.1,46.3,49.1,46.3,49.1L46.3,49.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "M14.9,41.1c-0.4-0.2-0.5-0.5-0.4-0.9c0.1,0,0.1-0.1,0.1-0.1c-0.1,0-0.1,0-0.1,0.1c-0.2,0-0.4,0-0.6,0 c0-0.1,0-0.3,0-0.4c0.1-0.1,0.1-0.1,0.2-0.2c0.3,0,0.6,0,0.8-0.1c0.4-0.2,0.5,0,0.7,0.3C16.1,40.6,15.4,40.8,14.9,41.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st236",
    d: "M14.9,41.1c0.2-0.4,0.9-0.6,0.6-1.3c0.7,0,0.6,0.7,0.9,1.1l0,0c-0.1,0.1-0.1,0.1-0.2,0.2l0,0 c-0.1,0.1-0.1,0.1-0.2,0C15.6,41.1,15.2,41.1,14.9,41.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st340",
    d: "M30.8,33.8c-0.1,0.2-0.1,0.3-0.3,0.3c0,0-0.1-0.2-0.1-0.3C30.5,33.8,30.7,33.8,30.8,33.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M2.6,30.8c0.1-0.1,0.1-0.1,0.2-0.2C2.8,30.7,2.7,30.8,2.6,30.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st341",
    d: "M41.1,60.1c-0.2-0.1-0.5-0.2-0.7-0.3c-0.1,0.4,0.3,0.5,0.3,0.8c-0.4,0.3-0.6,0-0.8-0.2 c-0.1-0.1-0.2-0.3-0.2-0.4c-0.1-0.2-0.1-0.4,0-0.6c0.1-0.2,0.1-0.5,0.3-0.7c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.3,0,0.4,0.1 c0.3,0.1,0.5,0.2,0.5,0.6c0,0.1-0.2,0.1-0.2,0.2c0.1,0,0.3,0,0.4,0.1c0.2,0.1,0.3,0.2,0.4,0.4C41.6,60,41.4,60.1,41.1,60.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st342",
    d: "M42.9,58.6c-0.3,0.1-0.1,0.7-0.5,0.7c-0.4-0.2,0.5-0.9-0.3-0.9c-0.3,0.1-0.6,0.2-0.9,0c0-0.1,0-0.2,0-0.3 c0.2-0.4,0.6-0.6,1-0.7c0.4-0.1,0.7-0.1,1,0.2c0,0.1,0.1,0.2,0.1,0.3c0,0.3-0.1,0.5-0.2,0.7C43,58.5,42.9,58.5,42.9,58.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st343",
    d: "M41.2,58.3c0.3,0,0.6-0.2,0.9,0c0,0.5,0,0.9-0.7,0.9c0,0-0.1-0.1-0.1-0.1C41.2,58.9,41,58.6,41.2,58.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st344",
    d: "M43.1,57.9c0-0.1,0-0.1,0-0.2c0.1-0.1,0.1-0.1,0.2,0l0,0c0.1,0.2,0.3,0.4,0.2,0.6h0 c-0.1,0.1-0.2,0.2-0.2,0.3c0,0.1-0.1,0.3-0.3,0.2c-0.1,0-0.2-0.2-0.2-0.3l0,0C43.1,58.4,42.9,58.1,43.1,57.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M42.2,60.7C42,60.6,42,60.5,42,60.3c0.1-0.2,0.2-0.4,0.4-0.4c0.1,0,0.2,0.1,0.2,0.2 C42.7,60.4,42.3,60.5,42.2,60.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st345",
    d: "M43.5,59.9c-0.1-0.1-0.3-0.1-0.4-0.2c0.1-0.2,0.3-0.2,0.5-0.2c0.2,0,0.4,0.1,0.4,0.3 C44,60,43.7,59.8,43.5,59.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st346",
    d: "M41.1,60.1c0.1-0.3,0.4-0.2,0.6-0.2c0,0.1,0,0.1,0,0.2C41.6,60.1,41.4,61,41.1,60.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st347",
    d: "M41.4,59.4c-0.2,0-0.4,0-0.5-0.1c-0.1-0.2,0.1-0.1,0.3-0.2c0.1-0.1,0.1-0.1,0.2,0l0,0 C41.4,59.3,41.4,59.4,41.4,59.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M42.7,60.1c-0.1-0.1-0.1-0.1-0.2-0.2c0.1-0.1,0.1-0.1,0.2-0.2c0,0.1,0,0.1,0,0.2C42.7,59.9,42.7,60,42.7,60.1 C42.7,60,42.7,60.1,42.7,60.1L42.7,60.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st348",
    d: "M13.8,41.1c0,0.1,0,0.1,0,0.2c-0.1,0-0.3,0.1-0.3-0.1C13.5,41.2,13.7,41.1,13.8,41.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M14.7,42c-0.1,0.1-0.1,0.1-0.2,0.2C14.5,42.1,14.6,42,14.7,42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st349",
    d: "M27.8,67c0.1,0.1,0.1,0.1,0.2,0.2c0,0.3,0.1,0.6-0.4,0.6c-0.5,0-0.5-0.3-0.5-0.6C27.3,66.9,27.6,67,27.8,67z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M27.2,68.5c-0.6,0-0.7,0.4-0.6,1.2c-0.2-0.5-0.3-0.7-0.4-0.9l0,0c0.1-0.2,0.2-0.5,0.4-0.6l0,0 C26.8,68,27.2,68,27.2,68.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M26.5,66.3c-0.1,0.3-0.3,0.6-0.2,0.9c-0.3,0.2-0.7,0.1-0.9,0.4h0c-0.1,0-0.1,0-0.2,0c-0.2-0.2-0.2-0.4,0-0.6 C25.3,65.8,25.3,65.8,26.5,66.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st101",
    d: "M25.2,67c0,0.2,0,0.4,0,0.6c-0.2,0-0.4,0-0.6,0C24.5,67.1,24.7,66.9,25.2,67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st350",
    d: "M26.5,68c0,0.3-0.1,0.5-0.4,0.6c0-0.2-0.4-0.2-0.2-0.5C26,68,26.3,68,26.5,68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M25.4,67.8c-0.1,0.2,0.1,0.5-0.2,0.5c-0.2,0-0.4-0.2-0.3-0.3C25,67.7,25.3,67.9,25.4,67.8L25.4,67.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st351",
    d: "M25.4,67.6c0.1,0,0.3,0,0.3,0.1c0,0.2-0.2,0.1-0.3,0.1l0,0C25.4,67.8,25.4,67.7,25.4,67.6L25.4,67.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st352",
    d: "M45.9,55.5c0.1-0.1,0.3-0.1,0.4-0.2c0.1,0.4-0.2,1.2,0.7,0.7c0.1,0,0.2,0.2,0.4,0.3c0,0.2,0,0.3-0.2,0.4 c-0.1-0.1-0.1-0.1-0.2,0l0,0c-0.4,0.2-0.7,0.4-1.1,0.6c-0.3-0.1-0.3-0.4-0.4-0.6C45.8,56.5,45.6,55.9,45.9,55.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st353",
    d: "M48.3,57.9c-0.2-0.1-0.2-0.3-0.1-0.6C48.3,57.6,48.2,57.7,48.3,57.9L48.3,57.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st354",
    d: "M30.2,37c0,0.1,0,0.3,0,0.4c-0.3,0.1-0.6-0.1-0.9-0.2c-0.1-0.1-0.2-0.1-0.3-0.1c0.1,0.1,0.2,0,0.3,0.1 c0.1,0.3,1,0.6,0,0.9c-0.2,0-0.4,0-0.6,0c-0.3,0-0.6-0.1-0.8-0.3c-0.2-0.2-0.1-0.5-0.2-0.8c0-0.1,0-0.3,0-0.4 c0.1-0.3,0.3-0.4,0.5-0.6c0.3-0.2,0.6-0.4,1-0.3c0.2,0.3,0.5,0.5,0.4,0.9c0.4,0.5,0.4-0.2,0.6-0.2C30.4,36.6,30.3,36.8,30.2,37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st242",
    d: "M29.7,39c-0.1,0.1-0.1,0.2-0.2,0.2c-0.2,0.3-0.7,0.4-1,0.6c-0.4,0.2-0.7,0.7-1.2,0.4 c-0.3-0.4-0.1-0.8,0.1-1.2c0.1-0.1,0.2-0.1,0.3-0.2c0.3,0,0.6,0.2,0.9-0.1c0.3-0.2,0.1-0.5,0.3-0.7C29,38,29.1,38,29.2,38 c0.1,0,0.2,0,0.3,0c0.1,0.1,0.2,0.2,0.2,0.4c0,0,0,0.1,0,0.1C29.7,38.7,29.7,38.8,29.7,39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st310",
    d: "M29.5,38.1c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1-0.1-0.1-0.1s0-0.1,0.1-0.1c0.1,0,0.2,0,0.2,0 c0.2-0.1,0-0.2-0.1-0.2c-0.4,0-0.2-0.3-0.1-0.4l0,0c0.4-0.3,0.6,0,0.9,0.2c0,0.2,0.1,0.5-0.2,0.7c-0.1,0.1-0.1,0.1-0.2,0.1 C29.7,38.2,29.6,38.2,29.5,38.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st355",
    d: "M29.5,36.6c-0.1-0.3-0.3-0.6-0.4-0.8c0.1-0.1,0.1-0.1,0.2,0c0.2,0.3,0.7-0.2,0.9,0.2 C29.8,36,29.8,36.4,29.5,36.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st356",
    d: "M30.4,36.4c0.2,0,0.5-0.1,0.5,0.2c0.1,0.3-0.2,0.2-0.3,0.3C30.5,36.7,30.3,36.6,30.4,36.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st357",
    d: "M30.4,36.4c0.1,0.1,0.1,0.3,0.2,0.4c-0.1,0.1-0.3,0.1-0.4,0.2c0-0.2,0-0.4,0-0.6 C30.2,36.4,30.3,36.4,30.4,36.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st242",
    d: "M29.7,38.1c0.1,0,0.1,0,0.2,0c0,0.2,0,0.3-0.2,0.4l0,0C29.6,38.4,29.6,38.3,29.7,38.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st242",
    d: "M30.2,38.7c0,0.1-0.1,0.2-0.2,0.2C30,38.9,30.1,38.8,30.2,38.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M19.6,3.2c0,0.1,0,0.1,0,0.2c-0.1,0-0.1,0-0.2,0c-0.2,0-0.4,0-0.6,0c-0.3-0.1-0.1-0.5-0.4-0.6 c-0.1,0-0.1,0-0.2,0c0.3-0.3,0.6-0.4,0.8,0.1C19.1,3.2,19.3,3.2,19.6,3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st96",
    d: "M19.4,1.7c0.1,0,0.1,0,0.2,0C19.5,1.9,19.5,1.9,19.4,1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st358",
    d: "M33.3,29c-0.1,0-0.2,0-0.4,0c-0.1,0.1-0.3,0.1-0.4,0.2l0,0c-0.2,0.2-0.4,0.3-0.7,0.4c-0.2,0-0.4,0-0.6-0.1 C31,29.3,31,29,31.1,28.7c0.1-0.3,0.2-0.5,0.3-0.8c0.2-0.2,0.5-0.4,0.9-0.4c0.2,0,0.4,0,0.6,0.1c0.2,0.1,0.4,0.2,0.5,0.3 c0.2,0.1,0.2,0.3,0.2,0.5C33.6,28.7,33.5,28.8,33.3,29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st224",
    d: "M33.4,28c-0.2,0-0.3,0-0.4-0.2c-0.1-0.5,0.4-0.6,0.6-0.9c0.1-0.1,0.2-0.1,0.2-0.2c0.1-0.1,0.2-0.1,0.3-0.2 c0.1,0,0.2,0,0.3-0.1c0.2,0,0.3,0.1,0.4,0.2c0.1,0.2,0.1,0.3-0.1,0.4c-0.1,0.1-0.3,0.3-0.4,0.4C33.9,27.6,33.9,28.3,33.4,28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st133",
    d: "M34.7,27.1c0-0.1,0-0.3,0-0.4c0-0.1,0.1-0.2,0.2-0.3c0.1,0,0.2,0,0.2,0.1c0,0.4,0,0.7,0.4,0.9 c0,0.1,0,0.1,0,0.2c0,0.2-0.1,0.5-0.3,0.2C35,27.6,34.9,27.3,34.7,27.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st340",
    d: "M33.4,28c0.4,0.1,0.5-0.5,0.9-0.4c-0.2,0.3-0.3,0.7-0.7,0.9C33.4,28.3,33.4,28.2,33.4,28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M32.3,59c0-0.1,0-0.3,0-0.4c0.2-0.3-0.1-0.3-0.2-0.4l0,0c-0.2-0.2,0.2-0.4,0-0.7c-0.1-0.1-0.2-0.1-0.3-0.1 c-0.2,0.1-0.4,0.2-0.5-0.1c-0.1-0.2,0.2-0.4,0.4-0.5c0.1,0.3,0.4,0.2,0.6,0.2c0.1,0.1,0.1,0.1,0.2,0l0,0c0.1-0.1,0.1-0.2,0.1-0.3 c0-0.2,0-0.3,0.2-0.4c0.1,0,0.2,0,0.2,0c0.1,0.1,0.1,0.1,0.2,0.2c0,0.1,0,0.2,0,0.2c-0.1,0.1-0.1,0.2,0,0.4c0,0.2,0.1,0.3,0.1,0.5 c0,0.1,0,0.2,0,0.3c0,0.1,0,0.3-0.1,0.4c-0.1,0.2-0.1,0.3-0.2,0.5c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0-0.2,0-0.2-0.1 C32.5,59,32.4,59,32.3,59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M33,56.4c-0.2,0.1-0.2,0.3-0.2,0.4c-0.1,0.1-0.1,0.1-0.2,0c-0.3-0.6,0.1-1.4-0.4-1.9l0,0 c0.1-0.1,0.1-0.3,0.2-0.4l0,0c0.4-0.1,0.5,0.1,0.4,0.4c0,0.1,0,0.1,0,0.2c0.2,0.1,0.2,0.3,0.2,0.5c0,0.2,0.1,0.4,0.1,0.5 C33.1,56.3,33,56.3,33,56.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M31.5,55.1c0.1,0.1,0.1,0.1,0.2,0.2c-0.1,0-0.1,0-0.2,0C31.5,55.3,31.5,55.2,31.5,55.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M32.5,56.8c0.1,0,0.1,0,0.2,0c0,0.1-0.1,0.2-0.2,0.2C32.5,57,32.5,56.9,32.5,56.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M32.5,57.1c-0.1,0.2-0.1,0.2-0.2,0C32.4,57.1,32.5,57.1,32.5,57.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M20.7,41.1c-0.3,0-0.6,0-0.7,0.3c-0.2-0.3,0-0.5,0.1-0.7c0.2-0.3-0.1-0.3-0.2-0.3c-0.1-0.1-0.1-0.2,0-0.3 c0.1-0.1,0.2-0.2,0.4-0.2c0.1,0,0.2,0,0.3,0.1C20.7,40.4,21,40.7,20.7,41.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M20.7,41.1c0-0.4-0.3-0.7-0.4-1.1c0.9-0.2,1,0.3,0.9,1.1l0,0C21,41.1,20.8,41.1,20.7,41.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st336",
    d: "M19.8,40.2c0,0.1,0,0.1,0,0.2c-0.1,0.1-0.1,0.1-0.2,0.2l0,0c-0.1-0.1-0.2-0.4-0.4-0.2l0,0 c-0.2-0.2-0.2-0.3,0-0.4c0.2-0.1,0.3-0.1,0.4-0.2C20,39.8,20,40,19.8,40.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st92",
    d: "M39.2,71.7c0,0.1,0,0.1,0,0.2c-0.2,0.1-0.4,0.2-0.6,0.2l0,0c-0.1-0.1-0.1-0.3,0-0.4l0,0 C38.8,71.7,39,71.7,39.2,71.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M36.2,65.7c0,0.2,0.1,0.4,0.3,0.4c0.3,0,0.3-0.2,0.3-0.4c0.4,0.3,0.1,0.6,0,0.9c-0.2,0.4-0.5,0.1-0.8,0 c-0.1,0-0.1-0.1-0.1-0.1c0,0,0-0.1,0-0.1c-0.1-0.1-0.1-0.3-0.2-0.4c0,0,0-0.1,0.1-0.1C35.9,65.7,36,65.6,36.2,65.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "M37.5,65.5c0.1,0.1,0.1,0.1,0.2,0.2c0,0.1,0,0.4-0.2,0.3C37.3,65.8,37.2,65.6,37.5,65.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st359",
    d: "M36,66.3c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c-0.2,0-0.4,0-0.3-0.3C35.7,66.3,35.8,66.3,36,66.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M28.2,23.9c0-0.2,0-0.4,0-0.6c0.4,0.1,0.9,0.3,1.3,0.4c0.1,0.2-0.1,0.3-0.2,0.4C28.7,24.7,28.7,24.7,28.2,23.9 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st102",
    d: "M29.3,24.1c0.1-0.1,0.1-0.3,0.2-0.4c-0.1-0.3-0.3-0.5-0.2-0.9c0.1-0.1,0.2-0.1,0.3-0.1 c0.3,0.1,0.5,0.5,0.7,0.7c0.1,0,0.2,0.1,0.2,0.2c0.1,0.1,0.1,0.2,0.1,0.3c-0.1,0.4,0,0.8-0.5,1c-0.3-0.1-0.2-0.6-0.5-0.7 C29.6,24.1,29.5,24.1,29.3,24.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M29.5,21.7c0.4-0.5,0.9-0.6,1.3,0c0.1,0.3-0.1,0.3-0.3,0.3c-0.3-0.2-0.5,0.2-0.8,0.2c-0.1,0-0.2,0-0.2-0.1 c0-0.1,0-0.1,0-0.2C29.5,21.9,29.4,21.9,29.5,21.7C29.5,21.8,29.5,21.7,29.5,21.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M29.5,22.2c0.1,0,0.1,0,0.2,0c0.2-0.1,0.4-0.1,0.5,0c0.2,0.3,0,0.5-0.2,0.7c-0.2,0.1-0.3,0.1-0.5,0 c-0.1,0-0.1,0-0.2,0C29.4,22.6,29.6,22.4,29.5,22.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M29.5,21.7c0,0.1,0,0.1,0,0.2c-0.1,0-0.3,0-0.4,0c0-0.1,0-0.1,0-0.2C29.2,21.5,29.4,21.7,29.5,21.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M32.1,57.5c0.9,0.2,0,0.4,0,0.7c-0.1,0-0.1,0-0.2,0C31.9,57.9,32,57.7,32.1,57.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st360",
    d: "M30.6,57.9c0-0.2,0-0.4,0.1-0.5c0,0,0.1,0,0.1,0.1C30.8,57.7,30.8,57.8,30.6,57.9L30.6,57.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st361",
    d: "M48,46.9c-0.3-0.1-0.5-0.2-0.8-0.2c-0.1-0.1-0.1-0.2-0.1-0.3c0.1-0.2,0.2-0.5,0.5-0.4 c0.1-0.1,0.3-0.1,0.4-0.2c0,0.2,0,0.4,0,0.6C48.1,46.6,48,46.8,48,46.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st129",
    d: "M50,46.5c-0.1,0-0.1,0-0.2,0c-0.1-0.1-0.1-0.1-0.2-0.2c0.1,0,0.3,0,0.4,0c0,0,0.1,0.1,0.1,0.1 C50,46.4,50,46.5,50,46.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st362",
    d: "M18.5,34.4c-0.3,0.2-0.7,0.2-0.9,0.6c-0.1,0.1-0.1,0.1-0.2,0c0-0.1,0-0.1,0-0.2c0.3-0.5,0-0.6-0.4-0.6 c-0.1-0.2-0.2-0.5-0.4-0.6c0-0.1,0-0.2,0-0.2c0,0,0.1-0.1,0.1-0.1c0.1,0,0.2-0.1,0.3-0.1c0.2,0,0.4,0.1,0.6,0.1 c0.2,0,0.3,0.2,0.4,0.3c0.2,0.3,0.5,0.4,0.6,0.7C18.6,34.4,18.6,34.4,18.5,34.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st259",
    d: "M17.5,35.1c0.1,0,0.1,0,0.2,0c0.5,0.2,0.5,0.6,0.5,1.1c-0.5-0.2-0.7-0.4-0.8-0.9 C17.5,35.2,17.5,35.2,17.5,35.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M16.6,35.5c0.4,0.3,0,0.5-0.1,0.8C16.3,36,16.5,35.7,16.6,35.5L16.6,35.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M32.8,55.8c0-0.2,0-0.4,0-0.6c0.3,0,0.6-0.2,0.9,0.1c0.3,0.4,0.5,0.1,0.6-0.1c0.1-0.1,0.1-0.1,0.2,0 c0.1,0,0.1,0,0.2,0c0.2,0.2,0.1,0.4,0.1,0.6c0,0.1-0.1,0.2-0.2,0.2C34.4,56,34.1,56,34,56.3c0,0.2,0,0.3-0.1,0.5 c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2-0.1-0.2-0.2c0-0.1,0-0.1,0-0.2c-0.1-0.1-0.1-0.2-0.2-0.2h0 c0-0.1,0-0.1,0-0.2C33,56,32.9,55.9,32.8,55.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st363",
    d: "M32.8,54.9c-0.1-0.2-0.2-0.4-0.4-0.4c0-0.6,0.4-0.3,0.6-0.2c0.1,0,0.1,0,0.2,0C33.2,54.6,33,54.8,32.8,54.9z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M34.5,55.1c-0.1,0-0.1,0-0.2,0c-0.2-0.1-0.2-0.2-0.1-0.4c0.1-0.1,0.2-0.2,0.2-0.1 C34.5,54.8,34.5,55,34.5,55.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st269",
    d: "M34.7,55.8c0-0.2,0-0.4,0-0.6c0-0.1,0-0.1,0-0.2c0.3,0.1,0.2,0.4,0.2,0.6C35,55.8,34.9,55.8,34.7,55.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st364",
    d: "M15.5,27.5c0.1,0.2,0.2,0.4,0.5,0.3c0.4-0.1,0.1,0.2,0.1,0.4c-0.2,0.4,0.1,0.6,0.3,0.8 c0.3,0.3,0.6,0.6,0.4,1.1c-0.1,0.1-0.2,0.1-0.3,0.1c-0.4,0-0.8-0.2-1.3-0.4c-0.5-0.2-0.4,0.2-0.6,0.4c-0.1,0.1-0.1,0.1-0.2,0.1 c-0.3-0.2-0.3-0.5-0.3-0.8c0-0.2-0.1-0.4-0.4-0.4c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.1-0.1-0.1-0.1-0.2c0-0.1,0-0.3-0.2-0.1 c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.2-0.1c-0.2-0.1-0.5-0.1-0.8-0.2c-0.1-0.1-0.2-0.2-0.2-0.3c0-0.1,0-0.1,0-0.1 c0-0.1,0.1-0.2,0.2-0.2c0.6-0.2,0.9-1.2,1.8-0.7c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.1,0,0.2-0.1c0-0.3-0.1-0.6,0.2-0.8 c0,0,0.1,0,0.1,0.1c0.2,0.2,0.4,0.3,0.6,0.3C15.3,26.9,15.6,27.1,15.5,27.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M10.8,26.9c-0.2-0.2-0.1-0.7-0.6-0.4c0-0.1,0-0.1,0-0.2c0.2-0.3,0.7-0.4,0.6-0.9c0.5-0.3,0.6,0.1,0.7,0.4 c0.1,0.4,0.4,0.7,0.6,0c0.1,0,0.3,0,0.4,0c-0.2,0.4-0.3,0.9-0.9,0.9C11.4,27,11.2,27.2,10.8,26.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st262",
    d: "M13.8,27.1c-0.3,0-0.7-0.1-0.9,0.3c-0.2,0.3-0.6,0.5-1,0.5c-0.3-0.4-0.1-0.6,0.2-0.9 C12.9,26,12.9,26,13.8,27.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M15.5,27.5c-0.1-0.3-0.3-0.5-0.7-0.6c-0.4,0.1-0.4-0.3-0.6-0.4l0,0c0.2-0.3,0.6-0.1,0.8-0.2 c0.5,0.4,1-0.1,1.5,0.2C16.2,26.8,16.1,27.4,15.5,27.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M16.6,26.5c-0.1,0-0.3,0-0.4,0c-0.5,0.6-0.8,0.2-1.1-0.3c0-0.1,0-0.1,0-0.2c0.1-0.1,0.3-0.1,0.4-0.1 c0.6,0.2,1.2-0.6,1.7,0.1C17.1,26.4,16.9,26.5,16.6,26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M12.1,27.1c-0.1,0.3-0.1,0.6-0.2,0.9l0,0c-0.1,0.1-0.3,0.1-0.4,0.1c-0.3-0.1-0.5-0.3-0.6-0.6 c-0.1-0.2-0.1-0.4,0-0.6l0,0c0.3-0.1,0.6-0.1,0.9-0.2c0,0.1,0,0.1,0,0.2c0,0,0,0.1,0,0.1c0,0.1,0.1,0.1,0.1,0.1c0,0,0.1,0,0.1,0 C11.9,27.1,12,27.1,12.1,27.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M15.5,26c-0.1,0-0.3,0-0.4,0C15,26,15,25.9,14.9,25.8c0.2,0,0.4,0,0.6,0C15.6,25.9,15.6,26,15.5,26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11.7,26.9c0.1,0.1,0.1,0.1,0.2,0.2l0,0C11.7,27.2,11.6,27.1,11.7,26.9L11.7,26.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M37.1,51.7c0.1,0,0.1,0,0.2,0c0.1,0.1,0.1,0.1,0.2,0.2l0,0c0.1,0.1,0.2,0.2,0.3,0.4c0,0.1,0.1,0.1,0.1,0.2 c0.1,0.1,0.3,0.2,0.3,0.4c0.1,0.2,0.1,0.4,0,0.5c0,0.1-0.1,0.2-0.2,0.2c0,0-0.1,0-0.1,0c-0.4-0.1-0.7,0.3-1.1,0 c-0.2,0-0.3-0.1-0.4-0.2l0,0c-0.1-0.3,0-0.5,0.2-0.7c0.1-0.1,0.5,0.2,0.4-0.3C36.9,52.2,36.9,51.9,37.1,51.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st365",
    d: "M37.5,54.5c0.1-0.3,0.3-0.6,0.4-0.9l0,0c0.1,0,0.1,0,0.2-0.1c0.1,0,0.1,0,0.2,0c0.2,0.1,0.3,0.3,0.4,0.5 c0,0.8-0.4,1.2-1.3,0.9C37.2,54.8,37.2,54.6,37.5,54.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st366",
    d: "M36.4,54c0.2,0.1,0.3,0.5,0.7,0.2c0.2,0.3,0,0.6,0,0.9c-0.1,0.2-0.2,0.4-0.4,0.5c-0.1,0-0.2,0-0.3,0 c-0.2-0.1-0.3-0.3-0.3-0.5c0-0.2,0-0.5,0.1-0.7l0,0C36.3,54.4,36.3,54.2,36.4,54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M36.6,52.7c0,0.2-0.1,0.4-0.2,0.6c-0.2,0-0.3,0-0.4-0.2c0.1-0.4,0.1-0.8,0.4-1.1l0,0 C36.6,52.3,36.9,52.4,36.6,52.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st112",
    d: "M36.2,54.5c0.2,0.2,0.1,0.4,0,0.7c-0.1,0.1-0.1,0.1-0.2,0c-0.2-0.1-0.4-0.2-0.5-0.4c0.1-0.1,0.3-0.1,0.4-0.2 C36.1,54.5,36.1,54.5,36.2,54.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st112",
    d: "M36.9,55.1c0.1-0.3,0.1-0.6,0.2-0.9c0.1,0.1,0.3,0.1,0.4,0.2c-0.1,0.1-0.1,0.3-0.2,0.4c0,0,0,0.1,0,0.1 C37.1,55.1,37,55.2,36.9,55.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M36.4,53.4c0.2,0,0.3,0,0.4,0.2c-0.1,0.2-0.3,0.3-0.5,0.1C36.3,53.7,36.4,53.5,36.4,53.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st112",
    d: "M36.4,54c0,0.2,0,0.3-0.2,0.4C36.2,54.3,36.2,54.1,36.4,54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M10.8,24.1c-0.1,0.5,0.2,0.7,0.6,0.6c-0.2,0.3-0.6,0.2-0.9,0.2C10.6,24.7,10.2,24.3,10.8,24.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M10.6,25c0,0.1,0,0.1,0,0.2C10.4,25.1,10.4,25,10.6,25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M28.4,39.6c0.3-0.3,0.7-0.3,1.1-0.4c0.3,0.5,0.2,1,0.2,1.5c-0.1,0.1-0.1,0.1-0.2,0.2 c-0.2,0.1-0.3-0.1-0.5-0.2c-0.1-0.1-0.1-0.1-0.2-0.2C28.6,40.3,28.4,40,28.4,39.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M30.6,39.2c0.1-0.3,0.4-0.3,0.6-0.4c0,0.2,0,0.5-0.1,0.7c-0.1,0.3-0.3,0.5-0.6,0.2c0.1,0,0.1-0.1,0.1-0.1 c0,0,0-0.1-0.1-0.1C30.6,39.3,30.6,39.3,30.6,39.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M30.6,39.4c0.2,0.1,0.2,0.1,0,0.2C30.6,39.5,30.6,39.5,30.6,39.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M30.2,39.2c0.1,0,0.1,0,0.2,0C30.3,39.3,30.2,39.3,30.2,39.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M24.4,48c-0.2-0.1-0.4-0.2-0.4-0.4c-0.1-0.1-0.3-0.1-0.3-0.3c0-0.2,0-0.4,0.1-0.6l0,0 c0.1-0.1,0.2-0.1,0.2-0.2c0.1-0.1,0.2-0.1,0.2-0.2c0.3-0.1,0.3,0.2,0.5,0.3c0.1,0.1,0.2,0.2,0.2,0.3c0,0.1,0,0.2-0.1,0.2l0,0 c-0.3,0.4,0.1,0.4,0.3,0.5c0.2,0.1,0.3,0.3,0.1,0.5c-0.1,0.2-0.3,0.2-0.4,0l0,0C24.7,48.1,24.5,48.1,24.4,48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st367",
    d: "M24.6,46.7c-0.1-0.1-0.3-0.3-0.4-0.4c0-0.1,0-0.3-0.1-0.4c-0.1-0.1-0.3-0.1-0.3-0.3c0-0.1,0.1-0.2,0.1-0.2 c0.1,0,0.3,0,0.4,0c0.2,0.2,0.3,0.4,0.4,0.6c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2,0,0.3C24.8,46.6,24.7,46.7,24.6,46.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st368",
    d: "M23.9,45.5c0,0.1,0,0.1,0,0.2c0.1,0,0.1,0.1,0.1,0.1c0,0,0,0.1,0,0.1c-0.1,0.1-0.2,0.2-0.3,0.2 c-0.1-0.1-0.1-0.2-0.1-0.4c0.1-0.2,0.1-0.3,0.2-0.5c0.1-0.1,0.2,0,0.2,0C24,45.3,24,45.4,23.9,45.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st144",
    d: "M23.7,46.7c-0.1,0.2,0,0.4,0,0.6c0.1,0.1,0.1,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.1-0.1,0.1-0.2,0 c0,0-0.1,0-0.1-0.1c-0.1-0.2-0.1-0.4,0-0.6C23.5,47,23.5,46.8,23.7,46.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st220",
    d: "M23.5,47.8c0.1,0,0.1,0,0.2,0c0,0.1,0,0.1,0,0.2c0.1,0.2,0.2,0.4,0,0.7c-0.1,0.1-0.2,0.1-0.3,0 c0-0.2,0-0.4,0-0.6C23.5,48,23.5,47.9,23.5,47.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st144",
    d: "M23.7,43.7c0.3,0.2,0.1,0.6,0.2,0.9C23.6,44.3,23.7,44,23.7,43.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st369",
    d: "M23.3,48c0,0.2,0.1,0.4-0.1,0.5c-0.1,0-0.1-0.3-0.1-0.5C23.1,48,23.2,48,23.3,48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st232",
    d: "M23.5,47.2c0,0.2,0,0.4,0,0.6C23.2,47.6,23.2,47.4,23.5,47.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st144",
    d: "M23.9,46.5c0,0.1-0.1,0.2-0.2,0.2C23.7,46.6,23.8,46.5,23.9,46.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st144",
    d: "M24,45.9c0-0.1,0-0.1,0-0.2c0.1,0,0.2,0.1,0.2,0.2C24.1,45.9,24,45.9,24,45.9L24,45.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M34.9,46.5c0.2,0.1,0.2,0.3,0,0.4C34.9,46.8,34.6,46.6,34.9,46.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M33.4,45.9c0-0.1,0-0.1,0-0.2c0.1,0,0.3,0,0.4,0c0.1,0.1,0.1,0.3,0,0.4l0,0C33.6,46.2,33.5,46,33.4,45.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M33.8,46.1c0-0.1,0-0.3,0-0.4c0.2,0.1,0.2,0.3,0.2,0.4C34,46.1,33.9,46.1,33.8,46.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M21.1,41.1C21,40.6,21,40.1,20.3,40l0,0c-0.1-0.3,0.1-0.4,0.3-0.6c0.1-0.1,0.1-0.1,0.2-0.2 c0.1,0,0.2,0,0.3,0.1c0.3,0.2,0.7,0.4,0.9,0.8c0.1,0.3,0.1,0.5-0.2,0.7C21.5,41,21.4,41.1,21.1,41.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st370",
    d: "M21.7,40.9c0-0.3,0-0.6,0-0.8c0.2-0.1,0.4,0,0.5,0.1c0.2,0.2,0.3,0.4,0.1,0.6c-0.1,0.1-0.2,0.3-0.4,0.3 C21.9,41,21.8,41,21.7,40.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st371",
    d: "M22,41.1c0-0.2,0-0.3,0.2-0.4c0.1,0,0.1,0.1,0.2,0.1c0,0.1,0.1,0.1,0.1,0.2c0.1,0.1,0.1,0.2,0.1,0.3 c0,0.1,0,0.1,0,0.2c-0.1,0.1-0.2,0.1-0.4,0.1c-0.1-0.1-0.2-0.2-0.3-0.3C22,41.3,22,41.2,22,41.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st372",
    d: "M22.2,41.6c0.1,0,0.3,0,0.4,0c0,0.1,0,0.3,0.1,0.4c-0.1,0.3-0.3,0.1-0.5,0c-0.1-0.1-0.1-0.2-0.2-0.3l0-0.1 C22.1,41.5,22.1,41.5,22.2,41.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st373",
    d: "M22,41.7c0.1,0.1,0.1,0.2,0.2,0.3c0,0.1,0,0.3,0.1,0.4c-0.1,0-0.2,0-0.3,0c0-0.1,0-0.3,0-0.4 C22,41.9,22,41.8,22,41.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st373",
    d: "M21.3,41.8c0.1-0.1,0.1-0.1,0.2-0.2c0,0,0,0.1,0.1,0.1C21.5,41.7,21.4,41.7,21.3,41.8L21.3,41.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st373",
    d: "M22.2,41.6c-0.1,0-0.1,0-0.2,0.1c0-0.1,0-0.2,0-0.3C22.1,41.4,22.1,41.5,22.2,41.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st274",
    d: "M20.7,17.4c-0.3,0.1-0.6,0.3-0.9,0.4c0,0-0.1,0.1-0.1,0.1c0,0-0.1,0-0.1-0.1c-0.1-0.1-0.1-0.2-0.1-0.3 c0-0.2,0-0.4,0-0.6c0-0.1,0.1-0.2,0.2-0.4c0.1-0.2,0.2-0.3,0.2-0.5c0.1-0.3,0.3-0.7,0.5-1c0.1-0.2,0.3-0.4,0-0.6 c-0.1-0.2-0.2-0.5-0.2-0.8c0-0.1,0.1-0.2,0.1-0.3c0.1-0.1,0.2-0.1,0.3-0.1c0.2,0,0.4,0,0.6,0.1c0.1,0,0.2,0.1,0.2,0.2 c0,0.1,0,0.2,0,0.3c0,0.1,0,0.1,0,0.2c-0.2,0.6-0.6,1.2-0.4,1.9c-0.3,0.1-0.2,0.4-0.2,0.6C20.7,17,20.7,17.2,20.7,17.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st234",
    d: "M22.6,16.8c-0.1,0-0.3,0-0.4,0C22.3,16.5,22.5,16.5,22.6,16.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st234",
    d: "M22.2,16.8C22.1,17,22,17,21.8,17C21.9,16.8,22,16.8,22.2,16.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st374",
    d: "M21.3,58.1c0-0.5,0.5-0.8,0.4-1.3c0,0,0.1,0,0.1-0.1c0,0,0.1,0,0.1,0c0,0,0.1,0.1,0.1,0.1 c0.1,0.2,0.1,0.4,0,0.5c0,0.1,0,0.2,0,0.3c0,0.2-0.1,0.5-0.2,0.7c-0.1,0.1-0.2,0.2-0.4,0.2c-0.1,0-0.2,0-0.3-0.1 C21.2,58.4,21.2,58.2,21.3,58.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st375",
    d: "M22,56.2c0.1,0.1,0.1,0.1,0.2,0.2c0.1,0.1,0,0.2-0.1,0.3c-0.1,0-0.3,0-0.3,0.1l0,0c-0.6,0-0.4-0.5-0.3-0.7 C21.6,55.9,21.8,56.2,22,56.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M21.3,58.1c0,0.1,0,0.3,0,0.4c-0.1,0.2-0.2,0.3-0.4,0.2c-0.1-0.1-0.1-0.3-0.2-0.4c0.1-0.1,0.1-0.1,0.2-0.2 C21.1,58.1,21.2,58.1,21.3,58.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st111",
    d: "M20.3,9.7c0.2,0.7-0.2,1.3-0.4,1.9c0,0.5-0.3,0.6-0.6,0.7c-0.5-0.1-0.5-0.6-0.7-1c-0.1-0.2-0.2-0.3-0.3-0.4 c-0.1-0.1-0.1-0.1-0.1-0.2c0-0.1,0-0.2,0.1-0.2c0.1-0.1,0.3-0.2,0.4-0.2c0,0,0.1,0,0.1,0c0,0,0-0.1,0-0.2c0-0.3,0.2-0.5,0.5-0.7 c0.1,0,0.2,0,0.3,0C19.7,9.5,20,9.4,20.3,9.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M19.2,12.3c0.1-0.4,0.5-0.4,0.7-0.6c0.2,0,0.4,0,0.6,0c0.3,0.4,0.1,0.7-0.3,0.9c-0.1,0-0.3,0.1-0.3,0.2 c0,0.1,0.2,0,0.2,0c0.6,0.1,0.5,0.4,0.3,0.8c0,0.1-0.1,0.2-0.1,0.3c0.1,0.3,0.2,0.6,0.2,0.9c-0.1,0.1-0.2,0.1-0.4,0.1 c-0.1-0.1-0.1-0.1-0.2-0.2c0-0.5-0.5-0.7-0.8-0.9C19,13.4,19,13.3,19,13.1c0-0.2,0-0.4,0-0.6C19,12.4,19.1,12.3,19.2,12.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st320",
    d: "M19.8,12.3c0.5,0.1,0.7-0.2,0.6-0.6c0.1,0,0.1,0,0.2,0c0.3,0.2,0,0.6,0.2,0.9c0.3,0.5,0,0.8-0.4,1.1l0,0 c-0.1,0.1-0.1,0.1-0.2,0c0-0.3,0.3-0.7-0.2-0.9c0,0-0.1,0-0.1,0c-0.1,0-0.1-0.1-0.2-0.2C19.7,12.4,19.8,12.3,19.8,12.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st376",
    d: "M20.3,9.7c-0.3-0.1-0.8,0.6-0.9-0.2c-0.1-0.2,0-0.3,0.2-0.3c0.2,0,0.3,0,0.4,0.1c0.1,0,0.1,0,0.2,0 C20.2,9.4,20.3,9.5,20.3,9.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st173",
    d: "M9.3,107.9c0,0.1,0,0.1,0,0.2c-0.1,0.1-0.1,0.1-0.2,0c0-0.1-0.1-0.3-0.1-0.3C9.1,107.6,9.2,107.7,9.3,107.9z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M9.1,108.1c0.1,0,0.1,0,0.2,0c0.2,0,0.3,0,0.4,0.2c-0.1,0.1-0.3,0.1-0.4,0.1c-0.1,0-0.2-0.1-0.2-0.1l0,0 C9.1,108.2,9.1,108.2,9.1,108.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st377",
    d: "M9.3,107.2c0-0.1,0-0.1,0-0.2c0.1-0.1,0.1-0.1,0.2,0c0,0.1,0,0.3,0,0.4C9.4,107.4,9.3,107.3,9.3,107.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st181",
    d: "M29.2,63.1c0,0-0.1,0.1-0.1,0.1c-0.1,0-0.2-0.1-0.1-0.2c0,0,0.1-0.1,0.2-0.1C29.2,63,29.2,63,29.2,63.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M10.6,10.3c-0.2,0.1-0.4,0.1-0.6,0c-0.4-0.5-0.3-0.8,0.2-1.1c0.2,0.3,0.5,0.5,0.6,0.9l0,0 C10.7,10.2,10.6,10.2,10.6,10.3L10.6,10.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M10.4,8.8c-0.1-0.1-0.1-0.1-0.2-0.2C10.3,8.6,10.3,8.7,10.4,8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M10.1,9c0.1,0,0.1,0,0.2,0c0,0.1-0.1,0.2-0.2,0.2C10.1,9.2,10.1,9.1,10.1,9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M34.9,47.4c0-0.1,0-0.1,0-0.2C35.1,47.2,35.1,47.3,34.9,47.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st102",
    d: "M34,22.6c-0.2,0-0.5,0.1-0.6-0.2c0-0.1,0-0.3,0.1-0.4c0.1-0.1,0.2-0.2,0.3-0.3c0.1,0,0.2,0,0.3,0 c0,0,0.1,0,0.1,0c0,0,0.1,0.1,0.1,0.1C34.3,22.1,34.2,22.3,34,22.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st79",
    d: "M34.3,21.5c0.1,0.1,0.1,0.1,0.2,0.2c-0.1,0-0.1,0-0.2,0l0,0C34.2,21.7,34.2,21.6,34.3,21.5 C34.2,21.5,34.2,21.5,34.3,21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M34.7,23.5c0,0.1,0,0.1,0,0.2c-0.1-0.1-0.1-0.1-0.2-0.2C34.5,23.5,34.6,23.5,34.7,23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st378",
    d: "M34,23.7c0.1,0,0.1,0,0.2,0c0,0.1,0,0.1,0,0.2c0,0-0.1,0-0.1,0c-0.1,0-0.1-0.1-0.2-0.2 C34,23.7,34,23.7,34,23.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st378",
    d: "M34.5,23.9c0,0.1,0,0.1,0,0.2c0,0-0.1,0-0.1,0c-0.1-0.1-0.1-0.1-0.1-0.2l0,0C34.3,23.9,34.4,23.9,34.5,23.9z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st379",
    d: "M44.6,55.5c0,0.1,0,0.3,0,0.4c0.1,0.2,0,0.4,0.1,0.6c0,0.1,0,0.2-0.1,0.2c0,0.4-0.2,0.6-0.6,0.7l0,0 c-0.2-0.2-0.4-0.2-0.6-0.4c-0.4-0.6-0.9-0.3-1.5-0.4c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2-0.1-0.3-0.1c-0.2-0.2-0.4-0.4-0.4-0.7 c0.1-0.5,0.2-1,0.3-1.5c0-0.4,0.2-0.7,0.7-0.7c0.1,0,0.2,0.1,0.3,0.1c-0.1,0.6,0.1,1.2,0.5,1.7c0.2,0.2,0.3,0,0.3-0.2 c0.3-1.1,0.9-0.4,1.5-0.2c0.1,0.1,0.2,0.1,0.2,0.2C44.7,55.4,44.7,55.5,44.6,55.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st380",
    d: "M44.6,56.6c-0.6-0.2-0.2-0.4,0-0.6c0.2,0,0.4-0.1,0.6-0.2c0.2,0.2,0.3,0.2,0.4,0c0.1-0.2,0.1-0.3,0.2-0.4 c0,0.1,0,0.1,0,0.2c0,0.2,0,0.5,0.1,0.7c0.3,0.6-0.1,0.6-0.5,0.6c0-0.1-0.1-0.2-0.2-0.2C45,56.9,44.8,56.6,44.6,56.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st352",
    d: "M44.6,56.6c0.2-0.3,0.4,0.1,0.6,0c0,0.6-0.4,0.1-0.6,0.2C44.6,56.8,44.6,56.7,44.6,56.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st313",
    d: "M20.9,58.8c0.1-0.1,0.3-0.1,0.4-0.2l0,0c0.3,0.5,0.5,1-0.2,1.3c-0.1-0.2-0.3-0.3-0.4-0.5 C20.7,59.2,20.8,59,20.9,58.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M15.5,11.6c0,0.1,0,0.3,0,0.4c0.2,0.2,0.2,0.4,0.1,0.6c-0.1,0.2-0.2,0.2-0.4,0.2c0,0-0.1-0.1-0.1-0.1 c0.2-0.7-0.6-0.7-0.8-1.1C14.7,11.2,15.1,11.8,15.5,11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st141",
    d: "M13.6,11.6c0-0.3,0.1-0.5,0.4-0.6C14,11.3,14.1,11.6,13.6,11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st111",
    d: "M14.2,12.7c-0.1,0-0.3,0-0.4,0c0-0.1,0-0.3,0-0.4c0.1,0,0.3,0,0.4,0C14.4,12.4,14.4,12.5,14.2,12.7 L14.2,12.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st224",
    d: "M14.7,13.1c0-0.2,0-0.4,0-0.6c0.1,0.1,0.3,0.1,0.4,0.2l0,0C15.2,13,15,13.2,14.7,13.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st224",
    d: "M14.2,12.7c0-0.1,0-0.3,0-0.4c0.1,0.1,0.1,0.1,0.2,0.2C14.4,12.5,14.3,12.6,14.2,12.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st274",
    d: "M22.8,22.8c0,0.3-0.1,0.4-0.2,0.6c0.1,0.2,0.4,0.4,0.2,0.6c-0.1,0.1-0.1,0.1-0.2,0.2 c-0.3,0.1-0.4-0.2-0.5-0.3c-0.1-0.1-0.3-0.2-0.4-0.3c-0.2-0.1-0.5-0.2-0.6-0.5c0-0.1,0-0.3,0.1-0.4c0.1-0.1,0.2-0.2,0.4-0.2 c0.2,0,0.4,0,0.7,0C22.4,22.7,22.7,22.6,22.8,22.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st381",
    d: "M23.7,24.5c0,0.2,0,0.4,0,0.7c0,0.2,0,0.5-0.1,0.7c-0.1,0.2-0.3,0.4-0.5,0.5c-0.1,0-0.2,0-0.3,0 c-0.1-0.1-0.2-0.2-0.2-0.4c-0.1-0.2-0.1-0.4-0.1-0.6c0-0.2,0.1-0.4,0.3-0.5c0.2-0.1,0.5-0.2,0.7-0.4C23.6,24.5,23.6,24.5,23.7,24.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st382",
    d: "M22.2,23.9c0.1,0.1,0.3,0.3,0.4,0.4c0,0.1,0,0.1,0,0.2c0.1,0.1,0.1,0.2,0,0.3c-0.3,0.3-0.4,0.7-0.8,0.8 c-0.2-0.1-0.3-0.3-0.3-0.5C21.7,24.7,21.9,24.2,22.2,23.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M22.8,24.1c0-0.2-0.5-0.3-0.2-0.6c0.3,0.1,0.6-0.4,0.9,0C23.4,23.8,23.1,24,22.8,24.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M22.6,24.7c0-0.1,0-0.1,0-0.2c0.3,0.1,0.6-0.3,0.9,0c-0.1,0.3-0.4,0.4-0.7,0.4C22.7,25,22.6,24.9,22.6,24.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M30.2,24.8c0.4-0.3,0.1-0.8,0.4-1.1c0.1-0.1,0.3-0.1,0.4,0c0.2,0.1,0.2,0.3,0.2,0.4c0,0,0,0.1,0,0.1 c0,0.2,0.1,0.3,0.1,0.5c0,0.1,0.1,0.2,0.1,0.3c0,0.3,0.1,0.6,0,0.9c0,0.1-0.1,0.2-0.2,0.2c-0.1,0.1-0.2,0.1-0.3,0.1 c-0.5-0.2-1-0.2-1.4-0.5c0-0.3,0.1-0.6,0.2-0.9c-0.1-0.1-0.1-0.3,0-0.4l0,0C30.2,24.2,29.9,24.7,30.2,24.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st130",
    d: "M31.2,24.1c0.3-0.1,0.1-0.5,0.4-0.6c0.1,0,0.2-0.1,0.2-0.2l0,0c0.1-0.1,0.2-0.3,0.3-0.3 c0.4,0.2,0.3,0.5,0.3,0.8c0,0.2-0.1,0.4-0.2,0.6c0,0.1-0.1,0.2-0.2,0.3c-0.3,0.2-0.5,0.4-0.9,0.1l0,0 C31.2,24.5,31.2,24.3,31.2,24.1L31.2,24.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M31,23.7c-0.1,0-0.3,0-0.4,0c-0.1,0-0.1,0-0.2,0c0-0.3,0.1-0.6-0.1-0.9c0.1-0.3,0.1-0.7,0.6-0.4 C31.1,22.8,31,23.2,31,23.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M30.8,22.4c-0.5,0-0.4,0.3-0.4,0.6c-0.1,0.1-0.1,0.1-0.2,0.1C30,23,30,22.9,30,22.8c0.1-0.3,0.4-0.6-0.2-0.7 c0.2-0.2,0.3-0.4,0.7-0.2c0.1,0.1,0.3,0.1,0.4,0.2C30.8,22.2,30.8,22.3,30.8,22.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M30.8,22.2c-0.2,0-0.3,0-0.4-0.2c0.2,0,0.3,0,0.4-0.2c0.1,0,0.1,0,0.2,0C31,21.9,31,22.1,30.8,22.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st325",
    d: "M31.9,23.2c0,0.1,0.1,0.3,0.1,0.3c-0.1,0.1-0.2,0-0.3-0.1C31.7,23.4,31.8,23.3,31.9,23.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "M32.1,23c-0.1,0.1-0.1,0.1-0.2,0.2c0-0.1,0-0.3,0-0.4c0.1,0,0.1,0,0.2,0C32.2,22.9,32.2,22.9,32.1,23 C32.2,23,32.1,23,32.1,23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M39.9,49.1c0.1,0,0.3,0,0.4,0c0.3,0.3,0.3,0.7,0.3,1c0,0.1,0,0.2-0.1,0.3c-0.3,0.3-0.8,0.4-1.1,0.7 c-0.2,0.1-0.5,0.3-0.7,0.2c-0.2-0.2-0.4-0.4-0.2-0.7c0.3,0,0.7-0.1,0.9-0.4c0.3-0.1,0.5-0.4,0.6-0.6C40,49.4,39.9,49.2,39.9,49.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st383",
    d: "M38.6,50.6c0.1,0.2,0.2,0.4,0.2,0.6c0.3,0.2,0.4,0.4,0.2,0.7c-0.7,0.1-1-0.2-0.8-0.9c0-0.1,0-0.3,0-0.4 C38.3,50.6,38.4,50.6,38.6,50.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M40.1,49.5c0.1,0.5-0.2,0.7-0.6,0.6c-0.1,0-0.3-0.1-0.2-0.1C39.6,50,39.7,49.5,40.1,49.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st384",
    d: "M31.9,65c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0.1-0.2c0-0.2,0-0.4,0.1-0.7c0.1-0.1,0.1-0.1,0.2-0.1 c0.1,0,0.2,0,0.3,0c0.6-0.1,1.2-0.4,1.8,0.2c0.1,0.2,0.1,0.4-0.1,0.5c-0.9,0.3-0.3,0.6,0,0.9c0.2,0.3,0,0.4-0.2,0.6 c0,0-0.1,0-0.1,0c-0.2,0.1-0.4,0.2-0.6,0.2C33,65.5,32.6,65.1,31.9,65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M35.8,65.9c-0.6,0.1-0.3,0.9-0.9,1.1c-0.3,0-0.6-0.1-0.9-0.4c0.5-0.2,0.6-0.6,0.6-1.1c0-0.1,0-0.3,0.1-0.4 c0-0.1,0.1-0.2,0.1-0.3c0.1-0.1,0.2-0.2,0.3-0.3c0.2-0.2,0.5-0.3,0.7-0.5c0.7,0.1,0,0.6,0.2,0.9C35.9,65.2,36,65.6,35.8,65.9 L35.8,65.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M34.9,65.5c0,0.1-0.1,0.2-0.1,0.3c0.2,0.9,0.2,0.9-0.8,0.8c-0.1-0.2-0.2-0.4-0.2-0.6l0,0 c0.1-0.2,0.5-0.1,0.5-0.3c0-0.1,0.1-0.2,0.2-0.2C34.7,65.3,34.8,65.3,34.9,65.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M32.1,23c0-0.1,0-0.1,0-0.2c0.4-0.1,0.7,0.1,1,0.2c0.3,0.1,0.1,0.3,0.1,0.4c0,0,0.1,0.1,0.1,0.1 c0,0,0,0.1,0,0.1c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.1-0.2,0.1-0.4,0.1c-0.1,0-0.2,0-0.3,0c0,0-0.1-0.1-0.1-0.1 C32.3,23.6,32.4,23.2,32.1,23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st79",
    d: "M33.6,22c0,0.2,0,0.3-0.2,0.4c-0.1-0.1-0.1-0.1-0.2-0.2c-0.3-0.7,0.3-0.7,0.6-0.9c0.1,0.1,0.1,0.1,0.2,0.2 c0.1,0,0.1,0.1,0.1,0.1c0,0,0,0.1-0.1,0.1l-0.1,0l-0.1,0C33.8,21.8,33.7,21.9,33.6,22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st378",
    d: "M33.4,23.7c0.1,0,0.2,0,0.2,0c0,0,0.1,0.1,0.1,0.1c0.1,0.2,0.2,0.4,0,0.7c-0.2,0.3-0.5,0.2-0.8,0 c-0.1-0.1-0.1-0.2-0.1-0.3c0-0.2,0.2-0.4,0.3-0.5l0,0C33.2,23.6,33.3,23.6,33.4,23.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st378",
    d: "M33.6,23.7c0.1-0.2,0.3-0.2,0.4,0l0,0C33.9,23.8,33.8,23.8,33.6,23.7L33.6,23.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st385",
    d: "M33.4,23.7l-0.1,0l-0.1,0c0-0.1,0-0.1,0-0.2C33.3,23.5,33.4,23.5,33.4,23.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st386",
    d: "M46.8,45.6c0-0.1,0-0.1,0-0.2c-0.2-0.2-0.2-0.4,0-0.6c0.1,0,0.3,0.3,0.4,0c0.2,0,0.4,0,0.3,0.3 C47.3,45.4,47.2,45.7,46.8,45.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st387",
    d: "M47.6,46.1c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.1-0.1,0.1-0.2,0c0-0.2,0.1-0.4,0.2-0.6 C47.4,45.9,47.5,45.9,47.6,46.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st388",
    d: "M13.4,20.9c-0.1,0-0.1,0-0.2,0c-0.2-0.3-0.2-0.6,0-0.8l0,0c0.1-0.1,0.3-0.1,0.4-0.1c0.2,0.1,0.3,0.3,0.3,0.5 C13.9,20.8,13.5,20.7,13.4,20.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st356",
    d: "M12.1,20c0.1,0,0.3,0,0.4,0c0,0.4,0.4,0.7-0.1,1.1C12.2,20.8,12.4,20.3,12.1,20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M8.2,23.7c-0.1,0-0.2-0.1-0.2-0.2C8.1,23.5,8.1,23.6,8.2,23.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M12.1,17.4c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1-0.1,0.2c0,0-0.1,0.1-0.1,0.2c0,0,0,0.1,0,0.1c0,0.5,0,1-0.6,1.1 c-0.2,0-0.4-0.1-0.4-0.4c-0.1-0.3-0.1-0.7-0.4-0.9c0-0.2,0-0.4,0-0.6c0.3-0.1,0.6-0.3,0.9-0.4C11.5,17,11.6,17.5,12.1,17.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st389",
    d: "M30.8,60.7c0,0.1,0,0.1,0,0.2c0,0-0.1,0.1-0.1,0.1c-0.1,0-0.2,0-0.3-0.1l0,0c0-0.1,0-0.3,0-0.4 c0.1-0.1,0.1-0.1,0.2,0v0C30.7,60.6,30.7,60.6,30.8,60.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M30.6,60.5c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2-0.1-0.2-0.2C30.3,60.3,30.5,60.3,30.6,60.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M8.6,105.5c0.2-0.7,0.4-0.1,0.6,0c0,0.1-0.1,0.2-0.2,0.2C8.9,105.6,8.7,105.6,8.6,105.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st390",
    d: "M9.5,107l-0.1,0l-0.1,0c-0.3-0.1,0-0.3,0-0.4C9.5,106.7,9.5,106.8,9.5,107z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st391",
    d: "M8.6,105.5c0.2,0,0.3,0,0.4,0.2c-0.1,0-0.1,0-0.2,0C8.8,105.7,8.7,105.6,8.6,105.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st227",
    d: "M9.3,106.6c-0.1-0.1-0.1-0.1-0.2-0.2C9.1,106.4,9.2,106.5,9.3,106.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st167",
    d: "M28.2,70.8c0,0.1-0.1,0.1-0.1,0.2C28.1,71,28.2,70.9,28.2,70.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st278",
    d: "M42,46.3c0.3,0,0.5,0.1,0.7,0.4c0,0,0,0.1-0.1,0.1c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0.1,0,0.2,0,0.3 c0,0.4,0.4,0.7,0.1,1.1c-0.2,0.1-0.4,0.1-0.6,0c-0.4-0.3-0.6-0.8-0.6-1.3c0.1-0.3,0.1-0.5,0.3-0.8C41.7,46.2,41.9,46.2,42,46.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M42.4,48.2c-0.2-0.3-0.5-0.6-0.4-1.1c0.1-0.1,0.2-0.1,0.4-0.1c0.2,0,0.3,0,0.5-0.1c0.1,0,0.1,0,0.2,0 c0,0.1,0,0.1,0,0.2c0.2,0.3,0.1,0.5,0,0.8c0,0.1-0.1,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.1C42.6,48.3,42.5,48.3,42.4,48.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st392",
    d: "M42,46.3c-0.1,0-0.3,0-0.4,0c-0.1,0.1-0.3,0.3-0.5,0.3c0,0-0.1,0-0.1-0.1c0-0.3,0-0.6,0.4-0.6 C41.5,46.2,41.9,46,42,46.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st278",
    d: "M42.9,46.9c0,0.3-0.1,0.6-0.4,0.2c0,0,0-0.1,0-0.1c0-0.1,0.1-0.2,0.2-0.3l0,0C42.7,46.8,42.8,46.9,42.9,46.9 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M12.5,18.9c-0.4-0.1-0.4-0.4-0.2-0.6c-0.1-0.1-0.1-0.2-0.1-0.4c0.1-0.1,0.2-0.2,0.3-0.3l0,0 c0.1-0.1,0.3-0.1,0.4-0.1c0.3,0.4,0.1,0.7-0.1,1.1c-0.1,0.1-0.1,0.2-0.2,0.2C12.6,18.9,12.6,18.9,12.5,18.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M13.6,20c-0.1,0-0.3,0-0.4,0c-0.4-0.3-0.5-0.7-0.6-1.1l0,0c0.1-0.1,0.3-0.1,0.4-0.1c0.1,0,0.2,0.1,0.2,0.2 C13.4,19.3,13.7,19.6,13.6,20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "M12.3,17.9c0,0.1,0,0.3,0,0.4c-0.1-0.1-0.3-0.1-0.4-0.2l0,0c-0.1-0.1-0.1-0.3,0-0.4c0.1,0,0.1,0,0.2,0 c0.1,0,0.1,0,0.2,0C12.4,17.7,12.4,17.7,12.3,17.9C12.3,17.8,12.3,17.9,12.3,17.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st393",
    d: "M9.5,111.9C9.5,111.9,9.4,111.9,9.5,111.9c-0.1-0.1-0.1-0.1,0-0.1C9.6,111.8,9.6,111.8,9.5,111.9 C9.6,111.9,9.5,111.9,9.5,111.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st166",
    d: "M16.4,8c0.2-0.4,0.5-0.9,1.1-0.9l0,0c0.3,0.3,0.1,0.6,0,0.8c-0.1,0.1-0.1,0.3-0.2,0.4 c-0.1,0.1-0.2,0.1-0.3,0.2c-0.2,0.1-0.4,0-0.6-0.1C16.3,8.2,16.3,8.1,16.4,8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M16.4,8c0,0.1,0,0.3,0,0.4c0,0.2-0.2,0.3-0.4,0.3c-0.1,0-0.2,0-0.3,0c-0.1,0-0.1-0.1-0.2-0.2c0,0,0-0.1,0-0.1 c0-0.1,0-0.1,0-0.2c-0.1,0-0.1-0.1-0.1-0.1c0,0,0-0.1,0-0.1C15.8,7.8,16.1,7.7,16.4,8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st186",
    d: "M16.3,84.5c-0.1,0-0.1,0.1-0.2,0.1c0-0.1,0-0.1,0-0.2c0.1-0.1,0.1-0.1,0.2-0.2c0,0.1,0,0.1,0.1,0.2 C16.3,84.4,16.3,84.5,16.3,84.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st170",
    d: "M16.2,84.6c0,0.1,0,0.3,0,0.4c0,0.1-0.1,0.1-0.2,0.1C15.9,84.9,16,84.7,16.2,84.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st394",
    d: "M16,85.1c0.1,0,0.1,0,0.2-0.1c0.1,0,0.2,0.1,0.2,0.2l-0.1,0l-0.1,0C16.1,85.2,16.1,85.2,16,85.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st213",
    d: "M16,85.5c-0.1,0.1-0.1,0.1-0.2,0.2C15.8,85.6,15.9,85.6,16,85.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M41.4,46.9c0.1,0.4,0.3,0.9,0.4,1.3c-0.1,0.2-0.2,0.4-0.3,0.6C41.3,49,41,49,40.7,49c-0.1,0-0.2-0.1-0.2-0.1 l0,0c-0.1-0.4,0.2-0.6,0.3-0.9c0.1-0.1,0.2-0.3,0.1-0.4c0-0.1,0-0.3,0-0.4c0-0.1,0.1-0.1,0.1-0.2c0,0,0.1-0.1,0.1-0.1 C41.2,46.9,41.3,46.9,41.4,46.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M40.9,47.6c0.2,0,0.4,0,0.3,0.3c0,0.1-0.2,0.2-0.3,0.2c-0.1,0.1-0.3,0.1-0.4,0c-0.1,0-0.1,0-0.2,0 C40.2,47.5,40.4,47.3,40.9,47.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M40.1,46.5c0.5-0.6,0.5-0.6,0.9,0l0,0c0,0,0,0.1,0.1,0.1c0,0,0,0.1-0.1,0.1C40.6,46.7,40.3,46.8,40.1,46.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M41.2,46.9c-0.1,0.1-0.1,0.1-0.2,0.2c-0.2-0.1-0.4,0.1-0.4-0.1c0-0.1,0.3-0.1,0.4-0.1 C41,46.9,41.1,46.9,41.2,46.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M39.4,47.6c0-0.1,0-0.1,0-0.2c0.1,0,0.3-0.2,0.3,0C39.8,47.6,39.6,47.6,39.4,47.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M41.2,46.9c-0.1,0-0.1,0-0.2,0c0-0.1,0-0.1,0-0.2c0,0,0,0,0,0C41.1,46.7,41.2,46.7,41.2,46.9L41.2,46.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st395",
    d: "M8.8,110c0-0.1,0-0.1,0-0.2c-0.1-0.2,0-0.3,0.2-0.2c0.2-0.1,0.5-0.2,0.4,0.2c0,0.1-0.1,0.2-0.2,0.2 C9.1,110,9,110,8.8,110z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st396",
    d: "M9.3,110c0.1-0.1,0.1-0.1,0.2-0.2c0.1,0.1,0.1,0.1,0.2,0.2c-0.1,0.1-0.1,0.1-0.1,0.2c0,0,0,0.1,0.1,0.1 c-0.1,0.2-0.2,0.2-0.4,0.2c-0.1,0-0.1-0.1-0.1-0.1c0,0,0-0.1,0-0.1C9.3,110.2,9.3,110.1,9.3,110z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M9.3,110.3c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c-0.1,0-0.3,0-0.4,0l0,0C8.9,110.4,9,110.2,9.3,110.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st397",
    d: "M8.9,110.7c0,0-0.1,0.1-0.1,0.1C8.8,110.8,8.8,110.7,8.9,110.7C8.8,110.7,8.8,110.7,8.9,110.7L8.9,110.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st398",
    d: "M9.3,110.7c0.1,0.1,0.1,0.1,0.2,0.2C9.4,110.9,9.3,110.8,9.3,110.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M35.8,63.9c0,0.4-0.4,0.5-0.6,0.6c-0.1,0.1-0.3,0-0.4,0c0.1,0.1,0.2,0.1,0.2,0.2c0,0.1,0,0.1,0,0.2 c-0.1,0.2-0.2,0.3-0.4,0.4l0,0c-0.1,0.1-0.1,0.1-0.2,0c-0.9,0-0.7-0.7-0.9-1.2c0.2-0.4,0.9,0.5,0.9-0.3c-0.1-0.4,0.3-0.4,0.5-0.5 c0.1,0,0.2,0,0.3,0c0.2,0.1,0.4,0.1,0.5,0.3C35.6,63.8,35.7,63.9,35.8,63.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M35.5,63.7c-0.2,0-0.3,0-0.4-0.2c-0.1-0.2-0.4-0.2-0.5-0.5c0.1-0.5,0.2-0.8,0.8-0.5c0.1,0.2,0.3,0.3,0.2,0.5 C35.5,63.3,36.5,63.5,35.5,63.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M35.8,65.9c0-0.4-0.4-0.8,0.2-1.1c0.1,0.1,0.1,0.1,0.2,0.2c0.2,0.2,0.1,0.4,0,0.6l0,0 C36.1,65.7,35.9,65.8,35.8,65.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st399",
    d: "M35.6,63.1c-0.1-0.1-0.1-0.3-0.2-0.4c-0.1-0.1-0.1-0.2,0-0.3c0.2-0.1,0.4-0.1,0.6,0.1c0,0.2,0.2,0.4,0.2,0.6 C36,63.1,35.8,63.1,35.6,63.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M36.2,65.7c0-0.2,0-0.4,0-0.6c0.1,0,0.1,0,0.2,0C36.4,65.3,36.5,65.5,36.2,65.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st315",
    d: "M31.2,29.5c0.2,0,0.4,0,0.7,0c0.2,0.1,0.2,0.3,0.2,0.4c-0.2,0.3-0.4,0.3-0.7,0.4c-0.3-0.1-0.5-0.3-0.7-0.4 c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1-0.4,0.1-0.5,0.5-0.4C31.1,29.3,31.2,29.4,31.2,29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M30.8,29.7c0.3,0.1,0.5,0.4,0.6,0.7c-0.2,0.1-0.4,0.2-0.6,0.2c-0.2,0.1-0.3,0-0.3-0.2 C30.5,30.1,30.6,29.9,30.8,29.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M32.1,29.9c-0.2-0.1-0.2-0.3-0.2-0.4c0.2-0.3,0.4-0.2,0.7-0.2C32.5,29.6,32.4,29.8,32.1,29.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st137",
    d: "M30.6,30.3c0.1,0.1,0.2,0.2,0.2,0.2c0,0.1,0,0.1,0,0.2c-0.2,0.1-0.4,0.3-0.6,0.4c0,0-0.1-0.1-0.1-0.1 C30.1,30.7,30.1,30.4,30.6,30.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M32.5,29.3c0.1-0.2,0.2-0.2,0.4-0.2C32.9,29.2,32.7,29.3,32.5,29.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st178",
    d: "M31,31c0-0.1,0-0.1,0-0.2C31.2,30.9,31.2,30.9,31,31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M36.6,52.7c0-0.2-0.1-0.4-0.2-0.6c0.4,0.1,0.4-0.3,0.6-0.4c0,0.3,0.2,0.6,0.1,0.8c-0.1,0.3,0.6,0.4,0.1,0.7 C36.9,53.3,36.9,52.9,36.6,52.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st333",
    d: "M37.7,52.5c-0.3-0.1-0.2-0.4-0.2-0.6c0.2,0,0.4,0,0.4-0.2c0.1-0.1,0.2-0.1,0.2,0c0.1,0.1,0.2,0.3,0.3,0.5 c0.1,0.2,0.2,0.3,0.2,0.5c-0.1,0.5-0.3,0.5-0.5,0.1C38,52.7,37.8,52.7,37.7,52.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st400",
    d: "M38.6,52.6c-0.2-0.1-0.2-0.3-0.2-0.4c-0.1-0.1-0.1-0.3-0.2-0.4c-0.1,0-0.1,0-0.2,0c0-0.1,0-0.1,0-0.2 c0-0.2,0-0.4,0.2-0.4c0.1,0.5,0.4,0.8,0.9,0.9c0,0,0,0.1,0.1,0.1c0,0.1,0,0.2-0.1,0.2C38.8,52.4,38.7,52.5,38.6,52.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st401",
    d: "M36.2,51.5c0.1,0,0.1,0,0.2,0c-0.1,0.1-0.1,0.2-0.3,0.1C36.1,51.6,36.2,51.5,36.2,51.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M37.5,51.9c-0.1-0.1-0.1-0.1-0.2-0.2C37.4,51.7,37.5,51.8,37.5,51.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st402",
    d: "M9.5,108.7c0,0.1,0,0.1,0,0.2c0,0,0.1,0.1,0,0.1c0,0,0,0.1,0,0.1c-0.1,0-0.3,0-0.4,0c-0.1,0.1-0.2,0.1-0.2,0 c-0.1-0.1,0-0.2,0-0.2l0,0c0.1-0.1,0.2-0.2,0.4-0.3C9.4,108.6,9.4,108.7,9.5,108.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st84",
    d: "M8.9,109.2c0.1,0,0.1,0,0.2,0c0,0.1,0,0.3,0,0.4c-0.1,0.1-0.2,0.2-0.2,0.2c-0.2-0.1-0.2-0.3-0.2-0.4 C8.7,109.3,8.8,109.2,8.9,109.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st226",
    d: "M10.1,110.2C10.1,110.3,10.1,110.3,10.1,110.2c-0.1,0.1-0.1,0.1-0.1,0C10,110.2,10,110.2,10.1,110.2 C10.1,110.2,10.1,110.2,10.1,110.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M9.5,109.2c0-0.1,0-0.1,0-0.2c0.1,0,0.1,0,0.2,0C9.7,109.1,9.6,109.1,9.5,109.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st84",
    d: "M9.7,110.3c-0.2-0.1-0.2-0.1,0-0.2C9.7,110.1,9.7,110.2,9.7,110.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M20.4,54.8C20.4,54.8,20.5,54.7,20.4,54.8c0.2,0,0.2,0,0.1,0.1C20.5,54.9,20.4,54.9,20.4,54.8 C20.4,54.8,20.4,54.8,20.4,54.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M18.1,1.7c0-0.1,0-0.1,0-0.2C18.3,1.6,18.3,1.6,18.1,1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M24.8,48.2c0.1,0,0.3,0,0.3-0.2c0-0.3-0.2-0.2-0.3-0.3c-0.1-0.1-0.1-0.3,0-0.4c0.5-0.1,0.7,0.2,0.6,0.6 c0.1,0.3,0.3,0.6-0.2,0.6l0,0C25.1,48.5,24.9,48.4,24.8,48.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M25.2,48.7c0.3-0.1,0.2-0.4,0.2-0.6c0.5,0,0.4,0.3,0.4,0.6C25.6,48.6,25.4,49.6,25.2,48.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st72",
    d: "M24.6,46.7c0.1-0.1,0.1-0.1,0.2-0.2c0.5-0.2,0.8-0.1,0.9,0.4c-0.1,0-0.3,0-0.4,0c-0.1,0.1-0.3,0.1-0.4,0 C24.7,46.9,24.6,46.8,24.6,46.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st403",
    d: "M24.8,47.4c0,0.1,0,0.3,0,0.4c-0.2,0-0.4-0.1-0.4-0.3c0-0.3,0.2-0.3,0.4-0.3C24.8,47.2,24.8,47.3,24.8,47.4z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M24.8,46.9c0.1,0,0.3,0,0.4,0c-0.1,0.2-0.2,0.2-0.4,0.2C24.8,47.1,24.8,47,24.8,46.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st404",
    d: "M50,46.3c0.1-0.2,0.5-0.3,0.4-0.6c0-0.5,0.3-0.4,0.6-0.4c0.1,0.1,0.1,0.1,0.2,0.2c0,0,0,0.1,0,0.1 c0,0.1-0.1,0.1-0.2,0.2c0,0-0.1,0.1-0.1,0.1c-0.1,0.2,0,0.5-0.2,0.7c-0.1,0-0.3,0-0.4,0C50.3,46.4,50.1,46.4,50,46.3L50,46.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st128",
    d: "M51.3,46.1c-0.1,0.1-0.1,0.1-0.2,0.2c-0.2-0.2-0.2-0.4,0-0.7l0,0c0.1-0.1,0.2-0.1,0.2-0.2l0,0 C51.7,45.6,51.3,45.9,51.3,46.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st224",
    d: "M11.6,33.4c-0.1-0.2-0.3-0.3-0.4-0.5c0-0.6,0.5-0.3,0.8-0.4c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0,0.2,0 c0.1,0.1,0.2,0.2,0.3,0.4c0.1,0.6-0.2,0.7-0.7,0.7C11.9,33.6,11.8,33.5,11.6,33.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st405",
    d: "M12.1,31.6c-0.1-0.1-0.2-0.1-0.2-0.2c-0.1,0-0.1-0.1-0.2-0.1c-0.1,0-0.1-0.1-0.1-0.1c0-0.1-0.1-0.1-0.1-0.2 l0,0c-0.1-0.1-0.1-0.1-0.1-0.2c0-0.1,0-0.1,0-0.1c0.2-0.1,0.4-0.1,0.6-0.1c0.1,0,0.3,0.1,0.4,0.1c0.2,0,0.4,0.1,0.5,0.1 c0.2,0.1,0.3,0.2,0.5,0.3c0.1,0.1,0.1,0.2,0,0.3c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0-0.2,0.1-0.3,0.1C12.6,31.7,12.3,31.9,12.1,31.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st406",
    d: "M12.1,32.5c-0.2,0.4-0.7,0.1-0.9,0.4l-0.1,0l-0.1,0c0-0.2,0-0.4,0-0.6c0.3,0,0.6,0,0.9,0 C11.9,32.3,12,32.4,12.1,32.5C12,32.4,12.1,32.5,12.1,32.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M11,31.9c-0.6-0.7,0.4-0.4,0.4-0.6c0,0,0.1,0,0.1,0c0,0,0.1,0.1,0.1,0.1c0,0,0,0.1,0,0.1 c0.1,0.2,0.2,0.5-0.2,0.4C11.3,32,11.1,32,11,31.9L11,31.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st407",
    d: "M12.1,31.6c0.3,0.1,0.6-0.1,0.9-0.1c0.1,0,0.2,0.1,0.2,0.1c0,0,0.1,0,0.1,0.1c0.1,0.1,0.1,0.1,0.1,0.2 c0,0,0,0.1,0,0.1c0,0,0,0.1-0.1,0.1c-0.1,0-0.2,0-0.2-0.1l-0.1,0l-0.1,0c-0.1-0.1-0.2-0.1-0.2-0.2C12.5,31.8,12.2,31.9,12.1,31.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st408",
    d: "M12.5,32.9c0-0.1,0-0.3,0-0.4l0,0c0.1-0.1,0.3-0.1,0.4,0c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1-0.1 c0,0,0.1,0.1,0.1,0.1c0,0.1,0,0.2-0.1,0.3C13.1,33.1,12.8,33.2,12.5,32.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st409",
    d: "M13.4,32.5c-0.1,0-0.1,0-0.2,0c0-0.1,0-0.3,0-0.4c0.1,0,0.2,0,0.2,0C13.5,32.2,13.5,32.4,13.4,32.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st409",
    d: "M12.9,32.5c-0.1,0-0.3,0-0.4,0C12.7,32.3,12.8,32.3,12.9,32.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M11,31.9c0.1,0,0.3,0,0.4,0C11.3,32.1,11.1,32.1,11,31.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st409",
    d: "M12.3,32.5c-0.1,0-0.1,0-0.2,0l0,0c0,0-0.1-0.1,0-0.1c0,0,0-0.1,0-0.1C12.2,32.3,12.3,32.4,12.3,32.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st224",
    d: "M12.1,32.3c0,0.1,0,0.1,0,0.2c-0.1-0.1-0.1-0.1-0.2-0.2C11.9,32.3,12,32.3,12.1,32.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st409",
    d: "M12.7,31.9c0.1,0.1,0.2,0.1,0.2,0.2C12.8,32,12.8,32,12.7,31.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st410",
    d: "M11.9,31.2c0,0.1,0,0.1,0,0.2l-0.1,0l-0.1,0l0,0c0,0-0.1-0.1-0.1-0.1c0,0,0-0.1,0.1-0.1 C11.7,31.1,11.8,31.1,11.9,31.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st389",
    d: "M51.1,45.6c0,0.2,0,0.4,0,0.7c0,0.1-0.1,0.2-0.2,0.2c-0.1-0.2-0.1-0.4-0.2-0.6 C50.6,45.5,50.8,45.5,51.1,45.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st128",
    d: "M50,46.3c0.2,0,0.3,0,0.4,0.2c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0C50,46.4,50,46.4,50,46.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st375",
    d: "M15.7,8.6c0.1,0,0.1,0,0.2,0c0.1,0.1,0.1,0.1,0.1,0.2c0,0.2,0,0.4-0.1,0.6c-0.2,0.1-0.3,0.5-0.6,0.4 c0-0.5,0-1,0.2-1.5l0,0C15.6,8.5,15.7,8.5,15.7,8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st163",
    d: "M9.7,104.7c0.1-0.2,0.1-0.2,0.2,0C9.9,104.7,9.8,104.7,9.7,104.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st411",
    d: "M23.3,40.5c0,0.1-0.1,0.1-0.1,0.2c-0.4,0.1-0.6-0.1-0.9-0.4c-0.2-0.2-0.4-0.4-0.5-0.7 c-0.1-0.2-0.1-0.4-0.1-0.5c0-0.1-0.1-0.3-0.1-0.4c0-0.1,0-0.3,0.1-0.4c0.1-0.1,0.2-0.1,0.3-0.1c0.3,0,0.5,0.2,0.7,0.4 c0.2,0.2,0.4,0.4,0.5,0.7c0.1,0.1,0.1,0.2,0.2,0.4c0,0.1,0.1,0.3,0.1,0.4C23.4,40.2,23.4,40.3,23.3,40.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st412",
    d: "M24.7,40.5c-0.4,0.3-0.8,0.7-1,1.3c-0.3-0.5,0.4-1,0-1.5c0,0-0.1,0-0.1-0.1c0,0,0-0.1,0-0.1 c0.1-0.2,0.2-0.4,0.3-0.5c0.1,0,0.2,0,0.3,0C24.4,39.9,24.9,40,24.7,40.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st413",
    d: "M22.4,40.2c0.3,0.1,0.6,0.3,0.8,0.4c0,0.1,0,0.2,0,0.2c-0.2,0.1-0.5,0.2-0.6,0.4c-0.1-0.1-0.1-0.1-0.2-0.2 c-0.1-0.1-0.1-0.2-0.2-0.2c0-0.1,0-0.1,0-0.2c0.3-0.1,0-0.3,0-0.4C22.3,40.2,22.3,40.2,22.4,40.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st414",
    d: "M23.7,40.1c0,0.1,0,0.1,0,0.2c-0.1,0.1-0.3,0.1-0.4,0.2c0-0.1,0-0.3,0-0.4C23.5,39.9,23.6,39.9,23.7,40.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M42.7,60.1c0-0.1,0-0.1,0-0.2C42.8,59.9,42.8,60,42.7,60.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M47,56.8c0.1-0.2,0.1-0.2,0.2,0C47.1,56.8,47,56.8,47,56.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st415",
    d: "M30.2,63.9c0.2-0.4,0.5-0.7,0.8-0.9c0.4,0.6,0.2,1-0.3,1.3c-0.1,0.1-0.2,0.1-0.3,0l0,0 c-0.1-0.1-0.2-0.2-0.2-0.2C30.2,64.1,30.2,64,30.2,63.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st388",
    d: "M30.2,64.1c0.1,0.1,0.1,0.2,0.2,0.2C30.3,64.3,30.2,64.3,30.2,64.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st388",
    d: "M30.4,64.4c0.1,0,0.1,0,0.2,0c0,0,0.1,0.1,0.1,0.1c0,0,0,0.1,0,0.1c-0.1,0-0.2,0-0.2,0 C30.4,64.5,30.4,64.4,30.4,64.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st388",
    d: "M30.2,64.8c-0.1,0-0.1,0-0.2,0c0-0.1,0.1-0.2,0.2-0.2C30.2,64.7,30.2,64.7,30.2,64.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st319",
    d: "M31,64.8c0-0.1,0-0.1,0-0.2c0-0.6,0.4-0.4,0.7-0.3c0.3,0.2,0.1,0.4-0.1,0.5C31.5,64.8,31.3,64.8,31,64.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st416",
    d: "M31.7,64.8c0.1-0.1,0.1-0.3,0.2-0.4c0,0,0.1,0,0.1,0c0.2,0.1,0.2,0.3,0.1,0.5c0,0-0.1,0-0.2,0 C31.9,64.8,31.8,64.8,31.7,64.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M33.4,45.9c0.1,0.1,0.3,0.1,0.4,0.2c-0.1,0.3-0.1,0.6-0.2,0.9c-0.1,0.1-0.2,0.1-0.2,0.2c-0.1,0-0.1,0-0.2,0 C33.3,46.7,33,46.2,33.4,45.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st417",
    d: "M13.3,91.5c0-0.1-0.1-0.1-0.1-0.2C13.3,91.3,13.3,91.4,13.3,91.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M23.7,55.8c-0.1,0-0.3,0-0.4,0c0-0.2,0-0.4,0.3-0.3C23.7,55.4,23.7,55.6,23.7,55.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st301",
    d: "M4.8,29.5c-0.1,0-0.3,0-0.4,0c0-0.1,0-0.1,0-0.2c-0.1-0.3,0.1-0.6,0.2-0.9c0-0.1,0-0.1,0-0.2 c0.7,0.2,0.7-0.2,0.6-0.6c0.1,0,0.1,0,0.2,0l0,0c0,0.2,0,0.4,0,0.7c0.1,0.1,0.3,0.3,0.4,0.4c0.1,0.3,0.2,0.5,0.1,0.8l0,0 c-0.2,0-0.4,0-0.6,0c0,0-0.1-0.1-0.1-0.1c0,0-0.1,0-0.1,0c0,0,0,0.1,0,0.1C4.9,29.5,4.8,29.5,4.8,29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st311",
    d: "M4.5,28.4c0.2,0.4,0,0.6-0.2,0.9c-0.4,0-0.8-0.1-1.1-0.4c0.2-0.3,0.6-0.1,0.8-0.4 C4.3,28.4,4.4,28.4,4.5,28.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st418",
    d: "M4.1,28.4c-0.1,0.6-0.5,0.4-0.8,0.4c-0.1,0-0.2-0.1-0.2-0.2C3.4,28.4,3.7,28.4,4.1,28.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M40.5,48c0.1,0,0.3,0,0.4,0c0,0.4-0.3,0.6-0.4,0.9C40.1,48.6,40.4,48.3,40.5,48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M40.5,50.2c-0.4-0.3-0.2-0.7-0.2-1.1c0.1,0,0.1,0,0.2,0c0.3,0.2,0.4,0.5,0.4,0.8 C40.8,50.1,40.7,50.2,40.5,50.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M40.7,50c-0.1-0.3-0.2-0.6-0.2-0.9c0-0.1,0-0.1,0-0.2c0.1,0,0.1,0,0.2,0c0.3,0.1,0.5,0.3,0.5,0.6 c0,0.1-0.1,0.3-0.1,0.4C41,49.9,40.9,50,40.7,50z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M23.7,48.7c0-0.2,0-0.5,0-0.7c0.5,0.3,0.5,0.6,0,0.9l-0.1-0.1C23.7,48.8,23.7,48.7,23.7,48.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M24.4,48c0.2,0,0.3,0,0.4,0.2C24.6,48.2,24.4,48.2,24.4,48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st220",
    d: "M23.7,47.6c0-0.1,0-0.1,0-0.2c0.1,0.1,0.1,0.1,0.2,0.2C23.9,47.6,23.8,47.6,23.7,47.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M7.3,24.7c0,0.1,0,0.1,0,0.2c-0.1-0.1-0.3-0.1-0.4-0.2C7.1,24.5,7.2,24.5,7.3,24.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st419",
    d: "M6.3,25.8C6.3,25.9,6.4,26,6.5,26c-0.1,0.2-0.2,0.3-0.4,0.2c0-0.1,0-0.3,0-0.4C6.1,25.8,6.2,25.8,6.3,25.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M6.7,25c0-0.1,0.1-0.2,0.2-0.2C6.8,24.8,6.8,24.9,6.7,25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st248",
    d: "M10.6,30.8C10.3,30.9,10,31,9.7,31c-0.4,0.2-0.5-0.2-0.6-0.4l0,0c-0.1-0.1-0.2-0.2-0.2-0.4 c0-0.1,0-0.2,0.1-0.3c0.2-0.2,0.4-0.1,0.6-0.1c0.2,0,0.4-0.2,0.6-0.2c0.2,0.1,0.2,0.3,0.1,0.5c-0.1,0.1-0.1,0.2-0.4,0.3 c0.3,0,0.4-0.2,0.5-0.3c0.3-0.2,0.5-0.2,0.8,0c0.2,0.2-0.1,0.4-0.1,0.6c0,0.1-0.1,0.1-0.2,0.2C10.8,30.9,10.7,30.9,10.6,30.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M9.1,30.6c0.2,0.1,0.4,0.3,0.6,0.4c0,0.3,0.6,0,0.4,0.4c-0.3,0-0.6,0-0.9,0c-0.1-0.2-0.3-0.2-0.4-0.2 C8.9,31,9.1,30.8,9.1,30.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st420",
    d: "M10.6,30.8c0.2,0,0.3,0,0.5,0c0,0,0.1,0.1,0,0.1c0,0,0,0.1,0,0.1C10.8,31,10.7,31,10.6,30.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st421",
    d: "M11,31c0-0.1,0-0.1,0-0.2l0,0c0.1,0,0.1,0,0.2-0.1c0,0,0.1,0.1,0.1,0.1c0,0-0.1,0.1-0.1,0.1L11,31L11,31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st410",
    d: "M11.4,31c0.1,0,0.1,0,0.2,0c0,0,0.1,0.1,0.1,0.1c0,0,0,0.1,0,0.1l0,0l-0.1,0l-0.1-0.1l0,0 C11.4,31.1,11.4,31.1,11.4,31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st410",
    d: "M11.2,31c0-0.1,0-0.1,0-0.2c0.1-0.1,0.2-0.1,0.3,0c0,0.1,0,0.1,0,0.2C11.4,31,11.3,31,11.2,31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M40.1,60.1c0.1,0.3,0.3,0.4,0.6,0.4c0.1,0.1,0.1,0.1,0.2,0.2c0.1,0.1,0.1,0.1,0.1,0.2c0,0,0,0.1-0.1,0.1 c-0.1,0-0.3,0-0.4,0c-0.1,0.1-0.3,0.1-0.4,0.1c-0.3-0.1-0.5-0.1-0.7-0.4C39.4,60.3,39.6,60,40.1,60.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st422",
    d: "M40.9,60.9c0-0.1,0-0.1,0-0.2c0.2,0,0.4,0,0.6,0C41.4,61,41.2,60.9,40.9,60.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st423",
    d: "M44.6,55.3c-0.3-0.1-0.6-0.1-0.8-0.2c-0.4-0.4-0.5,0-0.7,0.2c-0.6-0.2-1-0.6-0.7-1.3 c0.1-0.1,0.3-0.2,0.4-0.2c0.3,0.1,0.6,0.3,1,0.3c0.2,0,0.5,0,0.7,0.1c0.1,0.1,0.2,0.2,0.3,0.3c0,0.1,0,0.1,0,0.2 C44.7,55,44.7,55.2,44.6,55.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st379",
    d: "M44.6,55.3c0-0.2,0-0.3,0.2-0.4c0,0.1,0,0.3,0,0.4C44.7,55.4,44.7,55.4,44.6,55.3L44.6,55.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st424",
    d: "M44.8,54.7c-0.1-0.1-0.1-0.1-0.2-0.2c0.1-0.1,0.1-0.1,0.2,0l0,0C44.8,54.5,44.8,54.6,44.8,54.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st380",
    d: "M44.6,55.3c0.1,0,0.1,0,0.2,0c-0.1,0.1-0.1,0.1-0.2,0.2C44.6,55.5,44.6,55.4,44.6,55.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M41.8,56.4c0.3,0,0.7,0,1,0c0.4,0,0.7,0.2,0.7,0.6c-0.1,0.1-0.2,0.1-0.3,0.1c0,0-0.1-0.1-0.1,0 c0.1,0.1,0.3,0.1,0.2,0.3c0,0.1,0,0.1,0,0.2c-0.1,0-0.1,0-0.2,0c-0.3-0.4-0.7-0.2-1.1-0.2c-0.1,0.1-0.2,0.1-0.2,0 c-0.1-0.2-0.1-0.4,0.1-0.6c0-0.1,0-0.1,0-0.2C41.8,56.6,41.7,56.5,41.8,56.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st425",
    d: "M43.1,57.1c0.1,0,0.3,0,0.4,0c0.2,0.1,0.4,0.2,0.4,0.4c-0.2,0-0.4,0-0.6,0c-0.1-0.1-0.3-0.3-0.4-0.4 C42.9,57,43,57,43.1,57.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M43.5,58.3c-0.1-0.2-0.2-0.4-0.2-0.6C43.5,57.9,43.9,58,43.5,58.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st163",
    d: "M29.9,68.3c0,0.1,0,0.1,0,0.1C29.8,68.4,29.8,68.4,29.9,68.3C29.9,68.3,29.9,68.3,29.9,68.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st259",
    d: "M22,56.6c0.1,0,0.2-0.1,0.2-0.2c0.1-0.2,0.1-0.2,0.2,0c-0.1,0.3,0.3,0.6-0.1,0.9c-0.3,0-0.2-0.3-0.3-0.4 l0-0.1L22,56.6L22,56.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st102",
    d: "M29.1,40.5c0.1,0.1,0.3,0.3,0.4,0.4c0,0.1,0,0.1,0,0.2c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0-0.1,0-0.2,0 c-0.1-0.2-0.3-0.2-0.4,0c-0.3,0-0.6,0.1-0.9-0.2c0-0.1,0.2-0.2,0.1-0.2c-0.2-0.2-0.4-0.1-0.5,0c-0.3,0.1,0,0.3,0,0.4 c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.3,0-0.4-0.1c0-0.1-0.1-0.2-0.1-0.3c0-0.3,0.2-0.5,0.4-0.7 c0.1-0.1,0.2-0.2,0.2-0.3c0-0.1,0.1-0.1,0.2-0.2c0.1,0,0.2,0,0.2,0.1c0.4-0.2,0.7-0.4,1.1-0.6C28.7,39.9,28.8,40.3,29.1,40.5 L29.1,40.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st426",
    d: "M27.4,40.9c0-0.5,0.3-0.5,0.7-0.4c0.2,0.1,0.3,0.3,0.2,0.5c-0.1,0.2-0.3,0.1-0.5,0.1 C27.7,41,27.5,41,27.4,40.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st166",
    d: "M27.4,42.2c-0.1,0-0.1,0-0.2,0c-0.3-0.1-0.4-0.3-0.2-0.6l0,0c0.1-0.1,0.3-0.1,0.4,0c0.2,0,0.3,0,0.4,0.2 C27.7,41.9,27.5,42.1,27.4,42.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M28.7,41.3c0-0.2,0-0.4,0.3-0.3c0.1,0,0.2,0.2,0.2,0.3C28.9,41.3,28.8,41.3,28.7,41.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st313",
    d: "M27.4,41.5c-0.1,0-0.3,0-0.4,0c0.1-0.2,0.3-0.2,0.4-0.2C27.4,41.4,27.4,41.5,27.4,41.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st259",
    d: "M20.5,13.6c0.1-0.4,0.4-0.7,0.4-1.1c0.2,0,0.4-0.1,0.6-0.2c0,0.2,0.1,0.4,0.2,0.7c-0.1,0.4-0.1,0.8-0.4,1.1 c0-0.1,0-0.1,0-0.2c-0.1-0.1-0.1-0.1-0.2,0C20.9,13.8,20.7,13.6,20.5,13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.3,8c0.1-0.3,0.1-0.6,0.2-0.9c0.4,0,0.9,0.1,1.1-0.4c0.1,0,0.1,0,0.2,0c0.3,0.5,0.1,1.1,0.4,1.5 c-0.5,0.4-0.9,0-1.4,0c-0.1,0-0.2,0-0.3,0C17.4,8.1,17.3,8,17.3,8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st364",
    d: "M40.1,60.9c0.1,0,0.3,0,0.4,0c0.2,0.3,0.6,0.3,0.7,0.6c-0.1,0-0.3,0-0.4,0c-0.1,0-0.1,0-0.2,0 c-0.1-0.1-0.1-0.1-0.2-0.2l0,0c-0.1-0.1-0.2-0.1-0.3-0.2C40,61.1,40,61,40.1,60.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st326",
    d: "M34.3,26.7c-0.1,0-0.1,0-0.2,0c-0.1,0.1-0.2,0.1-0.2,0.2c-0.4,0.1-0.5-0.3-0.6-0.5c0-0.2,0.1-0.3,0.2-0.4 c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0,0.2,0.1,0.2c0.1,0.1,0,0,0-0.1c0-0.1,0-0.2,0.1-0.3c0.1-0.2,0.2-0.4,0.3-0.6 c0.1-0.1,0.2-0.2,0.3-0.2c0.1,0,0.3,0,0.4,0c0.1,0.1,0.1,0.1,0.2,0.2c0,0.1,0,0.1,0,0.2h0c-0.1,0.1-0.1,0.1-0.2,0.2 c0,0.1,0,0.3,0,0.4c-0.1,0.1-0.1,0.1-0.2,0.1C34.7,26.6,34.4,26.5,34.3,26.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M34.9,26.3c0.1,0,0.1,0,0.2,0c0,0.1,0,0.2,0,0.2l-0.1,0l-0.1,0C34.8,26.4,34.8,26.4,34.9,26.3 C34.9,26.3,34.9,26.3,34.9,26.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M35.1,25.8c0-0.1,0.1-0.2,0.2-0.2C35.3,25.7,35.2,25.8,35.1,25.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st335",
    d: "M36,55.1c0.1,0,0.1,0,0.2,0c0.1,0.1,0.2,0.3,0.2,0.4c0.1,0.2,0,0.3-0.1,0.5c-0.1,0.1-0.2,0.2-0.3,0.3 c-0.2,0.2-0.3,0.6-0.7,0.5c-0.2-0.1-0.4-0.4-0.7-0.3c-0.3,0-0.5,0-0.6-0.3c0-0.3,0.3-0.4,0.5-0.5c0.1,0,0.1,0,0.2,0 c0.1,0,0.2-0.1,0.2-0.2c0.1,0,0.1,0,0.2,0c0.4,0.2,0.6,0,0.9-0.2C36,55.3,36,55.2,36,55.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st262",
    d: "M36,55.3c0,0.3-0.1,0.6-0.5,0.6c-0.3,0-0.3-0.2-0.3-0.4C35.4,55.4,35.7,55.3,36,55.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M23.7,48.7c0,0,0,0.1,0,0.1c-0.1,0-0.1,0-0.2,0.1c0-0.1,0-0.2,0-0.3C23.6,48.6,23.6,48.7,23.7,48.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M23.5,49.3c0,0.1-0.1,0.2-0.2,0.2c0-0.1,0-0.1,0-0.2C23.4,49.3,23.4,49.3,23.5,49.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M13,17.6c-0.1,0-0.3,0-0.4,0c0-0.5,0.5-0.6,0.9-0.7c0.1-0.1,0.1-0.1,0.2,0c0,0.1,0.1,0.2,0,0.3 c0,0.1-0.1,0.2-0.2,0.3C13.3,17.6,13.2,17.8,13,17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M12.3,17.9c0-0.1,0-0.1,0-0.2c0.1,0,0.1,0,0.2,0C12.4,17.7,12.4,17.8,12.3,17.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st427",
    d: "M21.1,59.9c0.4-0.4,0.1-0.9,0.2-1.3c0.1-0.1,0.3-0.1,0.4-0.2c0.4,0.2,0.4,0.5,0.3,0.9 c-0.1,0.4-0.3,0.7-0.1,1.1c-0.3,0-0.5,0-0.8,0C21.1,60.2,21.1,60,21.1,59.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M2.6,24.5c0-0.1,0-0.1,0-0.2C2.8,24.4,2.8,24.5,2.6,24.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st309",
    d: "M18.5,41.1c0.1,0.1,0.1,0.1,0.2,0.2C18.7,41.3,18.6,41.2,18.5,41.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st428",
    d: "M23.3,50.8c-0.2,0-0.2,0.3-0.2,0.4l-0.1,0l-0.1,0c0-0.1,0-0.3-0.1-0.4c0-0.1,0-0.2,0.1-0.4 c0-0.1,0.1-0.1,0.2-0.1C23.3,50.5,23.3,50.6,23.3,50.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st176",
    d: "M23,50.4c-0.1,0-0.1,0-0.2,0.1c0-0.1,0.1-0.2,0.1-0.3C23,50.2,23,50.3,23,50.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st257",
    d: "M31.9,64.4c-0.3,0-0.7-0.1-0.9,0.2c-0.1,0-0.3,0-0.4-0.1c0-0.1,0-0.1,0-0.2c0.3-0.4,0.5-0.8,0.4-1.3 c0-0.1,0-0.1,0-0.2c0.3,0,0.6-0.1,0.8-0.2c0,0,0.1,0,0.1,0c0.1,0,0.3,0.1,0.4,0.2c0.1,0.1,0.1,0.1,0.2,0.2c0,0,0.1,0.1,0.1,0.1 c0,0.1,0,0.2,0,0.3c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0-0.2,0-0.3,0c-0.2,0-0.4-0.1-0.1,0.2c0,0,0.1,0.1,0.1,0.2 C32,64.1,32,64.3,31.9,64.4L31.9,64.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st274",
    d: "M20.1,9.2c-0.1,0-0.3,0-0.4,0c-0.1,0-0.1-0.1-0.1-0.1c0,0,0-0.1,0.1-0.1l0,0C19.8,9,20,9.1,20.1,9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M9.5,108.7c-0.1,0-0.1,0-0.2,0c-0.1-0.1-0.1-0.1-0.1-0.2c0-0.1,0-0.2,0.1-0.2c0.1,0,0.3,0,0.4,0 c0,0.1,0,0.1,0,0.2C9.6,108.6,9.5,108.6,9.5,108.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M34.7,25.2c-0.1,0.1-0.1,0.1-0.2,0.2c-0.3,0-0.3-0.2-0.3-0.4c0.1-0.3,0.2-0.5,0.5-0.5l0,0 C34.7,24.8,34.7,25,34.7,25.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st429",
    d: "M23.5,19.4c0.1,0,0.1,0,0.2,0c0,0.2,0,0.4,0,0.6c-0.1,0-0.2,0-0.2,0c-0.1,0.1-0.1,0.3-0.2,0.4l0,0 c-0.1,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.1-0.1,0.2c-0.1,0-0.2,0-0.2-0.1c-0.3,0.1-0.2,0.4-0.2,0.6c-0.1,0.1-0.2,0.1-0.3,0.1 c-0.3-0.2-0.9,0.2-1-0.5c0.4,0,0.6-0.4,0.9-0.7c-0.2-0.2,0-0.4,0-0.6c0.1-0.3,0.4-0.2,0.6-0.2C23.1,19.6,23.3,19.6,23.5,19.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st72",
    d: "M10.6,10.3c0.1-0.1,0.1-0.1,0.2-0.2C10.8,10.2,10.7,10.3,10.6,10.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M8.9,109.2c-0.1,0.1-0.1,0.1-0.2,0.2c0-0.1,0-0.3,0-0.4c0.1,0,0.1,0,0.2,0C8.9,109,8.9,109.1,8.9,109.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st430",
    d: "M34.7,24.5c-0.1,0.1-0.3,0.3-0.4,0.4c-0.2,0-0.3,0.1-0.5,0c0-0.1-0.1-0.1-0.1-0.2c0-0.1,0.1-0.2,0.2-0.3 c0.1-0.1,0.2-0.1,0.3-0.2c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.2,0.1C34.7,24.4,34.7,24.5,34.7,24.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st378",
    d: "M34.7,24.3c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1-0.1-0.1-0.1c0,0,0-0.1,0.1-0.1l0,0C34.5,24.2,34.6,24.2,34.7,24.3 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st431",
    d: "M13.6,17c0-0.1,0-0.1,0-0.2c0.1-0.1,0.2-0.1,0.2-0.2c0.1-0.1,0.3-0.1,0.4-0.2c-0.1,0.3-0.2,0.6-0.2,0.9 c-0.1,0.1-0.1,0.1-0.2,0.1c-0.1,0-0.2-0.1-0.2-0.1C13.6,17.1,13.6,17.1,13.6,17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st432",
    d: "M8.8,108.8c-0.1,0-0.1,0-0.2-0.1c0.1-0.2,0.3-0.2,0.4-0.2c0,0.1,0,0.1,0,0.2C9,108.8,9,108.8,8.8,108.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st173",
    d: "M9.3,108.3c0,0.1,0,0.1,0,0.2c-0.1,0.1-0.1,0.1-0.2,0l0,0c0-0.1,0-0.1,0-0.2C9.1,108.3,9.2,108.3,9.3,108.3z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M23.9,12.7c0,0.1-0.1,0.2-0.2,0.2C23.8,12.8,23.9,12.8,23.9,12.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "M9.1,108.5c0.1,0,0.1,0,0.2,0c0,0.1,0,0.1,0,0.2C9.2,108.9,9,109,8.8,109c0-0.1,0-0.1,0-0.2 C8.9,108.7,9,108.6,9.1,108.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M11.6,33.4c0.1,0,0.3,0,0.4,0c0.2,0.2,0.5,0.1,0.8,0.3c0.2,0.1,0.2,0.4,0.3,0.6l0,0c-0.1,0.1-0.1,0.3-0.2,0.4 c-0.5-0.7-0.6,0-0.9,0.2c0-0.6-0.2-1-0.9-1.1C11.4,33.7,11.5,33.5,11.6,33.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11,34.7C11,34.6,11.1,34.6,11,34.7C11.1,34.6,11.1,34.6,11,34.7C11.1,34.6,11,34.6,11,34.7L11,34.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17,47.1c0.2,0.1,0.2,0.3,0.2,0.4C17.1,47.5,17,47.3,17,47.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.4,49.3c0.1-0.1,0.1-0.1,0.2-0.2c0,0.2,0,0.3-0.2,0.4C16.4,49.4,16.4,49.4,16.4,49.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st433",
    d: "M21.2,11.7C21.2,11.7,21.2,11.6,21.2,11.7c0-0.2,0-0.2,0.1-0.1C21.3,11.6,21.3,11.6,21.2,11.7 C21.3,11.7,21.2,11.7,21.2,11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st434",
    d: "M28.2,32.7c-0.1,0-0.3,0-0.4,0c-0.1,0-0.3-0.1-0.4-0.2c-0.1-0.1-0.3-0.2-0.5-0.3c-0.2-0.1-0.5-0.2-0.6-0.4 c-0.1-0.1-0.2-0.2-0.2-0.4c0-0.2,0-0.3,0.1-0.5c0.3-0.3,0.7-0.3,1-0.2c0.1,0.1,0.2,0.2,0.3,0.3c0,0.1,0,0.2,0.1,0.3 c0.1,0,0.1-0.1,0.2-0.1c0.1,0,0.2,0,0.2,0.1c0.1,0.1,0.1,0.1,0.1,0.2c0,0.1,0.1,0.2,0.1,0.2C28.4,32.1,28.5,32.4,28.2,32.7 C28.3,32.7,28.3,32.7,28.2,32.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st435",
    d: "M29.1,34.4c-0.2,0.3-0.3,0.5-0.2,0.9c-0.2,0.5-0.5,0.7-1.1,0.5c-0.1-0.2-0.1-0.3,0-0.5l0,0 c0.1-0.1,0.2-0.2,0.2-0.3c0-0.1,0.1-0.2,0.2-0.3c0.1,0,0.1,0,0.2,0c0.1,0,0.1-0.1,0.2-0.2C28.8,34.2,29,34.5,29.1,34.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st436",
    d: "M27.8,35.3c0,0.1,0,0.3,0,0.4c0,0,0,0.1,0,0.1c0,0.3,0,0.6-0.4,0.6c-0.1,0-0.1-0.1-0.2-0.2 c-0.2-0.3-0.3-0.6-0.4-0.9c0-0.1,0-0.2,0-0.3c0-0.1,0.1-0.2,0.1-0.2c0.1-0.1,0.3-0.1,0.4,0C27.4,35.1,27.6,35.2,27.8,35.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M28.2,34.7c0,0.1,0,0.3,0,0.4c-0.2,0.2-0.3-0.1-0.4-0.2c-0.4-0.4-0.1-0.7,0.2-0.8 C28.3,34.1,28.2,34.4,28.2,34.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st437",
    d: "M27.3,34.8c-0.1,0-0.3,0-0.4,0c-0.1,0.1-0.1,0.1-0.2,0c-0.1-0.2-0.1-0.3,0-0.5c0-0.1,0.1-0.3,0.2-0.4 c0.1-0.1,0.1-0.1,0.2-0.1c0.1,0,0.2,0,0.2,0.1C27.2,34.3,27.4,34.6,27.3,34.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st438",
    d: "M27.6,32.5c0.1,0.1,0.1,0.1,0.2,0.2c0,0.1,0,0.3,0,0.4c0,0,0.1,0.1,0,0.1c0,0,0,0.1-0.1,0.1 c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0-0.2-0.1-0.2-0.1c-0.1-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.3,0.1-0.4C27.4,32.7,27.5,32.6,27.6,32.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st439",
    d: "M27.4,33.4c0.1,0.1,0.1,0.2,0.2,0.3c-0.1,0.1-0.2,0.2-0.3,0.4c-0.1,0-0.1,0-0.2,0 C26.9,33.7,27.1,33.5,27.4,33.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st336",
    d: "M27.8,34.9c0.1,0.1,0.3,0.1,0.4,0.2c-0.1,0.2-0.2,0.2-0.4,0.2C27.8,35.2,27.8,35,27.8,34.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st440",
    d: "M27.8,33.4c0-0.1,0-0.1,0-0.2c0.1,0,0.3,0,0.3,0.1C28.1,33.4,27.9,33.4,27.8,33.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st441",
    d: "M28.7,34.4c0,0.1,0,0.2-0.1,0.3c0,0.1-0.1,0-0.2-0.1C28.5,34.6,28.6,34.5,28.7,34.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M28.4,32.7c-0.1,0.2-0.1,0.2-0.2,0l0,0c0,0,0.1-0.1,0.1-0.1C28.4,32.7,28.4,32.7,28.4,32.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M28.7,32.5c0,0.1-0.1,0.2-0.2,0.2l0,0c-0.1-0.1,0-0.2,0.1-0.2C28.6,32.5,28.6,32.5,28.7,32.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.1,32.3c-0.1,0-0.1,0-0.2,0c0,0,0-0.1-0.1-0.1c0-0.1,0.1-0.1,0.2-0.2C29.1,32.1,29.2,32.1,29.1,32.3 L29.1,32.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M28.9,32.3c0,0.1-0.1,0.2-0.2,0.2l0,0c-0.1,0-0.1-0.1-0.1-0.2c0-0.1,0-0.1,0-0.1 C28.7,32.2,28.8,32.2,28.9,32.3L28.9,32.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M29.7,34c0,0,0.1,0.1,0.1,0.1C29.8,34.1,29.8,34.1,29.7,34C29.8,34.1,29.8,34,29.7,34L29.7,34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st442",
    d: "M28.9,32.3l-0.1,0l-0.1,0c-0.4,0.1-0.3-0.3-0.5-0.4c0-0.1-0.1-0.2,0-0.3c0,0,0-0.1,0.1-0.1 c0.1-0.1,0.2-0.2,0.3-0.2c0.2-0.2,0.1-0.5,0.1-0.7c0-0.1,0-0.3,0.1-0.4c0.1-0.2,0.2-0.4,0.4-0.5c0.1,0,0.2,0,0.3,0.1 c0.4,0.5,0.6,1,0.5,1.6c0,0.1-0.1,0.2-0.1,0.3c-0.2,0-0.3,0-0.4,0.2C29.2,32,29,32,28.9,32.1C28.9,32.1,28.9,32.2,28.9,32.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st241",
    d: "M28.9,32.1c0.1-0.2,0.2-0.2,0.4-0.2c0.3,0.3-0.1,0.3-0.2,0.4C29.1,32.2,29,32.1,28.9,32.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M29.7,31.6c0-0.1,0-0.1,0-0.2c0,0,0.1-0.1,0.1-0.1c0,0,0.1,0.1,0.1,0.1C29.9,31.5,29.8,31.6,29.7,31.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st443",
    d: "M30.2,31.2c0,0.1-0.1,0.2-0.2,0.2l0,0C29.9,31.2,30,31.2,30.2,31.2L30.2,31.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M38.6,71.7c0,0.1,0,0.3,0,0.4C38.3,72,38.3,71.8,38.6,71.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M13.8,17.2c0.1,0,0.1,0,0.2,0c0.5,0.1,0.7,0.8,1.3,0.6c0.4,0.3,0.6,0.7,0.5,1.2c0,0.1-0.1,0.2-0.2,0.2 c-0.1,0-0.2,0-0.3,0c-0.4-0.1-0.6-0.4-0.9-0.6c-0.1-0.1-0.2-0.2-0.3-0.3c0-0.1-0.1-0.2-0.1-0.2c0-0.1-0.1-0.2-0.1-0.4 c-0.1-0.1-0.1-0.2-0.2-0.3C13.7,17.4,13.7,17.3,13.8,17.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "M15.7,17.9c0.1,0,0.3,0,0.4,0c0.1-0.1,0.2-0.1,0.3,0c0.1,0.2,0.2,0.4,0.2,0.6c0,0.2-0.1,0.4-0.3,0.5 c-0.1,0-0.2,0-0.3,0C15.8,18.6,15.5,18.3,15.7,17.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M15.7,17.9c0,0.4,0.3,0.7,0.4,1.1c-0.1,0.2-0.2,0.3-0.4,0.2c-0.1-0.4-0.2-0.9-0.4-1.3 C15.5,17.9,15.6,17.9,15.7,17.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st444",
    d: "M16.4,17.8l-0.1,0l-0.1,0c0-0.3,0-0.6,0-0.9c0.1,0.1,0.1,0.1,0.2,0.2C16.6,17.4,16.6,17.6,16.4,17.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st301",
    d: "M16.6,14.8c0,0.5,0.1,0.9,0,1.4c-0.1,0.5-0.3,0.1-0.4-0.1C16.1,16.1,16,16,16,15.9h0c-0.1-0.1,0-0.3-0.2-0.4 c-0.2-0.3-0.3-0.5-0.2-0.9c0,0,0.1,0,0.1-0.1c0.3,0,0.6,0,0.9,0.2C16.5,14.8,16.6,14.8,16.6,14.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M14.9,13.8c0-0.1,0-0.1,0-0.2c0.2-0.4,0.5-0.6,1-0.4c0.2,0.5,0.2,1-0.3,1.4l0,0c-0.1-0.1-0.3-0.2-0.4-0.2 c0-0.1,0-0.1,0-0.2C15.1,14,15.1,13.9,14.9,13.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st430",
    d: "M15.8,15.5c0.4,0,0.3,0.2,0.2,0.4c-0.1,0-0.1,0-0.2,0C15.8,15.8,15.8,15.6,15.8,15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st445",
    d: "M16.8,14.8c-0.1,0-0.1,0-0.2,0l0,0c-0.2-0.2-0.2-0.5-0.3-0.8c0-0.1-0.1-0.3-0.2-0.4C16,13.5,16,13.3,16,13.1 c0.1-0.8,1-0.7,1.4-1c0.5-0.2,0.3,0.4,0.5,0.5c0.1,0,0.2,0.1,0.2,0.1c0.1,0.1,0.1,0.1,0.1,0.2c0.1,0.2,0.1,0.3,0.1,0.5 c0,0.1-0.1,0.2-0.2,0.2c-0.5-0.1-0.9,0-1.1,0.6c-0.1,0.2-0.1,0.4-0.2,0.5C16.9,14.8,16.9,14.8,16.8,14.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st389",
    d: "M16.8,14.2c0.4-0.8,0.7-1,1.5-0.7c0.1,0,0.2,0,0.2,0.1c0,0.1,0,0.2,0,0.3c-0.1,0.1-0.2,0.1-0.2,0.2 c-0.6,0.3-0.7,0.9-0.7,1.4c-0.4,0.4,0.2,1-0.2,1.4C17.2,17,17,17,16.8,16.8c-0.1-0.6,0.2-1.1,0.2-1.7c-0.1-0.1-0.1-0.1-0.1-0.2 C16.9,14.6,17,14.4,16.8,14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st446",
    d: "M16.4,17.8c0-0.2,0-0.4,0-0.6c0.1,0,0.2,0,0.2,0c0.5-0.1,0.8,0.1,1.1,0.4c0,0.1,0.1,0.2,0.1,0.3 c-0.2,0.4-0.5,0.9-0.5,1.4c0,0.1,0,0.3-0.1,0.4c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0-0.2-0.1-0.2-0.1c-0.1-0.1-0.1-0.3-0.1-0.4 c-0.1-0.3,0-0.6-0.2-0.8C16.4,18.3,16.4,18.1,16.4,17.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M17.7,17.6c-0.4,0-0.7-0.3-1.1-0.4c0-0.2,0-0.3,0.2-0.4c0.2,0,0.4,0,0.6,0c0.2-0.2,0.3-0.6,0.7-0.4 c0.1,0.1,0.1,0.2,0.1,0.3C18.3,17.1,18.2,17.5,17.7,17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st447",
    d: "M17,14.9c0,0.1,0,0.1,0,0.2c-0.1,0-0.2-0.1-0.2-0.2l0,0C16.9,14.7,17,14.7,17,14.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st430",
    d: "M16,15.9c0.1,0,0.2,0.1,0.2,0.2C16.1,16.1,16,16,16,15.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st250",
    d: "M15.7,13.1c-0.3,0.1-0.6,0.3-0.9,0.4c-0.1,0-0.1,0-0.2,0c0-0.1,0-0.3,0-0.4c0.2-0.1,0.3-0.2,0.4-0.4 c0.1,0,0.3,0,0.4,0c0.3,0,0.5,0.1,0.5,0.4C15.9,13.2,15.8,13.2,15.7,13.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M9.1,39.2c-0.2-0.1-0.2-0.3,0-0.4C9.1,38.9,9.1,39,9.1,39.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M46.8,44.8c0,0.2,0,0.4,0,0.6c-0.2-0.3-0.7,0.2-0.9-0.2c0.3-0.1,0.2-0.4,0.2-0.6 C46.3,44.7,46.4,45.1,46.8,44.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st224",
    d: "M22.8,22.8c-0.2,0-0.4,0.1-0.6,0.2c-0.2-0.2-0.3-0.5-0.3-0.8c0-0.2,0.1-0.3,0.2-0.4c0.3-0.2,0.6-0.2,0.8,0.1 c0.1,0.2-0.2,0.4,0,0.7C22.8,22.7,22.8,22.7,22.8,22.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st250",
    d: "M22.8,22.6c-0.8-0.2,0.2-0.4,0-0.6c0.1-0.1,0.1-0.1,0.2,0c0,0.1,0,0.3,0,0.4C23,22.4,22.9,22.5,22.8,22.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st429",
    d: "M23.1,22L23,22l-0.1,0c-0.2-0.1-0.4-0.1-0.7,0c-0.1-0.2-0.2-0.4,0.2-0.4c0.1,0,0.1,0,0.2,0 C22.9,21.5,23.1,21.7,23.1,22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st448",
    d: "M23.1,20.9c0-0.1,0-0.1,0-0.2c0.1-0.1,0.1-0.1,0.2,0l0,0c0,0.2,0.2,0.3,0.1,0.5c-0.1,0.2-0.2,0-0.4,0 C23,21,23,21,23.1,20.9C23,20.9,23,20.9,23.1,20.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M23.4,21.8C23.4,21.8,23.4,21.8,23.4,21.8c-0.1,0-0.1,0-0.1-0.1C23.4,21.6,23.4,21.6,23.4,21.8 C23.5,21.7,23.4,21.8,23.4,21.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st449",
    d: "M23.1,20.9c0,0.1,0,0.2,0,0.2c-0.1,0-0.2-0.1-0.2-0.2C22.9,20.9,23,20.9,23.1,20.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st256",
    d: "M23.3,20.4c0-0.2,0-0.4,0.2-0.4c0,0.1,0,0.1,0,0.2C23.4,20.3,23.4,20.4,23.3,20.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st256",
    d: "M23.3,20.7c-0.1,0-0.1,0-0.2,0c0-0.1,0.1-0.2,0.2-0.2C23.3,20.5,23.3,20.6,23.3,20.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M38.3,60.3c-0.5,0-1,0-1.5,0c-0.2,0.1-0.4,0.2-0.6,0.1c-0.5-0.5,0.1-0.8,0.3-1.1c0.1-0.1,0.1-0.1,0.2-0.2 c0.1-0.1,0.3-0.3,0.4-0.4c0.1-0.1,0.2-0.2,0.4-0.2c0.3-0.2,0.3,0.4,0.6,0.2c0.2,0,0.4,0.1,0.6,0.2c0,0.1,0.1,0.2,0,0.3 C38.6,59.5,38.5,59.9,38.3,60.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st450",
    d: "M36.6,60.9c0.1,0.3,0.4,0.6,0,0.9c0,0-0.1,0-0.1,0c-0.1,0-0.2-0.1-0.2-0.1c0,0-0.1-0.1-0.1-0.1 c-0.3-0.3-0.8-0.3-1.1-0.7c0-0.7,0.6-0.3,0.9-0.4c0.2,0.1,0.5-0.1,0.7,0.1C36.6,60.7,36.6,60.8,36.6,60.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st130",
    d: "M38.3,60.3c-0.3-0.5-0.2-0.9,0.4-1.1c0.2-0.1,0.3,0,0.3,0.2c-0.1,0.3,0.3,0.7,0,1c0,0-0.1,0.1-0.1,0.1 C38.8,60.4,38.6,60.3,38.3,60.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "M40.1,60.9c0,0.1,0,0.1,0,0.2c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0-0.2,0-0.2,0c-0.1,0-0.2-0.1-0.3-0.2 c-0.1-0.1-0.1-0.1-0.2-0.2c0-0.1,0-0.3,0-0.4l0,0c0.2-0.1,0.3,0.1,0.4,0.2C39.7,60.7,39.9,60.6,40.1,60.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st317",
    d: "M39,60.9c0.1,0,0.1,0,0.2,0c0.1,0.1,0.1,0.1,0.2,0.2c0.1,0,0.1,0,0.2,0c0.1,0.4-0.3,0.2-0.4,0.4 c-0.1,0-0.3,0-0.4,0C38.5,61.2,39,61.2,39,60.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st327",
    d: "M36.6,60.5c-0.2-0.1-0.4,0.1-0.6,0.2c-0.2-0.2-0.1-0.4,0.2-0.4c0.2,0,0.4,0,0.7,0 C36.8,60.4,36.7,60.4,36.6,60.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st334",
    d: "M39.2,61.6c0.1-0.1,0.3-0.3,0.4-0.4c0.1,0,0.3,0,0.4,0c0.1,0,0.2,0.1,0.2,0.2C39.9,61.4,39.6,61.7,39.2,61.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st334",
    d: "M40.3,61.4c0.1,0,0.2,0.1,0.2,0.2C40.4,61.5,40.4,61.4,40.3,61.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st451",
    d: "M36.2,62.2c-0.1,0-0.1,0-0.2,0c0,0-0.1-0.1-0.1-0.1c0-0.4,0.1-0.6,0.5-0.5l0,0c0.1,0.1,0.1,0.2,0.2,0.2l0,0 c0,0.1,0,0.1,0,0.2C36.5,62.2,36.3,62.1,36.2,62.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st452",
    d: "M36.2,62.2c0.1-0.2,0.3-0.2,0.4-0.2c0.1,0.1,0.1,0.1,0.2,0.2c0,0.1,0,0.1,0,0.2 C36.6,62.3,36.4,62.2,36.2,62.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st260",
    d: "M37.5,61.4c0.2,0.1,0.2,0.3,0,0.4C37.5,61.6,37.5,61.5,37.5,61.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st453",
    d: "M36,62.5c-0.2,0-0.4,0-0.6,0c-0.2-0.1-0.5-0.1-0.5-0.5c0.6-1,0.8-0.1,1.2,0.2l0,0C36,62.3,36,62.4,36,62.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M33.4,47.1c0.1-0.1,0.1-0.1,0.2-0.2C33.6,47,33.5,47.1,33.4,47.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st454",
    d: "M47,46.5c0.1,0,0.1,0,0.2,0c0,0.1,0,0.2,0,0.2c0,0.2,0,0.4,0,0.6c-0.3-0.1-0.4-0.3-0.4-0.7 c0-0.1,0-0.1,0-0.2C46.8,46.5,46.9,46.5,47,46.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st455",
    d: "M47.6,47.8c0-0.1,0-0.2,0-0.2c0.1,0,0.1,0,0.2,0C47.8,47.7,47.7,47.7,47.6,47.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st456",
    d: "M17.7,23.5c0,0.4-0.4,0.3-0.6,0.5c-0.1-0.2-0.2-0.4-0.1-0.6c0.1-0.3-0.1-0.4-0.4-0.6c-0.5-0.3-1-0.7-1.3-1.2 c0,0,0.1,0,0.1-0.1c0.6,0,0.3-0.3,0.2-0.5c-0.1-0.5,0.2-0.8,0.6-1.1c0,0,0.1-0.1,0.1-0.1c0.1,0,0.2-0.1,0.3-0.1 c0.1,0,0.2,0.1,0.3,0.1l0,0c0.4,0.5,0.5,1.1,0.4,1.7c-0.1,0.1-0.1,0.2-0.2,0.3c0,0-0.1,0-0.1,0c-0.1,0.1,0,0.1,0,0 c0.1,0,0.1,0,0.2,0.1c0.1,0.1,0.2,0.2,0.3,0.4c0.1,0.1,0.2,0.3,0.3,0.4c0.1,0.1,0.1,0.2,0.2,0.4C17.8,23.2,17.8,23.4,17.7,23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st457",
    d: "M18.5,26.5c0-0.1,0-0.3,0-0.4c0.2-0.2,0-0.5,0.2-0.7c0.1-0.1,0.2-0.1,0.2-0.1c0.4,0,0.7,0,1.1,0.1 c0.2,0.1,0.2,0.3,0.3,0.5c0.1,0.2,0.2,0.5,0,0.7c-0.6,0.4-1.2,0.3-1.8,0C18.6,26.5,18.6,26.5,18.5,26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st88",
    d: "M15.5,26c0-0.1,0-0.1,0-0.2c0-0.1,0-0.3,0-0.4c0.2,0,0.4,0,0.7,0c0.3-0.1-0.1-0.5,0.2-0.7 c0.6,0.2,0.9,0.7,0.9,1.3c-0.4-0.2-0.7,0-1.1,0.1C15.9,26.2,15.7,26.3,15.5,26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st458",
    d: "M17.9,29.1c-0.1-0.5-0.5-1-0.2-1.5c0.1-0.2,0.3-0.3,0.5-0.3c0.1,0,0.2,0.1,0.2,0.2c0.2,0.6,0.1,1.2,0.4,1.8 c0,0.3-0.2,0.5-0.5,0.5C17.9,29.7,17.8,29.4,17.9,29.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st459",
    d: "M16.8,30.1c-0.1-0.5-0.2-1-0.8-1.2c-0.2-0.1-0.2-0.1,0.2-0.7c0.2,0.4,0.7,0.5,0.9,0.9c0.3,0.3,0.7,0.5,0.5,1 c-0.2,0.2-0.4,0.2-0.6,0.1C16.9,30.2,16.9,30.2,16.8,30.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st364",
    d: "M17.5,30.1c0.1-0.4-0.5-0.6-0.4-1.1c0.3,0,0.6,0,0.8,0c0.2,0.2,0.2,0.5,0.4,0.7c0.3,0.1,0.6,0.3,0.5,0.7 c-0.2,0.2-0.5,0.2-0.7,0.1c-0.2,0-0.4-0.1-0.5-0.3C17.5,30.2,17.5,30.2,17.5,30.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st364",
    d: "M18.8,25.4c0.2,0.3,0.1,0.5-0.2,0.7c0.1-0.6-0.7-0.6-0.9-1.1c0,0,0.1-0.1,0.1-0.1c0.1,0,0.1,0,0.1-0.1 c0,0,0-0.1-0.1-0.1c0-0.1,0-0.1,0.1-0.2c0.1-0.1,0.2-0.1,0.2-0.2c0.1-0.1,0.2-0.1,0.3-0.1C18.9,24.5,19.1,24.9,18.8,25.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st446",
    d: "M17.7,23c-0.1-0.1-0.1-0.1-0.2-0.2c0.3-0.3-0.1-0.4-0.2-0.6c-0.1-0.1-0.1-0.2,0-0.3c0.2-0.3,0.5-0.3,0.8-0.2 c0.1,0.1,0.2,0.1,0.2,0.2c0.2,0.2,0.3,0.5,0.3,0.7c0,0.3,0.1,0.6,0,0.9c0,0.1-0.1,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0 c-0.1-0.1-0.1-0.3-0.2-0.4C17.9,23.3,17.8,23.1,17.7,23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st96",
    d: "M16.4,24.7c0,0.2,0,0.3,0.2,0.5c0.1,0.1,0.3,0.2,0.1,0.3c-0.2,0.1-0.3,0-0.4-0.2c-0.2-0.3,0-0.6,0-0.9 C16.3,24.6,16.4,24.6,16.4,24.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st460",
    d: "M15.1,21.5c-0.1-0.2-0.3-0.4-0.4-0.6c-0.1-0.1-0.1-0.2,0-0.3c0.3-0.2,0.6,0,0.9,0.2c0.1,0.3,0,0.5-0.2,0.7 l0,0C15.2,21.5,15.2,21.5,15.1,21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st224",
    d: "M15.9,22.9c0.4,0,0.5,0.2,0.6,0.5c0,0.1-0.1,0.2-0.2,0.2C16,23.5,15.9,23.2,15.9,22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st461",
    d: "M18.1,27.3c-0.1,0.2-0.2,0.2-0.4,0.2c-0.1-0.2-0.2-0.4-0.2-0.6c0.1-0.1,0.1-0.1,0.2-0.1 c0.2,0,0.4,0.1,0.5,0.3C18.2,27.2,18.2,27.3,18.1,27.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st461",
    d: "M17.7,26.9c-0.1,0-0.1,0-0.2,0c0-0.4,0-0.9,0.6-0.4c0,0,0,0.1,0,0.1C18,26.7,17.8,26.8,17.7,26.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st462",
    d: "M17.7,25c-0.1,0-0.3,0-0.3-0.2c0-0.3,0.2-0.2,0.4-0.3c0.1,0.1,0.1,0.1,0.1,0.2C17.8,24.8,17.8,24.9,17.7,25 L17.7,25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st442",
    d: "M17.7,23c0.3,0,0.6,0.1,0.2,0.4c-0.1,0-0.1,0-0.2,0C17.7,23.3,17.7,23.2,17.7,23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st135",
    d: "M18.1,23.9c0.1,0,0.1,0,0.2,0c0.1,0.1,0.1,0.1,0.1,0.2c0,0.1,0,0.2-0.1,0.2c-0.1,0-0.2,0-0.2,0 C17.8,24.2,18.1,24,18.1,23.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st411",
    d: "M18.1,26.5c0.1,0,0.3,0,0.4,0l0,0c0.1,0.1,0,0.2,0,0.2c-0.1,0.1-0.2,0.1-0.3,0.1 C18.1,26.7,18,26.6,18.1,26.5L18.1,26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st96",
    d: "M16.2,24.5c-0.1,0-0.2-0.1-0.2-0.2C16.1,24.4,16.1,24.4,16.2,24.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st463",
    d: "M17.7,24.7c0-0.1,0-0.1,0-0.2c0.1,0,0.1,0,0.2,0c0,0.1,0,0.1,0,0.2C17.8,24.8,17.8,24.8,17.7,24.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st464",
    d: "M13.4,20.9c0.1-0.1,0.3-0.3,0.4-0.4c0,0,0.1-0.1,0.1-0.1c0.1,0,0.2,0,0.2,0.1c0.1,0.1,0.1,0.1,0.1,0.2 c-0.2,0.4,0.5,0.6,0.2,1.1c-0.3,0-0.6,0-0.9,0C13.7,21.4,14.1,21,13.4,20.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.5,22.8c0.1-0.3-0.2-0.8,0.4-0.9c0.1,0,0.3,0,0.4,0c0,0.1,0,0.2,0,0.2c0.1,0,0.1,0.1,0.1,0.1 c0,0,0,0.1-0.1,0.1C13,22.3,12.8,22.7,12.5,22.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st313",
    d: "M13.4,22.4c0-0.1,0-0.1,0-0.2c0.3,0.3,0.2,0.6,0.1,1C13.3,22.9,13.4,22.6,13.4,22.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st262",
    d: "M14.2,20.7c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1-0.1-0.1-0.1-0.1-0.2c0-0.1,0-0.1,0-0.1c0.1,0,0.2-0.1,0.3-0.1 c0.2,0.1,0.5,0.2,0.4,0.5c0,0.1,0,0.1,0,0.2C14.5,20.8,14.4,20.7,14.2,20.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st465",
    d: "M44.9,50.2c-0.2,0.4-0.7,0.3-0.9,0.6l0,0c-0.2,0.2-0.3,0.2-0.6,0.1c-0.1,0-0.2-0.1-0.2-0.2 c0-0.2,0-0.4,0.1-0.5c0.1-0.1,0.1-0.1,0.2-0.2c0.1-0.1,0.3-0.1,0.4-0.1c0.2-0.1,0.4-0.2,0.6,0C44.7,50,44.8,50.1,44.9,50.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st466",
    d: "M44,50c0,0.1-0.1,0.2-0.2,0.2c-0.1-0.1-0.3-0.2-0.4-0.3c-0.1-0.1-0.2-0.2-0.2-0.3c0-0.1,0-0.3,0-0.4 c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.3-0.1,0.4,0.1c0,0.2,0,0.3,0.2,0.4C44,49.5,44,49.7,44,50z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st467",
    d: "M44.9,50.2c-0.1-0.1-0.2-0.2-0.3-0.3l0,0c0.1-0.1,0.1-0.1,0.2-0.2c0.1-0.1,0.2-0.2,0.3-0.2 c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0.1,0.2,0.2c-0.1,0.1-0.2,0.1-0.2,0.2c-0.1,0-0.1,0.1-0.1,0.2c0,0-0.1,0.1-0.1,0.1 C45,50.2,44.9,50.2,44.9,50.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st465",
    d: "M44.8,49.8c-0.1,0.1-0.1,0.1-0.2,0.2C44.6,49.8,44.7,49.8,44.8,49.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st468",
    d: "M43.3,48.9c0,0.1,0,0.1,0,0.2c-0.1,0.2-0.3,0.4-0.5,0.1c-0.2-0.4-0.1-0.7,0.1-1c0-0.1,0-0.1,0-0.2 c0.1-0.1,0.3-0.1,0.4,0l0,0c0,0.2,0,0.4,0,0.6C43.4,48.7,43.4,48.8,43.3,48.9C43.4,48.8,43.3,48.9,43.3,48.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st88",
    d: "M43.3,48.9c0-0.1,0-0.1,0-0.2c0.2-0.1,0.4-0.2,0.4,0.2C43.6,48.9,43.5,48.9,43.3,48.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st469",
    d: "M43.3,48c-0.1,0-0.3,0-0.4,0c0.1-0.3,0.2-0.6,0.2-0.9c0.1,0,0.1,0,0.2,0c0,0.1,0,0.3,0,0.4 c0.1,0,0.1,0.1,0.1,0.1c0,0,0,0.1-0.1,0.1C43.3,47.9,43.3,47.9,43.3,48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M43.3,47.8c0-0.1,0-0.1,0-0.2c0.2,0,0.3,0,0.4,0.2C43.6,47.8,43.5,47.8,43.3,47.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st470",
    d: "M46.5,46.7c-0.1,0.2-0.3,0.2-0.4,0.2c0-0.2-0.1-0.5,0.2-0.6C46.5,46.3,46.5,46.6,46.5,46.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st471",
    d: "M22,56.9c0.3,0,0.2,0.3,0.3,0.4c0,0.1,0,0.1,0,0.2c-0.1,0-0.1,0-0.2,0c-0.1,0.1-0.1,0.1-0.2,0 C22,57.3,22,57.1,22,56.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M23.3,58.8c0,0.1,0,0.1,0,0.2c-0.1-0.1-0.1-0.1-0.2-0.2C23.1,58.8,23.2,58.8,23.3,58.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st472",
    d: "M44.4,51.9c0.1-0.2,0.2-0.5,0.4-0.6c0.2,0.1,0.3,0.2,0.2,0.4c-0.1,0.1-0.1,0.3-0.2,0.4c-0.1,0-0.1,0-0.2,0 C44.5,52,44.5,52,44.4,51.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st473",
    d: "M45,51.7c-0.1-0.1-0.1-0.3-0.2-0.4c0.2-0.3,0.4-0.3,0.7,0C45.4,51.5,45.2,51.6,45,51.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st474",
    d: "M44.8,54.5c-0.1,0-0.1,0-0.2,0c-0.3,0-0.6,0-0.9,0c-0.2-0.3-0.6-0.3-0.9-0.4c-0.1,0-0.3,0-0.4,0 c-0.1,0-0.1-0.1-0.1-0.2c0-0.1,0-0.1,0-0.1c0.2-0.3,0-0.4-0.2-0.5c-0.1-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.2,0-0.3 c0.2-0.2,0.3-0.5,0.5-0.7c0.5,0.1,0.6,0.6,1,0.9c0.1,0.2,0.1,0.5,0.3,0.6c0,0.1,0.1,0.2,0.2,0.2c0.3,0,0.5,0.2,0.6,0.4 C44.8,54.3,44.8,54.4,44.8,54.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st475",
    d: "M43.5,53.2c-0.3-0.4-0.6-0.7-0.9-1.1c0.1-0.3-0.5-0.5-0.3-0.9c0-0.1,0.1-0.2,0.2-0.2c0,0,0.1-0.1,0.1-0.1 c0.1,0,0.2-0.1,0.3-0.1c0.2,0,0.3,0,0.4,0.1c0.2,0.1,0.3,0.2,0.3,0.4c0,0.1-0.3,0.2-0.2,0.4c0,0.1,0,0.2-0.1,0.2 c-0.1,0.2,0,0.4,0.2,0.6c0.1,0.1,0.3,0.1,0.4,0.2c0,0.1,0,0.1,0,0.2C43.8,53.1,43.8,53.3,43.5,53.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st424",
    d: "M44.8,54.3c-0.2-0.1-0.5-0.2-0.6-0.4c0.1-0.4,0.2-0.5,0.5-0.2C44.9,53.8,44.8,54,44.8,54.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st476",
    d: "M43.5,53.2c0.1-0.1,0.3-0.1,0.4-0.2c0,0.2,0,0.4,0,0.7C43.7,53.5,43.6,53.4,43.5,53.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st477",
    d: "M43.3,51.9c0-0.1,0-0.1,0-0.2c0-0.1,0.1-0.2,0.2-0.2c0-0.2,0-0.4-0.2-0.4c0,0-0.1-0.1,0-0.1 c0,0,0-0.1,0.1-0.1c0.2,0,0.4,0,0.6,0c0,0.1,0,0.1,0,0.2c0.1,0.1,0.1,0.3,0,0.4c0,0.1,0,0.1,0,0.2c-0.1,0.1-0.3,0.1-0.4,0.2 C43.4,52,43.4,52,43.3,51.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st478",
    d: "M43.3,51.9c0.1,0,0.1,0,0.2,0c0,0.2,0,0.4,0,0.6C43.1,52.4,42.9,52.2,43.3,51.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M22.4,21.5c-0.2,0.1-0.2,0.3-0.2,0.4c-0.1,0-0.2,0.1-0.2,0.2c0.1,0.3-0.1,0.5-0.4,0.5 c-0.2-0.1-0.3-0.4-0.5-0.6c-0.2-0.3-0.3-0.6-0.1-0.9c0,0,0.1-0.1,0.1-0.1c0.1,0,0.1,0,0.2,0c0.2,0.3,0.5,0.2,0.7,0.2 C22.3,21.2,22.4,21.3,22.4,21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st479",
    d: "M20.5,19.6c0.1,0.2,0.2,0.4,0.4,0.4c0.1,0.2,0.1,0.4,0.2,0.6c-0.1,0.1-0.1,0.1-0.2,0.2 c-0.1,0.1-0.1,0.1-0.2,0.1c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.3,0c-0.1-0.1-0.2-0.1-0.3-0.3c-0.1-0.1-0.1-0.2-0.1-0.2 c0-0.1-0.1-0.2-0.1-0.3c-0.1-0.2-0.1-0.5,0-0.7c0.1-0.2,0.1-0.4,0.3-0.4C20.4,19.1,20.3,19.5,20.5,19.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st325",
    d: "M23.5,19.4c-0.1,0.5-0.3,0.6-0.6,0.2C23,19.3,23.3,19.4,23.5,19.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st321",
    d: "M22.2,19.8c0.3,0.2-0.1,0.4,0,0.6c-0.2,0-0.4,0-0.4-0.2C21.8,20,22,19.9,22.2,19.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st480",
    d: "M20.9,20.7c0.1,0,0.1,0,0.2,0c0,0.1,0,0.3,0,0.4l0,0c-0.2,0.1,0,0.5-0.3,0.5c-0.3-0.2-0.3-0.4-0.1-0.7l0,0 C20.8,20.8,20.8,20.7,20.9,20.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st315",
    d: "M19.6,17.9c0.1,0,0.1,0,0.2,0c0,0.1,0,0.1,0,0.2c0,0,0,0,0,0C19.6,18.1,19.6,18,19.6,17.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st262",
    d: "M20.5,19.6c-0.2-0.1-0.4-0.6-0.5,0c0,0.3,0.1,0.6,0.1,0.8c-0.7,0.3-0.6-0.4-0.9-0.7 c-0.1-0.1-0.2-0.2-0.2-0.4c0-0.1,0-0.2,0-0.3c0.1-0.3,0.3-0.4,0.6-0.5c0.1,0,0.3,0.1,0.4,0.1c0.1,0.1,0.3,0.1,0.3,0.2 c0.2,0.1,0.2,0.3,0.2,0.4C20.5,19.4,20.5,19.5,20.5,19.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st435",
    d: "M19.8,18.9c-0.1-0.1-0.1-0.1-0.2-0.2c-0.2-0.1-0.3-0.2-0.4-0.5c0-0.2,0.1-0.4,0.4-0.4l0,0 c0.1,0.1,0.1,0.1,0.2,0.2c0,0.1,0,0.3,0,0.4C20,18.6,20,18.8,19.8,18.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M19.8,18.9c0-0.1,0-0.3,0-0.4c0.1,0.1,0.3,0.1,0.4,0.2c0,0.1,0,0.1,0,0.2C20.1,18.9,20,18.9,19.8,18.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st481",
    d: "M5,29.3c0.1,0.1,0.1,0.1,0.2,0.2l-0.1,0l-0.1,0C5,29.4,5,29.3,5,29.3L5,29.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st482",
    d: "M5.8,29.5c-0.2-0.3-0.3-0.5-0.2-0.9c0-0.2,0.2-0.3,0.3-0.3c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0,0.2,0.1 c0,0.1-0.1,0.1,0,0.1c0.1,0,0.1-0.1,0.1-0.2c0-0.1,0.1-0.1,0.2-0.2c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0.1,0.2,0.1 c0.1,0.1,0.1,0.2,0.2,0.4c0.1,0.2,0.2,0.4,0.3,0.6c0.1,0.1,0.1,0.2,0.1,0.2c0,0,0,0.1-0.1,0.1c-0.1,0-0.1,0-0.2,0 c-0.5,0-0.8,0.6-1.3,0.4C6.2,29.7,6,29.6,5.8,29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st294",
    d: "M8.2,30.4c-0.1,0.1-0.3,0.3-0.4,0.4c-0.5-0.4,0-0.9,0-1.3l0,0c0.1-0.2,0.3-0.2,0.5-0.2c0.1,0,0.2,0,0.3,0.1 c0.1,0.1,0.2,0.2,0.2,0.3c0,0.1,0,0.2-0.1,0.2C8.6,30,8.6,30,8.5,30c-0.1,0-0.1,0-0.2,0.1C8.2,30.2,8.2,30.3,8.2,30.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st483",
    d: "M17.7,7.9c0.5-0.2,1,0.3,1.5,0.2c0,0.1,0,0.1,0,0.2c0,0-0.1,0.1-0.1,0.1c0,0.3-0.3,0.7,0.1,1 c-0.1,0.3-0.5,0.5-0.4,0.9l0,0c-0.1,0-0.1,0-0.2,0c0,0-0.1-0.1-0.1-0.1c0-0.1-0.1-0.1-0.1-0.2c0-0.1-0.1-0.1-0.1-0.2 c0-0.1-0.1-0.1-0.1-0.2c0-0.1,0-0.2-0.1-0.3c0-0.2-0.1-0.3-0.2-0.4C17.8,8.6,17.5,8.3,17.7,7.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st484",
    d: "M19.2,9.5c-0.7-0.3-0.2-0.7,0-1.1c0,0.3,0,0.7,0.4,0.6c0,0.1,0,0.1,0,0.2c-0.1,0.1-0.1,0.1-0.2,0.2 C19.3,9.5,19.3,9.5,19.2,9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st485",
    d: "M16,9.5c0-0.2-0.4-0.4,0-0.6c0.5,0.1,0.8,0.3,1,0.8c0,0.1,0,0.2,0,0.3c-0.1,0.2-0.3,0.1-0.5,0.2l0,0 C16.1,10,16.1,9.7,16,9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st486",
    d: "M16.4,10.1c0.1-0.2,0.2-0.2,0.4-0.2c0.4-0.3,0.5,0.1,0.7,0.3c0.2,0.3,0.3,0.7,0.6,1c0.1,0.2,0.1,0.3,0.2,0.5 c0.2,0.4,0.2,0.7-0.3,0.9c-0.1,0.2-0.2,0.1-0.2-0.1c0-0.2,0-0.4-0.2-0.5c0,0-0.1,0-0.1-0.1c-0.1-0.1-0.1-0.1-0.2-0.2 c-0.1-0.1-0.2-0.2-0.3-0.4c-0.1-0.1-0.1-0.3-0.3-0.5C16.6,10.7,16.7,10.3,16.4,10.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M16.6,11c0.2,0.1,0.4,0.2,0.4,0.4c-0.1,0.1-0.3,0.1-0.4,0c-0.1,0-0.1-0.1-0.1-0.2c0-0.1,0-0.1,0-0.1 C16.6,11.1,16.6,11,16.6,11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st487",
    d: "M16.6,11.2c0,0.1,0,0.1,0,0.2c0,0-0.1,0.1-0.1,0.1c-0.1,0-0.2,0-0.2,0c0,0-0.1-0.1-0.1-0.1 c0-0.1,0-0.1,0-0.2C16.3,11.2,16.5,11.2,16.6,11.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "M16,13.1c-0.1-0.1-0.3-0.3-0.4-0.4c0-0.2,0-0.4,0-0.7c0.3-0.1,0.1-0.7,0.6-0.6l0,0c0.1,0.1,0.1,0.1,0.2,0.2 c0.1,0.1,0.3,0.2,0.4,0.3c0.2,0.1,0.3,0.1,0.5,0.1c0.1,0,0.2,0.1,0.2,0.1l0,0c0,0.2,0.1,0.7-0.3,0.6c-0.6-0.2-0.7,0.2-1,0.5 C16.1,13.2,16,13.2,16,13.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M14.9,32.7c0-0.1,0-0.1,0-0.2c0-0.2,0.2-0.3,0.3-0.5c0.6-0.3,0.9-1,1.6-1.1c0.4,0.1,0.4,0.5,0.5,0.8 c0,0.1,0,0.2,0,0.3c-0.1,0.3-0.3,0.5-0.7,0.5c-0.1,0-0.2,0-0.3,0.1c0,0.1-0.1,0.1-0.2,0.1c-0.1,0-0.1,0-0.2,0 c-0.1,0-0.2-0.1-0.2,0.1c-0.1,0.3-0.4,0.2-0.6,0.2C15,33,14.9,32.9,14.9,32.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st488",
    d: "M17.5,33.4c-0.2,0.2-0.4-0.1-0.7,0c-0.1-0.1-0.2-0.1-0.2,0l0,0c-0.1-0.1-0.3-0.1-0.4-0.2 c-0.1-0.1,0-0.2,0-0.3c0.4-0.2,0.7-0.1,1,0c0,0,0.1,0.1,0.1,0.1c0,0,0.1,0.1,0.1,0.1C17.5,33.2,17.5,33.3,17.5,33.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st489",
    d: "M14.9,32.7c0.2,0.1,0.2,0.3,0.2,0.4c-0.1,0-0.2,0-0.2,0C14.9,33,14.6,32.8,14.9,32.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st490",
    d: "M15.7,32.9c-0.2-0.4,0.1-0.2,0.2-0.2c0,0,0.1,0.1,0.1,0.1c0,0,0,0.1-0.1,0.1C15.9,33,15.8,32.9,15.7,32.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M16.2,32.9c0,0.1,0,0.1,0,0.2c-0.1,0-0.2-0.1-0.2-0.2l0,0c0,0,0.1-0.1,0.1-0.1C16.1,32.9,16.1,32.9,16.2,32.9 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st362",
    d: "M17,34.2c0,0.2,0,0.3-0.2,0.4C16.7,34.4,16.6,34.2,17,34.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M16.2,34.9c-0.1-0.1-0.1-0.1-0.2-0.2C16.1,34.7,16.1,34.8,16.2,34.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st491",
    d: "M14.7,32.3c-0.1,0-0.1,0-0.2,0c-0.1,0.1-0.3,0.2-0.4,0.1c-0.2-0.1-0.3-0.1-0.3-0.3c0.1-0.1,0.2-0.2,0.3-0.3 c0.4-0.2,0.3-0.4,0.1-0.7c0-0.1,0-0.3,0.1-0.4c0.1-0.2,0.2-0.3,0.4-0.4l0,0c0.1-0.1,0.2-0.1,0.3,0c0.2,0.1,0.3,0.3,0.3,0.5 c0,0.2,0.1,0.3,0.1,0.5c0,0.3,0,0.5-0.1,0.8C15.1,32.2,14.9,32.3,14.7,32.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M14,32.3c0.1,0,0.3,0,0.4,0c0,0.1,0,0.1,0,0.2c0,0-0.1,0.1-0.1,0.1c0,0,0,0.1,0,0.1c-0.2,0.3-0.4,0.3-0.6,0 C13.7,32.5,13.8,32.4,14,32.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st492",
    d: "M14,32.3c-0.1,0.1-0.2,0.3-0.2,0.4c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1-0.1-0.2-0.2l0,0c0-0.1,0-0.3,0-0.4l0-0.1 c0.2-0.1,0.3-0.1,0.4,0.1C13.9,32.2,14,32.2,14,32.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st493",
    d: "M14.7,32.3c0.1-0.2,0.3-0.2,0.4-0.2c0.1-0.1,0.2-0.1,0.2,0c0,0.1,0,0.2-0.1,0.2c-0.1,0.1-0.3,0.2-0.4,0.2 C14.8,32.4,14.7,32.4,14.7,32.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st494",
    d: "M13.4,32.5c0.1,0,0.2,0.1,0.2,0.2c0,0.1,0,0.3,0,0.4c-0.1,0.1-0.1,0.1-0.2,0.2c-0.2,0.1-0.2,0-0.3-0.2 c0.1-0.2,0.2-0.3,0.3-0.5C13.4,32.6,13.4,32.6,13.4,32.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st495",
    d: "M14.4,32.7c-0.1,0-0.1-0.1-0.1-0.1c0,0,0.1,0,0.1,0C14.4,32.6,14.4,32.6,14.4,32.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st336",
    d: "M13.2,33.2c0.1,0.1,0.2,0.1,0.2,0.2c-0.1,0.3-0.2,0.6-0.2,0.9c-0.1-0.1-0.3-0.3-0.4-0.4 C12.7,33.5,12.7,33.1,13.2,33.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M24.8,46.1c-0.5,0-0.4-0.3-0.4-0.6c-0.1-0.2,0-0.2,0.1-0.3c0.1,0,0.1,0.2,0.2,0.1c0-0.1-0.1,0-0.2-0.1 c0-0.1,0-0.2,0.1-0.3c0.1-0.1,0.2-0.1,0.3-0.1c0.2,0,0.3,0,0.5,0c0.3,0,0.6,0.1,0.8,0.5c-0.1,0.5-0.7,0.3-0.9,0.6 C25.1,46,25,46.2,24.8,46.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st496",
    d: "M26.1,45.2c-0.3-0.2-0.5-0.3-0.8-0.2c-0.3-0.4,0-0.6,0.3-0.8c0.2-0.1,0.4-0.1,0.6,0c0,0,0.1,0.1,0.1,0.1 c0,0.3,0.2,0.6,0,0.8C26.2,45.2,26.2,45.2,26.1,45.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M25.6,46.9c-0.2-0.3-0.5-0.4-0.9-0.4c0-0.1,0-0.1,0-0.2c0.1-0.1,0.3-0.2,0.5-0.1c0.2,0.1,0.4,0.2,0.6,0.2 c0,0,0.1,0,0.1,0c0.2,0,0.5,0,0.5,0.3c0,0.3-0.3,0.3-0.4,0.3C26,46.9,25.8,46.9,25.6,46.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st199",
    d: "M25.4,46.3c-0.2,0-0.4,0-0.6,0c0-0.1,0-0.1,0-0.2c0.1-0.1,0.3-0.1,0.4-0.2c0.3,0.2,0.7,0.1,0.9,0.4l0,0 C25.9,46.4,25.6,46.4,25.4,46.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st496",
    d: "M26.7,45.2c0.1-0.2,0.1-0.2,0.2,0C26.9,45.2,26.8,45.2,26.7,45.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st496",
    d: "M26.7,43.9c0.1,0,0.1,0,0.2,0c0,0.1,0,0.3,0,0.4c-0.1,0.1-0.3,0.1-0.4,0l-0.1,0l-0.1,0l0,0 c-0.1,0-0.1-0.1-0.1-0.1c0-0.1,0-0.1,0-0.1C26.4,44,26.5,43.9,26.7,43.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st446",
    d: "M26.5,44.4c0.1,0,0.3,0,0.4,0C26.8,44.6,26.7,44.6,26.5,44.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st284",
    d: "M44,51.5c0-0.1,0-0.3,0-0.4C44.2,51.2,44.2,51.3,44,51.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st379",
    d: "M44.8,50.8c0.1-0.2,0.2-0.2,0.2,0C45,50.8,44.9,50.8,44.8,50.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st497",
    d: "M45.5,50.2c0.2,0,0.4,0,0.6,0c-0.1,0.3-0.4,0.2-0.6,0.2C45.4,50.3,45.4,50.3,45.5,50.2 C45.4,50.2,45.4,50.2,45.5,50.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st498",
    d: "M45.5,50.2c0,0.1,0,0.1,0,0.2c-0.2,0-0.3,0-0.4-0.2l0,0c0.1-0.1,0.1-0.1,0.2,0 C45.3,50.2,45.4,50.2,45.5,50.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st415",
    d: "M31.9,62.6c-0.2-0.3-0.2-0.7-0.2-1c0.3,0,0.8-0.9,0.8,0.2c0.1,0,0.1,0.1,0.1,0.1c0,0,0,0.1-0.1,0.1 c0,0.2,0,0.4,0,0.7C32.3,62.8,32.1,62.8,31.9,62.6L31.9,62.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M33.9,60.7c-0.4-0.1-0.8,0-1.2,0.2c-0.1,0-0.2,0-0.2-0.1c0-0.1,0.1-0.2,0.3-0.3c0.3-0.3,0.3-0.9,0.9-0.9 c0.3,0.2,0.4,0.5,0.5,0.9C34.1,60.6,34.1,60.7,33.9,60.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st499",
    d: "M33.9,60.7c0.1-0.1,0.2-0.1,0.1-0.3c-0.1-0.3,0.1-0.3,0.3-0.3c0.1,0,0.2,0.1,0.3,0.1 c0.1,0.1,0.1,0.1,0.2,0.2c0,0.1,0,0.2,0,0.3c0,0,0,0.1,0,0.1c0,0.1-0.1,0.1-0.2,0.2c-0.1,0.1-0.2,0.2-0.2,0.3 c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.1,0.1-0.2,0.1c-0.1,0-0.2,0-0.2-0.1c-0.1-0.1-0.1-0.2-0.1-0.3c0,0,0-0.1,0-0.1 C33.7,61.2,33.9,61,33.9,60.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M33.6,59.6c-0.3,0.3-0.4,0.7-0.9,0.9c0-0.1,0-0.3,0-0.4c-0.1-0.3,0-0.6,0.2-0.9c0.3-0.2,0.5-0.1,0.7,0.2 C33.6,59.4,33.6,59.5,33.6,59.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st389",
    d: "M31.7,61.6c-0.2,0-0.4,0-0.6,0c-0.5-0.1-0.4-0.4-0.2-0.6l0,0c0.2,0.2,0.5,0.5,0.8,0.2 C31.7,61.3,31.7,61.4,31.7,61.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M33,59.2c0,0.3-0.1,0.6-0.2,0.8c-0.3-0.1-0.2-0.4-0.2-0.6c0.1-0.1,0.1-0.1,0.1-0.2c0,0,0.1-0.1,0.1-0.1 C32.9,59.1,32.9,59.1,33,59.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st500",
    d: "M33,62.6c0-0.3,0.2-0.5,0.4-0.7c0.1,0.1,0.1,0.1,0.1,0.2c0,0.3-0.1,0.5-0.3,0.7c-0.1,0-0.2,0.1-0.3,0 C32.9,62.8,32.9,62.7,33,62.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st501",
    d: "M33.4,62.2c0-0.1,0-0.2,0-0.3c0-0.2-0.1-0.5,0.2-0.6l0,0c0.1,0.1,0.1,0.3,0.2,0.4l0.1,0.1 C33.9,62.1,33.7,62.3,33.4,62.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st502",
    d: "M33,62.6c0,0.1,0,0.1,0,0.2c0.1,0.2,0.1,0.3,0,0.5c-0.2,0.1-0.3,0.1-0.5,0c0-0.1,0-0.2,0-0.2 c0-0.1,0.1-0.2,0.2-0.2C32.8,62.8,32.9,62.7,33,62.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st464",
    d: "M32.5,62c0-0.1,0-0.1,0-0.2c0.1,0,0.3-0.2,0.3,0C33,62,32.7,62,32.5,62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st503",
    d: "M31.9,62.7c0.2,0,0.4,0,0.6,0c0,0.1,0,0.1,0,0.2c0,0-0.1,0-0.1,0.1c0,0-0.1-0.1-0.1-0.1 C32.2,62.9,32,62.9,31.9,62.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M32.5,59c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0.1,0.1,0.1c0,0,0,0.1-0.1,0.1l0,0c-0.1,0.1-0.1,0.1-0.2,0 C32.5,59.1,32.5,59.1,32.5,59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st178",
    d: "M32.5,59.2c0.1,0,0.1,0,0.2,0c-0.1,0.1-0.1,0.1-0.2,0.2C32.5,59.4,32.5,59.3,32.5,59.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st178",
    d: "M32.3,59.7c-0.1,0-0.1,0-0.2,0C32.2,59.5,32.3,59.5,32.3,59.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M31.9,60.3c0.1-0.1,0.1-0.1,0.2-0.2C32.1,60.2,32,60.3,31.9,60.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st504",
    d: "M32.8,62.9c0,0.1-0.1,0.2-0.2,0.2l0,0c-0.1-0.1,0-0.2,0-0.2l0,0C32.6,62.9,32.7,62.9,32.8,62.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M32.1,58.1c0.2,0,0.5-0.1,0.6,0.1c0.1,0.3-0.2,0.2-0.3,0.3C32.3,58.4,32.2,58.3,32.1,58.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M30.8,60.7c-0.1,0-0.2-0.1-0.2-0.2c0.1,0,0.1,0,0.2,0C30.8,60.6,30.8,60.6,30.8,60.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st505",
    d: "M9.1,30.1c0,0.1,0,0.3,0,0.4c-0.1,0.1-0.3,0.1-0.4,0.2c0-0.2,0-0.4-0.2-0.4c-0.1-0.2,0.1-0.3,0.2-0.4l0,0 C8.9,29.8,8.9,30,9.1,30.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st400",
    d: "M8.6,29.9c-0.1,0.1-0.1,0.3-0.2,0.4c-0.1,0-0.1,0-0.2,0c-0.3-0.2-0.3-0.4,0-0.6c0.1,0.1,0.1,0.1,0.2,0.2 C8.5,29.9,8.6,29.9,8.6,29.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M6.9,24.1c0-0.2,0-0.4,0-0.6l0,0c0.1-0.1,0.1-0.1,0.2,0c0.1,0,0.1,0,0.2,0c0,0.1,0,0.1,0,0.2 c-0.1,0.1-0.1,0.3-0.2,0.4C7.1,24.1,7,24.1,6.9,24.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M7.1,24.1c0-0.2,0-0.3,0.2-0.4C7.3,23.9,7.3,24,7.1,24.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M6.7,24.1c0.1,0,0.1,0,0.2,0C6.8,24.3,6.8,24.3,6.7,24.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st506",
    d: "M7.1,23.5l-0.1,0l-0.1,0c0-0.2-0.1-0.5,0.2-0.6C7.1,23,7.1,23.2,7.1,23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st73",
    d: "M34,21.7c0-0.1,0-0.1,0-0.2c0.1,0,0.1,0,0.2,0c0,0.1,0,0.1,0,0.2C34.2,21.7,34.1,21.7,34,21.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st436",
    d: "M26.1,26.5c0.1,0.1,0.1,0.1,0.2,0.2c0.1,0.1,0.2,0.2,0.3,0.3c0,0.1,0.1,0.2,0.1,0.2c0,0.1-0.1,0.2-0.1,0.2 c-0.1,0-0.1,0-0.2,0.1c0,0.1,0.1,0.1,0.2,0.1c0.1,0.2,0.2,0.4,0.1,0.6c-0.1,0.2-0.3,0.4-0.5,0.4c-0.5-0.4-0.7-1-1.2-1.4 c-0.1-0.3-0.6-0.1-0.7-0.4c0-0.2,0.1-0.4,0.3-0.5c0.1,0,0.2,0,0.3,0c0.1,0.1,0.3-0.1,0.4-0.1C25.4,26.4,25.8,26.2,26.1,26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M24.6,26.5c-0.2,0.1-0.3,0.2-0.4,0.5c-0.1,0.4-0.4,0.6-0.8,0.5c-0.4-0.2-0.6-0.5-0.4-0.9 c0.5-0.3,1-0.7,1.6-0.7c0,0.1,0,0.1,0,0.2C24.7,26.2,24.7,26.3,24.6,26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M24.6,25.8c-0.5,0.3-0.8,0.8-1.5,0.6c-0.1,0-0.1-0.1-0.1-0.1c0-0.1,0-0.1,0-0.1c0.1-0.2,0.2-0.3,0.4-0.4 c0.3-0.3,0.6-0.4,1-0.3c0,0,0.1,0.1,0.1,0.1C24.6,25.7,24.6,25.8,24.6,25.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st507",
    d: "M24.6,26.5c0-0.1,0-0.3,0-0.4c0.3-0.1,0.5,0.3,0.9,0c0.4-0.3,0.5,0.1,0.6,0.4c-0.4,0-0.9,0-1.3,0 C24.7,26.5,24.7,26.5,24.6,26.5L24.6,26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st508",
    d: "M24.8,25.2c0.1-0.2,0.2-0.3,0.4-0.4c0.2,0,0.5,0.1,0.3,0.3c-0.2,0.3-0.4,0.6-0.9,0.5l0,0 c-0.1-0.1-0.1-0.1-0.1-0.2c0,0,0-0.1,0.1-0.1l0,0C24.7,25.3,24.7,25.2,24.8,25.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st317",
    d: "M26.3,24.7c0-0.2-0.4-0.4,0-0.6c0.2-0.1,0.4,0,0.5,0.2c0.1,0.3-0.1,0.3-0.3,0.4 C26.4,24.8,26.4,24.8,26.3,24.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st509",
    d: "M26.9,27.1c0.1,0,0.1,0,0.2,0l0,0c0.1,0.1,0.3,0.1,0.3,0.3c0.1,0.2,0.1,0.4,0,0.6c-0.1,0.1-0.1,0.1-0.2,0.2 c-0.6,0.1-0.6-0.3-0.6-0.7c0-0.1,0.1-0.2,0.2-0.2C26.9,27.1,26.9,27.1,26.9,27.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st510",
    d: "M26.3,24.7c0.1,0,0.1,0,0.2,0c0,0.2-0.1,0.4-0.3,0.4c-0.2,0-0.3-0.1-0.2-0.2C26,24.8,26.2,24.8,26.3,24.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st511",
    d: "M27.8,25.6c0.1-0.1,0.3-0.3,0.4-0.4l0,0c0.1,0.1,0.1,0.3,0.2,0.4l0,0c0,0,0.1,0.1,0,0.1c0,0,0,0.1,0,0.1 c-0.2,0-0.4,0-0.7,0C27.8,25.8,27.8,25.7,27.8,25.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st512",
    d: "M26.5,27.1c-0.2-0.1-0.2-0.3-0.2-0.4c0.3,0,0.5,0.1,0.6,0.4l0,0C26.8,27.2,26.6,27.3,26.5,27.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st445",
    d: "M27.6,25.2c0,0.1,0,0.1,0,0.2c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1-0.1-0.2-0.3-0.1-0.5c0.1,0.1,0.2,0.2,0.4,0.3 l0,0C27.6,25,27.7,25.1,27.6,25.2C27.6,25.2,27.6,25.2,27.6,25.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st511",
    d: "M27.3,26.3C27.3,26.3,27.3,26.3,27.3,26.3c-0.1,0.1-0.1,0.1-0.1,0C27.2,26.2,27.3,26.2,27.3,26.3 C27.3,26.2,27.3,26.2,27.3,26.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st326",
    d: "M29.5,25.6c0.6-0.1,1.1,0,1.5,0.4c0.1,0.1,0.1,0.2,0,0.3c-0.2,0.3-0.7,0.3-0.7,0.9c0,0.5-0.6,0.1-1,0 c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1-0.3-0.3-0.7,0.1-1C29.4,25.9,29.5,25.8,29.5,25.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M29.3,26c0,0.3,0,0.6,0,0.9c-0.2,0.4,0.4,0.9,0,1.3c-0.1,0.1-0.3,0.1-0.4,0.1c-0.3-0.3-0.5-0.7-1-0.7 c-0.2,0-0.4-0.1-0.5-0.3c-0.1,0-0.2-0.1-0.2-0.2c0.5-0.1,1.2,0.2,1.3-0.7c0.1-0.1,0.2-0.3,0.4-0.2C29,26.2,29.2,26.1,29.3,26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st308",
    d: "M30.2,24.8c-0.4,0.1-0.1-0.5-0.4-0.4c0-0.1,0-0.1,0-0.2c0.2-0.2,0.3-0.2,0.4,0.1 C30.2,24.3,30.2,24.6,30.2,24.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st513",
    d: "M29.7,24.3c0,0.1,0,0.3,0,0.4c-0.2,0-0.4,0-0.3-0.3C29.4,24.3,29.6,24.3,29.7,24.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st158",
    d: "M28.9,26.2c-0.1,0.1-0.3,0.1-0.4,0.2c0-0.1-0.2-0.3,0-0.4C28.6,26,28.8,26.1,28.9,26.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st364",
    d: "M28,23.9c0.1,0,0.1,0,0.2,0c0,0.2,0.1,0.4-0.1,0.5C28,24.4,28,24.1,28,23.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st262",
    d: "M28.5,25.6c-0.2-0.1-0.2-0.3-0.2-0.4C28.4,25.3,28.4,25.4,28.5,25.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st296",
    d: "M28.5,25.8c0-0.1,0-0.1,0-0.2C28.6,25.7,28.6,25.7,28.5,25.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M24.6,25.4c0,0.1,0,0.1,0,0.2c-0.4-0.1-0.7,0.2-1.1,0.2c0-0.2,0-0.5,0.2-0.6C24,25.3,24.3,25.3,24.6,25.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M23.9,24.3c0.1,0,0.1,0,0.2,0C24.1,24.5,24,24.5,23.9,24.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st315",
    d: "M24.8,25.2c-0.1,0.1-0.1,0.1-0.2,0.2C24.6,25.3,24.7,25.2,24.8,25.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st315",
    d: "M27.6,25.2c0-0.1,0-0.1,0-0.2C27.8,25,27.8,25.1,27.6,25.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st90",
    d: "M19.6,36.6c-0.4-0.2-0.4-0.5-0.4-0.9c0.2-0.4,0.4-0.7,0.7-1.1c0,0,0.1-0.1,0.1-0.1c0.5,0,0.6,0.2,0.6,0.7 c0,0.2-0.1,0.4-0.2,0.5C20.1,36.1,20,36.5,19.6,36.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M19.8,34.7c-0.4-0.1-0.9,0.2-1.3-0.2l0,0c0.3-0.3,0.7-0.5,1.2-0.5C20,34.1,20,34.4,19.8,34.7L19.8,34.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M19.4,37.7c-0.4,0-0.6-0.3-0.5-0.6c0.2-0.4,0.6,0.1,0.9-0.1c0,0,0.1,0.1,0.1,0.1c0,0.1,0.1,0.2,0,0.3 C19.9,37.7,19.7,37.9,19.4,37.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st224",
    d: "M19.4,37.7c0.3,0,0.4-0.2,0.4-0.4c0.3,0,0.4,0.2,0.4,0.4c0,0.2,0,0.5-0.2,0.6c-0.3,0.2-0.5,0-0.8-0.1 c-0.3,0-0.5,0.1-0.8-0.1c0-0.1,0-0.1,0-0.2C18.8,37.8,19.2,38,19.4,37.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st489",
    d: "M19.8,37c0-0.1,0-0.1,0-0.2c0-0.4,0-0.8,0.6-0.7c0.1,0.1,0.2,0.3,0.2,0.5C20.5,37,20.3,37.1,19.8,37L19.8,37 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st485",
    d: "M20.5,36.2c-0.4,0-0.5,0.4-0.7,0.7c-0.1-0.1-0.1-0.2-0.2-0.2c0.2-0.3,0.2-0.7,0.7-0.9c0,0,0.1,0,0.1,0 c0.1,0.1,0.2,0.2,0.2,0.3C20.5,36.1,20.5,36.1,20.5,36.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M20.7,39.6c-0.1,0.1-0.3,0.3-0.4,0.4c-0.1,0.1-0.3,0.1-0.4,0.2c0-0.2,0-0.3-0.2-0.4c-0.1-0.1-0.3-0.3-0.4-0.4 c0.1-0.1,0.1-0.1,0.2-0.2c0.2-0.1,0.4-0.1,0.6-0.1c0.1,0,0.2,0,0.3,0.1C20.5,39.3,20.6,39.5,20.7,39.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M19.4,39.4c-0.1,0-0.1,0-0.2,0c0-0.2-0.1-0.4-0.2-0.6c0.1-0.1,0.1-0.1,0.2,0c0.1,0,0.1,0,0.2,0 c0.2-0.2,0.4-0.1,0.5,0.1C20,39.3,19.6,39.2,19.4,39.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M19.2,38.7c-0.1,0-0.1,0-0.2,0c-0.2,0-0.3,0-0.4-0.2C18.8,38.5,19,38.5,19.2,38.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M19.8,39c-0.1-0.2-0.3-0.2-0.4-0.2c0-0.1,0-0.3,0-0.4c-0.1-0.1-0.1-0.1-0.1-0.1c0,0,0.1-0.1,0.1-0.1 c0.2,0.1,0.4,0.1,0.6,0.2c0.1-0.1,0.2-0.1,0.3,0c0.1,0.2,0.2,0.4,0.1,0.6c0,0.2-0.1,0.3-0.2,0.4c-0.1,0-0.1,0-0.2,0 C19.9,39.3,20,39.1,19.8,39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st224",
    d: "M19.4,38.1c0,0.1,0,0.1,0,0.2c-0.3,0-0.6,0-0.9,0c0-0.1,0-0.1,0-0.2C18.8,38.1,19.1,38.1,19.4,38.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st514",
    d: "M6.1,26.3c0.1-0.1,0.3-0.1,0.4-0.2l0,0c0.1,0,0.1,0.1,0.2,0.1c0.3,0.2,0.8,0.1,0.8,0.6 c0,0.4-0.4,0.7-0.8,0.8c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2-0.1-0.2-0.2c0,0,0-0.1,0-0.1C6,26.8,6.1,26.6,6.1,26.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st515",
    d: "M6.3,28c-0.2-0.1-0.3-0.3-0.4-0.5c0.1-0.1,0.2-0.1,0.3-0.1c0.2,0,0.3,0,0.5,0.1c0,0.1,0.1,0.2,0.1,0.2 c0,0.1-0.1,0.2-0.1,0.2c0,0-0.1,0-0.1,0.1C6.4,28.1,6.3,28.1,6.3,28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st461",
    d: "M6,28.4c-0.1,0.1-0.3,0.1-0.4,0.2c-0.2-0.1-0.2-0.3-0.2-0.4c0.2,0,0.4,0,0.6,0C6.1,28.2,6.1,28.3,6,28.4 C6.1,28.4,6.1,28.4,6,28.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st120",
    d: "M6,28.4c0-0.1,0-0.1,0-0.2c0.1-0.1,0.1-0.1,0.2-0.2c0.1,0,0.1,0,0.2,0c0.1,0.1,0.1,0.3,0,0.4 C6.3,28.4,6.2,28.4,6,28.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st516",
    d: "M6.3,27.5c-0.1,0-0.3,0-0.4,0c0-0.2,0-0.3,0.2-0.4l0,0c0.1,0.1,0.2,0.1,0.2,0.2l0,0 C6.3,27.4,6.4,27.4,6.3,27.5C6.3,27.5,6.3,27.5,6.3,27.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st517",
    d: "M5.4,27.3c0.1-0.2,0.2-0.2,0.2,0C5.5,27.4,5.5,27.4,5.4,27.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st518",
    d: "M5.4,27.3c0.1,0,0.1,0,0.2,0c-0.1,0.1-0.1,0.1-0.2,0.2l0,0C5.4,27.5,5.4,27.4,5.4,27.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st337",
    d: "M25.2,43.1c0.1-0.2,0.4-0.3,0.3-0.7c-0.1-0.3-0.3-0.5-0.2-0.9c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.3,0.1 c0.4,0.2,0.7,0.4,0.6,0.9c-0.4,0.5,0.4,0.2,0.3,0.4c0,0,0,0.1,0,0.1c0,0.2,0.4,0.2,0.2,0.5c0,0-0.3-0.1-0.4-0.1 c-0.1,0.1-0.3,0.2-0.4,0.2C25.7,43.5,25.4,43.4,25.2,43.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st313",
    d: "M26.3,42.4c0.1-0.5-0.4-0.6-0.6-0.8c0,0,0.1-0.1,0.1-0.1c0.2-0.1,0.4-0.1,0.5-0.1c0.1,0,0.2,0.1,0.2,0.2 c0.1,0,0.3,0,0.4,0c0,0.2,0.1,0.4,0.2,0.6c0,0.1,0,0.1,0,0.2c-0.1,0-0.2,0-0.2,0C26.7,42.6,26.5,42.6,26.3,42.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M26.1,43.3c0.1,0,0.3,0,0.4,0c0,0.1,0,0.3,0,0.4c0,0.2-0.1,0.3-0.2,0.4c0,0.1,0,0.1,0,0.2c-0.2,0-0.4,0-0.6,0 c-0.1-0.1-0.2-0.3-0.2-0.4C25.5,43.6,25.8,43.4,26.1,43.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st409",
    d: "M26.3,42.4c0.2,0,0.4,0,0.6,0c-0.1,0.1-0.1,0.3-0.2,0.4c-0.1,0-0.2,0-0.3,0c-0.1,0-0.4,0-0.4,0 C26,42.6,26.3,42.6,26.3,42.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st337",
    d: "M26.3,44.1c0-0.2,0-0.4,0.2-0.4c0.1,0.1,0.1,0.2,0.2,0.2C26.6,44.1,26.5,44.1,26.3,44.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M30.8,60.9c0,0.2-0.1,0.5,0.2,0.6c0,0.1-0.1,0.2-0.2,0.2c-0.4-0.2-0.4-0.5-0.4-0.9 C30.5,60.9,30.7,60.9,30.8,60.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st519",
    d: "M22,59.2c-0.1-0.3-0.2-0.6-0.3-0.9c0.1-0.2,0.2-0.4,0.2-0.7c0.1-0.1,0.1-0.1,0.2,0c0.1,0.5,0.2,1,0,1.5 C22.1,59.2,22.1,59.2,22,59.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st520",
    d: "M22.2,57.7c-0.1,0-0.1,0-0.2,0c0-0.1,0-0.1,0-0.2c0.1,0,0.1,0,0.2,0C22.2,57.6,22.2,57.6,22.2,57.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M32.3,54.5c0,0.2,0,0.3-0.2,0.4C32.1,54.7,32.1,54.6,32.3,54.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st316",
    d: "M31.7,54.7c0,0,0.1-0.1,0.1-0.1C31.8,54.6,31.8,54.6,31.7,54.7C31.7,54.7,31.7,54.7,31.7,54.7L31.7,54.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M16,41.1c0.1,0,0.1,0,0.2,0c-0.1,0.1-0.1,0.1-0.2,0.2C16,41.3,16,41.2,16,41.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M16.2,41.1c0-0.1,0.1-0.2,0.2-0.2C16.4,41,16.3,41.1,16.2,41.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st112",
    d: "M19.2,40.5c0.4-0.4,0.4,0,0.4,0.2C19.5,40.6,19.3,40.5,19.2,40.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M27.8,35.7c0.5,0.1,0.7-0.2,1.1-0.4c0.3,0,0.7-0.1,0.4,0.4c-0.1,0-0.1,0-0.2,0c-0.3,0.1-0.6,0.3-0.8,0.4 C27.9,36.3,27.7,36.1,27.8,35.7L27.8,35.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st419",
    d: "M6.3,27.5c0-0.1,0-0.1,0-0.2c0.5,0.1,0.7-0.3,1-0.6c-0.2-0.3-0.7-0.2-0.8-0.7C7.7,26.3,8,26.6,8,28.2 c-0.1,0.1-0.1,0.1-0.2,0.1c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2-0.1-0.2-0.1C7.2,28,7,28,6.9,27.9c-0.1,0-0.1-0.1-0.2-0.2 C6.6,27.6,6.5,27.5,6.3,27.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st521",
    d: "M9.1,28.8c0-0.5,0.5-0.7,0.7-1.1l0,0c0.1-0.1,0.2-0.1,0.3,0c0.2,0.2,0.3,0.4,0.3,0.7 c-0.1,0.3-0.2,0.6-0.5,0.7C9.4,29.2,9.2,29.1,9.1,28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st522",
    d: "M9.1,28.8c0.2,0.1,0.4,0.2,0.6,0.2c0.2,0.3,0.2,0.5-0.1,0.7c-0.4,0-0.6-0.1-0.8-0.4c0-0.1,0-0.2,0-0.3 C8.9,29,9,28.9,9.1,28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st523",
    d: "M7.8,28.2c0.1,0,0.1,0,0.2,0c0,0.1,0,0.1,0,0.2c0.1,0.1,0.1,0.2,0.1,0.4C8,28.9,8,28.9,7.9,29 c-0.3,0-0.4-0.1-0.6-0.3c-0.1-0.1-0.1-0.3,0-0.4c0,0,0.1-0.1,0.1-0.1c0.1,0,0.1,0,0.2,0C7.6,28.3,7.7,28.3,7.8,28.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st250",
    d: "M8,28.8c0-0.1,0-0.3,0-0.4c0.2,0.1,0.6-0.1,0.4,0.4C8.3,29,8.1,29,8,28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st524",
    d: "M8.8,29.1c0,0.1,0,0.1,0,0.2c0,0.2,0,0.3-0.2,0.2c-0.1,0-0.1,0-0.2,0c-0.1-0.1-0.1-0.1-0.1-0.2 c0.1-0.1,0.2-0.1,0.3-0.2C8.7,29.1,8.8,29.1,8.8,29.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st525",
    d: "M8,28.8c0.1,0,0.3,0,0.4,0c0,0.1,0,0.1,0,0.2c0,0-0.1,0.1-0.1,0.1c-0.1,0-0.2,0-0.2,0c0,0-0.1,0-0.1,0 c0,0-0.1-0.1-0.1-0.1C7.9,28.9,7.9,28.9,8,28.8L8,28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st526",
    d: "M8.6,29.1c0,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.1-0.1-0.1-0.1c0,0,0-0.1,0.1-0.1l0,0C8.5,29.1,8.6,29.1,8.6,29.1z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st119",
    d: "M7.6,25.8c0.1,0,0.2,0.1,0.2,0.2C7.7,26,7.6,25.9,7.6,25.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st527",
    d: "M9.9,27.8c-0.1,0-0.1,0-0.2,0c0.1-0.1,0.1-0.3,0.2-0.4c0.1,0,0.3,0,0.4,0c0,0,0.1,0.1,0.1,0.1 c0,0.2,0,0.3-0.1,0.4C10.2,27.9,10,27.9,9.9,27.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "M10.8,26.9c0.1,0.1,0.1,0.3,0.2,0.4c-0.2,0.2-0.4,0.2-0.7,0l0,0C10.4,27.1,10.6,27,10.8,26.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st528",
    d: "M45.5,49.7c-0.1-0.1-0.2-0.2-0.2-0.2c0.1-0.1,0.1-0.1,0.2-0.2c0.1,0.1,0.2,0.1,0.2,0c0.1,0,0.1,0,0.2,0 c0.1-0.1,0.1-0.1,0.2,0C46,49.6,45.8,49.7,45.5,49.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st529",
    d: "M46.1,49.3c-0.1,0-0.1,0-0.2,0c0.1-0.2,0.3-0.2,0.4-0.2c0,0.1,0,0.1,0,0.2C46.2,49.3,46.2,49.3,46.1,49.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st529",
    d: "M45.7,49.3c-0.1,0.2-0.2,0.2-0.2,0C45.5,49.3,45.6,49.3,45.7,49.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st529",
    d: "M45.2,50.2c-0.1,0-0.1,0-0.2,0c0-0.1,0.1-0.2,0.2-0.2C45.2,50,45.2,50.1,45.2,50.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M14.4,40.3c0-0.1-0.2-0.3,0-0.4c0.2-0.1,0.4,0.1,0.4,0.3c0,0.1,0.1,0.3-0.1,0.3 C14.6,40.5,14.5,40.3,14.4,40.3L14.4,40.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.4,60.7c-0.1-0.1-0.3-0.2-0.4-0.2c0.2-0.4-0.2-0.7,0-1.1c0.1-0.1,0.1-0.1,0.2-0.1c0.3,0.1,0.4,0.3,0.6,0.5 c0.1,0.1,0.1,0.2,0.2,0.2C39.8,60.2,39.6,60.4,39.4,60.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st530",
    d: "M40.3,58.6c-0.1,0-0.1,0-0.2,0c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.1-0.1-0.2-0.2c-0.1-0.1-0.1-0.2-0.2-0.3 c-0.2-0.1-0.4-0.2-0.4-0.5c0-0.3,0.2-0.3,0.5-0.4c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0.1,0.3,0.2c0.1,0.1,0.2,0.1,0.3,0.2 c0.1,0.1,0.1,0.1,0.1,0.2C40.5,58.3,40.5,58.4,40.3,58.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st531",
    d: "M41.4,59.2c-0.1,0-0.1,0-0.2,0c-0.1-0.3-0.3-0.4-0.7-0.4c-0.2-0.3-0.2-0.6,0.1-0.9c0.2,0,0.3,0,0.5,0.1 c0,0.1,0.1,0.1,0.1,0.2c0,0.1,0,0.1,0,0.2C41.3,58.6,41.4,58.9,41.4,59.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st86",
    d: "M40.7,57.9c-0.3,0.2-0.2,0.6-0.2,0.9c-0.1,0-0.2-0.1-0.2-0.2c0-0.2,0-0.4,0-0.6c-0.3-0.3-0.4-0.7-0.1-1.1 c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.3,0.1C41,57.2,40.9,57.6,40.7,57.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st532",
    d: "M39.9,59.8c-0.3,0-0.5-0.1-0.7-0.4c0.1-0.3,0.3-0.4,0.5-0.3c0,0,0.1,0.1,0.1,0.1 C39.9,59.4,39.9,59.6,39.9,59.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st533",
    d: "M39.6,58.6c0.1,0,0.3,0,0.4,0c0,0.2,0.1,0.5-0.2,0.6l0,0C39.6,59.1,39.4,58.9,39.6,58.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st534",
    d: "M41.8,57.5c0.1,0,0.1,0,0.2,0c-0.3,0.2-0.6,0.4-0.9,0.6l0,0c-0.3-0.4-0.4-0.8,0.2-1.1 C41.7,56.9,41.6,57.3,41.8,57.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M43.1,57.9c0,0.2,0.1,0.5-0.2,0.6C42.9,58.3,42.8,58.1,43.1,57.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M27.8,37.7c0.3,0.1,0.6,0.2,0.8,0.2c0,0,0.1,0.1,0.1,0.1c0,0,0,0.1,0,0.1c-0.1,0.2-0.3,0.3-0.4,0.3 c-0.2,0.1-0.5,0.1-0.7,0.2c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2-0.1-0.2-0.1c-0.2-0.3,0-0.6,0.1-0.9c0-0.1,0-0.2,0.1-0.3 c0-0.1,0.1-0.1,0.2-0.2C27.8,37.2,27.7,37.5,27.8,37.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M27.8,35.7c0.1,0.2,0.2,0.4,0.4,0.4c-0.1,0.1-0.3,0.3-0.4,0.4c-0.2,0.2-0.3,0.4-0.5,0.1c0-0.1,0-0.2,0.1-0.3 C27.7,36.3,27.5,35.8,27.8,35.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st535",
    d: "M29.3,37.2c0,0-0.1,0-0.1,0c-0.3-0.1-0.3,0.5-0.7,0.2c-0.1,0-0.1-0.2,0-0.3C28.8,36.9,29.1,36.9,29.3,37.2 L29.3,37.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st445",
    d: "M27.4,36.6c0.1,0.3,0.3,0,0.4,0c0,0.1,0,0.3,0,0.4c-0.1,0.2-0.3,0.1-0.4,0.2l0,0c-0.4,0-0.4-0.3-0.3-0.6 C27.1,36.5,27.2,36.5,27.4,36.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st462",
    d: "M27.4,37.3c0.1-0.2,0.2-0.2,0.4-0.2c0.1,0.2,0.1,0.4,0,0.6C27.7,37.5,27.5,37.4,27.4,37.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st536",
    d: "M28.7,38.1c0-0.1,0-0.1,0-0.2c0.2,0,0.4,0,0.6,0c0,0.1,0,0.1,0,0.2c-0.1,0-0.3,0-0.4,0 C28.8,38.2,28.7,38.2,28.7,38.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st130",
    d: "M27.2,38.5c0.1,0,0.1,0,0.2,0c0.1,0.1,0.1,0.1,0.2,0.1c0,0,0.1,0.1,0.1,0.1c0,0.1,0,0.2-0.1,0.2 c-0.1,0.4-0.3,0.8-0.2,1.3c-0.1,0-0.1,0-0.2,0c-0.5,0-0.3-0.5-0.5-0.7c0-0.2,0-0.5,0.1-0.7C26.9,38.8,27,38.6,27.2,38.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st243",
    d: "M27.6,38.5c0.1-0.3,0.4-0.2,0.6-0.2c0.2,0.1,0.3,0.3,0.4,0.5c0,0,0,0.1,0,0.1c-0.3,0.3-0.6,0.6-0.9,0 c-0.1-0.1-0.1-0.1-0.2-0.2l0,0C27.5,38.7,27.5,38.7,27.6,38.5C27.5,38.6,27.6,38.5,27.6,38.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st450",
    d: "M28.7,38.1c0.1,0,0.1,0,0.2,0c0.1,0.3,0.5,0.7-0.2,0.8l0,0C28.2,38.7,28.5,38.4,28.7,38.1L28.7,38.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st336",
    d: "M29.7,38.1c0,0.1,0,0.3,0,0.4c-0.2-0.1-0.2-0.2-0.2-0.4C29.6,38.1,29.7,38.1,29.7,38.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st445",
    d: "M27.6,38.7c0.1,0,0.2,0.1,0.2,0.2c-0.1,0-0.1,0-0.2,0C27.6,38.9,27.6,38.8,27.6,38.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st243",
    d: "M33.4,26.3c0.1,0.2,0.2,0.5,0.4,0.6c-0.1,0.5-0.8,0.4-0.9,0.9c-0.2,0-0.4,0-0.6,0c-0.1-0.2-0.1-0.5,0-0.7 c0.2-0.2,0.2-0.5,0.4-0.8C32.9,26.1,33.2,26,33.4,26.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st537",
    d: "M32.3,27.1c0.1,0.2,0.1,0.4,0,0.6c-0.3,0.1-0.6,0.1-0.9,0.2c-0.3,0-0.4-0.2-0.5-0.4c0-0.2,0.1-0.3,0.2-0.5 c0-0.1,0.1-0.2,0.1-0.2c0-0.1,0.1-0.1,0.2-0.2c0.1,0,0.2-0.1,0.2-0.1c0.1,0,0.2,0,0.2,0.1c0.1,0.1,0.2,0.2,0.3,0.3 C32.3,27,32.3,27,32.3,27.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st538",
    d: "M31,27.6c0.2,0.1,0.3,0.2,0.4,0.4c0,0.2,0.1,0.5-0.2,0.7c-0.2,0-0.3-0.1-0.3-0.3c-0.1-0.1-0.1-0.3-0.1-0.4 C30.9,27.8,30.9,27.7,31,27.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st539",
    d: "M31,28.4c0.1,0.1,0.1,0.1,0.2,0.2c0,0.3,0,0.6,0,0.8c-0.1,0-0.1,0-0.2,0c-0.2-0.2-0.3-0.4-0.3-0.6 c0-0.2,0.1-0.3,0.2-0.4C30.9,28.4,31,28.4,31,28.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st243",
    d: "M34.9,26.3c0,0.1,0,0.1,0,0.2c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0-0.3,0-0.4,0C34.4,26.4,34.7,26.4,34.9,26.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st243",
    d: "M33.8,26.9c0-0.1,0.1-0.2,0.2-0.2C34,26.8,33.9,26.8,33.8,26.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st540",
    d: "M33.6,56.8c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0.1c0.1,0.1,0.1,0.1,0.2,0.2c0.2,0.2,0.3,0.5,0.4,0.7 c0,0.1,0,0.2,0,0.3c0,0.1-0.1,0.2-0.1,0.2c0,0-0.1,0.1-0.1,0.1c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c-0.1,0-0.1-0.2-0.2,0 c-0.1,0.1-0.1,0.1-0.2,0.1c-0.2,0-0.3,0-0.5-0.2c0-0.1,0-0.3,0-0.4c0.1-0.1,0.1-0.2,0.1-0.4C33.3,57.2,33.4,57,33.6,56.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st178",
    d: "M32.7,59.2c0-0.1,0-0.1,0-0.2c0.1-0.1,0.1-0.1,0.2-0.2c0.2-0.3,0.6-0.2,0.9-0.4h0c0.1-0.1,0.1-0.1,0.2,0h0 c0.2,0.1,0.2,0.3,0.2,0.5c0,0.1-0.1,0.3-0.2,0.4c-0.1,0.1-0.1,0.1-0.2,0.2c0,0-0.1,0-0.1,0c-0.2-0.1-0.4-0.3-0.7-0.2 C32.9,59.2,32.8,59.2,32.7,59.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st335",
    d: "M33.8,58.3c-0.2,0.4-0.5,0.5-0.9,0.4c0-0.2,0-0.3,0.2-0.4C33.4,58.3,33.6,58.3,33.8,58.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M33.6,56.8c-0.1,0.3-0.2,0.6-0.2,0.8c-0.1,0.1-0.1,0.1-0.2,0c-0.1-0.2-0.1-0.4,0-0.6c0-0.1,0.2-0.1,0.2-0.2 C33.5,56.8,33.5,56.8,33.6,56.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M33.4,56.8c-0.1,0.1-0.1,0.1-0.2,0.2c-0.2-0.1-0.2-0.1,0-0.2C33.3,56.8,33.3,56.8,33.4,56.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M33,56.4c0.1,0.1,0.1,0.1,0.2,0.2C33.1,56.6,33,56.5,33,56.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st335",
    d: "M33.2,57.7c0.1,0,0.1,0,0.2,0c0,0.1-0.1,0.2-0.2,0.2C33.2,57.8,33.2,57.8,33.2,57.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M32.8,55.8c0.2,0,0.4,0,0.5,0.1c0.1,0.2-0.1,0.3-0.3,0.4C32.8,56.1,32.8,55.9,32.8,55.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M30.2,23c0.1,0,0.1,0,0.2,0c0.1,0,0.3-0.1,0.4-0.1c0.1,0.1,0.1,0.3,0,0.4c-0.1,0.1-0.2,0.2-0.4,0.3l-0.1,0 l-0.1,0C30,23.5,30,23.2,30.2,23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M30.2,23c0,0.2,0,0.4,0,0.6c-0.2-0.3-0.4-0.6-0.6-0.9c0.1,0,0.3,0,0.4,0C30,22.9,30.1,23,30.2,23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st111",
    d: "M19.6,34c-0.3,0.3-0.7,0.4-1.1,0.4c-0.2-0.3-0.7-0.3-0.7-0.8c0,0,0-0.1,0-0.1c0-0.1,0-0.2,0.1-0.3 c0.1-0.1,0.1-0.1,0.2-0.2c0.2-0.1,0.4-0.1,0.6-0.1c0.2,0,0.4,0.1,0.5,0.2c0,0.1,0,0.3,0.2,0.3c0.1,0.1,0.2,0.2,0.2,0.3 C19.7,33.9,19.7,34,19.6,34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st541",
    d: "M18.1,33.2c0,0.1,0,0.1,0,0.2c-0.1,0.1-0.1,0.1-0.2,0.2l0,0c-0.1-0.1-0.3-0.2-0.4-0.2c0-0.1,0-0.1,0-0.2 c0-0.1,0.1-0.2,0.2-0.2C17.9,33,18,33,18.1,33.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st298",
    d: "M16.6,33.4c0.1-0.2,0.1-0.2,0.2,0C16.7,33.4,16.7,33.4,16.6,33.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st335",
    d: "M34.5,57.9c-0.2-0.3-0.3-0.7-0.6-0.9c0.1,0,0.1-0.1,0.1-0.1c0,0,0-0.1-0.1-0.1l0,0c0-0.2,0-0.4,0-0.6 c0.1-0.1,0.1-0.1,0.2,0c0.2,0.3,0.4,0.2,0.7,0.2c0.6,0.1,0.2,0.6,0.3,0.9c0,0.2-0.1,0.3-0.1,0.5C34.8,57.9,34.7,58,34.5,57.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M34,56.2c-0.1,0-0.1,0-0.2,0c-0.1-0.7,0.4-0.3,0.6-0.4C34.4,56,34.2,56.1,34,56.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st542",
    d: "M14.7,30.3c0,0.2,0,0.3-0.2,0.4c-0.7,0.1-0.7-1-1.4-0.9c-0.1,0-0.1-0.1-0.2-0.2c0.2-0.2,0.2-0.4-0.1-0.5 c0-0.2,0-0.4,0.1-0.5c0.1,0,0.1,0,0.2,0c0.1,0.1,0.2,0.1,0.2,0.2c0.1,0.1,0.3,0.1,0.4,0.2c0.3,0,0.5,0.3,0.6,0.4 C14.5,29.8,14.3,30.1,14.7,30.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M15.1,31.2c0-0.1,0-0.3,0-0.4c0.2-0.3-0.1-0.5-0.3-0.7c0-0.3,0.2-0.4,0.5-0.4c0.5,0,0.9,0.1,1.3,0.4 C16.3,30.7,16.1,31.5,15.1,31.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M15.1,31.2c0.7-0.1,1-0.8,1.5-1.1c0.1,0,0.1,0,0.2,0l0,0c0.1,0.1,0.1,0.2,0.1,0.3c-0.4,0.7-0.9,1.2-1.6,1.7 c-0.1,0-0.1,0-0.2,0C15.1,31.8,15.1,31.5,15.1,31.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st543",
    d: "M12.9,29.5c0,0.1,0,0.1,0,0.2c-0.1,0.1-0.2,0.1-0.3,0c-0.4-0.3-0.9-0.7-0.6-1.3c0.4-0.4,0.6,0,0.9,0.2 c0,0.2,0,0.4,0,0.7C13,29.3,13,29.4,12.9,29.5C13,29.5,13,29.5,12.9,29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st269",
    d: "M12.1,28.4c0,0.5,0.4,0.9,0.7,1.3c0.1,0.1,0.1,0.2,0.1,0.3c-0.1,0.2-0.2,0.3-0.5,0.3 c-0.2-0.1-0.4-0.3-0.5-0.5c-0.1-0.2,0.1-0.4-0.2-0.6c-0.2-0.3-0.3-0.6-0.1-1c0.1-0.1,0.2-0.1,0.3,0C11.9,28.3,12,28.3,12.1,28.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st450",
    d: "M15.3,29.7c-0.1,0.2-0.3,0.3-0.4,0.5c0.1,0.1,0.1,0.2,0,0.2c-0.1,0-0.1,0-0.2,0c0-0.2,0-0.4,0-0.5 c0-0.2,0-0.4,0.2-0.5C15.1,29.3,15.2,29.5,15.3,29.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st479",
    d: "M14.3,28.4c0.3,0,0.6-0.2,0.9-0.1C15,29.1,14.6,28.7,14.3,28.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st544",
    d: "M14.4,29.5c-0.3,0-0.5-0.1-0.6-0.4C14.4,28.6,14.3,29.2,14.4,29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st418",
    d: "M14.2,26.5c0.3,0,0.4,0.3,0.6,0.4C14.4,27.2,14.3,26.9,14.2,26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st248",
    d: "M11.9,28.2c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.2-0.1c0,0,0-0.1,0-0.1c0.1,0,0.3,0,0.4,0 C11.9,28.1,11.9,28.1,11.9,28.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st262",
    d: "M13.3,27.6C13.3,27.6,13.4,27.6,13.3,27.6c0.2,0,0.2,0,0.1,0.1C13.4,27.7,13.3,27.7,13.3,27.6 C13.3,27.7,13.3,27.7,13.3,27.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st545",
    d: "M13.4,28.8c-0.1-0.1-0.1-0.1-0.2-0.2l0,0c0.1-0.1,0.1-0.1,0.2,0C13.4,28.7,13.4,28.8,13.4,28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st262",
    d: "M13.4,28.6c-0.1,0-0.1,0-0.2,0C13.2,28.5,13.3,28.5,13.4,28.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st248",
    d: "M10.4,27.3c0.2,0,0.4,0,0.7,0c0.1,0.2,0.3,0.4,0.4,0.6l0,0c-0.2,0.4-0.6,0.4-1,0.3c-0.2-0.1-0.3-0.3-0.1-0.5 C10.4,27.6,10.4,27.5,10.4,27.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M11.7,26.9c0.1,0.1,0.1,0.1,0.2,0.2c-0.1,0.1-0.2,0.2-0.3,0.1C11.4,27.1,11.5,27,11.7,26.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st546",
    d: "M38.6,52.6c0-0.3,0.1-0.5,0.4-0.5c0,0,0.1,0,0.1,0c0.1,0.1,0.2,0.2,0.2,0.3c0,0.1,0,0.1-0.1,0.2 c-0.1,0.1,0.1,0.1,0.1,0.3c0,0.1,0,0.3-0.1,0.4c-0.1,0.1-0.2,0.2-0.3,0.3c-0.3,0.2-0.6,0.2-0.8,0l0,0c-0.1,0-0.1-0.1-0.1-0.1 c0,0,0-0.1,0.1-0.1c0-0.2,0-0.4,0-0.6C38.4,52.8,38.6,53,38.6,52.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st547",
    d: "M38.1,53.4c0,0.1,0,0.1,0,0.2c-0.1,0-0.1,0-0.2,0C38,53.5,38,53.4,38.1,53.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st548",
    d: "M37.3,54.9c0.7,0.1,1.2-0.1,1.3-0.8c0,0,0.1,0,0.1-0.1c0.1,0,0.2,0,0.2,0.1c0.1,0.1,0.2,0.2,0.2,0.3 c0,0.1,0.1,0.2,0.1,0.3c0,0.2,0.1,0.5-0.1,0.6c-0.2,0-0.4,0-0.5,0.1c-0.1,0-0.2,0-0.3,0.1c-0.1,0-0.3,0.1-0.4,0.1 c-0.2,0-0.4,0.1-0.6,0C37.2,55.3,37.1,55.1,37.3,54.9L37.3,54.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st547",
    d: "M39,54.3c-0.1-0.1-0.2-0.1-0.2-0.2c-0.1-0.1-0.1-0.1-0.2,0l0,0c-0.2-0.1-0.4-0.2-0.4-0.4 c0.3,0,0.6-0.1,0.9-0.2c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.1-0.1c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0.1 c0.1,0.1,0.1,0.1,0.1,0.2c0,0.1,0,0.2,0,0.4c0,0.1-0.1,0.1-0.1,0.2c-0.1,0.1-0.3,0.1-0.4,0.2C39.1,54.3,39.1,54.3,39,54.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st549",
    d: "M36.2,56c0.1-0.1,0.1-0.3,0.2-0.4c0.1,0,0.1,0,0.2,0c0.2,0,0.3,0.2,0.4,0.3c0.1,0.2,0.3,0.3,0.5,0.5 c0.1,0.1,0,0.3-0.1,0.4c-0.1,0.1-0.2,0.3-0.4,0.4c-0.1,0-0.2,0-0.3,0C36.4,56.8,36.2,56.4,36.2,56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st550",
    d: "M36.9,56c-0.1-0.2-0.2-0.3-0.2-0.5c0.1-0.1,0.2-0.3,0.2-0.4c0.1-0.1,0.3-0.2,0.4-0.2c0,0.2,0,0.3,0.2,0.4 C37.7,56,37.3,56,36.9,56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M24.7,40.5c-0.1-0.3-0.7-0.4-0.6-0.9C24,39.5,24,39.4,24,39.2c0.2-0.3,0.4-0.4,0.7-0.4c0.1,0,0.2,0,0.3,0.1 c0,0.1,0.1,0.2,0.1,0.2c0,0.2-0.1,0.3,0,0.5c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.2,0.2,0.2,0.3c0.1,0.1,0.1,0.3,0,0.4 c0,0.1-0.1,0.2-0.2,0.3c-0.1,0-0.3,0-0.4-0.1c-0.1-0.1-0.1-0.1-0.2-0.2C24.8,40.6,24.8,40.6,24.7,40.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st551",
    d: "M25.2,40.9c0.1-0.1,0.1-0.1,0.2-0.2c0-0.1,0.1-0.1,0.1-0.1c0-0.1,0-0.1,0-0.2c0-0.1,0.1-0.1,0.1-0.2 c0.1-0.2,0.2-0.3,0.4-0.3c0.1,0,0.2,0.1,0.3,0.1c0.4,0.8,0.1,1.2-0.7,1.5l0,0c-0.1,0-0.2,0-0.2,0c-0.1,0,0-0.2-0.2-0.2 c-0.3-0.1-0.4-0.3-0.4-0.7c0.1,0,0.1,0,0.2,0C25.1,40.8,25.2,40.8,25.2,40.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st367",
    d: "M25.6,43.9c0,0.1,0,0.3,0,0.4c-0.3,0.1-0.4,0.3-0.4,0.6c-0.1,0-0.3,0-0.4,0c-0.2-0.2-0.2-0.4-0.2-0.6 c0-0.1-0.1-0.2-0.1-0.2c0-0.1,0-0.2,0-0.2c0.1-0.1,0.2-0.2,0.3-0.2c0-0.1,0-0.2,0-0.2c-0.1-0.1-0.1-0.1-0.1-0.2 c0-0.1,0-0.1,0.1-0.1c0.1,0,0.2,0,0.3,0C25.3,43.5,25.5,43.7,25.6,43.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M25.6,43.9c-0.5,0.1-0.7-0.2-0.6-0.7c-0.1-0.1-0.1-0.1-0.1-0.1c0,0,0-0.1,0.1-0.1c0.1,0,0.1,0,0.2,0 c0.3,0.1,0.6,0.1,0.9,0.2C25.9,43.5,25.8,43.7,25.6,43.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st552",
    d: "M24.6,44.1c0,0.1,0,0.1,0.1,0.2c0.1,0.2,0.1,0.4,0,0.6c0,0.1-0.1,0.1-0.1,0.2l0,0c-0.1,0-0.2,0.2-0.2,0.3 c-0.1,0-0.3,0-0.4,0c0-0.1,0-0.2,0-0.3c0-0.1,0-0.3,0-0.4c0.3-0.1,0.4-0.3,0.5-0.6C24.4,44,24.5,44,24.6,44.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st553",
    d: "M25,43c0,0.1,0,0.1,0,0.2c-0.1,0-0.1,0-0.2,0c-0.1,0.1-0.1,0.1-0.2,0C24.6,43,24.7,42.8,25,43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st554",
    d: "M25.2,41.3c0.1,0,0.1-0.1,0.2-0.1c0,0.1,0,0.2,0,0.3l-0.1,0l-0.1,0C25.2,41.5,25.2,41.4,25.2,41.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st555",
    d: "M24.6,44.1L24.6,44.1l-0.2,0c0-0.2,0-0.3,0.2-0.4l0.1,0.1l-0.1,0.1C24.6,44,24.6,44.1,24.6,44.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st556",
    d: "M24.6,43.9c0-0.1,0-0.1,0-0.2c0.1,0,0.1,0,0.2,0C24.8,43.8,24.7,43.9,24.6,43.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st217",
    d: "M24.6,43.3c0.1,0,0.1,0,0.2,0c0,0.1,0,0.1,0,0.2C24.6,43.5,24.6,43.4,24.6,43.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st557",
    d: "M20.3,38.9c0-0.2,0-0.4,0-0.6c-0.2-0.4,0.2-0.4,0.4-0.6c0.1,0,0.2,0,0.3,0c0.3,0,0.6,0.2,0.8,0.4 c0,0,0,0.1,0,0.2c0,0.1,0,0.3,0,0.4c0.1,0.1,0.1,0.1,0.2,0.2c0,0.2,0,0.4,0,0.6c-0.5,0.5-0.7-0.3-1.1-0.2c-0.1,0-0.1,0-0.2,0 C20.5,39.3,20.4,39.1,20.3,38.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st558",
    d: "M20.9,39.4c0-0.2,0-0.3,0-0.6c0.5,0.1,0.4,1,1,0.8c0.3,0.1,0.3,0.4,0.4,0.6c-0.1,0-0.1,0-0.2,0 c-0.1-0.1-0.3-0.1-0.4-0.2C21.3,40,21.1,39.7,20.9,39.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M20.3,38.9c0.2,0.1,0.3,0.2,0.4,0.5c0,0.1,0,0.1,0,0.2c-0.1-0.1-0.3-0.1-0.4-0.2 C20.3,39.2,20.3,39.1,20.3,38.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st370",
    d: "M22.2,40.9c0.1,0,0.2,0.1,0.2,0.2C22.3,41.1,22.2,41,22.2,40.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st559",
    d: "M20.5,15.3c0,0.4-0.3,0.7-0.5,1.1c-0.2,0.2-0.4,0.1-0.7,0c-0.3-0.2-0.4-0.6-0.5-0.9c0-0.1-0.1-0.2-0.1-0.3 c0-0.2,0-0.3,0.1-0.4c0.4-0.5,0.7-0.6,1.1,0l0,0C20.2,14.8,20.8,14.8,20.5,15.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M19.6,17c0,0.2,0,0.4,0,0.7c-0.1,0.1-0.2,0.1-0.2,0.1c-0.2-0.1-0.3-0.2-0.5-0.2c-0.1,0-0.2-0.1-0.4-0.2 c-0.1-0.1-0.1-0.1-0.1-0.2c0-0.1,0-0.3,0-0.4c0-0.1,0-0.2,0.1-0.3c0.1-0.3,0.1-0.6,0.1-0.8c0-0.1,0.1-0.2,0.1-0.3 c0.1-0.1,0.2-0.1,0.3,0l0,0C19.1,15.9,19.3,16.5,19.6,17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st315",
    d: "M19.4,17.6c0.1,0,0.1,0,0.2,0c0,0.1,0,0.1,0,0.2c-0.2,0.1-0.2,0.3-0.2,0.4c-0.2,0.3-0.4,0.3-0.7,0.1 c-0.1-0.1-0.2-0.3-0.3-0.4c0-0.1,0-0.2,0-0.2c0-0.2-0.2-0.2-0.2-0.4c0.1-0.1,0.1-0.2,0.3-0.1c0.1,0,0.3,0,0.4,0 C19.1,17.4,19.2,17.5,19.4,17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st333",
    d: "M19.6,17c-0.9-0.3-0.6-1.1-0.7-1.7c0.3,0.2,0.2,0.6,0.4,0.9c0.1,0.2,0.3,0.4,0.4,0.6 C19.8,16.9,19.7,17,19.6,17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M19.8,16.8c-0.5,0-0.4-0.3-0.4-0.6c0.2,0.1,0.4,0.2,0.6,0.2C20,16.5,20,16.7,19.8,16.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M20.5,15.3c0.1-0.3-0.3-0.4-0.4-0.6c0.1,0,0.3,0,0.4,0C21.2,14.9,20.6,15.1,20.5,15.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st259",
    d: "M20.3,13.6c0.1,0,0.1,0,0.2,0c-0.1,0.1-0.1,0.1-0.2,0.2C20.3,13.7,20.3,13.6,20.3,13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st560",
    d: "M21.1,13.8c0.1-0.2,0.1-0.2,0.2,0C21.3,13.8,21.2,13.8,21.1,13.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M22,56.6c0,0.1,0,0.1,0,0.2c-0.1,0-0.1,0.1-0.2,0.1C21.8,56.8,21.9,56.7,22,56.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st561",
    d: "M18.1,11.4c-0.4,0-0.6-0.3-0.7-0.7c-0.1-0.3,0-0.8-0.6-0.9c0-0.1,0-0.1,0-0.2c0.1-0.1,0.2-0.2,0.3-0.2 c0.1,0,0.2,0,0.2,0c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.2,0.1c0,0,0.1,0,0.1,0c0.1,0,0.1,0.1,0.1,0.2c0,0.1,0,0.2,0,0.3 c0,0.1-0.2,0.1-0.1,0.3c0,0.1,0,0.1,0,0.2c0.1,0.1,0.1,0.1,0.2,0.2c0.1,0.2,0.2,0.3,0.1,0.5C18.2,11.5,18.2,11.5,18.1,11.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st562",
    d: "M19.2,12.3c0,0.1,0,0.1,0,0.2c-0.2,0.1-0.1,0.5-0.4,0.5c-0.2-0.2-0.3-0.4-0.3-0.7c0-0.1,0-0.3-0.1-0.4 c0-0.1,0-0.2,0-0.3c0.1-0.1,0-0.3,0.2-0.4C19,11.4,18.8,12,19.2,12.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st296",
    d: "M18.7,10.3c0.2,0,0.4-0.2,0.5,0c0.1,0.2-0.1,0.3-0.2,0.3C18.8,10.8,18.8,10.5,18.7,10.3L18.7,10.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st563",
    d: "M18.6,11.2c0,0.1,0,0.3,0,0.4c-0.1,0.1-0.2,0.1-0.3,0c-0.1-0.1,0-0.2,0-0.2c-0.1-0.1-0.1-0.3-0.2-0.4 c0.1-0.1,0.1-0.1,0.2-0.2C18.5,10.8,18.5,11,18.6,11.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st564",
    d: "M18.1,10.5c-0.2-0.1-0.2-0.2,0-0.2c0.1-0.1,0.3-0.1,0.4,0l0,0C18.5,10.5,18.3,10.5,18.1,10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st565",
    d: "M18.3,10.8c-0.1,0.1-0.1,0.1-0.2,0.2c0-0.1,0-0.1,0-0.2C18.2,10.7,18.3,10.7,18.3,10.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M20,14.6c-0.4-0.3-0.8-0.2-1.1,0.2c0,0-0.1-0.1-0.1-0.1c-0.2-0.2-0.2-0.4-0.2-0.7c0.1-0.2,0.1-0.6,0.5-0.6 C20.1,13.6,20.2,13.7,20,14.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M19.8,12.3c0,0.1,0,0.1,0,0.2c0.1,0.1,0.1,0.2,0.2,0.2v0c0,0.2,0.1,0.4-0.1,0.5c-0.3,0.1-0.4-0.2-0.5-0.4 C19.3,12.4,19.5,12.3,19.8,12.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st566",
    d: "M19.2,13.5c-0.3,0.1-0.1,0.5-0.4,0.6c-0.1,0.1-0.1,0.1-0.2,0c-0.1-0.1-0.1-0.2-0.1-0.2 c0-0.1,0.1-0.2,0.1-0.2c0-0.1,0-0.1,0-0.2c0,0,0-0.1,0-0.1c0-0.1,0.1-0.1,0.2-0.2c0,0,0.1-0.1,0.1-0.1c0.1-0.1,0.2-0.1,0.4,0 C19.2,13.3,19.2,13.4,19.2,13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st567",
    d: "M19.2,13.1c-0.1,0.1-0.3,0.1-0.4,0.2c-0.1-0.1-0.1-0.1-0.1-0.2c0-0.1,0-0.2,0.1-0.2c0.1-0.1,0.3-0.3,0.4-0.4 C19.2,12.7,19.2,12.9,19.2,13.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M20,12.7c-0.1-0.1-0.1-0.1-0.2-0.2C19.9,12.5,20,12.6,20,12.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st73",
    d: "M33.6,22c0.1-0.1,0.1-0.1,0.2-0.2C33.8,21.8,33.7,21.9,33.6,22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M34.5,24.1c0,0.1,0,0.1,0,0.2c-0.1,0-0.1,0-0.2,0c-0.1,0.1-0.2,0.1-0.2,0.2c-0.1,0.1-0.1,0.1-0.2,0.2 c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.2-0.3,0.3c-0.2,0.1-0.4,0.2-0.6,0.1c-0.1-0.1-0.1-0.2-0.2-0.4c0-0.1,0-0.3,0-0.4 c0-0.1,0.1-0.2,0.1-0.3c0.1-0.1,0.2-0.1,0.3,0c0.8,0.2,0.8,0.2,0.7-0.6c0.1,0,0.3,0,0.4,0c0.1,0.1,0.1,0.1,0.2,0.2 C34.3,24,34.4,24,34.5,24.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st568",
    d: "M42,53.8c-0.4,0-0.7,0.1-0.6,0.6c0.1,0.6-0.2,1.1-0.4,1.6c0,0-0.1,0.1-0.1,0.1c-0.4,0.1-0.6,0-0.8-0.3 c-0.1-0.2-0.1-0.4-0.1-0.6c0.1-0.3,0.4-0.7-0.1-1c0-0.1-0.1-0.2-0.1-0.3c0.1-0.2,0.1-0.3-0.1-0.5l-0.1-0.1c0-0.4,0.4-0.5,0.6-0.7 c0.2-0.2,0.4-0.3,0.6-0.2c0.1,0,0.1,0.1,0.2,0.2c0,0.1,0,0.3,0,0.4c0.1,0.3,0.4,0.1,0.6,0.1c0.1,0,0.2,0.1,0.3,0.1 c0.1,0.1,0.1,0.1,0.2,0.2c0,0,0,0.1,0.1,0.1C42.1,53.7,42.1,53.8,42,53.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st569",
    d: "M42.4,53.8c0,0.1,0,0.1,0,0.2c-0.2,0.6,0.4,0.9,0.6,1.3c0.2,0.3,0.1,0.5-0.2,0.7c-0.3,0.1-0.4-0.2-0.5-0.3 c-0.3-0.4-0.4-0.8-0.7-1.2c-0.4-0.4,0.4-0.4,0.6-0.6c0,0,0.1-0.1,0.1-0.1C42.4,53.8,42.4,53.8,42.4,53.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st570",
    d: "M41.8,57.5c-0.1-0.1-0.3-0.3-0.4-0.4c0,0,0-0.1-0.1-0.1c0-0.1,0-0.2,0.1-0.4c0.1-0.1,0.1-0.1,0.2-0.2 c0.1,0,0.1,0,0.2,0c0.1,0.1,0.2,0.1,0.2,0.2c0.1,0.1,0.3,0.2,0.2,0.4C42,57.1,41.8,57.2,41.8,57.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st571",
    d: "M40.9,56c0.2,0.1,0.4,0.2,0.4,0.4c0,0-0.1,0.1-0.1,0.1c-0.1,0.1-0.3,0.1-0.4,0c-0.1,0-0.2-0.1-0.2-0.2 C40.6,56.2,40.8,56.1,40.9,56L40.9,56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st572",
    d: "M42,53.8c0-0.1,0-0.1,0-0.2c0.2,0,0.3,0,0.2,0.2l0,0.1C42.2,53.9,42.1,53.8,42,53.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st573",
    d: "M41.6,56.4c0,0.1,0,0.1,0,0.2c-0.2,0.1-0.3,0-0.2-0.2c0,0,0,0,0,0C41.4,56.4,41.5,56.4,41.6,56.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st574",
    d: "M21.1,23.3c0.1,0.3,0.5,0.1,0.7,0.4c0,0.1-0.1,0.1-0.2,0.2c-0.2,0.1-0.3,0.3-0.5,0.3c-0.1,0-0.2,0-0.3,0 c-0.2-0.1-0.4-0.3-0.6-0.3c-0.2,0-0.4,0-0.5-0.1c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1-0.1-0.1-0.2-0.1-0.3c0-0.3-0.2-0.6,0.1-0.8 c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0.1,0.2,0.2c0,0.1,0.1,0.2,0.2,0.2c0.1-0.1,0.1-0.3,0.2-0.4c0-0.1,0.1-0.1,0.2-0.2 c0.3-0.1,0.5,0,0.7,0.2C21.1,22.7,20.9,23,21.1,23.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st461",
    d: "M21.5,23.7c0.1,0,0.1,0,0.2,0c0.2,0,0.3,0,0.4,0.2c0.2,0.5-0.3,0.9-0.4,1.3c-0.2,0.1-0.3,0.1-0.5,0 C21.2,24.6,21.3,24.1,21.5,23.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st445",
    d: "M21.1,23.3c-0.6,0-0.1-0.5-0.2-0.7c-0.3-0.4-0.3-0.7,0-1.1c0-0.2,0-0.3,0.2-0.4c0,0.3-0.1,0.6,0.2,0.9 c0.1,0.4,0.2,0.7,0,1.1C21.3,23.1,21.2,23.2,21.1,23.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st269",
    d: "M21.6,22.6c0.2-0.1,0.3-0.2,0.4-0.4c0.3,0.2,0.2,0.6,0.2,0.8c-0.2,0-0.4-0.1-0.6-0.2 C21.5,22.8,21.5,22.7,21.6,22.6C21.5,22.6,21.6,22.6,21.6,22.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st281",
    d: "M21.6,22.6c0,0.1,0,0.1,0,0.2c0,0.1-0.1,0.2-0.2,0.2c0-0.4,0-0.7,0-1.1C21.6,22.1,21.5,22.4,21.6,22.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st575",
    d: "M21.3,25.2c0.1,0,0.3,0,0.4,0c0,0.2,0,0.3,0.2,0.4c0.2-0.2,0.3-0.4,0.6-0.2c0.1,0.1,0.1,0.3,0.2,0.4 c-0.2,0.2-0.4,0.5-0.7,0.7c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.1-0.1-0.2-0.2c0-0.1-0.1-0.2-0.1-0.3 c-0.1-0.2-0.1-0.4-0.1-0.7C21.2,25.3,21.3,25.2,21.3,25.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st576",
    d: "M22,26.5c0.2-0.3,0.4-0.6,0.9-0.6c0,0.1,0,0.3,0,0.4c0.2,0.5,0,0.9-0.4,1.2c-0.6,0.1-0.9-0.1-1-0.6 c0-0.1,0-0.2,0.1-0.3c0.1,0,0.1,0,0.2,0c0.1,0.1,0.2,0.1,0.3,0.1C22.1,26.6,22,26.5,22,26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st577",
    d: "M22.4,27.3c0.2-0.3,0.5-0.6,0.4-1.1c0.1,0,0.1,0,0.2,0c0,0.1,0,0.1,0,0.2c0,0.4,0,0.7,0.4,0.9 c0.1,0.2,0,0.3-0.1,0.4c-0.3,0.2-0.5,0.2-0.8,0C22.4,27.6,22.3,27.5,22.4,27.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st445",
    d: "M22.6,25.4c-0.2,0.1-0.4,0.2-0.6,0.2c-0.1-0.5,0.3-0.7,0.6-0.9c0.1,0.1,0.2,0.2,0.2,0.2 C22.8,25.1,22.7,25.3,22.6,25.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st578",
    d: "M32.7,24.5c0,0.1,0,0.3,0,0.4c-0.2,0.1-0.2,0.3-0.3,0.5c0,0.1-0.1,0.2-0.1,0.2c-0.1,0.1-0.1,0.1-0.2,0.2 c0,0-0.1,0-0.1,0c-0.1,0-0.2-0.1-0.2-0.1c-0.1,0,0.1-0.2-0.1-0.2c-0.1,0,0.1,0,0,0.1c-0.1,0.1-0.1,0.2-0.3,0.2 c-0.1,0-0.2,0-0.2-0.1c0-0.4,0-0.7,0-1.1c0.3,0,0.6-0.1,0.8-0.2c0,0,0.1,0,0.1,0c0.1,0,0.2-0.1,0.3-0.1 C32.6,24.4,32.7,24.5,32.7,24.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st102",
    d: "M31.3,24.1c0.1,0.2,0.1,0.4,0,0.6C30.9,24.5,31,24.3,31.3,24.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st579",
    d: "M31.2,25.8c0.1,0,0.1,0,0.2,0c0.1-0.1,0.1-0.1,0.2-0.1c0.1,0,0.2,0,0.2,0.1l0,0c0.1,0.2,0,0.2-0.1,0.3 c-0.1,0.1-0.3,0.1-0.4,0c-0.1,0-0.2-0.1-0.2-0.2C31.2,26,31.2,25.9,31.2,25.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st580",
    d: "M31,26.3c0-0.1,0-0.1,0-0.2c0.1,0,0.1,0,0.2,0l0.1,0c0.1,0.1,0.1,0.1,0.1,0.2c0,0,0,0.1,0,0.1 c0,0-0.1,0.1-0.1,0.1c-0.1,0-0.2,0-0.3,0C30.9,26.4,31,26.3,31,26.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M32.1,24.3c0-0.2,0-0.3,0.2-0.4l0,0c0.1,0.1,0.1,0.1,0.1,0.2c0,0.1,0,0.2-0.1,0.2 C32.2,24.4,32.2,24.4,32.1,24.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st578",
    d: "M32.1,24.3c0.1,0,0.1,0,0.2,0c0.1,0.2,0,0.2-0.1,0.3c0,0-0.1,0-0.1,0C32.1,24.5,32.1,24.4,32.1,24.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st262",
    d: "M40.7,50c0.1-0.1,0.1-0.2,0.2-0.2c0.2-0.2,0.3-0.1,0.5,0c0.1,0.2,0.3,0.4,0.4,0.6c0,0.1,0,0.2-0.1,0.3 c-0.1,0.1-0.2,0.1-0.4,0.2c-0.7,0.1-0.8,1-1.4,1.1c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.1-0.1-0.2-0.2c0-0.1-0.1-0.3,0-0.4 c0.2-0.4,0.7-0.5,1-0.8c0-0.1,0-0.1,0-0.2C40.6,50.1,40.7,50,40.7,50z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M40.5,50.4c-0.1,0.4-0.6,0.6-0.9,0.9c-0.2,0-0.3,0-0.2-0.2C39.5,50.4,40,50.4,40.5,50.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st464",
    d: "M39.4,51c0.1,0.1,0.1,0.1,0.2,0.2c0,0.1,0,0.3,0,0.4c-0.3-0.3-0.3,0.4-0.6,0.2l0,0c0-0.3-0.1-0.4-0.2-0.7 C39,51.2,39.2,51,39.4,51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st581",
    d: "M33,63.3c0-0.1,0-0.3,0-0.4c0.1,0,0.1,0,0.2,0c0.2-0.2,0.5-0.1,0.7-0.1c0.1,0,0.3,0.1,0.4,0.1 c0.2,0.2,0.5,0.3,0.6,0.6c-0.1,0.3-0.5,0.1-0.6,0.4c-0.6-0.5-1.2,0.2-1.7,0c0,0-0.1-0.1-0.1-0.2c0-0.1,0-0.1,0-0.1 C32.6,63.5,32.8,63.5,33,63.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st582",
    d: "M31.9,64c-0.3,0-0.6,0.1-0.6-0.3c0-0.1,0-0.3,0.1-0.4c0.4-0.3,0.5,0.3,0.8,0.3c0.1,0.1,0.2,0.1,0.2,0.2 c0,0,0,0.1,0.1,0.1c0,0-0.1,0.1-0.1,0.1c-0.1,0-0.1,0-0.2,0C32.1,64,32,64.1,31.9,64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st583",
    d: "M31.9,64c0.1,0,0.1,0,0.2,0c0.1,0.3,0.4,0.6,0,0.9c0-0.2,0-0.3-0.2-0.4C31.9,64.3,31.9,64.1,31.9,64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M34.3,65.5c0.1,0,0.1,0,0.2,0c0,0.5-0.3,0.4-0.6,0.4C34,65.7,34.1,65.6,34.3,65.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st584",
    d: "M32.3,63.9c0-0.1,0-0.1,0.1-0.2c0.1-0.1,0.1-0.1,0.2,0c0,0.1,0,0.1-0.1,0.2C32.4,63.9,32.4,63.9,32.3,63.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st510",
    d: "M34.9,64.8c-0.2,0-0.4,0.1-0.5-0.2c0-0.1,0.1-0.3,0.2-0.3c0.3-0.2,0.3,0.3,0.5,0.3 C35.1,64.7,35,64.8,34.9,64.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M34.5,65.5c0.1-0.2,0.2-0.4,0.4-0.4c0,0.1,0,0.3,0,0.4C34.8,65.5,34.6,65.5,34.5,65.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st585",
    d: "M32.4,24.1c0-0.1,0-0.1,0-0.2c0.1,0,0.3,0,0.4-0.1c0.1,0,0.2,0,0.2,0c0,0.1,0,0.2,0,0.2c0,0.1,0,0.1,0,0.2 c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.2-0.1C32.5,24.2,32.4,24.2,32.4,24.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st586",
    d: "M33,24.1c0-0.1,0-0.2,0-0.3c0-0.1,0-0.1,0-0.2c0.1,0,0.1,0,0.2,0C33.2,23.9,33.2,24,33,24.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st587",
    d: "M33,23.7c0,0.1,0,0.1,0,0.2l-0.1,0l-0.1,0C32.8,23.8,32.9,23.7,33,23.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st243",
    d: "M14.2,20.2c-0.1,0-0.1,0-0.2,0c-0.1,0.1-0.1,0.1-0.2,0.2l0,0c-0.2-0.1-0.2-0.3-0.2-0.4 c-0.2-0.4-0.4-0.7-0.6-1.1c0.3-0.4,1-0.2,1.3-0.6c0.1,0.1,0.1,0.1,0.2,0.2c0.1,0.1,0.1,0.2,0.2,0.3C15,19.4,14.9,19.9,14.2,20.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M11.9,17.6c0,0.1,0,0.3,0,0.4C11.6,17.9,11.6,17.8,11.9,17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M41.4,48.9c0-0.3,0-0.6,0.4-0.6c0.2,0,0.4,0,0.6,0c0.1,0,0.1,0,0.2,0c0,0.6-0.5,0.8-1,0.9 C41.5,49.1,41.4,49,41.4,48.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M41.2,46.9c-0.1-0.1-0.1-0.1-0.2-0.2c0-0.1,0-0.1,0-0.2c0.2-0.1,0.4-0.2,0.6-0.2c0,0.2,0.1,0.5-0.2,0.6 C41.3,46.9,41.2,46.9,41.2,46.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st588",
    d: "M42.4,47.1c-0.1,0-0.3,0-0.4,0c0-0.2-0.3-0.3-0.1-0.5c0.1-0.1,0.2,0,0.3,0.1C42.3,46.8,42.6,46.9,42.4,47.1z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M42.4,47.1c-0.1-0.1-0.1-0.3-0.2-0.4c0.1,0,0.3,0,0.4,0C42.7,46.9,42.6,47.1,42.4,47.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st589",
    d: "M41.6,49.1c0.4-0.3,0.7-0.6,1.1-0.9c0.1,0,0.1,0,0.2,0c0,0.4,0,0.7,0,1.1c-0.2,0.3-0.6,0-0.8,0.4 c0,0.1-0.1,0.1-0.2,0.2c-0.3,0-0.4-0.1-0.6-0.3C41.3,49.3,41.4,49.2,41.6,49.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st312",
    d: "M14.2,18.3c0,1.1-0.8,0.5-1.3,0.6l0,0c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1-0.4,0.2-0.7,0.2-1.1 c0.1-0.1,0.3-0.2,0.4-0.2c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0c0.1,0.1,0.1,0.1,0.2,0.2c0.1,0.1,0.1,0.3,0.2,0.4 C14.2,18.1,14.2,18.2,14.2,18.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M12.7,18.7c0.1,0,0.2,0.1,0.2,0.2c-0.1,0-0.3,0-0.4,0C12.6,18.9,12.7,18.8,12.7,18.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st303",
    d: "M17.9,9.9c-0.1,0-0.1,0-0.2,0c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1,0-0.1,0-0.2,0c-0.6-0.3-0.6-0.8-0.2-1.3 c0-0.1,0-0.1,0-0.2C17.2,8,17.4,8.1,17.5,8c0.1,0,0.1,0,0.2,0c0.1,0.4,0.4,0.7,0.4,1.1c0.1,0.2,0,0.3,0,0.5 C18.1,9.7,18,9.8,17.9,9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M17,8.4c0.3,0.3,0.3,0.3,0.1,0.5C16.9,9,16.9,9,17.3,9.7c-0.1,0-0.3,0-0.4,0c-0.1-0.5-0.7-0.4-0.9-0.9 c0-0.1,0-0.1,0-0.2c0.1-0.1,0.3-0.1,0.4-0.2C16.6,8.4,16.8,8.4,17,8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st483",
    d: "M17.5,8c-0.1,0.2-0.3,0.2-0.4,0.2C17.1,8.1,17.2,8,17.3,8C17.3,8,17.4,8,17.5,8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st489",
    d: "M15.7,8.6c-0.1,0-0.2-0.1-0.2-0.2C15.7,8.4,15.7,8.5,15.7,8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st72",
    d: "M41.6,49.1c-0.1,0.1-0.2,0.3-0.2,0.4c-0.1,0.1-0.1,0.1-0.2,0c-0.1-0.2-0.3-0.4-0.4-0.6c0.2-0.1,0.4-0.1,0.6,0 C41.4,48.9,41.5,49,41.6,49.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st453",
    d: "M34.9,63.5c-0.2-0.1-0.5-0.2-0.7-0.4c0.1-0.1,0.3-0.1,0.4,0c0.3,0,0.4,0.1,0.4,0.4 C35,63.5,35,63.5,34.9,63.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M34.7,63.1c-0.1,0-0.3,0-0.4,0c-0.1,0-0.3,0-0.4,0c-0.3-0.7,0.3-0.9,0.8-1.2c0.1,0,0.2,0,0.3,0.1 c0.1,0.1,0.3,0.3,0.4,0.4c0,0.1,0,0.1,0,0.2C34.8,62.4,34.8,62.9,34.7,63.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st590",
    d: "M30.2,31.2c-0.1,0-0.2,0.1-0.2,0.2c-0.1,0-0.1,0-0.2,0c0.1-0.7-0.4-1.1-0.4-1.7c0,0,0-0.1,0.1-0.1 c0.2-0.2,0.3-0.4,0.2-0.6c0-0.1,0-0.2,0.1-0.3c0.2-0.2,0.3-0.2,0.5-0.1c0.3,0.3,0.1,0.8,0.4,1.1c0.1,0,0.1,0,0.2,0 c0,0.2-0.1,0.4-0.2,0.6C30.3,30.6,30.2,30.9,30.2,31.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st591",
    d: "M30.6,29.7c-0.5-0.2-0.4-0.7-0.4-1.1c-0.1-0.1-0.1-0.3,0-0.4c0.1,0,0.2,0,0.3,0c0.2,0.2,0.2,0.4,0.4,0.6 c0.3,0.1,0.2,0.4,0.2,0.6C30.8,29.4,30.6,29.3,30.6,29.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st340",
    d: "M38.1,51.7c0.2,0.1,0.2,0.3,0.2,0.4C38.2,52,38.1,51.9,38.1,51.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st308",
    d: "M37.9,52.4c0,0,0,0.1,0.1,0.1c-0.1,0-0.1,0-0.2,0.1c-0.1,0-0.1,0,0-0.1C37.8,52.4,37.9,52.4,37.9,52.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M39,51.9c0.2-0.1,0.3-0.5,0.6-0.2l0,0c0,0.1,0.1,0.2,0,0.3c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0-0.3,0-0.4-0.1l0,0 C39,52,39,52,39,51.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st389",
    d: "M51.3,45.4c0,0.1-0.1,0.2-0.2,0.2C51.1,45.6,51.2,45.5,51.3,45.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st309",
    d: "M13.2,33.2c-0.3,0.1-0.3,0.4-0.4,0.6c-0.2-0.1-0.5-0.2-0.6-0.4c0.3,0,0.7,0.1,0.4-0.4c0.3,0,0.6-0.1,0.9-0.2 C13.4,32.9,13.3,33.1,13.2,33.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M12.3,30.1c0.2,0,0.4,0,0.4-0.2c0.2-0.1,0.3,0.1,0.4,0.2c0,0.1,0.1,0.2,0.1,0.3c0,0.2,0,0.5-0.3,0.6 c-0.2,0-0.4-0.1-0.6-0.1c-0.1,0-0.2-0.1-0.2-0.1c-0.2,0-0.4,0-0.6,0c-0.1,0-0.2,0-0.3,0l0,0c-0.1-0.1-0.1-0.3,0-0.4 c-0.2-0.4-0.6-0.2-0.8-0.2v0c0-0.2,0-0.3-0.2-0.4c0,0,0-0.1,0-0.1c0.1-0.2,0.2-0.2,0.4-0.3c0.2-0.1,0.1-0.3,0-0.4 c0-0.1,0-0.2,0.1-0.3c0.9-0.6,0.8,0.6,1.3,0.7c0.3,0.1,0,0.3,0,0.4C12,29.8,12,30,12,30.1c0,0.1,0.1,0.1,0.1,0.1 C12.2,30.2,12.2,30.1,12.3,30.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st592",
    d: "M13.8,32.1c-0.1,0-0.3,0-0.4-0.1c0-0.1,0-0.1,0-0.2c-0.1-0.1-0.1-0.1-0.2-0.2l0,0c-0.1,0-0.1-0.1-0.1-0.1 c0,0,0-0.1,0.1-0.1c0.1,0,0.1,0,0.2,0c0.1-0.1,0.1-0.1,0.2-0.1c0.1,0,0.2,0,0.3,0.1c0.2,0.2,0.5,0.4,0.4,0.7 C14.1,32.1,14,32.1,13.8,32.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st269",
    d: "M12.9,31.1c0-0.2,0-0.5,0-0.7c0.2-0.1,0.3,0,0.4,0.1c0.1,0.2,0.2,0.3,0.2,0.6c0,0.1-0.1,0.2-0.2,0.2 C13.2,31.2,13,31.2,12.9,31.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st593",
    d: "M13.2,31.4c0,0.1,0,0.1,0,0.2c-0.1-0.1-0.1-0.1-0.2-0.2C13,31.5,13.1,31.4,13.2,31.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st430",
    d: "M13.6,31.4c-0.1,0-0.1,0-0.2,0c0-0.1,0-0.1-0.1-0.2l0.1,0C13.6,31.2,13.6,31.2,13.6,31.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st592",
    d: "M11.7,31.2c0-0.1,0-0.1,0-0.2c0.1,0,0.2,0.1,0.2,0.2C11.8,31.2,11.7,31.2,11.7,31.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st410",
    d: "M12.1,30.8c0.1,0,0.2,0.1,0.2,0.1C12.2,31,12.1,30.9,12.1,30.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M11.4,31.2c0.1,0,0.1,0,0.2,0c0,0.1,0,0.1,0,0.2C11.6,31.4,11.5,31.3,11.4,31.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st409",
    d: "M13.2,31.6c0.1,0,0.2,0.1,0.2,0.2C13.3,31.8,13.2,31.7,13.2,31.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st485",
    d: "M22,38.3c-0.1,0-0.1,0-0.2,0l0,0c-0.2-0.3-0.2-0.6-0.6-0.8c-0.2-0.2-0.4,0.1-0.6-0.1c-0.1-0.2-0.1-0.4,0-0.5 c0.1-0.2,0.3-0.3,0.5-0.4c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.2-0.1,0.2-0.1c0.1,0,0.2,0.1,0.2,0.1c0.1,0.2,0.1,0.3,0.1,0.5 c0.3,0.4,0.4,0.1,0.4-0.2c0-0.1,0.1-0.2,0.1-0.3c0.1-0.1,0.1-0.1,0.2-0.2c0.2,0,0.3,0.2,0.3,0.3c0.1,0.5,0.1,0.9,0.2,1.4 c0,0,0,0.1,0,0.1c0,0,0,0.1-0.1,0.1C22.8,38.3,22.3,37.9,22,38.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M23.7,40.1c-0.1,0-0.3,0-0.4,0c0-0.1,0-0.3-0.1-0.4c0,0,0-0.1,0-0.1c0-0.1,0-0.1-0.1-0.1 c0-0.1,0-0.1-0.1-0.2c0-0.1-0.1-0.2-0.1-0.3c0-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.2,0-0.2c0-0.1,0.1-0.1,0.1-0.2l0.1,0 c0.1-0.1,0.3-0.1,0.4-0.1c0.1,0.1,0.3,0.2,0.3,0.3c0.1,0.1,0.1,0.3,0.1,0.5c0,0.3,0,0.5-0.1,0.8C23.8,39.8,23.8,39.9,23.7,40.1 L23.7,40.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st594",
    d: "M23,38.1c0,0.1,0,0.2,0,0.2c-0.1,0.2-0.2,0.4-0.4,0.4c-0.2-0.1-0.4-0.3-0.6-0.4C22.1,37.6,22.1,37.6,23,38.1 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st595",
    d: "M22.6,38.8c0-0.3,0.1-0.4,0.4-0.4c0,0.1,0.1,0.1,0.1,0.2c0.1,0.1,0.1,0.2,0.2,0.3c0,0.2,0,0.4,0,0.6 c-0.1,0.1-0.1,0.1-0.2,0C22.9,39.2,22.8,39,22.6,38.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st596",
    d: "M23.1,39.4c0.1,0,0.1,0,0.2,0l0.1,0c0,0.1,0,0.2,0,0.2l-0.1,0C23.1,39.6,23.1,39.5,23.1,39.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st558",
    d: "M22,39c-0.1-0.1-0.1-0.1-0.2-0.2C21.8,38.8,21.9,38.9,22,39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st597",
    d: "M24.1,39.2c0,0.1,0,0.3,0,0.4c-0.1,0-0.2,0-0.2,0c0,0-0.1-0.1-0.1-0.1c0-0.2-0.1-0.5,0.3-0.6 C24.2,39,24.2,39,24.1,39.2C24.2,39.2,24.2,39.2,24.1,39.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st414",
    d: "M23.7,40.1c0-0.2,0-0.3,0-0.5c0.1-0.1,0.1,0,0.2,0.1l0,0C23.9,39.8,23.9,40,23.7,40.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st598",
    d: "M5,29.3c-0.1-0.1-0.1-0.1-0.2-0.2c0,0,0.1,0,0.1-0.1C4.9,29.1,5,29.2,5,29.3L5,29.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st248",
    d: "M41.2,49.5c0.1,0,0.1,0,0.2,0c0.2,0.1,0.4,0.2,0.7,0.2c0.1,0.1,0.1,0.2,0.1,0.3c-0.3,0.5-0.5,0.2-0.7-0.1 c-0.1-0.2-0.2-0.2-0.4-0.2C41,49.6,41,49.6,41.2,49.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M9.5,29.7c0.3-0.1,0.2-0.4,0.2-0.6c0.1-0.2,0.2-0.5,0.4-0.6c0.1,0.1,0.1,0.1,0.2,0.2c0.2,0.4-0.3,0.7-0.2,1.1 l0,0c-0.1,0.2-0.2,0.4-0.4,0.4C9.6,30,9.5,30,9.4,29.8C9.5,29.8,9.5,29.7,9.5,29.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st599",
    d: "M8.6,29.5c0.1-0.1,0.2-0.1,0.2-0.2c0.2,0.1,0.5,0.2,0.6,0.4l0,0c-0.1,0.2-0.3,0.1-0.4,0.2c0,0.1,0,0.1,0,0.2 c-0.1-0.1-0.3-0.1-0.4-0.2C8.6,29.8,8.6,29.6,8.6,29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st600",
    d: "M10.4,30.1c0,0.5-0.4,0.4-0.9,0.4C9.9,30.4,10.1,30.2,10.4,30.1L10.4,30.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st522",
    d: "M9.1,29.9c0.1-0.2,0.2-0.2,0.4-0.2c0.1,0.1,0.1,0.3,0.2,0.4C9.5,30.2,9.3,30,9.1,29.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st235",
    d: "M11.2,30.4c0,0.1,0,0.3,0,0.4c-0.1,0-0.1,0-0.2,0C10.9,30.6,10.8,30.3,11.2,30.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st601",
    d: "M42.9,54c0.3,0.2,1-0.5,0.9,0.4C43.4,54.5,43.1,54.3,42.9,54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st602",
    d: "M42.2,57c-0.1-0.1-0.1-0.3-0.2-0.4C42.3,56.7,42.6,56.7,42.2,57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st603",
    d: "M43.1,57.1c-0.1,0-0.2,0-0.2,0c-0.1,0-0.1-0.1-0.1-0.1C42.9,56.8,43,56.9,43.1,57.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st604",
    d: "M25.6,41.5c0.5-0.4,1-0.8,0.4-1.5c0-0.5,0.2-0.6,0.7-0.4c0.6-0.1,0.2,0.5,0.4,0.7c0,0.1,0,0.1,0,0.2 c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.2-0.3,0.4-0.4,0.6c-0.1,0.1-0.1,0.2-0.2,0.2C26.1,41.5,25.9,41.5,25.6,41.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st605",
    d: "M29.1,40.5c-0.1,0.1-0.1,0.1-0.2,0.2c0,0,0-0.1-0.1-0.1C28.9,40.5,29,40.5,29.1,40.5L29.1,40.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st337",
    d: "M26.3,41.5c0.1-0.1,0.1-0.1,0.2-0.2c0,0.1,0,0.1,0,0.2C26.4,41.5,26.4,41.5,26.3,41.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M26.9,40.7c0-0.1,0.1-0.2,0.2-0.2C27.1,40.5,27,40.6,26.9,40.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st606",
    d: "M31.7,26c0.1-0.1,0.2-0.1,0.2-0.2c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0s0-0.1,0-0.1 c0,0,0.1-0.1,0.1-0.1l0,0c0.1-0.1,0.2-0.2,0.4-0.2c0.2-0.1,0.4-0.2,0.6-0.2c0.1-0.1,0.2-0.1,0.2,0c0.1,0.2,0,0.4,0.3,0.5 c0,0.1,0,0.2,0,0.3c-0.1,0.1-0.1,0.2-0.3,0.1c-0.1,0-0.2,0.1-0.2,0.2c-0.2,0-0.5-0.1-0.6,0.2c-0.2,0.2-0.3,0.3-0.6,0.3 c-0.2-0.1-0.3-0.2-0.5,0l-0.1,0l-0.1,0c-0.1,0-0.1-0.1-0.1-0.2c0-0.1,0-0.2,0-0.2C31.5,26.2,31.6,26.1,31.7,26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st535",
    d: "M33.8,25.8c0-0.1,0-0.1,0-0.2c-0.1-0.1-0.1-0.3-0.2-0.4c-0.1,0-0.2,0-0.2,0c0.1-0.1,0.1-0.1,0.2-0.2 c0.1-0.1,0.1-0.1,0.2,0c0.1,0,0.3-0.3,0.4,0c0,0.2,0,0.3,0.2,0.4c0,0.3-0.1,0.6-0.4,0.8C33.9,26.2,34,25.9,33.8,25.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st429",
    d: "M33.8,25.8c0.2,0.1,0.2,0.3,0.2,0.4l0,0c-0.1,0.1-0.1,0.1-0.2,0c-0.1-0.1-0.1-0.1-0.2-0.2 C33.7,26,33.8,25.9,33.8,25.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st243",
    d: "M33.8,26.3c0.1,0,0.1,0,0.2,0C34,26.4,33.9,26.4,33.8,26.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st607",
    d: "M35.4,56.8c0.2-0.2,0.3-0.6,0.6-0.7c0.2-0.1,0.3,0,0.3,0.2c0,0.3,0,0.6-0.2,0.9c-0.4,0.4-0.7,0.2-0.9-0.2 C35.2,57,35.3,56.9,35.4,56.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st409",
    d: "M35.4,56.8c0,0.1,0,0.1,0,0.2c-0.1,0.3-0.2,0.8-0.6,0.2c-0.1-0.3,0.4-0.6,0-0.9C35.3,56,35.1,56.8,35.4,56.8 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st608",
    d: "M36.2,56.4c0-0.1-0.1-0.2-0.2-0.2c0.1-0.1,0.1-0.1,0.2-0.2c0.4,0.3,0.4,0.7,0.7,1.1c0,0.1,0,0.2,0,0.2 c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0C36.1,57.1,36.1,56.8,36.2,56.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st312",
    d: "M13.8,17.2c0,0.1,0,0.1,0,0.2l0,0c-0.1,0.1-0.3,0.1-0.4,0l0,0c0.1-0.1,0.2-0.1,0.2-0.2 C13.7,17.2,13.7,17.2,13.8,17.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st609",
    d: "M32.6,63.7c-0.1,0-0.1,0-0.2,0l-0.1,0c0-0.1,0-0.1,0-0.2c0.1-0.1,0.1-0.2,0.2-0.2c0.2,0,0.3,0,0.5,0 C33,63.6,32.9,63.7,32.6,63.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st315",
    d: "M32.6,62.9c0,0.1,0,0.1,0,0.2c-0.1-0.1-0.1-0.1-0.2-0.2C32.4,62.9,32.5,62.9,32.6,62.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st384",
    d: "M32.3,63.5c0,0.1,0,0.1,0,0.2c-0.1-0.1-0.1-0.1-0.2-0.2C32.2,63.5,32.2,63.5,32.3,63.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st378",
    d: "M34,24.5c0.1-0.1,0.1-0.1,0.2-0.2C34.2,24.4,34.1,24.5,34,24.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st378",
    d: "M33.8,25l-0.1,0l-0.1,0c0.1-0.1,0.1-0.1,0.2-0.2C33.8,24.8,33.8,24.9,33.8,25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st610",
    d: "M27.4,31c-0.4,0.1-0.8-0.2-1.1,0.2c-0.1,0.1-0.2,0.1-0.2,0.2c-0.5,0.2-0.9,0.8-1.5,0.4 c-0.1-0.1-0.1-0.2-0.1-0.3c0-0.6,0.2-1.2,0.3-1.8c0.1-0.1,0.2-0.3,0.3-0.3c0.5,0.7,1,1.3,2,0.6c0.1,0,0.2,0,0.3,0.1 c0.1,0.1,0.1,0.2,0.1,0.3C27.6,30.6,27.6,30.9,27.4,31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st611",
    d: "M27.4,31c0-0.2,0-0.4,0-0.7c0.1,0,0.1-0.1,0.1-0.1c0,0,0-0.1-0.1-0.1c-0.1,0-0.1,0-0.2,0 c-0.3-0.2-0.4-0.3,0-0.5c0.1,0,0.2,0,0.3,0c0.1,0.1,0.3,0.1,0.4,0.2c0.2,0.2,0.3,0.4,0.4,0.6c0.1,0.4-0.1,0.7-0.4,1 c0,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.1-0.2-0.2-0.2C27.4,31.3,27.4,31.1,27.4,31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st612",
    d: "M27.6,32.5c0,0.1-0.1,0.3-0.1,0.4c-0.2,0.1-0.4,0.4-0.7,0.2c-0.1-0.1-0.1-0.2-0.1-0.3 c-0.1-0.4,0.1-0.6,0.4-0.8C27.5,32.1,27.6,32.3,27.6,32.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st178",
    d: "M27.2,32.1c-0.1,0.3-0.3,0.5-0.2,0.9c-0.6-0.1-0.5-0.5-0.5-0.9c0,0,0.1-0.1,0.1-0.1 C26.7,31.9,26.9,32.1,27.2,32.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st613",
    d: "M27.8,31.4c0-0.4,0.3-0.7,0.2-1.1c0.1-0.1,0.2,0,0.3,0c0.2,0.2,0.2,0.5,0.1,0.8c0,0.1-0.1,0.2-0.1,0.3 c-0.1,0.1-0.2,0.1-0.3,0C28,31.4,27.9,31.4,27.8,31.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st614",
    d: "M28.2,31.8c0.1,0.1,0.3,0.3,0.4,0.4c0,0.1,0,0.1,0,0.2c-0.1,0-0.2,0.1-0.2,0.2c-0.1,0-0.1,0-0.2,0 c0-0.3-0.1-0.6-0.2-0.9C28.1,31.8,28.1,31.8,28.2,31.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st613",
    d: "M27.4,31.4c0.1,0.1,0.1,0.1,0.2,0.2c0,0.1-0.1,0.1-0.2,0.1C27.4,31.6,27.4,31.5,27.4,31.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M26.1,31.2c0.1,0,0.1,0,0.2,0c0,0.1,0,0.3,0,0.4c0,0-0.1,0-0.1,0C26,31.6,25.9,31.4,26.1,31.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st613",
    d: "M28.2,31.8c-0.1,0-0.1,0-0.2,0c0-0.1,0-0.1,0-0.2c0.1-0.1,0.1-0.1,0.2,0C28.2,31.7,28.2,31.8,28.2,31.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st487",
    d: "M26.3,31.6c0.1,0,0.2,0.1,0.2,0.2l0,0c-0.1,0.1-0.2,0.1-0.2,0C26.2,31.8,26.2,31.7,26.3,31.6L26.3,31.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st615",
    d: "M28.2,31.7c-0.1,0-0.1,0-0.2,0c0-0.1,0-0.1,0-0.2c0.1,0,0.1,0,0.2,0C28.3,31.5,28.3,31.5,28.2,31.7 C28.3,31.6,28.2,31.6,28.2,31.7L28.2,31.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st616",
    d: "M26.7,34.9c0.1,0,0.1,0,0.2,0c0,0.1,0,0.1,0,0.2c-0.1,0.1-0.1,0.1-0.1,0.2c0,0,0,0.1,0,0.1 c-0.1,0.2-0.1,0.3-0.3,0.4c-0.1,0.1-0.3,0.2-0.5,0.2c-0.1,0-0.2-0.1-0.3-0.1c-0.1-0.2-0.1-0.3-0.2-0.5c0-0.1,0-0.2,0-0.3 c0-0.1,0-0.2,0-0.3c0-0.1,0.1-0.2,0.1-0.3c0.1-0.2,0.3-0.4,0.5-0.4c0.1,0,0.2,0,0.3,0.1C26.8,34.4,26.6,34.7,26.7,34.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st617",
    d: "M26.9,35.3c0.3,0.2,0.2,0.6,0.4,0.9c-0.1,0.2-0.3,0.2-0.5,0.1c-0.2-0.1-0.2-0.3-0.2-0.5 c0.1-0.2-0.1-0.3,0-0.5l0,0C26.8,35.2,26.9,35.2,26.9,35.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st618",
    d: "M26.7,36.2c0.2,0,0.4,0,0.6,0c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c-0.1,0-0.1,0-0.2,0 c-0.1,0.1-0.3,0.1-0.4,0C26.6,36.5,26.6,36.3,26.7,36.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st619",
    d: "M26.9,35.3c-0.1,0-0.1,0-0.2,0c0.1-0.1,0.1-0.1,0.2-0.2C26.9,35.2,26.9,35.2,26.9,35.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st620",
    d: "M26.3,31.9c0.1,0,0.1,0,0.2,0c0.1,0.4,0.1,0.8,0.4,1.1c0,0.1,0,0.1,0,0.2c0.1,0.1,0.3,0,0.4,0.2 c0,0,0.1,0,0.1,0c-0.2,0.2-0.3,0.4-0.3,0.6l-0.1,0l-0.1,0c0,0-0.1,0-0.1,0c-0.2,0-0.4,0-0.5,0.1c-0.1,0-0.3,0-0.4-0.1 c-0.1-0.1-0.1-0.1-0.2-0.2c0-0.1,0-0.3,0-0.4c0.1-0.2,0.1-0.4,0.2-0.6c0.1-0.2,0.1-0.4,0.2-0.6C26.2,32,26.2,31.9,26.3,31.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st621",
    d: "M26.7,34.9c-0.3-0.1-0.2-0.4-0.2-0.6c0.1-0.1,0.1-0.1,0.2-0.1c0.1,0.1,0.1,0.2,0.2,0.3 C26.9,34.6,26.8,34.7,26.7,34.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st620",
    d: "M26.9,34.4c-0.1,0-0.2-0.1-0.2-0.2c-0.1-0.2,0-0.3,0.2-0.2l0,0C26.9,34.2,26.9,34.3,26.9,34.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st622",
    d: "M27.3,33.4c-0.2,0-0.3,0-0.4-0.2c0.2-0.1,0.4-0.1,0.6-0.2C27.6,33.1,27.4,33.2,27.3,33.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st611",
    d: "M28.2,31.2c0-0.3,0-0.6,0-0.9c-0.3-0.4-0.1-0.7,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1c0.2,0,0.3,0.1,0.3,0.3 c0,0.2,0,0.4-0.2,0.4c-0.1,0.1-0.1,0.3,0,0.4c0,0.2,0,0.5,0,0.7c0,0.1,0,0.3-0.2,0.1C28.5,31.3,28.3,31.4,28.2,31.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st623",
    d: "M29.1,29.7c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1,0-0.1-0.1-0.1-0.2c0-0.1,0-0.1,0-0.1c0.1-0.2,0.3-0.3,0.5-0.3 c0.1,0,0.2,0.1,0.3,0.1c0.1,0.3-0.1,0.5-0.3,0.6l0,0C29.2,29.7,29.2,29.7,29.1,29.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st624",
    d: "M28.2,31.2c0.2,0,0.3,0,0.4,0.2c-0.1,0.1-0.3,0.1-0.4,0.2c0-0.1,0-0.1,0-0.2C28.2,31.4,28.2,31.3,28.2,31.2z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st625",
    d: "M28.9,30.6c-0.3-0.1-0.2-0.3,0-0.4C28.9,30.3,28.9,30.4,28.9,30.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st429",
    d: "M14.2,20.2c0.3-0.5,0.5-1,0.2-1.5c0.5-0.2,0.4,0.6,0.9,0.4c0.1,0,0.1,0,0.2,0c-0.2,0.8,0.6,0.3,0.9,0.7 c-0.2,0.4-0.7,0.6-0.7,1.1c-0.1,0.1-0.1,0.1-0.2,0c-0.3-0.1-0.6-0.1-0.9-0.2C14.5,20.5,14.4,20.4,14.2,20.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M16.4,19.8c-0.4,0-0.7,0.1-1,0.3c-0.1-0.4,0-0.7,0.2-1c0.1,0,0.1,0,0.2,0c0.1-0.1,0.3-0.1,0.4-0.2h0 C16.6,19.1,16.7,19.4,16.4,19.8L16.4,19.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M15.3,19.1c-0.1-0.1-0.3,0.7-0.5,0c0-0.2-0.2-0.3-0.4-0.4c0-0.1,0-0.1,0-0.2C14.9,18.5,15.1,18.8,15.3,19.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st626",
    d: "M14.2,18.1C14,18,14,17.8,14,17.6C14.2,17.7,14.2,17.9,14.2,18.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M16.4,19.8c0-0.3-0.1-0.6-0.2-0.9c0.2-0.1,0.2-0.3,0.2-0.4c0.3,0.2,0.4,0.5,0.4,0.9c-0.1,0.1-0.1,0.3-0.2,0.4 C16.5,19.8,16.5,19.8,16.4,19.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st576",
    d: "M16,13.1c0.1,0,0.1,0,0.2,0c0,0.2,0,0.3,0.2,0.4c0.1,0.1,0.2,0.1,0.2,0.2c0,0.4,0,0.7,0,1.1 c-0.4,0-0.7,0.1-1-0.2c0.1-0.5,0.3-1,0.2-1.5C15.8,13.1,15.9,13.1,16,13.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st627",
    d: "M18.5,11.9c0,0.1,0,0.3,0,0.4c0.1,0.2,0.1,0.4-0.2,0.5c-0.1,0-0.2,0-0.3-0.1c-0.1,0-0.1,0-0.2,0 c0.2-0.3,0.4-0.5,0-0.8c0.1-0.1,0.2-0.1,0.4-0.1C18.4,11.7,18.5,11.8,18.5,11.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st248",
    d: "M17,14.9c-0.1,0-0.1,0-0.2,0c0-0.2,0-0.4,0-0.7C17.1,14.4,17,14.6,17,14.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st566",
    d: "M18.8,13.1c0,0.1,0,0.1,0,0.2l0,0c-0.1,0.1-0.1,0.1-0.2,0.2l0,0c-0.1,0-0.1,0-0.2,0c0-0.1,0-0.2,0-0.2 c-0.1-0.2,0-0.3,0.2-0.3C18.6,13,18.7,13,18.8,13.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st628",
    d: "M18.5,13.1c-0.1,0.1-0.1,0.1-0.2,0.2c-0.2-0.1-0.2-0.2-0.2-0.4c0.1-0.1,0.2-0.1,0.3-0.1 C18.5,12.9,18.7,12.9,18.5,13.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st629",
    d: "M18.3,12.9c-0.1,0-0.1,0-0.2,0c0-0.1,0-0.1,0-0.2c0.1,0,0.1,0,0.2,0C18.4,12.7,18.4,12.8,18.3,12.9 C18.4,12.9,18.4,12.9,18.3,12.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M16.6,13.8c-0.1-0.1-0.1-0.1-0.2-0.2C16.5,13.6,16.6,13.7,16.6,13.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st102",
    d: "M18.5,14c0,0.1,0,0.2,0,0.2c0.2,0.2,0.1,0.4-0.1,0.6c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0-0.2,0-0.1,0.1 c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.3-0.1,0.4c-0.3,0.1-0.5,0-0.6-0.3c-0.2-1,0-1.3,0.9-1.7C18.4,13.8,18.5,13.9,18.5,14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M17.5,15.5c0.2,0,0.4,0.1,0.6,0.2c0,0.1,0,0.1,0,0.2c0,0-0.1,0-0.1,0s0,0.1,0,0.1c0.1,0,0.1,0.1,0.1,0.2 c0,0,0,0.1-0.1,0.1c-0.2,0.1-0.3,0.5-0.6,0.4C17.3,16.3,16.9,15.9,17.5,15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st630",
    d: "M18.5,14c-0.1,0-0.2-0.1-0.2-0.2c0.1,0,0.1,0,0.2,0C18.5,13.8,18.5,13.9,18.5,14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st631",
    d: "M17,19.4c0-0.6,0-1.2,0.7-1.5c0.3-0.1,0.5,0.1,0.7,0.2c0.1,0.1,0.2,0.2,0.2,0.3c0.1,0.2,0.2,0.4,0.2,0.6 c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2-0.1,0.2c-0.3,0.1-0.5,0.1-0.8,0c-0.2-0.1-0.4-0.1-0.6-0.1C17.3,19.5,17.1,19.5,17,19.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st448",
    d: "M18.1,22c-0.3,0-0.6-0.2-0.9,0c-0.1,0.1-0.1,0.1-0.2,0l0,0c-0.1,0-0.1-0.1-0.1-0.1c0,0,0-0.1,0.1-0.1 c0.1-0.7-0.3-1.3-0.2-1.9c0.1,0,0.1,0,0.2,0c0.2,0,0.4,0.1,0.5,0.3c0,0.2,0,0.3,0.1,0.5c0.1,0.2,0.3,0.3,0.4,0.5 c0.1,0.2,0.2,0.4,0.2,0.6C18.2,21.8,18.2,21.9,18.1,22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st151",
    d: "M18.3,18.3c-0.2-0.1-0.4-0.3-0.6-0.4c0-0.1,0-0.1,0-0.2c0.2-0.3,0.5-0.6,0.4-1.1c0.1-0.1,0.1-0.1,0.2,0 c0.1,0.1,0,0.3,0.2,0.5c0,0.1,0,0.2,0,0.2c-0.1,0-0.2,0.1-0.2,0.2c0.1,0.1,0.2,0.1,0.2,0.2c0,0.1,0,0.2,0,0.3 C18.6,18.1,18.5,18.2,18.3,18.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st355",
    d: "M17.5,20.2c-0.1-0.1-0.3-0.3-0.4-0.4c0-0.1,0-0.3,0-0.4c0.1,0,0.3,0,0.4,0c0.3,0,0.5,0.1,0.6,0.4 c0,0.2-0.1,0.4-0.3,0.5c0,0-0.1,0-0.1,0C17.6,20.3,17.5,20.2,17.5,20.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st429",
    d: "M16.6,19.8c0-0.2,0-0.3,0.2-0.4c0,0.1,0,0.3,0,0.4C16.7,19.8,16.7,19.8,16.6,19.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st632",
    d: "M18.3,16.6c-0.1,0-0.1,0-0.2-0.1c0-0.1,0-0.1,0-0.2l0,0c0.2-0.1,0.4-0.2,0.4,0.2l0,0 C18.5,16.7,18.4,16.7,18.3,16.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st633",
    d: "M36.2,60.3C36,60.4,36,60.5,36,60.7c-0.3,0.2-0.7-0.5-0.9,0.2c0,0-0.1,0.1-0.1,0.1c-0.1,0-0.2-0.1-0.2-0.1 c0-0.1,0-0.3-0.1-0.3l0,0c0-0.1-0.1-0.1-0.1-0.2c0-0.1,0-0.1,0-0.1c0.1-0.2,0.2-0.3,0.3-0.5c0-0.1,0.1-0.2,0.1-0.2 c0.2-0.2,0.4-0.4,0.7-0.5c0.1,0,0.2,0,0.3-0.1c0.3,0,0.6,0,0.8,0.2C36.9,59.7,36.1,59.7,36.2,60.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st634",
    d: "M36.8,59.2c-0.3,0.2-0.6,0-0.9,0c-0.1-0.1-0.1-0.2-0.1-0.3c0.1-0.4,0.4-0.7,0.6-1c0.1-0.1,0.1-0.1,0.2-0.2 c0,0,0.1,0,0.1-0.1c0.1,0,0.2,0,0.3,0.1c0.1,0.2,0.1,0.3,0.2,0.5c0.1,0.1,0.2,0.2,0.2,0.3c-0.1,0.1-0.2,0.2-0.2,0.2 C37.2,59,37,59.1,36.8,59.2L36.8,59.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "M39.6,58.6c0,0.2,0.1,0.4,0.2,0.6c-0.2,0-0.4,0.1-0.6,0.2c-0.1,0-0.1,0-0.2,0c-0.1-0.1-0.1-0.1-0.2-0.2 c0-0.1,0-0.1,0-0.2c-0.1-0.3,0-0.4,0.2-0.6C39.2,58.4,39.5,58.4,39.6,58.6L39.6,58.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st635",
    d: "M37.5,58.6c-0.2,0-0.4,0-0.5-0.2c0.3-0.3,0.7-0.3,1-0.1c0.1,0.1,0.2,0.3,0.1,0.5c0,0.2,0,0.5-0.3,0.5 c-0.3,0-0.1-0.3-0.1-0.5C37.8,58.6,37.6,58.6,37.5,58.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st636",
    d: "M38.1,58.8c0-0.1,0-0.3,0-0.4c0,0,0.1-0.1,0.1-0.1c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0.1,0.4,0.1 c0.1,0.1,0.1,0.1,0.2,0.2c-0.1,0.1-0.1,0.3-0.2,0.4C38.5,59,38.3,58.9,38.1,58.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st635",
    d: "M36.8,59.2c0.1-0.2,0.2-0.4,0.4-0.4C37.3,59.1,37.1,59.2,36.8,59.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st452",
    d: "M34.9,62c-0.1,0-0.1,0-0.2,0c-0.2-0.1-0.5,0-0.7-0.2c0-0.2,0-0.4,0.2-0.5c0.2-0.2,0.6-0.2,0.9-0.4l0,0 c0.5,0.1,1.1,0,1.3,0.7c-0.3,0.1-0.4,0.3-0.4,0.6c-0.2-0.1-0.4-0.2-0.6-0.4C35.1,61.5,35,61.8,34.9,62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st452",
    d: "M36.6,61.8c-0.1-0.1-0.1-0.1-0.2-0.2C36.5,61.6,36.6,61.7,36.6,61.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st260",
    d: "M39.4,61.1c-0.1-0.1-0.1-0.1-0.2-0.2C39.3,61,39.4,61,39.4,61.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st637",
    d: "M15.5,20.9c0.1,0,0.1,0,0.2,0c0.1,0.3,0.8,0.3,0.5,0.7c-0.2,0.3-0.6,0.1-0.9-0.1 C15.3,21.3,15.4,21.1,15.5,20.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st274",
    d: "M17.3,22.2c0.2,0,0.5-0.1,0.6,0.3c0.1,0.3-0.2,0.4-0.4,0.4c-0.1-0.1-0.1-0.3-0.2-0.4 C17.2,22.3,17.2,22.3,17.3,22.2C17.2,22.2,17.2,22.2,17.3,22.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st261",
    d: "M17,21.7c0,0.1,0,0.1,0,0.2c-0.2,0.1-0.2,0.4-0.3,0.5C16.4,22,16.5,21.8,17,21.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M17.3,22.2c0,0.1,0,0.2,0,0.2C17.1,22.3,17,22.1,17,22c0.1,0,0.1,0,0.2,0C17.2,22,17.2,22.1,17.3,22.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st250",
    d: "M18.5,26.7c0-0.1,0-0.1,0-0.2c0.6-0.1,1.3,0.2,1.9,0c0,0,0.1,0.1,0.1,0.1c0,0.1,0.1,0.2,0.1,0.2 c0,0.2,0.1,0.4,0.2,0.6c0,0.1,0,0.3-0.1,0.4c-0.2,0.1-0.4,0-0.5-0.1c-0.2-0.2-0.5-0.2-0.8-0.2c-0.5,0-0.7-0.3-0.8-0.7 C18.6,26.8,18.5,26.7,18.5,26.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st638",
    d: "M18.3,24.3c0-0.1,0-0.1,0-0.2c0.1-0.1,0.1-0.3,0.2-0.3c0.1-0.1,0.3-0.1,0.4-0.1c0.1,0,0.2,0,0.3,0 c0.2,0.1,0.5,0,0.6,0.4c-0.2,0.5-0.6,0.9-0.9,1.3l-0.1,0l-0.1,0C18.8,25,18.7,24.6,18.3,24.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st639",
    d: "M19,25.4c-0.1-0.7,0.4-1,0.8-1.3c0,0,0.1,0.1,0.1,0.1c0,0.1,0.1,0.2,0.1,0.2c0,0.1,0,0.2,0,0.3 c0,0.2,0.1,0.5,0,0.7C19.7,25.7,19.3,25.4,19,25.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st640",
    d: "M20.5,26.5c-0.1-0.2-0.1-0.4-0.2-0.6c-0.1-0.1-0.1-0.3-0.1-0.4c0-0.1,0.1-0.1,0.2-0.2c0.1,0,0.3,0.1,0.4,0.2 c0.1,0.1,0.2,0.3,0.2,0.5c0,0.1,0,0.2,0,0.3c0,0,0,0.1-0.1,0.1c-0.1,0.1-0.1,0.1-0.2,0.2C20.6,26.6,20.5,26.5,20.5,26.5L20.5,26.5z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st641",
    d: "M20.3,25.4c0,0.2,0,0.3,0,0.5c-0.2-0.1-0.2-0.3-0.2-0.5c-0.1-0.3-0.3-0.5-0.2-0.9c0.1-0.1,0.2-0.1,0.4-0.1 c0.1,0.1,0.1,0.1,0.1,0.2c-0.1,0.1-0.1,0.2,0,0.3C20.4,25.1,20.4,25.3,20.3,25.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st539",
    d: "M18.8,30.4c-0.1-0.2-0.3-0.4-0.4-0.6c0.1-0.1,0.3-0.3,0.4-0.4c0.1-0.3,0.4-0.4,0.6-0.5 c0.3,0,0.5,0.1,0.7,0.2c0.2,0.1,0.3,0.3,0.3,0.5c0,0.1-0.1,0.2-0.1,0.3c-0.1,0.1-0.1,0.1-0.2,0.2C19.8,30,19.6,30,19.4,30 c-0.3-0.1-0.2,0.3-0.4,0.4C18.9,30.4,18.8,30.4,18.8,30.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st642",
    d: "M19.4,28.8c-0.1,0.3-0.4,0.3-0.6,0.4c-0.6-0.5-0.4-1.3-0.4-1.9c0.1-0.1,0.2-0.1,0.3-0.1 c0.2,0,0.3,0.2,0.3,0.3C18.9,28,19.4,28.4,19.4,28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st643",
    d: "M18.5,27.3c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0c0-0.1,0-0.1,0-0.2c-0.1-0.2,0.1-0.3,0.2-0.4 c0.1,0,0.1,0,0.2,0l0,0C18.7,26.9,18.7,27.1,18.5,27.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st644",
    d: "M16.8,30.4c0-0.1,0-0.1,0-0.2c0.2,0,0.4,0,0.6,0l0,0c0.3,0.3,0.1,0.7,0.2,1c0,0.2,0,0.5-0.3,0.6 c0,0-0.1,0-0.1,0c-0.4-0.2-0.1-0.7-0.4-0.9C16.6,30.8,16.7,30.6,16.8,30.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st315",
    d: "M18.8,30.4c0.1,0,0.1,0,0.2,0c0.1-0.1,0.2-0.1,0.2-0.1c0.3,0.1,0.5,0.2,0.7,0.4c0.1,0.1,0.3,0.2,0.4,0.2 c0.1,0,0.2,0.1,0.2,0.1c0,0.1,0.1,0.2,0.1,0.2c0,0.1,0,0.2,0,0.3c-0.1,0.2-0.2,0.3-0.3,0.4c-0.2,0-0.3-0.1-0.4-0.1 c-0.3-0.2-0.6-0.4-0.8-0.7c-0.2,0.5,0.4,0.4,0.5,0.7c-0.1,0.5,0.3,0.7,0.7,0.9c0.3,0.8,0,1-0.8,0.9c-0.1,0-0.3,0.1-0.3,0.1 c-0.1-0.1,0-0.2,0.1-0.3c0.1-0.5-0.4-0.2-0.5-0.4c-0.8-0.3-1-1-1.1-1.8c-0.1-0.3,0-0.6,0.3-0.8C18.2,30.4,18.5,30.4,18.8,30.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st62",
    d: "M17.9,30.3c-0.1,0.3-0.1,0.6-0.2,0.9c-0.1,0.1-0.1,0.1-0.2,0c-0.3-0.4,0-0.7,0-1.1 C17.7,30.1,17.8,30.2,17.9,30.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st269",
    d: "M17.7,24.7c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0.1,0.1,0.2c-0.1,0.1-0.2,0-0.3,0.1C17.7,24.9,17.7,24.8,17.7,24.7z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st608",
    d: "M18.1,22c0-0.1,0-0.1,0-0.2c0.1-0.1,0.1-0.1,0.2-0.2c0.2-0.1,0.4-0.1,0.6,0c0.1,0,0.2,0.1,0.3,0.1 c0.1,0.1,0.1,0.2,0.1,0.3c-0.1,0.4-0.3,0.8-0.3,1.2c0,0.1-0.1,0.2-0.1,0.3c0,0.1-0.1,0.2-0.2,0.2c0,0-0.1,0-0.1,0.1 c-0.1,0-0.2,0-0.2-0.1c0-0.4,0-0.7,0-1.1C18.5,22.3,18.2,22.2,18.1,22L18.1,22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st448",
    d: "M18.1,22c0.2,0.2,0.6,0.3,0.2,0.6C18.2,22.4,18.1,22.2,18.1,22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st460",
    d: "M18.3,23.7c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0.1,0.1,0.1c0,0,0,0.1-0.1,0.1c-0.1,0.1-0.1,0.1-0.2,0.2 c0-0.1,0-0.1,0-0.2C18.3,23.8,18.3,23.7,18.3,23.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st299",
    d: "M18.3,26.7c-0.1,0.1-0.1,0.3-0.2,0.4C18,27,17.8,27,17.7,26.9c0-0.3,0.1-0.4,0.4-0.4 C18.2,26.5,18.3,26.6,18.3,26.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st645",
    d: "M13.8,20.4c0.1-0.1,0.1-0.1,0.2-0.2c0,0.1,0,0.1,0,0.2C13.9,20.4,13.9,20.4,13.8,20.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st646",
    d: "M43.5,49.7c0.2,0.1,0.2,0.2,0.2,0.4c0,0-0.1,0.1-0.2,0.1c-0.1,0.1-0.3,0.1-0.4,0.1C43.1,50.2,43,50.1,43,50 C43.1,49.8,43.3,49.7,43.5,49.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st647",
    d: "M43.1,50.2c0.2,0,0.3,0,0.5,0c-0.1,0.1-0.2,0.2-0.3,0.4c-0.1,0.1-0.1,0.1-0.2,0.1c-0.2-0.1-0.3-0.3-0.2-0.5 C42.9,50.1,43,50.1,43.1,50.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st648",
    d: "M43.1,50.6c0.1,0,0.1,0,0.2,0c0,0.1,0,0.2,0,0.3c0,0.1,0,0.1,0,0.2c-0.1,0-0.3,0-0.4,0 c-0.1-0.1-0.1-0.1-0.1-0.2c0-0.1,0-0.2,0.1-0.2C42.9,50.5,43,50.5,43.1,50.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st544",
    d: "M43.1,50.6L43.1,50.6l-0.2,0c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.2-0.1,0.2l0,0c-0.1,0.1-0.2,0.1-0.3,0 c-0.2-0.2-0.5-0.3-0.4-0.7c0.1-0.1,0.2-0.3,0.1-0.4c0-0.1,0-0.1,0-0.2l0,0c0.4-0.3,0.8-0.3,1.3-0.2c0.1,0.1,0.1,0.1,0.2,0.2 c-0.1,0.2-0.3,0.2-0.4,0.2C43,50,43,50.1,42.9,50.2C42.9,50.3,43,50.4,43.1,50.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st335",
    d: "M43.3,49.5c-0.4,0.2-0.8,0.2-1.3,0.2c-0.1-0.3-0.2-0.5,0.2-0.4c0.2,0,0.4,0,0.6,0c0.1-0.1,0.3-0.1,0.4-0.2 C43.3,49.2,43.3,49.4,43.3,49.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st436",
    d: "M42,50.4c0.1,0.2,0.5,0.3,0.4,0.6c0.1,0,0.1,0.1,0.1,0.1c0,0,0,0.1-0.1,0.1c-0.1,0.3,0.5,0.5,0.2,0.9 c0,0.3,0,0.6-0.4,0.6c-0.1,0-0.2-0.1-0.2-0.1c-0.2-0.1-0.5-0.3-0.5-0.6c0.1-0.5-0.3-1.1,0.3-1.4c0-0.1,0-0.1,0-0.2 C41.9,50.3,41.9,50.3,42,50.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st649",
    d: "M42.2,53.8c-0.1-0.1-0.1-0.1-0.2-0.2l0,0c-0.1-0.1-0.1-0.2-0.2-0.2l0,0c0-0.4,0.2-0.4,0.4-0.2 c0.3,0.1,0.7-0.2,0.8,0.2c0.1,0.4-0.3,0.4-0.6,0.5C42.4,53.8,42.3,53.8,42.2,53.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st572",
    d: "M42.2,53.2c-0.2,0-0.3,0-0.4,0.2c-0.4-0.2-0.8,0.5-1.1-0.2c-0.1-0.1-0.1-0.2,0.1-0.3 c0.1-0.1,0.3-0.1,0.4-0.2c0.2-0.1,0.4-0.1,0.6,0c0.2,0,0.3,0.1,0.4,0.2C42.2,53,42.2,53.1,42.2,53.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st650",
    d: "M42.2,53c-0.1,0-0.3,0-0.4,0c-0.2-0.5,0-0.6,0.4-0.4c0,0.1,0,0.1,0,0.2C42.2,52.8,42.2,52.9,42.2,53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st651",
    d: "M43.5,51.5c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1-0.1-0.3-0.2-0.1-0.3C43.3,51.3,43.4,51.4,43.5,51.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st652",
    d: "M42.7,51c0-0.1,0-0.1,0-0.2c0.1-0.1,0.1-0.1,0.2,0c0,0.1,0,0.1,0,0.2C42.8,51,42.7,51,42.7,51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st653",
    d: "M42.4,51.2c0-0.1,0-0.1,0-0.2c0.1,0,0.1,0,0.2,0C42.6,51.1,42.5,51.2,42.4,51.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st301",
    d: "M20.3,22.4c0,0.1,0,0.1,0,0.2c-0.3,0.1-0.5-0.1-0.6-0.4c-0.1-0.5-0.4-1-0.5-1.5c0-0.3-0.2-0.7-0.1-1.1 c0,0,0.1-0.1,0.1-0.1c0.5,0.1,0.2,0.9,0.8,0.9l0,0c0.1,0.1,0.1,0.1,0.2,0.2c0.1,0.1,0.1,0.1,0.2,0.2C20.7,21.4,20.7,21.9,20.3,22.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st575",
    d: "M20.3,22.4c-0.1-0.5,0.3-1,0.2-1.5c0.1,0,0.1,0,0.2,0c0,0.2-0.1,0.5,0.2,0.6c0,0.4,0,0.7,0,1.1 C20.7,22.6,20.5,22.5,20.3,22.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st262",
    d: "M20.3,20.7c-0.1-0.1-0.1-0.1-0.2-0.2C20.2,20.5,20.2,20.5,20.3,20.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st654",
    d: "M20.9,20.7c0,0.1-0.1,0.2-0.2,0.2C20.7,20.8,20.8,20.7,20.9,20.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st655",
    d: "M18.8,19.1c0-0.2-0.5-0.3-0.2-0.6c0.1-0.1,0.1-0.2,0.3-0.2c0.2,0.2,0.4,0.1,0.6,0c0.1,0.1,0.1,0.3,0.2,0.4 c-0.2,0.1-0.4,0.3-0.6,0.4C18.9,19.3,18.8,19.3,18.8,19.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st656",
    d: "M18.8,19.1c0.1,0,0.2,0,0.2,0c0,0.1,0,0.1,0,0.2c0,0-0.1,0.1-0.1,0.1c0,0-0.1,0-0.1-0.1 C18.8,19.3,18.8,19.2,18.8,19.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st657",
    d: "M19,19.4c0.1,0,0.2,0.1,0.2,0.2c0,0-0.1,0-0.1,0C19,19.6,18.9,19.6,19,19.4L19,19.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st447",
    d: "M8,28.8c0,0.1,0,0.1,0,0.2c-0.1,0.2-0.3,0.1-0.4,0.2c-0.3-0.2-0.3-0.4-0.4-0.7c0.1-0.1,0.1-0.1,0.2,0 C7.5,28.7,7.7,28.9,8,28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st658",
    d: "M7.6,29.3c0.1-0.2,0.3-0.2,0.4-0.2l0,0c0.1,0.1,0.1,0.1,0.2,0c0.1,0,0.1,0,0.2,0c0,0.1,0,0.1,0,0.2 c0,0.1,0,0.1,0,0.2c-0.2,0-0.4,0-0.6,0C7.7,29.4,7.6,29.3,7.6,29.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st523",
    d: "M6.9,27.8c0.3,0,0.4,0.1,0.5,0.4l0,0c-0.1,0.1-0.1,0.1-0.2,0c-0.1,0-0.1,0-0.2,0C6.8,28.1,6.8,27.9,6.9,27.8 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st659",
    d: "M7.1,28.2c0.1,0,0.1,0,0.2,0c0,0.1,0,0.3,0,0.4l-0.1,0l-0.1,0C7.1,28.5,7.1,28.3,7.1,28.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st660",
    d: "M6.5,28.4c0-0.1,0-0.3,0-0.4l0,0c0.1-0.1,0.2-0.1,0.3,0c0.1,0.1,0,0.2,0,0.3c0,0.1,0,0.1,0,0.2 C6.6,28.5,6.6,28.5,6.5,28.4L6.5,28.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st661",
    d: "M6.7,28.2c0-0.1,0-0.2,0-0.3c0,0-0.1-0.1,0-0.1c0,0,0-0.1,0.1-0.1l0,0c0.1,0,0.1,0,0.2,0c0,0.1,0,0.3,0,0.4 C6.8,28.2,6.8,28.2,6.7,28.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st662",
    d: "M6.5,28.4c0.1,0,0.1,0,0.2,0C6.6,28.6,6.6,28.6,6.5,28.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st663",
    d: "M8.4,29.9c-0.1,0-0.2-0.1-0.2-0.2C8.3,29.7,8.4,29.8,8.4,29.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st664",
    d: "M17.9,9.5C18,9.3,18,9.2,18.1,9c0.2,0.1,0.2,0.2,0.2,0.4c-0.1,0.1-0.1,0.1-0.2,0.1C18,9.6,18,9.5,17.9,9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st665",
    d: "M18.5,10.3c-0.1,0-0.3,0-0.4,0c0-0.1,0-0.3,0-0.4c0.1-0.1,0.1-0.1,0.2,0l0,0c0.1,0.1,0.1,0.2,0.2,0.2 C18.5,10.2,18.5,10.3,18.5,10.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st484",
    d: "M18.3,9.9c-0.1,0-0.1,0-0.2,0l0,0c-0.1-0.1-0.1-0.3,0-0.4c0.1,0,0.1,0,0.2,0C18.3,9.6,18.3,9.7,18.3,9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st484",
    d: "M18.5,10.1c-0.1-0.1-0.1-0.2-0.2-0.2C18.4,9.9,18.5,10,18.5,10.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st260",
    d: "M17.2,12c-0.2,0.1-0.4,0.1-0.6,0c-0.1-0.1-0.1-0.3-0.1-0.4c0-0.1,0.1-0.2,0.1-0.2l0,0c0.1,0,0.3,0,0.4,0 c0.2,0.1,0.4,0.2,0.4,0.4C17.4,11.9,17.3,12,17.2,12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st666",
    d: "M18.3,11.8c-0.1,0-0.2,0-0.4,0c0.1-0.1,0.1-0.3,0.2-0.4c0.1,0,0.1,0,0.2,0c0,0.1,0,0.2,0,0.2 C18.4,11.7,18.4,11.8,18.3,11.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st445",
    d: "M17.2,12c0.1-0.1,0.1-0.1,0.2-0.2c0,0.1,0,0.1,0,0.2C17.4,12,17.3,12,17.2,12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st259",
    d: "M16.6,11.4c0,0.1,0,0.1,0,0.2c-0.1,0.1-0.3,0.1-0.4,0c0-0.1,0-0.1,0-0.2C16.3,11.4,16.5,11.4,16.6,11.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M16.2,11.6c0.1,0,0.3,0,0.4,0c0,0.1,0,0.3,0,0.4C16.4,12,16.2,11.8,16.2,11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M16.8,30.4c0,0.2,0,0.4,0,0.6c-0.4,0.5-0.9,1-1.5,1.3c0-0.1,0-0.1,0-0.2C15.8,31.5,16.3,30.9,16.8,30.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st667",
    d: "M17.7,33.1c-0.1,0-0.1,0-0.2,0.1l0-0.1c-0.1-0.1-0.1-0.2-0.2,0c-0.3-0.2-0.7-0.2-1.1-0.2l0,0 c-0.1,0-0.1-0.1-0.1-0.1c0,0,0-0.1,0.1-0.1l0,0c0.2-0.1,0-0.6,0.4-0.4c0.3,0.3,0.4-0.2,0.7-0.2c0,0,0.1,0,0.1,0.1 C17.7,32.4,18,32.7,17.7,33.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M16.6,32.3c-0.1,0.1-0.3,0.3-0.4,0.4c0-0.2-0.1-0.4,0.1-0.5C16.4,32.1,16.5,32.1,16.6,32.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st668",
    d: "M16.2,32.7c0,0.1,0,0.1,0,0.2c-0.1,0-0.1,0-0.2,0c0-0.1,0-0.1,0-0.2C16,32.7,16.1,32.7,16.2,32.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st644",
    d: "M17.3,32.1c0-0.1,0-0.1,0-0.2l0,0c0.1,0,0.2,0,0.2,0.1C17.5,32.1,17.4,32.1,17.3,32.1L17.3,32.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st545",
    d: "M13.6,31.4c0-0.1-0.1-0.2-0.2-0.2c0-0.2-0.1-0.4-0.2-0.6c0.1-0.1,0.1-0.1,0.2-0.1c0,0,0.1-0.1,0.1-0.1 s-0.1,0-0.1,0c-0.1-0.1-0.3-0.1-0.4-0.2c-0.1-0.1-0.1-0.2-0.2-0.2c0-0.1,0-0.1,0-0.2c0.1,0,0.1,0,0.2,0c0.5,0,1.2-0.1,1.1,0.7 c0,0.2,0.2,0.3,0.4,0.3c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.2-0.2,0.4-0.5,0.5C13.7,31.5,13.6,31.4,13.6,31.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st447",
    d: "M13.8,31.5c0.1-0.2,0.2-0.4,0.5-0.5c0.7,0.4,0.7,0.5,0,1.1C14.1,31.9,13.9,31.7,13.8,31.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M14.9,30.4c0-0.1,0-0.1,0-0.2c0.2,0,0.5-0.1,0.6,0.2c0.1,0.3-0.2,0.4-0.3,0.5C15,30.6,14.9,30.5,14.9,30.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st118",
    d: "M24.6,45c0-0.2,0-0.4,0-0.6c0.6,0.1,0,0.4,0.2,0.6C24.7,45,24.7,45,24.6,45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st367",
    d: "M24.5,45.2c0.1,0,0.2,0,0.3,0.1c0,0,0,0.1-0.1,0.1C24.7,45.3,24.6,45.2,24.5,45.2L24.5,45.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M25.4,46.3c0.2,0,0.4,0,0.6,0C25.9,46.6,25.6,46.6,25.4,46.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st335",
    d: "M34,59c0-0.2,0-0.4,0-0.6c0.1,0,0.1,0,0.2,0c0.1,0.3,0.2,0.3,0.4,0.1c0.2,0,0.3,0.1,0.5,0.2 c0.1,0.1,0.1,0.2,0.1,0.2c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0.1-0.1,0.1-0.1,0.2c0,0-0.1,0.1-0.1,0.1c-0.1,0.1-0.2,0.2-0.3,0.4 c0,0.1-0.1,0.1-0.1,0.2c0,0.1-0.1,0.1-0.2,0.2c-0.2,0-0.4,0-0.5,0.2c-0.3-0.2-0.4-0.5-0.4-0.9c0-0.1,0-0.1,0-0.2l0,0 c0.1-0.1,0.1-0.1,0.2-0.1C33.9,59.2,34,59.1,34,59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st453",
    d: "M34,61.8c0.2,0,0.5-0.1,0.7,0.2c-0.4,0.3-0.8,0.5-0.9,1.1c-0.2-0.1-0.5-0.1-0.7-0.2c0.1-0.2,0.2-0.4,0.3-0.6 c0.2,0,0.3-0.2,0.5-0.4C33.9,61.8,34,61.8,34,61.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st451",
    d: "M35.1,61c-0.2,0.4-0.5,0.4-0.9,0.4c0-0.2,0-0.3,0.3-0.4c0.1,0,0.1,0,0.2-0.1l0,0c0.1-0.1,0.2-0.1,0.2,0 C35,60.9,35,60.9,35.1,61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st669",
    d: "M34.5,60.3c0-0.1,0-0.2,0-0.2c0.2,0,0.3,0.1,0.2,0.3c0,0.1,0,0.1,0,0.2C34.6,60.4,34.5,60.4,34.5,60.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st452",
    d: "M34.9,60.9c-0.1,0-0.2,0-0.2,0c0-0.1,0-0.3,0-0.4C34.9,60.6,34.9,60.8,34.9,60.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st670",
    d: "M33.8,61.8c-0.2-0.1-0.2-0.2-0.2-0.4C33.8,61.5,33.8,61.6,33.8,61.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st452",
    d: "M34.7,60.9c0,0.1-0.1,0.2-0.2,0.1C34.5,60.9,34.6,60.9,34.7,60.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st489",
    d: "M23.3,27.6c0.1-0.1,0.1-0.1,0.2-0.2c0.2-0.1,0.4-0.3,0.6-0.4c0.2,0.2,0.5,0,0.6,0.2c0.4,0.5,0.5,1.2,0.5,1.8 c0,0.1,0,0.2,0,0.3c-0.1,0.1-0.2,0.2-0.4,0.2c-0.1,0-0.2-0.1-0.2-0.2c-0.2-0.2-0.2-0.5-0.4-0.6c-0.1-0.1-0.3-0.2-0.5-0.2 c-0.2-0.1-0.4-0.2-0.6-0.4C23.2,27.8,23.2,27.7,23.3,27.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st671",
    d: "M25.2,29.1c-0.3-0.6-0.4-1.3-0.4-1.9c0.6,0.3,1,0.9,1.3,1.5c0.2,0,0.3,0.1,0.2,0.3 C25.9,29.1,25.6,29.2,25.2,29.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st299",
    d: "M26.3,28.8c0-0.1-0.1-0.2-0.2-0.2c0-0.3,0.1-0.4,0.4-0.4c0.2-0.2,0.4-0.1,0.6-0.1c0.1,0.1,0.1,0.2,0.1,0.3 c-0.1,0.4-0.2,0.9-0.6,1.1C26.3,29.5,26.1,29.3,26.3,28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st671",
    d: "M27.2,28.2c-0.2,0-0.4,0-0.6,0c-0.1-0.2-0.2-0.4-0.2-0.6c0-0.1,0.2-0.1,0.2-0.2l0,0c0.1-0.1,0.1-0.1,0.2,0 c0.2,0.2-0.1,0.7,0.4,0.6C27.2,28,27.2,28.1,27.2,28.2C27.2,28.2,27.2,28.2,27.2,28.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st509",
    d: "M26.5,27.3c-0.1,0.1-0.1,0.1-0.2,0.2C26.1,27.2,26.4,27.4,26.5,27.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st611",
    d: "M26.7,27.3c-0.1,0-0.1,0-0.2,0c0-0.1,0-0.1,0-0.2c0.1,0,0.3,0,0.4,0C26.9,27.2,26.8,27.3,26.7,27.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st672",
    d: "M24.6,26.5c0.1,0,0.1,0,0.2,0C24.7,26.6,24.7,26.7,24.6,26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st489",
    d: "M27.4,27.3c0.2,0,0.4,0,0.7,0c0.2,0.3,0,0.6-0.2,0.9c-0.2,0.1-0.4,0-0.5-0.2C27.4,27.8,27.4,27.6,27.4,27.3z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st544",
    d: "M27.4,28c0.1,0.1,0.3,0.1,0.4,0.2c0.1,0.1,0.1,0.2,0.1,0.2c0,0.2-0.1,0.2-0.3,0.3c-0.2,0-0.4-0.1-0.5-0.3 c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.2C27.2,28,27.3,28,27.4,28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st247",
    d: "M31,26.3c0,0.1,0,0.2,0,0.2c0.1,0.1,0.2,0.1,0.3,0.2c0,0.1,0,0.2-0.1,0.2c-0.1,0.1-0.2,0.2-0.3,0.2 c-0.1,0.1-0.2,0.3-0.3,0.4c-0.3,0.2-0.6,0.2-0.9,0.1c-0.3-0.1-0.5-0.3-0.4-0.6c0.3-0.1,0.6,0.2,0.9,0.2c0.1-0.3-0.3-0.3-0.4-0.6 C30.3,26.6,30.6,26.3,31,26.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M29.3,27.1c0.1,0.2,0.2,0.4,0.4,0.4c0.1,0.1,0.1,0.2,0.1,0.3c0,0.3-0.1,0.6-0.4,0.8c-0.3-0.1-0.3-0.2-0.2-0.5 c0-0.4-0.5-0.9,0-1.3C29.3,27,29.3,27,29.3,27.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st673",
    d: "M27.8,28.4c0-0.1,0-0.1,0-0.2c0-0.3,0.1-0.6,0.2-0.9c0.5,0.1,0.9,0.2,0.9,0.9c0.1,0.2,0,0.4-0.2,0.5 c-0.1,0-0.2,0-0.3,0C28.2,28.7,28,28.6,27.8,28.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st674",
    d: "M28.7,28.6c0.1-0.1,0.2-0.3,0.2-0.4c0.1,0,0.3,0,0.4,0c0,0.2,0,0.3,0.2,0.4c0.1,0,0.1,0.1,0.1,0.2 c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.3,0.1-0.4,0.2C28.4,29.2,28.5,28.9,28.7,28.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st88",
    d: "M19.6,34c0-0.1,0-0.1,0-0.2c0.1-0.1,0.2-0.1,0.4-0.1c0.2,0.1,0.3,0.1,0.5,0c0.1-0.1,0.2-0.1,0.4-0.1 c0.1,0,0.2,0.1,0.2,0.2c0.1,0.3,0.2,0.7,0.1,1c-0.2,0.2-0.2,0.7-0.7,0.6c0-0.4-0.2-0.6-0.6-0.6C19.8,34.4,19.9,34.2,19.6,34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st435",
    d: "M20.5,35.3c0.3-0.1,0.1-0.7,0.6-0.6c0.1-0.1,0.2-0.1,0.4-0.1c0.1,0.1,0.1,0.1,0.1,0.2 c-0.1,0.2-0.4,0.3-0.5,0.6c0,0.1-0.1,0.1-0.2,0.2c-0.2,0.1-0.4,0.2-0.6,0.1l0,0C20.3,35.5,20.3,35.4,20.5,35.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st408",
    d: "M20.7,36.8c0,0.2,0,0.4,0,0.6c0,0.2-0.1,0.3-0.2,0.3c-0.1,0-0.3,0-0.4-0.1c0-0.2,0-0.3-0.2-0.4 c0-0.1,0-0.2,0-0.2c0.2-0.1,0.5-0.2,0.6-0.4c0.1-0.1,0.2-0.1,0.2,0C20.8,36.7,20.8,36.7,20.7,36.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st675",
    d: "M20.1,37.7c0.1,0,0.3,0,0.4,0c0.1,0,0.2,0.1,0.2,0.2c-0.1,0.1-0.3,0.3-0.4,0.4c-0.1,0-0.1,0-0.2,0 C20.1,38.1,20.1,37.9,20.1,37.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st485",
    d: "M20.7,36.6c-0.1,0-0.1,0-0.2,0c0-0.1,0-0.3,0-0.4c0,0,0,0,0,0C20.9,36.2,20.8,36.4,20.7,36.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st676",
    d: "M20.7,36.6c0-0.2,0-0.3-0.2-0.4c-0.1-0.1-0.1-0.3-0.2-0.4c0.2-0.1,0.4-0.2,0.6-0.2c0.2,0.2,0.4,0.4,0.5,0.7 c0,0.1,0,0.3-0.1,0.4c-0.2,0.1-0.4,0.2-0.6,0.2C20.7,36.7,20.7,36.7,20.7,36.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M19.8,39C20,39,20,39.2,20,39.4c-0.2,0-0.4,0-0.6,0C19.5,39.3,19.7,39.1,19.8,39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st419",
    d: "M6.3,27.3c-0.1-0.1-0.1-0.1-0.2-0.2C6.2,27.2,6.2,27.2,6.3,27.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st677",
    d: "M6.7,27.8c0,0.1,0,0.1,0,0.2c-0.1,0-0.1,0-0.2,0C6.5,27.9,6.6,27.8,6.7,27.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st678",
    d: "M7.8,28.2c-0.1,0.2-0.2,0.2-0.2,0C7.6,28.2,7.7,28.2,7.8,28.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st679",
    d: "M10.1,28.6c0-0.1,0-0.1,0-0.2c-0.1-0.2-0.1-0.4-0.2-0.6c0.1,0,0.3,0,0.4,0c0.2,0.8,0.7,0.2,1.1,0.2 c0.1,0.1,0.1,0.1,0.2,0.2c-0.1,0.4,0.2,0.7,0.2,1.1c-0.4,0-0.6-0.2-0.7-0.5c-0.1-0.3-0.4-0.2-0.6-0.1c-0.1,0-0.2,0.1-0.3,0.1 C10.2,28.7,10.2,28.7,10.1,28.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st294",
    d: "M8.2,29.1C8.1,29.3,8,29.2,8,29C8.1,29.1,8.1,29.1,8.2,29.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st680",
    d: "M40.5,56.8c-0.1,0-0.1,0-0.2,0C40,57,40,57.4,39.6,57.5c-0.1,0-0.1,0-0.2,0C39,57.1,39,56.6,39,56.1 c0.2-0.1,0.3-0.2,0.5-0.2c0.1,0,0.2,0,0.3,0c0.3,0.2,0.7,0,0.9,0.4l0,0C40.9,56.7,40.6,56.7,40.5,56.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st681",
    d: "M39,56.2c0.4,0.3,0.3,0.9,0.4,1.3c0,0.3-0.4-0.1-0.4,0.2c-0.1,0.2-0.2,0.3-0.5,0.2c-0.1-0.1-0.1-0.3-0.1-0.4 c0-0.3,0.1-0.5-0.1-0.8c0-0.1-0.1-0.2-0.1-0.3c0-0.2,0.1-0.3,0.3-0.4C38.8,56.1,38.9,56.1,39,56.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "M39.6,57.5c0.2-0.3,0.2-0.7,0.6-0.6c-0.1,0.4-0.1,0.7,0,1.1c-0.1,0-0.1,0-0.2,0c-0.1-0.1-0.2-0.1-0.2-0.2 C39.8,57.6,39.7,57.6,39.6,57.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st682",
    d: "M38.6,57.9c0.1-0.1,0.3-0.1,0.4-0.2c0.1,0.3,0.5,0.1,0.6,0.4c-0.2,0.3-0.6,0.1-0.9,0.4 c-0.1-0.1-0.3-0.1-0.4-0.2c-0.1-0.1-0.1-0.1-0.1-0.2C38.3,58,38.4,57.9,38.6,57.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st683",
    d: "M38.8,58.5c0.1-0.6,0.5-0.3,0.9-0.4c0,0.1,0,0.3,0,0.4c-0.2,0-0.4,0-0.7,0C38.9,58.6,38.9,58.6,38.8,58.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st86",
    d: "M39.9,57.7c0.1,0,0.2,0.1,0.2,0.2C40,57.9,39.9,57.8,39.9,57.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st573",
    d: "M41.4,57.1c-0.3,0.3-0.4,0.7-0.2,1.1c-0.1-0.1-0.3-0.1-0.4-0.2c-0.3-0.4,0.1-0.7,0-1.1 C41,56.7,41.2,56.9,41.4,57.1L41.4,57.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st379",
    d: "M41.4,57.1c-0.2,0-0.4-0.1-0.6-0.2c-0.1,0-0.1,0-0.2,0c0.1-0.1,0.1-0.3,0.2-0.4c0.2,0,0.4,0,0.6,0 c0.1,0.1,0.1,0.1,0.2,0.2C41.5,56.8,41.4,56.9,41.4,57.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st481",
    d: "M26.7,36.6c0.1,0,0.3,0,0.4,0c0,0.2-0.1,0.5,0.2,0.6c0,0.1,0,0.1,0,0.2c-0.3,0.4-0.3,0.8-0.4,1.3 c0,0.1-0.1,0.1-0.2,0.1c0.1,0,0.1,0.1,0.1,0.2c0,0.2-0.1,0.4-0.2,0.6c-0.3,0-0.5,0.1-0.7,0.4c-0.1,0-0.1,0-0.2,0 c-0.1-0.1-0.1-0.2-0.1-0.3c0.1-0.1,0.1-0.2,0-0.3c-0.1-0.1-0.1-0.2,0-0.4c0-0.1,0.1-0.2,0.1-0.4c0-0.2,0.1-0.3,0.1-0.5 c0.1-0.2,0.1-0.3,0.2-0.4c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.2-0.2,0.3-0.2c0.1,0,0.2-0.1,0.2-0.1c0-0.1,0.1,0-0.1,0 c-0.1-0.1-0.1-0.1-0.1-0.2C26.6,36.8,26.6,36.7,26.7,36.6C26.7,36.6,26.7,36.6,26.7,36.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st445",
    d: "M26.9,39c-0.1,0-0.1,0-0.2,0l0,0c0.4-0.4-0.1-1.2,0.6-1.5c0.1,0.4-0.2,0.7-0.2,1.1 C27.2,38.7,27.1,38.9,26.9,39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st242",
    d: "M28.7,38.1c0,0.3-0.2,0.6,0,0.9c-0.5,0-0.4-0.3-0.4-0.6C28.4,38.2,28.5,38.2,28.7,38.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st445",
    d: "M27.6,38.5c0,0.1,0,0.1,0,0.2c-0.1-0.1-0.1-0.1-0.2-0.2C27.4,38.5,27.5,38.5,27.6,38.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st676",
    d: "M32.1,26.7c0.2-0.1,0.4-0.2,0.6-0.2c0,0.3,0,0.6-0.4,0.6c-0.1,0-0.1,0-0.2,0C32,27,32,26.9,32.1,26.7 C32,26.7,32.1,26.7,32.1,26.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st151",
    d: "M29.8,27.8c0-0.1,0-0.2,0-0.3c0.3-0.1,0.6,0.1,0.9-0.2c0.1-0.1,0.1-0.3,0.2-0.4c0.1,0,0.3,0,0.4,0 c0,0,0.1,0,0.1,0c0,0.1,0.1,0.1,0.1,0.2c-0.1,0.2-0.3,0.3-0.4,0.5c0,0.1,0,0.3,0,0.4c-0.1,0.1-0.2,0.3-0.4,0.3 c-0.1,0-0.2,0-0.2-0.1c-0.1,0-0.2,0-0.2,0c0,0,0-0.1-0.1-0.1c0-0.1-0.1-0.1-0.1-0.2C29.9,27.9,29.8,27.9,29.8,27.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st684",
    d: "M31.7,26.7c0.1-0.2,0.1-0.3,0.3-0.3c0,0,0.1,0.2,0.1,0.3l0,0c-0.1,0.1-0.1,0.1-0.2,0 C31.8,26.7,31.8,26.7,31.7,26.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st243",
    d: "M31.9,26.7c0.1,0,0.1,0,0.2,0c0,0.1,0,0.3,0,0.4C31.9,27,31.9,26.9,31.9,26.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st685",
    d: "M31.2,26.9c0-0.1,0-0.1,0-0.2c-0.1,0-0.1-0.1,0-0.1c0,0,0-0.1,0.1-0.1l0,0c0.1-0.1,0.1-0.1,0.2,0 c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2C31.4,27,31.3,27,31.2,26.9L31.2,26.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M31.3,26.9c0.1,0,0.1,0,0.2,0c0,0.1,0,0.1,0,0.2C31.3,27.1,31.3,27,31.3,26.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st591",
    d: "M30.6,28.2C30.7,28,30.8,28,31,28c0,0.1,0,0.3,0,0.4l0,0C30.8,28.5,30.7,28.4,30.6,28.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st538",
    d: "M30.6,28.2c0.1,0.1,0.3,0.2,0.4,0.2c-0.1,0.1-0.1,0.3-0.2,0.4c-0.5,0-0.4-0.3-0.4-0.6 C30.5,28.2,30.5,28.2,30.6,28.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st686",
    d: "M34.7,58.6c-0.2,0.1-0.5,0.2-0.4-0.2l0,0c0.1-0.1,0.1-0.1,0.2-0.2c0-0.1,0-0.1,0-0.2 c0.1-0.1,0.1-0.1,0.2-0.2c0.4-0.1,0.4,0.2,0.4,0.4C35,58.4,35,58.6,34.7,58.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st335",
    d: "M34,58.3c-0.1,0-0.1,0-0.2,0C33.9,58.2,34,58.2,34,58.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st335",
    d: "M34.5,58.1c-0.1,0.1-0.1,0.1-0.2,0.2C34.3,58.2,34.4,58.2,34.5,58.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st335",
    d: "M33.8,56.8c0.2,0.1,0.2,0.1,0,0.2C33.8,57,33.8,56.9,33.8,56.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st687",
    d: "M34,59c0.2,0.3,0,0.3-0.2,0.4c0,0-0.1-0.1,0-0.1c0,0,0-0.1,0.1-0.1C33.9,59.1,34,59.1,34,59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M33.8,59.2c0,0.1,0,0.1,0,0.2c-0.1,0-0.1,0-0.2,0C33.6,59.3,33.7,59.2,33.8,59.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M17.3,32.1c0.2-0.1,0.2-0.1,0-0.2c0.1-0.2,0.2-0.4,0.2-0.6c0.1,0,0.1,0,0.2,0c0.2,0.7,0.6,1.3,1.1,1.7 c0.1,0.1,0.1,0.1,0.1,0.1c0,0,0,0.1-0.1,0.1c-0.2,0-0.4,0-0.7,0c-0.1,0-0.3,0-0.4,0C17.9,32.7,17.2,32.5,17.3,32.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st243",
    d: "M20,33.8c-0.1,0-0.3,0-0.4,0c-0.1-0.1-0.1-0.1-0.2-0.2c0.5-0.1,0.9-0.2,0.6-0.9c-0.1-0.3,0-0.6,0.2-0.9 c0-0.2,0-0.3,0.2-0.4c0.2,0.2,0.3,0.4,0.4,0.7c0.1,0.6,0,1.1-0.4,1.5c-0.1,0.1-0.2,0.1-0.3,0.2C20.2,33.8,20.1,33.8,20,33.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st684",
    d: "M18.8,33.1c0-0.1,0-0.1,0-0.2c0.1,0,0.2,0,0.3,0c0.1,0,0.4-0.1,0.4,0.2c0,0.1-0.2,0.2-0.3,0.3 C19.1,33.2,18.9,33.2,18.8,33.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st688",
    d: "M17.9,33.6c0.1-0.1,0.1-0.1,0.2-0.2C18.1,33.5,18,33.5,17.9,33.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st594",
    d: "M34.9,58.1c0-0.2,0-0.4-0.2-0.4c0-0.1,0-0.3,0-0.4c0.3,0.3,0.4-0.1,0.6-0.2c0.2,0.2,0.3,0.6,0.6,0.2 c0.2-0.2,0.4-0.1,0.6,0l0,0c0.1,0.1,0.1,0.1,0.1,0.2c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.3,0.2-0.4,0.3c-0.2,0.2-0.3,0.4-0.5,0.5 c-0.1,0-0.2,0-0.3,0C35.1,58.5,35.1,58.3,34.9,58.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st545",
    d: "M12.9,29.5c0-0.1,0-0.1,0-0.2c0.1,0,0.3-0.2,0.3,0C13.4,29.5,13.1,29.5,12.9,29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st259",
    d: "M12.3,30.1c0,0.1,0,0.1,0,0.2c-0.1,0.1-0.2,0.1-0.2,0.2c-0.3-0.2-0.4-0.5-0.2-0.9 C12.2,29.7,12.3,29.8,12.3,30.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.4,53.4c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1-0.1-0.1-0.1c0-0.1,0-0.1,0-0.1c0-0.1,0-0.3,0-0.4 c-0.1-0.1-0.1-0.1,0-0.2l0,0c0.1-0.1,0.2-0.1,0.3,0.1C39.7,52.9,39.6,53.1,39.4,53.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st689",
    d: "M39.4,52.5c-0.1,0-0.1,0-0.2,0c-0.1-0.1-0.2-0.3-0.2-0.4c0.1,0,0.3,0,0.4,0c0.1,0,0.2,0.1,0.3,0.3 C39.7,52.5,39.6,52.6,39.4,52.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st690",
    d: "M39.2,52.5c0,0.1,0,0.1,0,0.2C39,52.7,39.1,52.6,39.2,52.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st547",
    d: "M39.2,53.2c0,0.1,0,0.1,0,0.2l0,0c-0.1,0-0.1,0-0.2,0l0,0C39.1,53.3,39.1,53.3,39.2,53.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st691",
    d: "M39,56.2c-0.1,0-0.3,0-0.4,0c-0.2-0.2,0-0.5,0-0.7c0.1-0.2,0.2-0.3,0.4-0.4c0.3-0.2-0.1-0.4,0-0.6 c0.1-0.1,0.3-0.1,0.4-0.1c0.5,0.1,0.5,0.4,0.6,0.8c0,0.2,0,0.4,0,0.6c0,0-0.1,0.1-0.1,0.1c-0.3,0-0.4,0.1-0.3,0.4 C39.4,56.2,39.2,56.2,39,56.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st258",
    d: "M36.9,56c0.3-0.2,0.6-0.2,0.6-0.6c0.1-0.1,0.3-0.1,0.4-0.2c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2-0.1,0.2 c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.2-0.2,0.3-0.4,0.4C37.2,56.4,37,56.3,36.9,56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st692",
    d: "M39,55.1c-0.1,0.1-0.1,0.3-0.2,0.4c-0.1,0.1-0.2,0.1-0.3,0c-0.1-0.2-0.1-0.3,0-0.4 C38.7,54.9,38.9,55.1,39,55.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st550",
    d: "M37.9,55.6c0-0.1,0-0.3,0-0.4c0.1,0,0.3,0,0.4,0c0.1,0.1,0.1,0.1,0.1,0.2c0,0.1-0.1,0.1-0.1,0.2 c0,0-0.1,0-0.1,0.1C38.1,55.6,38,55.6,37.9,55.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st693",
    d: "M38.4,55.3c0-0.1,0-0.1,0-0.2c0.1,0,0.1,0,0.2,0c0,0.1,0,0.3,0,0.4c-0.1,0.1-0.2,0.1-0.3,0 C38.3,55.5,38.3,55.4,38.4,55.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st694",
    d: "M39.4,54.4c-0.1,0-0.3,0-0.4,0c0-0.1,0-0.1,0-0.2c0.1,0,0.1,0,0.2-0.1C39.4,54.2,39.5,54.3,39.4,54.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st365",
    d: "M38.6,54c0.1-0.2,0.1-0.2,0.2,0C38.7,54,38.6,54,38.6,54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st695",
    d: "M39.4,54.4c-0.1-0.1-0.1-0.2-0.2-0.2c0-0.4,0.2-0.2,0.4-0.2c0.1-0.1,0.2-0.1,0.2,0c0.2,0.1,0.5,0.3,0.7,0.4 c0,0.4-0.5,0.4-0.5,0.7C39.8,54.9,39.8,54.5,39.4,54.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M39.4,52.5c0.1-0.1,0.1-0.1,0.2-0.2c0.2-0.1,0.4,0,0.5,0.1c0.1,0.1,0.2,0.2,0.1,0.4c0,0.5-0.5,0.4-0.7,0.6 l-0.1,0l-0.1,0C39.4,53.1,39.4,52.8,39.4,52.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st696",
    d: "M39.7,53.4c0.2,0,0.4-0.1,0.5,0c0.1,0.2-0.1,0.3-0.3,0.4c-0.1,0.1-0.2,0.1-0.2,0 C39.7,53.7,39.7,53.6,39.7,53.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st697",
    d: "M39,53.4c0.1,0,0.1,0,0.2,0C39.1,53.6,39.1,53.5,39,53.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st698",
    d: "M39.7,53.8c0.1,0,0.1,0,0.2,0c0,0.1,0,0.1,0,0.2c-0.1,0-0.2,0-0.2,0C39.7,54,39.7,53.9,39.7,53.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st699",
    d: "M37.9,55.6c0.1,0,0.1,0,0.2,0c0.3,0.3,0.2,0.6,0,0.9c0,0.1-0.1,0.2-0.1,0.2c-0.1,0.1-0.2,0.3-0.3,0.4 c0,0.1-0.1,0.1-0.1,0.2c-0.1,0.1-0.1,0.1-0.2,0.2c0,0-0.1,0-0.1,0.1c-0.1,0-0.2,0-0.3,0c0,0-0.1,0-0.1,0c0,0-0.1-0.1-0.1-0.1 c0-0.1,0-0.2,0.1-0.2c0-0.1,0-0.1,0-0.2c0.1,0,0.1,0,0.2-0.1c0.1-0.1,0.1-0.3,0.3-0.4c0.1,0,0.1-0.1,0.1-0.2 c0.1-0.2,0.2-0.4,0.3-0.6C37.8,55.7,37.9,55.6,37.9,55.6L37.9,55.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st700",
    d: "M37.3,56.6c0,0.2-0.1,0.3-0.3,0.4C37.1,56.8,37.1,56.7,37.3,56.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st315",
    d: "M24.1,39.2c0-0.1,0-0.1,0-0.2c-0.1-0.1-0.2-0.1-0.3-0.3c0-0.1,0-0.3,0.1-0.4c0.2-0.1,0.5,0,0.7-0.3 c0.2-0.2,0.3-0.5,0.7-0.4c0.3,0.1,0.4,0.3,0.4,0.6c0,0.2-0.1,0.4-0.2,0.6c-0.1,0.1-0.2,0.2-0.4,0.2C24.7,39,24.4,39.1,24.1,39.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st642",
    d: "M25,39c0.1-0.1,0.1-0.1,0.2-0.2c0.1-0.1,0.2-0.1,0.3,0c0.1,0.2,0.2,0.4,0.2,0.6c0,0.1,0,0.3,0,0.4 c0,0.1,0,0.2-0.1,0.3c0,0-0.1,0.1-0.1,0.1c-0.1,0-0.2,0-0.3,0c-0.3,0-0.4-0.1-0.4-0.4c0.1-0.1,0.1-0.2,0.2-0.3 C25.1,39.2,25.1,39.1,25,39L25,39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st315",
    d: "M25.2,39.2c-0.1,0.2-0.2,0.4-0.4,0.5c0-0.2,0-0.4,0.2-0.4C25.1,39.1,25.1,39.1,25.2,39.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st701",
    d: "M25.6,40.7c-0.1,0-0.1,0-0.2,0c0-0.2,0-0.3,0-0.5c0-0.1,0-0.1,0-0.2l0,0c0.4,0,0.3,0.2,0.2,0.4 C25.6,40.5,25.6,40.6,25.6,40.7L25.6,40.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st702",
    d: "M25.2,40.9c-0.1,0-0.2-0.1-0.2-0.2C25.1,40.8,25.1,40.8,25.2,40.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st702",
    d: "M25.4,40c0,0.1,0,0.1,0,0.2c-0.1-0.1-0.1-0.1-0.2-0.2C25.3,40,25.4,40,25.4,40z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st509",
    d: "M25.2,39.2c-0.1,0-0.1,0-0.2,0c0-0.1,0-0.1,0-0.2C25.1,39,25.2,39.1,25.2,39.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st703",
    d: "M25.7,40.5c0-0.2,0-0.3-0.2-0.4c0-0.1,0-0.1,0-0.2c0.1-0.1,0.1-0.1,0.1-0.2c0.1-0.1,0.1-0.1,0.2-0.1 c0,0,0.1,0,0.1,0.1c0,0.2,0,0.3,0,0.5C25.9,40.2,25.8,40.4,25.7,40.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st704",
    d: "M25.6,40.7c0,0,0.1,0.1,0.1,0.1C25.7,40.8,25.7,40.8,25.6,40.7C25.7,40.7,25.6,40.7,25.6,40.7L25.6,40.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M21.1,37.5c0.8-0.1,0.6,0.4,0.6,0.8c-0.3-0.1-0.6-0.3-0.8-0.4C20.8,37.6,21,37.6,21.1,37.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st224",
    d: "M21.1,37.5c-0.1,0.1-0.1,0.3-0.2,0.4c-0.1,0-0.2,0-0.2,0c-0.1-0.1-0.1-0.1-0.2-0.2c0.1-0.1,0.1-0.1,0.2-0.2 C20.8,37.7,21,36.6,21.1,37.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M19,15.3l-0.1,0l-0.1,0c0,0-0.1-0.1-0.1-0.1c0-0.2,0-0.4,0.3-0.3l0,0C19,15,19,15.1,19,15.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M19.6,15.3c0,0,0.1-0.1,0.1-0.1C19.7,15.2,19.7,15.2,19.6,15.3C19.7,15.3,19.6,15.3,19.6,15.3L19.6,15.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M19.6,15.3C19.6,15.3,19.6,15.3,19.6,15.3C19.5,15.4,19.5,15.3,19.6,15.3C19.6,15.3,19.6,15.3,19.6,15.3 L19.6,15.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st705",
    d: "M18.5,16.6c-0.1-0.2-0.2-0.2-0.4-0.2c-0.1-0.1-0.1-0.2-0.2-0.2c-0.1-0.1-0.1-0.1-0.1-0.1 c0,0,0.1-0.1,0.1-0.1c0.1,0,0.2-0.1,0.2-0.2c0-0.1,0-0.3,0-0.4c0-0.1,0.1-0.1,0.2-0.1c0.1,0,0.1,0.1,0.2,0.2c0,0.1,0,0.1,0,0.2 c0,0.1,0,0,0-0.1c0,0,0.1-0.1,0.1-0.1c0.1,0,0.1,0,0.2,0.1C18.7,15.8,18.9,16.3,18.5,16.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st544",
    d: "M19.4,17.6c-0.3,0-0.4-0.1-0.4-0.4C19.2,17.3,19.3,17.4,19.4,17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st706",
    d: "M18.3,16.6c0.1,0,0.1,0,0.2,0c0,0.1,0,0.3,0,0.4C18.4,16.9,18.3,16.8,18.3,16.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st707",
    d: "M18.7,15.5c-0.1,0-0.1,0-0.2,0c0-0.1-0.1-0.1-0.1-0.2c0-0.1,0-0.1,0-0.1c0.1-0.1,0.2,0,0.2,0l0,0 C18.8,15.3,18.8,15.4,18.7,15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st708",
    d: "M18.8,18.3c-0.1,0.1-0.2,0.1-0.3,0.2c0-0.1-0.1-0.2-0.2-0.2c0.1-0.1,0.2-0.3,0.2-0.4 C18.7,18,18.8,18.1,18.8,18.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st544",
    d: "M18.5,17.6c-0.1,0-0.2-0.1-0.2-0.2c0.1,0,0.2,0,0.3,0.1C18.7,17.5,18.6,17.6,18.5,17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st483",
    d: "M18.1,9.5c0,0.1,0,0.3,0,0.4c-0.1,0-0.1,0-0.2,0c0-0.1,0-0.3,0-0.4C18,9.5,18,9.5,18.1,9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st483",
    d: "M17.5,9.7c0.1,0.1,0.1,0.1,0.2,0.2C17.6,9.9,17.5,9.8,17.5,9.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st709",
    d: "M18.3,12.9c0-0.1,0-0.1,0-0.2c0.2-0.1,0.2-0.2,0.3-0.4c0.3,0.2,0.2,0.4,0.2,0.6c0,0.1,0,0.1,0,0.2 c-0.1,0-0.1,0-0.2,0C18.5,13,18.5,12.9,18.3,12.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st614",
    d: "M18.3,11.8c0-0.1,0-0.1,0-0.2c0.1,0,0.1,0,0.2,0c0,0.1,0,0.2,0,0.3C18.5,11.9,18.4,11.8,18.3,11.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st494",
    d: "M18.7,15.3L18.7,15.3l-0.2,0c-0.1-0.1-0.2-0.2-0.2-0.3c0,0,0-0.1,0-0.1c0.1-0.2,0.2-0.4,0.2-0.7 c0.1,0,0.1,0,0.2,0c0.1,0.2,0.2,0.4,0.2,0.6C18.8,14.9,18.8,15.1,18.7,15.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st376",
    d: "M18.5,13.5c0-0.1,0.1-0.2,0.2-0.2C18.7,13.4,18.7,13.5,18.5,13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st710",
    d: "M32.8,25.4c-0.1,0.2-0.2,0.2-0.4,0.2c-0.1-0.4-0.2-0.8,0.4-0.7C32.7,25.1,32.8,25.2,32.8,25.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st711",
    d: "M32.6,24.1c0.1,0,0.2,0.1,0.2,0.2c0,0.1,0,0.1,0,0.2c-0.1,0-0.1,0-0.2,0.1C32.4,24.4,32.4,24.3,32.6,24.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st712",
    d: "M40.3,52.7c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1-0.1-0.1-0.1-0.1-0.2 c0,0,0.1-0.1,0.1-0.1c0.3-0.1,0.5-0.4,0.7-0.7c0.2-0.3,0.4-0.6,0.8-0.5c0.1,0.5-0.5,0.9-0.2,1.4c0,0.1,0,0.2,0,0.3 c-0.1,0.1-0.2,0.2-0.3,0.2C40.7,52.5,40.5,52.7,40.3,52.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st713",
    d: "M40.7,56.4c-0.3-0.1-0.6-0.2-0.9-0.2c-0.1-0.2,0.1-0.3,0.2-0.4l0,0c0.3,0.2,0.5,0.3,0.9,0.2 C40.9,56.1,40.8,56.3,40.7,56.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st714",
    d: "M40.9,52.5c0.1-0.1,0.2-0.1,0.2-0.2c0.1,0.1,0.1,0.3,0.1,0.4c-0.1,0.1-0.2,0.1-0.3,0 C40.9,52.7,40.9,52.6,40.9,52.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st712",
    d: "M40.9,52.7c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0.1,0.1,0.1c0,0,0,0.1,0,0.1c-0.1,0-0.3,0-0.4,0 C40.8,52.9,40.9,52.8,40.9,52.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st572",
    d: "M41.8,53.4c0.1,0,0.2,0.1,0.2,0.2C41.9,53.6,41.8,53.5,41.8,53.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st715",
    d: "M19.4,20.7c0.1,0.5,0.5,0.9,0.4,1.4c-0.1,0.2,0,0.4-0.2,0.5c0,0-0.1,0-0.1,0c-0.3-0.1-0.4-0.3-0.3-0.6 c0-0.1,0-0.1,0-0.2c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.2-0.2-0.3c0-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.2,0-0.2 c0-0.1-0.1-0.2-0.1-0.2c0,0,0-0.1,0-0.1c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0.1-0.3c0,0,0.1-0.1,0.1-0.1c0,0,0.1,0,0.1,0 C19.2,19.9,19.2,20.3,19.4,20.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st716",
    d: "M19.1,22c0,0.2,0.1,0.4,0.3,0.6c-0.3,0.2,0.1,0.4,0,0.7c-0.1,0.1-0.2,0.3-0.4,0.3c-0.1,0-0.2,0-0.2-0.1 C18.8,22.9,18.7,22.4,19.1,22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st717",
    d: "M21.3,25.2c0,0.1,0,0.1,0,0.2c-0.1,0.1-0.2,0.1-0.3,0c-0.1-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.2,0-0.3 c0-0.3,0-0.5,0.2-0.7c0-0.3,0.1-0.4,0.4-0.4C21.5,24.2,21.6,24.7,21.3,25.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st718",
    d: "M21.1,24.1c0,0.3,0,0.6,0,0.9c-0.2,0.2-0.4,0.2-0.6,0.1c-0.2-0.2-0.1-0.4-0.1-0.7c0.1-0.2,0.3-0.4,0.5-0.3 C21,24.1,21,24.1,21.1,24.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st719",
    d: "M19.6,22.5c0-0.2,0.1-0.3,0.2-0.5c0.1,0.2,0.2,0.4,0.5,0.5c-0.1,0.3,0,0.6-0.4,0.6c-0.1-0.1-0.1-0.3-0.2-0.4 C19.6,22.7,19.6,22.6,19.6,22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st720",
    d: "M20.9,24.1c-0.1,0.1-0.3,0.1-0.4,0.2c0,0-0.1,0.1-0.1,0.1c0,0-0.1,0-0.1-0.1c-0.1-0.1-0.1-0.2-0.1-0.3 c0-0.2,0.1-0.3,0.2-0.4C20.6,23.5,20.6,23.5,20.9,24.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st721",
    d: "M20.3,23.7c0,0.1,0,0.3,0,0.4c-0.1,0.1-0.3,0.1-0.4,0l0,0c-0.1-0.3-0.4-0.2-0.6-0.2c-0.1,0-0.1-0.1-0.1-0.1 c0-0.1,0-0.1,0-0.1c0.1-0.1,0.2-0.1,0.2-0.1c0.1,0,0.2,0.1,0.2,0.1C19.8,23.7,20,23.7,20.3,23.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st722",
    d: "M19.6,22.8c0.2,0.1,0.2,0.2,0.2,0.4C19.6,23.2,19.6,23,19.6,22.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st460",
    d: "M19,23.5c0.1-0.2,0.3-0.2,0.4-0.2c0,0.1,0,0.1,0,0.2c0,0-0.1,0.1-0.1,0.1C19.2,23.6,19.1,23.6,19,23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st723",
    d: "M19.6,23.7c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1-0.1-0.1-0.1c0,0,0-0.1,0.1-0.1l0,0C19.5,23.5,19.6,23.6,19.6,23.7 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st543",
    d: "M22,26.5c0.2,0.1,0.4-0.2,0.6,0c0.1,0.1,0,0.3-0.2,0.3c-0.3,0.2-0.5-0.1-0.6-0.3 C21.8,26.5,21.9,26.5,22,26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st550",
    d: "M21.6,26.5c0,0.1,0,0.1,0,0.2c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0-0.3,0-0.4-0.1c-0.1-0.1-0.1-0.1-0.1-0.2 c0-0.1,0-0.2,0.1-0.3l0.1,0c0-0.1,0.1-0.1,0.2-0.1c0.2,0,0.3,0,0.4,0.1C21.6,26.3,21.6,26.4,21.6,26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st724",
    d: "M21.1,25.4c0.1,0,0.1,0,0.2,0c0,0.2,0.1,0.4,0.2,0.6c-0.2,0.1-0.3,0.1-0.5,0C20.9,25.8,20.9,25.6,21.1,25.4z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st685",
    d: "M21.1,26c0.1,0,0.3,0,0.4,0c0,0.1,0,0.2,0,0.2c-0.1,0-0.3,0.3-0.4,0c0,0-0.1-0.1-0.1-0.1 C21.1,26.1,21.1,26.1,21.1,26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st720",
    d: "M21.3,26.7c0.1,0,0.1,0,0.2,0c0.2,0.3,0.4,0.6,0.9,0.6c0.1,0.1,0.1,0.1,0.2,0.2c0.1,0.2,0,0.3-0.1,0.4 c-0.1,0.1-0.2,0.1-0.4,0.2c-0.1,0-0.2,0-0.3-0.1c-0.3-0.3-0.6-0.5-0.7-0.9C21.2,26.9,21.2,26.8,21.3,26.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st725",
    d: "M22.4,27.8c0.1-0.1,0.1-0.1,0.2-0.2c0.2,0.1,0.4,0.1,0.6,0c0,0.1,0,0.3,0,0.4c0,0.1,0,0.1,0,0.2 c-0.1,0.1-0.1,0.2-0.2,0.2c-0.2,0-0.3,0-0.5,0C22.3,28.2,22.2,28,22.4,27.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st726",
    d: "M32.6,24.1c0,0.1,0,0.3,0,0.4c-0.1,0.2-0.3,0.2-0.4,0c0.1-0.1,0.2-0.1,0.1-0.3c0-0.1,0-0.1,0.1-0.2 C32.4,24.1,32.5,24.1,32.6,24.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st727",
    d: "M31.9,25.8l-0.1,0l-0.1,0c-0.1,0-0.1-0.1-0.1-0.1c0-0.1,0-0.1,0.1-0.1c0-0.1,0.1-0.2,0.1-0.3 C32,25.5,31.8,25.7,31.9,25.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st728",
    d: "M31.7,25.6c0,0.1,0,0.1,0,0.2c-0.1,0-0.2,0-0.3,0C31.5,25.7,31.5,25.6,31.7,25.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.3,25.6c0,0.1,0,0.2,0,0.2c-0.1,0-0.1,0-0.2,0l0,0C32.1,25.7,32.2,25.6,32.3,25.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st729",
    d: "M31.7,26c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.1-0.1,0.1-0.2,0c0-0.1,0-0.1,0-0.2C31.4,26,31.5,26,31.7,26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st730",
    d: "M31.2,26.5c0,0.1,0,0.1,0,0.2c-0.1,0-0.2-0.1-0.2-0.2C31.1,26.5,31.2,26.5,31.2,26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st579",
    d: "M31.3,26.2c0.1,0,0.1,0,0.2,0c0,0.1,0,0.1,0,0.2l-0.1,0l-0.1,0C31.2,26.4,31.3,26.3,31.3,26.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st731",
    d: "M41.2,52.1c-0.6-0.2-0.4-0.6-0.2-0.9c0.1-0.2,0.3-0.4,0.5-0.6c0.1,0,0.3,0,0.4,0c-0.4,0.5,0.3,1.1-0.2,1.5 C41.4,52.2,41.3,52.2,41.2,52.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st259",
    d: "M42,50.4l-0.1,0l-0.1,0c-0.3,0-0.4-0.1-0.4-0.4c0.2,0,0.4,0.4,0.7,0c0.2,0,0.5-0.1,0.5,0.2 C42.6,50.5,42.2,50.3,42,50.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st464",
    d: "M39.6,51.9c0-0.1,0-0.1,0-0.2c0.1,0,0.2,0.1,0.2,0.2l0,0c0,0-0.1,0.1-0.1,0.1C39.7,51.9,39.7,51.9,39.6,51.9 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st732",
    d: "M13.4,17.4c0.1,0,0.3,0,0.4,0c0,0.2,0,0.5-0.3,0.5C13.2,17.9,13.4,17.6,13.4,17.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st733",
    d: "M29.8,27.8c0,0,0.1,0,0.1,0c0.2,0.1,0.1,0.3,0.3,0.4l0,0c0,0.1,0,0.2,0,0.4c-0.2,0-0.3,0.1-0.4,0.2 c-0.1,0.1-0.1,0.1-0.2,0c0-0.1,0-0.1,0-0.2C29.5,28.3,29.6,28,29.8,27.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st151",
    d: "M29.3,29.7c0-0.2,0.1-0.4,0.2-0.6c0-0.1,0.1-0.1,0.2,0C30.2,29.6,29.7,29.6,29.3,29.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st734",
    d: "M29.7,29c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.1,0,0.2,0 C29.7,28.9,29.7,29,29.7,29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st735",
    d: "M39.9,52.1c0.2,0.1,0.2,0.3,0.2,0.4c-0.1-0.1-0.3-0.1-0.4-0.2c-0.1-0.1-0.1-0.1-0.2-0.2 c0.1-0.1,0.1-0.2,0.2-0.2l0,0C39.7,52,39.8,52,39.9,52.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st429",
    d: "M10.1,28.6c0.1,0,0.1,0,0.2,0c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2-0.1,0.2 c-0.2,0-0.3,0-0.4,0.2C9.6,29.3,10.2,29,10.1,28.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st684",
    d: "M10.6,29.5c0-0.1,0-0.1,0-0.2c-0.1-0.1-0.1-0.1-0.1-0.2c0-0.1,0-0.2,0.1-0.2c0.2,0,0.4,0.1,0.4,0.3 C11,29.4,10.8,29.5,10.6,29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st671",
    d: "M13.6,30.3c-0.1,0.2-0.2,0.2-0.4,0.2c-0.1-0.1-0.1-0.1-0.2-0.2c0-0.1,0-0.1,0-0.2 C13.2,30.1,13.4,30.3,13.6,30.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st533",
    d: "M10.6,28.8c0,0.1,0,0.2,0,0.2c-0.1,0.1-0.1,0.1-0.2,0c0-0.1,0-0.3,0-0.4c0.1-0.2,0.1-0.2,0.2,0 C10.6,28.7,10.6,28.8,10.6,28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st269",
    d: "M12.1,30.6c0.1-0.1,0.1-0.1,0.2-0.2C12.3,30.5,12.2,30.5,12.1,30.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st736",
    d: "M22.9,36.4c-0.1-0.1-0.1-0.2-0.2-0.2c-0.1-0.1-0.2-0.2-0.2-0.3c0-0.1,0-0.3,0-0.4c0-0.1,0-0.3,0-0.4 c0-0.1-0.1-0.3-0.1-0.4c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.3c0.1-0.5-0.2-0.9-0.3-1.3c0-0.2-0.1-0.4-0.2-0.7 c-0.1-0.2-0.2-0.3-0.2-0.5c-0.1-0.2-0.1-0.4,0-0.6c0-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.3-0.1,0.5-0.1c0.1,0,0.2,0.1,0.3,0.2 c0.2,0.3,0.2,0.7,0.3,1c0.1,0.2,0.2,0.5,0.2,0.7c0.1,0.6,0.3,1.2,0.3,1.9c0,0.2,0,0.4,0.1,0.6c0,0.1,0.1,0.3,0.1,0.4 c0,0.1,0,0.2,0,0.3c0,0.2-0.1,0.3-0.1,0.4C23.2,36.3,23.1,36.5,22.9,36.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st737",
    d: "M22.6,35.3c0,0.2,0,0.3,0,0.5c-0.1,0.2-0.2,0.4,0,0.6c0,0.1,0,0.2,0,0.2c-0.2,0.2-0.5,0.4-0.9,0.2 c0-0.2,0-0.4,0-0.6c0,0-0.1-0.1-0.1-0.1c0,0,0.1-0.1,0.1-0.1l-0.1,0c0,0-0.1,0.1-0.1,0.1l0,0c-0.1,0.1-0.1,0.1-0.2,0 c-0.5,0-0.4-0.3-0.4-0.6c0-0.1,0-0.1,0-0.2c0.2-0.2,0.5-0.1,0.8-0.3c0.1-0.1,0.3-0.2,0.4-0.3c0.1-0.1,0.2-0.2,0.3,0 c0.1,0.1,0.2,0.1,0.2,0.3C22.5,35,22.5,35.2,22.6,35.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st738",
    d: "M22.9,36.4c0.1-0.1,0.3-0.1,0.4-0.2c0.1,0.1,0.2,0.2,0.2,0.3c0.1,0.3,0.2,0.5,0.2,0.8c0,0.1,0,0.2-0.1,0.3 c-0.1,0.1-0.1,0.3-0.2,0.4c-0.1,0.1-0.2,0-0.2,0C22.7,37.4,22.9,36.9,22.9,36.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st356",
    d: "M21.8,36.8c0.3-0.1,0.5-0.3,0.9-0.2c-0.1,0.7-0.3,0.8-0.9,0.4C21.7,37,21.7,36.9,21.8,36.8 C21.7,36.9,21.7,36.8,21.8,36.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st739",
    d: "M22.6,36.4c-0.4-0.2-0.4-0.4,0-0.6c0,0.1,0,0.3,0.1,0.4C22.6,36.2,22.6,36.3,22.6,36.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st740",
    d: "M21.3,36.2c0.1,0,0.1,0,0.2,0c0,0.2,0,0.3-0.2,0.4C21.3,36.5,21.3,36.3,21.3,36.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st741",
    d: "M23.1,37.9c0.1,0,0.1,0,0.2,0c0.1-0.1,0.1-0.1,0.2,0c0,0.1,0,0.2,0,0.2c-0.1,0-0.3,0-0.4,0 C23.1,38,23.1,38,23.1,37.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st742",
    d: "M21.6,36.2c0.1-0.1,0.1-0.1,0.2-0.2l0,0c0,0.1,0,0.1,0,0.2C21.7,36.2,21.6,36.2,21.6,36.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st743",
    d: "M23.9,38.3c0,0.1,0,0.3,0,0.4c-0.1,0.1-0.1,0.1-0.2,0c0-0.1,0-0.3-0.1-0.4c-0.1-0.3-0.2-0.6-0.1-0.9 c0.1-0.2,0.3-0.2,0.4,0C24.2,37.7,24.2,38,23.9,38.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M23.8,38.7c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0.1,0.2,0.2c-0.3,0.1-0.2,0.4-0.3,0.7c-0.1,0-0.1,0-0.2-0.1 C23.7,39.3,23.7,39,23.8,38.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st744",
    d: "M23.7,37.5c0,0.3,0,0.6,0,0.9c-0.1-0.1-0.1-0.1-0.2-0.2c0-0.1,0-0.2,0-0.2c-0.1-0.1-0.1-0.3,0-0.4l0.1,0 C23.6,37.4,23.6,37.4,23.7,37.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st414",
    d: "M23.3,38.8c-0.1-0.1-0.2-0.2-0.2-0.3C23.2,38.6,23.3,38.7,23.3,38.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st414",
    d: "M23.3,39.6c0-0.1,0-0.2,0-0.2C23.4,39.5,23.4,39.5,23.3,39.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st479",
    d: "M33.6,25.2c0.4,0,0.3,0.2,0.2,0.4c-0.1,0-0.3,0.2-0.4,0C33.4,25.5,33.6,25.4,33.6,25.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st579",
    d: "M32.1,25.9c0.1,0,0.1,0,0.2,0C32.3,26,32.2,26,32.1,25.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st436",
    d: "M36.6,57.3c-0.2,0-0.4,0-0.6,0c0-0.3-0.1-0.6,0.2-0.9C36.3,56.7,36.3,57.1,36.6,57.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st745",
    d: "M36.8,57.3c0,0.1,0,0.1,0,0.2c-0.1,0.1-0.2,0.1-0.2,0c0-0.1,0-0.1,0-0.2C36.7,57.3,36.8,57.3,36.8,57.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st243",
    d: "M26.1,32.7c0,0.2,0.1,0.5-0.2,0.6c-0.2,0.1-0.2,0.4-0.4,0.5c-0.1,0.1-0.3,0.1-0.4,0 c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1-0.3-0.2-0.6-0.3-1c0-0.1,0-0.2,0-0.3c0-0.1,0-0.3,0.1-0.4c0,0,0.1-0.1,0.1-0.1 c0.6,0.1,0.9-0.6,1.5-0.6c0,0.2,0,0.3,0.2,0.4c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2C26,32.2,26.2,32.5,26.1,32.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st746",
    d: "M26.3,28.8c0,0.3,0.1,0.5,0.5,0.6c0.2-0.3,0.4-0.3,0.7,0c0,0.1,0,0.2,0,0.3c-0.4,0-0.3,0.2-0.2,0.4 c-0.6,0.7-1.4,0.7-1.8,0c-0.1-0.2-0.1-0.4-0.2-0.6c-0.1,0-0.1-0.1-0.1-0.1c0-0.1,0-0.1,0.1-0.1c0-0.1,0-0.1,0-0.2 C25.5,28.9,25.9,28.8,26.3,28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st607",
    d: "M24.6,31.6c0,0.1,0,0.1,0,0.2l0,0.1c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.3,0c-0.4-0.1-0.6-0.3-0.8-0.6 c-0.1-0.3-0.3-0.6-0.4-0.9c0-0.2,0-0.3,0.1-0.4c0.3-0.2,0.5-0.4,0.8-0.6c0.1,0,0.2-0.1,0.3,0c0.1,0,0.3,0.1,0.4,0.2 c0,0,0,0.1,0.1,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c-0.1,0.2-0.1,0.4,0.1,0.6C24.6,31.1,24.7,31.3,24.6,31.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st503",
    d: "M24.6,31.6c-0.2-0.3-0.3-0.5-0.2-0.9c-0.2-0.2-0.2-0.4,0-0.7l0,0c0.1,0,0.1-0.1,0.1-0.1c0,0,0-0.1-0.1-0.1 l0,0c-0.1-0.3,0.2-0.3,0.4-0.4c0.1,0,0.2,0.1,0.3,0.1C25,30.4,24.9,31,24.6,31.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st671",
    d: "M25,29.7l-0.1,0l-0.1,0c-0.1-0.1-0.1-0.2-0.1-0.3c0,0,0.1-0.1,0.1-0.1c0.1,0,0.3,0,0.4,0c0,0.1,0,0.1,0,0.2 C25.1,29.6,25.1,29.6,25,29.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st746",
    d: "M27.4,30.1c0.2,0.1,0.2,0.1,0,0.2C27.4,30.3,27.4,30.2,27.4,30.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st288",
    d: "M27.4,29.7c0-0.1,0-0.1,0-0.2c-0.1-0.2,0-0.2,0.2-0.3c0.2,0,0.3-0.1,0.4-0.3c0-0.1,0.1-0.1,0.2-0.2 c0.1,0,0.3,0,0.4,0.1c0.1,0.2,0.1,0.5,0.2,0.7c-0.2,0.2-0.5,0.4-0.4,0.9c-0.1,0-0.1,0-0.2,0c-0.1-0.1-0.3-0.3-0.4-0.4 C27.5,29.8,27.4,29.8,27.4,29.7L27.4,29.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st746",
    d: "M27.4,29.7c0.1,0.1,0.1,0.1,0.2,0.2C27.5,29.8,27.4,29.8,27.4,29.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st618",
    d: "M25.9,35.3c0,0.2,0,0.4,0,0.6c0.1,0.1,0.1,0.3,0,0.5c-0.1,0.1-0.3,0.1-0.5,0c-0.3-0.3-0.4-0.6-0.3-1 C25.3,35.2,25.6,35.2,25.9,35.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st747",
    d: "M25,33.8c0.1,0,0.3,0,0.4,0c0.1-0.1,0.3-0.1,0.4,0l0,0c0.2,0.3,0.2,0.6,0,0.9c0,0.1,0,0.1,0,0.2 c0,0-0.1,0.1-0.1,0.1c-0.1,0-0.2-0.1-0.2-0.1c-0.1-0.3-0.4-0.5-0.5-0.8c0,0,0-0.1,0-0.1C25,33.9,25,33.8,25,33.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st748",
    d: "M26.7,36.2c0,0.1,0,0.3,0,0.4l0,0c-0.1,0.1-0.1,0.1-0.2,0.1c-0.1,0-0.1-0.1-0.2-0.2 c-0.1-0.2-0.4-0.3-0.2-0.5c0.1-0.1,0.3-0.2,0.4-0.2c0.1-0.1,0.3-0.1,0.4,0C26.8,35.9,26.8,36,26.7,36.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st749",
    d: "M26.9,34c-0.1,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0c0,0-0.1-0.1-0.1-0.1 c0,0,0-0.1,0-0.1c0-0.2,0-0.4,0.2-0.4C26.7,33.6,26.9,33.8,26.9,34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st658",
    d: "M25.9,35.3c-0.2,0.1-0.4,0.1-0.6,0c0,0-0.1-0.1-0.1-0.1c-0.1-0.1-0.2-0.3,0-0.4c0.2-0.1,0.4-0.1,0.6,0.1l0,0 c0.1,0.1,0.1,0.1,0.2,0.2C25.9,35.2,25.9,35.2,25.9,35.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st621",
    d: "M26.3,34c0,0.1,0,0.1,0,0.2c-0.1,0.2-0.2,0.4-0.4,0.4c0-0.3,0-0.6,0-0.9C26,33.9,26.1,33.9,26.3,34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st750",
    d: "M26.1,36c0,0.2,0.4,0.2,0.4,0.4c0,0.1-0.1,0.1-0.1,0.2c0,0-0.1,0-0.1,0.1c-0.1,0-0.2,0-0.2,0 c-0.1-0.1-0.2-0.1-0.2-0.3c0-0.1,0-0.3,0-0.4C25.9,36,26,36,26.1,36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st751",
    d: "M26.9,35.7c-0.1,0-0.3,0-0.4,0c0-0.2,0-0.3,0.2-0.4C26.8,35.4,26.8,35.6,26.9,35.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st618",
    d: "M25.9,35.1c-0.1,0-0.2-0.1-0.2-0.2c0.1,0,0.1,0,0.2,0C25.9,34.9,25.9,35,25.9,35.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st429",
    d: "M26.1,32.7c-0.1-0.3-0.4-0.6,0.2-0.6C26.3,32.3,26.4,32.6,26.1,32.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st271",
    d: "M25.8,33.8c-0.1,0-0.3,0-0.4,0c0-0.3,0.1-0.4,0.4-0.4C25.9,33.5,25.9,33.6,25.8,33.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st684",
    d: "M28.7,29.5c-0.3-0.1-0.2-0.4-0.2-0.6c0,0-0.1-0.1-0.1-0.1c0,0,0.1-0.1,0.1-0.1c0.1,0,0.1,0,0.2,0 c0,0.2-0.1,0.5,0.2,0.6c0,0.1,0,0.1,0,0.2C28.8,29.5,28.7,29.5,28.7,29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st281",
    d: "M17.9,15.1c-0.2-0.1-0.3-0.2-0.1-0.4c0-0.1,0.1-0.1,0.2-0.1c0.2,0,0.1,0.2,0.2,0.3 C18.2,15,18.1,15.1,17.9,15.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st752",
    d: "M17.9,15.1c0.1-0.1,0.1-0.1,0.2-0.2c0.1,0,0.1,0,0.2,0l0,0c0.1,0.1,0.1,0.3,0,0.4c-0.1,0-0.2,0-0.2,0 C18,15.3,17.9,15.2,17.9,15.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st753",
    d: "M17.9,15.9c0,0.1,0,0.1,0,0.2c-0.1,0-0.3,0-0.3-0.1C17.6,15.9,17.8,16,17.9,15.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st754",
    d: "M18.8,20c0,0.1,0,0.1,0,0.2c-0.1,0-0.1,0.1-0.1,0.1c0,0,0,0.1,0.1,0.1l0,0c0.1,0.1,0.2,0.1,0.2,0.3 c0,0.1,0,0.1,0,0.2c-0.1,0.2-0.2,0.3-0.4,0.3c-0.2-0.1-0.4-0.2-0.5-0.4c-0.1-0.1-0.3-0.2-0.4-0.3c0-0.1,0-0.2,0.1-0.2 c0.1-0.1,0.1-0.3,0.2-0.4c0.1-0.1,0.1-0.2,0.2-0.2c0.2-0.1,0.4-0.1,0.6,0c0.1,0,0.1,0.1,0.1,0.2c0,0.1,0,0.1,0,0.1l0,0 C18.7,19.9,18.7,19.9,18.8,20C18.7,20,18.7,20,18.8,20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st755",
    d: "M18.8,19.8c0-0.1,0-0.2,0-0.2c0-0.1,0-0.1,0.1-0.2c0.1,0,0.1,0,0.2,0c0.1,0.1,0.1,0.1,0.2,0.2 c0,0.4,0.3,0.7,0.2,1.1C19.2,20.4,19,20.1,18.8,19.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st326",
    d: "M18.1,19.6c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1-0.1-0.3-0.3-0.4-0.4C17.8,19,18,19.1,18.1,19.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st326",
    d: "M18.1,18.7C18.1,18.7,18,18.8,18.1,18.7c-0.1,0.1-0.1,0.1-0.1,0C17.9,18.7,18,18.6,18.1,18.7 C18,18.6,18,18.7,18.1,18.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st756",
    d: "M18.1,20.7c0.2,0.1,0.4,0.2,0.4,0.4c0.1,0.1,0.3,0.1,0.5,0.2c0.1,0,0.1,0.1,0.1,0.2c0,0.1-0.1,0.2-0.2,0.2 c-0.2,0-0.4,0-0.6,0c-0.2-0.2-0.3-0.4-0.4-0.6c-0.3,0-0.4-0.1-0.4-0.4c0,0,0.1-0.1,0.1-0.1c0.1,0,0.2,0,0.2,0.1 C17.9,20.7,18,20.6,18.1,20.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st549",
    d: "M17.9,21.1c0.3,0.1,0.4,0.3,0.4,0.6c-0.1,0-0.1,0-0.2,0C17.8,21.6,17.9,21.3,17.9,21.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st757",
    d: "M17.5,20.7c-0.2-0.1-0.2-0.3,0-0.4l0,0C17.6,20.4,17.6,20.5,17.5,20.7L17.5,20.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st448",
    d: "M17.5,20.7c0-0.1,0-0.3,0-0.4c0.1,0,0.1,0,0.2,0c0,0.1,0,0.1,0,0.2c0.1,0,0.1,0.1,0.1,0.1c0,0,0,0.1-0.1,0.1 C17.6,20.7,17.5,20.7,17.5,20.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st758",
    d: "M34.7,60.3c-0.1-0.1-0.1-0.2-0.2-0.3c0,0,0-0.1,0-0.1c0.1-0.1,0.2-0.2,0.4-0.2c0.1,0,0.2,0.1,0.2,0.1 C35.2,60.2,35,60.3,34.7,60.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st759",
    d: "M35.8,59.2c-0.1,0.3-0.4,0.3-0.7,0.4c-0.1,0.1-0.1,0.1-0.2,0c-0.1-0.1-0.1-0.2,0-0.3l0,0 c0.1,0,0.1-0.1,0.1-0.2l0.1,0c0.2-0.2,0.3-0.2,0.5-0.1C35.7,59.1,35.7,59.2,35.8,59.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st759",
    d: "M36,59c0,0.1,0,0.1,0,0.2c-0.1,0-0.1,0-0.2,0c0,0,0,0,0,0C35.7,59,35.8,59,36,59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st760",
    d: "M34.9,59.6c0.1,0,0.1,0,0.2,0c0,0.1,0,0.1,0,0.2c-0.1,0-0.1,0-0.2,0C34.8,59.8,34.8,59.8,34.9,59.6 C34.9,59.7,34.9,59.6,34.9,59.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st404",
    d: "M37.4,57.3c0-0.1,0.1-0.1,0.1-0.2c0.1-0.1,0.3-0.3,0.4-0.4l0,0c0.2-0.1,0.3-0.1,0.4,0l0,0 c0.2,0.2,0.2,0.4,0.1,0.5c-0.4,0.4,0.3,0.1,0.2,0.3c0,0.1,0,0.3,0,0.4c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.1-0.1,0.1-0.2,0.2l0,0 c-0.4,0-0.7,0-1.1,0c-0.3-0.2,0.1-0.4,0-0.7c0,0,0.1-0.1,0.1-0.1c0.1,0,0.1-0.1,0.2-0.1l0-0.1C37.3,57.4,37.4,57.4,37.4,57.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st761",
    d: "M36,59c-0.1,0.1-0.1,0.1-0.2,0.2c-0.2,0-0.4,0-0.6,0c0-0.1,0-0.1,0-0.2c0.1-0.1,0.1-0.2,0.2-0.3 c0.1-0.1,0.1-0.1,0.1-0.2c0.2-0.2,0.3-0.4,0.5-0.6c0.1-0.1,0.3-0.1,0.4-0.2c0.1-0.1,0.1-0.1,0.2-0.2c0.1,0,0.2,0,0.2,0l0,0 c0.1,0,0.1,0.1,0.1,0.1c0,0.1,0,0.1-0.1,0.1l0,0c-0.1,0.1-0.1,0.2-0.2,0.3C36.4,58.3,36.2,58.7,36,59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st745",
    d: "M36.9,57.7c0-0.1,0-0.1,0-0.2c0.1,0,0.2,0,0.3,0c0,0.1,0,0.1,0,0.2l0,0C37,57.7,36.9,57.7,36.9,57.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st762",
    d: "M36.6,58c0-0.1,0.1-0.2,0.2-0.3C36.8,57.8,36.7,57.9,36.6,58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st635",
    d: "M38.1,58.4c0.1-0.1,0.1-0.1,0.2-0.2c0,0.1,0,0.1,0,0.2C38.3,58.3,38.2,58.4,38.1,58.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st336",
    d: "M19.4,27.3c0.4-0.2,0.7-0.3,0.9,0.2c0.1,0.2,0,0.3-0.2,0.4c-0.2,0.1-0.3,0.1-0.5,0c-0.2-0.1-0.3-0.2-0.3-0.3 C19.3,27.5,19.3,27.4,19.4,27.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st763",
    d: "M20,27.8c0.1-0.1,0.2-0.2,0.2-0.2c0.1,0.1,0.3,0.1,0.4,0.2c0.1-0.1,0.2-0.1,0.3,0c0.1,0.2,0.1,0.4-0.1,0.6 C20.4,28.5,20.1,28.4,20,27.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st684",
    d: "M19.4,27.3c0,0.1,0,0.2,0,0.2c-0.2,0.2-0.4,0.2-0.6,0c-0.1-0.1-0.1-0.1-0.2-0.2c0-0.2,0-0.4,0-0.6 C18.9,26.8,18.9,27.4,19.4,27.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st764",
    d: "M20.7,27.3c-0.3-0.2-0.2-0.4-0.2-0.6c0.1-0.1,0.2-0.1,0.2,0c0.1,0.2,0.1,0.4,0.1,0.6 C20.8,27.3,20.7,27.3,20.7,27.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st764",
    d: "M20.9,27.8c-0.1,0-0.1,0-0.2-0.1c0-0.1,0-0.3,0-0.4c0,0,0,0,0,0C21.1,27.4,21.1,27.6,20.9,27.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st457",
    d: "M20.7,26.6c-0.1,0-0.1,0-0.2,0c0-0.1,0-0.1,0-0.2c0.1,0,0.1,0,0.2,0c0,0,0.1,0.1,0.1,0.1 C20.7,26.6,20.7,26.6,20.7,26.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st574",
    d: "M19.4,23.5c0,0.1,0,0.1,0,0.2c-0.1,0-0.1,0-0.2,0c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0-0.3,0-0.4,0 c0-0.1,0-0.1,0-0.2l0,0c0.1-0.1,0.1-0.1,0.2-0.2l0,0c0.1,0,0.1,0,0.2,0C19.1,23.5,19.3,23.5,19.4,23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st460",
    d: "M19,23.9c0.1-0.1,0.1-0.1,0.2-0.2c0,0.1,0,0.1,0,0.2C19.1,23.9,19,23.9,19,23.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st765",
    d: "M19.8,24.1c0.1,0,0.3,0,0.4,0c0,0.1,0,0.1,0,0.2c-0.1,0.1-0.3,0.1-0.4,0C19.8,24.2,19.8,24.2,19.8,24.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st766",
    d: "M19.8,24.3c0.1,0,0.2,0,0.4,0l0.1,0c0.1,0.1,0,0.2-0.1,0.2c-0.1,0-0.2,0-0.4,0 C19.9,24.5,19.9,24.4,19.8,24.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st767",
    d: "M21.1,25.4c0,0.2,0,0.4,0,0.6l0,0c-0.1,0.1-0.2,0.1-0.2,0c-0.2-0.1-0.2-0.3-0.2-0.4 c-0.1-0.4,0.1-0.5,0.4-0.4C21.1,25.3,21.1,25.3,21.1,25.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st724",
    d: "M21.1,25.2c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1-0.1-0.1-0.2-0.2-0.2c-0.1-0.1-0.1-0.3,0-0.4c0.2,0,0.4,0,0.6,0 C21.1,25,21.1,25.1,21.1,25.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st768",
    d: "M20.5,25c0,0.1,0,0.3,0,0.4c-0.1,0-0.1,0-0.2,0c0-0.1,0-0.3,0-0.4c0,0-0.1-0.1-0.1-0.1c0-0.1,0-0.1,0-0.1 c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0.1-0.2c0.1,0,0.1,0,0.2,0C20.5,24.5,20.5,24.8,20.5,25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st764",
    d: "M20.8,26.2c0,0.1,0,0.2,0,0.2c-0.1,0.1-0.1,0.1-0.2,0l0,0C20.7,26.4,20.8,26.3,20.8,26.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st137",
    d: "M20.9,26c0.1,0,0.2,0,0.2,0c0,0.1,0,0.1,0,0.2l-0.1,0c0,0-0.1,0-0.1,0C20.9,26.2,20.9,26.1,20.9,26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st766",
    d: "M20.2,24.7c0,0.1,0,0.1,0,0.2C20.1,24.9,20.1,24.8,20.2,24.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st769",
    d: "M20.3,29.5c-0.1-0.1-0.1-0.3-0.2-0.4C20,29,20,29,20,28.9c0-0.1,0-0.1,0-0.1c0.3-0.1,0.6-0.2,0.9-0.3 c0.1,0,0.2,0,0.3,0.1c0.1,0.1,0.1,0.2,0.2,0.4c0,0.2,0.1,0.4,0.1,0.5c0,0.1,0,0.2,0.1,0.3c0,0.2,0,0.4-0.1,0.6 c-0.2,0.2-0.4,0.2-0.6,0.3c-0.1,0-0.2,0-0.3,0c-0.1,0-0.1-0.1-0.2-0.2C20.3,30.1,20.3,29.8,20.3,29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st770",
    d: "M20,28.8c0,0.1,0,0.1,0,0.2c-0.2,0-0.4-0.1-0.6-0.2c-0.6-0.2-0.7-0.7-0.6-1.3c0.2,0,0.4,0,0.6,0 c0.1,0.1,0.1,0.2,0.2,0.2C19.8,28.1,20.3,28.3,20,28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st611",
    d: "M20.3,29.5c0.6,0.2,0.1,0.7,0.2,1.1c-0.4,0.4-0.7,0-1-0.1c-0.1-0.1-0.2-0.1-0.2-0.2c0-0.1,0-0.2,0.1-0.3 c0.2-0.1,0.4-0.2,0.6-0.2l0,0C20.1,29.6,20.2,29.6,20.3,29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st771",
    d: "M19.4,29.9c0,0.1,0,0.1,0,0.2c0,0.1-0.1,0.1-0.1,0.2c0,0-0.1,0-0.1,0.1c-0.1,0-0.1,0-0.2,0 c0-0.1-0.1-0.3-0.1-0.4c-0.1-0.2,0.1-0.4,0.3-0.4C19.4,29.5,19.4,29.7,19.4,29.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st418",
    d: "M20.3,31.9c0,0.3,0.1,0.6-0.2,0.9c-1-0.1-1-0.1-0.6-0.9c0.2-0.2,0.3-0.4,0.6-0.2 C20.1,31.7,20.2,31.8,20.3,31.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st772",
    d: "M20,31.6c-0.2,0-0.4,0.1-0.6,0.2c-0.3-0.5-0.5,0.2-0.8,0.1c-0.3-0.4,0.6-0.7,0.1-1.2 C19.2,31.1,19.6,31.4,20,31.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st769",
    d: "M19.4,30.3c0.4,0,0.7,0.3,1.1,0.2l0,0c0.1,0.1,0.1,0.3,0,0.4c-0.1,0-0.1,0-0.2,0c-0.2,0.1-0.3-0.1-0.4-0.2 c-0.2-0.1-0.5-0.2-0.6-0.4l0,0C19.3,30.3,19.3,30.3,19.4,30.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st243",
    d: "M20.5,31c0-0.1,0-0.3,0-0.4c0.1,0,0.1,0,0.2,0c0.4-0.2,0.5,0,0.5,0.3c0,0.2-0.1,0.3-0.3,0.4 c-0.2,0.1-0.3,0.1-0.5-0.1C20.5,31.1,20.5,31.1,20.5,31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st773",
    d: "M20.5,31.2c0.1,0,0.3,0,0.4,0c0.2,0.3,0.1,0.6,0,0.9c-0.1,0-0.2,0-0.2,0c-0.3-0.1-0.2-0.4-0.2-0.7 C20.5,31.4,20.5,31.3,20.5,31.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st243",
    d: "M19.8,30.8c0.1,0.1,0.3,0.1,0.4,0.2C19.9,31.4,19.9,31.1,19.8,30.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st774",
    d: "M19,21.7c0.1-0.1,0.1-0.1,0.2-0.2c0,0.1,0,0.1,0,0.2C19.1,21.7,19,21.7,19,21.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st460",
    d: "M18.8,23.5c-0.1,0.1-0.1,0.1-0.2,0.2C18.6,23.6,18.7,23.5,18.8,23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st79",
    d: "M42.9,50.2c0-0.1,0.1-0.2,0.2-0.2c0,0.1,0,0.1,0,0.2l-0.1,0L42.9,50.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st647",
    d: "M42.9,50.8l-0.1,0l-0.1,0c0-0.1,0.1-0.2,0.2-0.2C42.9,50.7,42.9,50.7,42.9,50.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st775",
    d: "M41.2,52.1c0.1,0,0.3,0,0.4,0c0.1,0.3,0.5,0.1,0.6,0.4c-0.3,0-0.4,0.1-0.4,0.4c-0.2,0-0.4,0-0.6,0 c0-0.1,0-0.1,0-0.2c0-0.1,0-0.3,0-0.4C41.2,52.3,41.2,52.2,41.2,52.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st376",
    d: "M13.7,30.1c0,0.1,0,0.1,0,0.2c0,0.1-0.1,0.1-0.1,0.1c0-0.1,0-0.1,0-0.2C13.6,30.1,13.7,30.1,13.7,30.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st111",
    d: "M34.9,58.1c0.3,0,0.4,0.1,0.4,0.4c0,0.1,0,0.1-0.1,0.2c0,0-0.1,0-0.1,0c-0.2,0-0.4,0-0.4-0.2 C34.9,58.5,34.9,58.3,34.9,58.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st669",
    d: "M34.9,59.6c0,0.1,0,0.1,0,0.2c-0.1,0-0.3,0-0.4,0c0-0.2,0.2-0.4,0.4-0.5C34.9,59.5,34.9,59.6,34.9,59.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st759",
    d: "M35.5,58.7c0,0.2-0.2,0.3-0.4,0.3c0-0.1,0-0.1,0-0.2l0,0C35.2,58.7,35.4,58.7,35.5,58.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st669",
    d: "M35,59.2c0,0.1,0,0.2-0.1,0.2C35,59.3,35,59.3,35,59.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st776",
    d: "M23.7,29.7c0,0.4-0.4,0.5-0.6,0.6c-0.5-0.3-0.1-0.6,0.1-0.8c0-0.1,0.1-0.2,0.1-0.2c0-0.1,0-0.2,0-0.4 c0.1-0.2,0.3-0.2,0.2-0.5c0.1-0.2,0.3-0.2,0.4-0.1c0.1,0.1,0.3,0.2,0.5,0.1c0.2,0.1,0.3,0.4,0.4,0.6C24.5,29.4,24,29.3,23.7,29.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st777",
    d: "M23.7,29.7c-0.1-0.9,0.6-0.6,1.1-0.6c0,0.1,0,0.1,0,0.2l0,0c-0.2,0.3-0.6,0.2-0.9,0.4 C23.9,29.7,23.8,29.7,23.7,29.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st778",
    d: "M23.9,28.4c-0.2,0-0.3,0-0.4,0.2c-0.2,0.1-0.3,0-0.3-0.2c0-0.2,0-0.3,0.1-0.4l0,0c0.3,0,0.4,0.1,0.6,0.2 C24,28.3,24,28.3,23.9,28.4C24,28.4,23.9,28.4,23.9,28.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st779",
    d: "M23.9,28.4c0-0.1,0-0.1,0-0.2c0.2,0,0.3,0,0.4,0.2c0,0.1,0,0.3-0.1,0.3C24.1,28.7,24,28.6,23.9,28.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st780",
    d: "M27.6,29.3c-0.1,0.1-0.1,0.2-0.2,0.2c-0.2-0.2-0.4-0.1-0.6,0c0-0.4,0.1-0.8,0.4-1.1c0.2,0,0.4,0,0.4,0.2 c0.1,0.1,0.1,0.1,0.1,0.2C27.7,29,27.7,29.2,27.6,29.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st684",
    d: "M27.6,28.9c0-0.1,0-0.2,0-0.2c0.1-0.1,0.1-0.2,0.2-0.2c0.2,0,0.5-0.1,0.6,0.2l0,0c-0.1,0.1-0.3,0.1-0.4,0.2 l0,0C27.9,29,27.7,29,27.6,28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st481",
    d: "M30.8,26.9c0,0.2,0,0.3-0.2,0.4C30.6,27.2,30.6,27,30.8,26.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st781",
    d: "M21.6,34.7c-0.1,0-0.3,0-0.4,0c-0.2-0.3-0.3-0.7-0.2-1.1c0.1-0.1,0.2-0.1,0.2,0c0.2,0.1,0.4,0.3,0.5,0.5 c0.1,0.2,0.1,0.4,0,0.5C21.6,34.6,21.6,34.6,21.6,34.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M20.5,33.8c0,0.1-0.1,0.3-0.3,0.3c-0.2,0-0.1-0.2-0.2-0.3l0,0C20.2,33.7,20.3,33.7,20.5,33.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M20.5,33.8c-0.1,0-0.3,0-0.4,0c0-0.1,0.1-0.2,0.2-0.2c0.1-0.1,0.2-0.1,0.4-0.1c0,0,0.1,0.1,0.1,0.1 C20.7,33.7,20.6,33.8,20.5,33.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M21.1,33.6c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0l0,0c-0.1-0.3,0.2-0.3,0.4-0.3 C21.1,33.3,21.2,33.4,21.1,33.6C21.1,33.5,21.1,33.6,21.1,33.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st481",
    d: "M21.8,35.1c-0.1,0.7-0.6,0-0.9,0.2c0-0.5,0.3-0.4,0.6-0.4c0.1-0.1,0.2-0.1,0.2,0 C21.9,34.9,21.8,35,21.8,35.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st737",
    d: "M21.8,34.9c-0.1,0-0.1,0-0.2,0c0-0.1,0-0.1,0-0.2l0,0c0.2-0.2,0.4-0.1,0.5,0.2C22,35,21.9,35,21.8,34.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st782",
    d: "M40.1,55.8c-0.1,0.1-0.1,0.3-0.2,0.4l-0.1,0l-0.1,0c-0.1-0.2-0.5-0.2-0.6-0.5C39.4,55.6,39.8,55.6,40.1,55.8 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st783",
    d: "M38.6,57.5c-0.2,0-0.5,0-0.8,0.1c0.2-0.4,0.9-0.4,0.6-0.9C39,56.8,38.9,57.1,38.6,57.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st784",
    d: "M38.4,56.6c-0.1,0-0.3,0-0.4,0c0.2-0.3,0.3-0.7,0.2-1.1l0,0c0.1-0.1,0.1-0.1,0.2,0c0.1,0,0.2,0,0.2,0 c0.1,0,0.1,0,0.2,0c0,0.2-0.1,0.4-0.2,0.6C38.5,56.3,38.4,56.5,38.4,56.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st785",
    d: "M26.1,38.1c0,0.2,0,0.4-0.1,0.6c-0.1,0.1-0.1,0.1-0.2,0.2c0,0.1,0,0.3,0,0.4c0,0-0.1,0-0.1,0.1 c0,0-0.1,0-0.1,0c0,0-0.1-0.1-0.1-0.1c0-0.2,0-0.4,0-0.6c0-0.1,0-0.3,0-0.4c0-0.2,0.1-0.4,0.3-0.4C26.1,37.9,26.2,37.9,26.1,38.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st786",
    d: "M26.1,38.1C26,38,26,38,25.9,37.9c0,0-0.1,0-0.1-0.1c-0.1-0.2,0-0.3,0.2-0.4c0.1,0,0.2,0,0.3,0 c0,0,0.1,0,0.1,0.1c0.1,0.1,0.1,0.2,0,0.2C26.3,37.8,26.3,38,26.1,38.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st787",
    d: "M26.5,36.6c0.1,0,0.1,0,0.2,0c0,0.1,0,0.3,0,0.4c-0.1,0.2-0.2,0.4-0.5,0.2c-0.1-0.2-0.1-0.4,0.1-0.6l0,0 C26.4,36.5,26.5,36.5,26.5,36.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st788",
    d: "M26.3,37.2c0.1-0.1,0.3-0.1,0.4-0.2l0,0c0,0,0.1,0.1,0.1,0.1c0,0,0,0.1,0,0.1c-0.1,0.1-0.1,0.2-0.2,0.2 c-0.1,0.1-0.1,0.1-0.2,0l0,0C26.2,37.4,26.2,37.4,26.3,37.2C26.3,37.3,26.3,37.2,26.3,37.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st787",
    d: "M26.7,37.2c0-0.1,0-0.1,0-0.2C26.9,37.1,26.9,37.2,26.7,37.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st298",
    d: "M25.9,39.4c0,0,0.1,0.1,0.1,0.1c0,0-0.1,0-0.1,0l-0.1,0c-0.1,0-0.1-0.1-0.1-0.1 C25.8,39.4,25.8,39.4,25.9,39.4L25.9,39.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st445",
    d: "M26.7,39C26.7,39,26.7,39,26.7,39C26.6,39,26.6,39,26.7,39C26.7,39,26.7,39,26.7,39L26.7,39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st789",
    d: "M25.9,39c0.1-0.1,0.1-0.1,0.2-0.2C26.1,38.9,26,39,25.9,39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st787",
    d: "M26.3,37.4c0.1,0,0.1,0,0.2,0c-0.1,0.1-0.1,0.1-0.2,0.2C26.3,37.6,26.3,37.5,26.3,37.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st790",
    d: "M30.2,28.2c-0.2-0.1-0.2-0.3-0.3-0.4C30.3,27.7,30.3,27.9,30.2,28.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st791",
    d: "M21.1,33.4c-0.2,0-0.4,0-0.4,0.2c-0.1,0-0.3,0-0.4,0c0.3-0.5,0.5-0.9,0.4-1.5c0.1,0,0.1,0,0.2,0 c0.4-0.2,0.7-0.2,1.1,0c0.2,0.2,0.1,0.4,0.1,0.7c-0.2,0.2-0.3,0.4-0.5,0.6C21.5,33.4,21.3,33.5,21.1,33.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st745",
    d: "M36.4,57.7c-0.1,0.2-0.2,0.2-0.4,0.2C36.1,57.7,36.2,57.7,36.4,57.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st669",
    d: "M35.5,58.7c-0.1,0-0.3,0.1-0.4,0.1c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.1,0,0.2,0C35.5,58.6,35.5,58.7,35.5,58.7z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st550",
    d: "M37.9,55.6c-0.1,0.1-0.1,0.2-0.2,0.2C37.7,55.7,37.8,55.6,37.9,55.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st792",
    d: "M38.4,55.5l-0.1,0l-0.1,0c0-0.1,0.1-0.2,0.2-0.2C38.4,55.4,38.4,55.5,38.4,55.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st793",
    d: "M37.9,56.6c0,0.3-0.1,0.4-0.4,0.4C37.6,56.9,37.7,56.7,37.9,56.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st794",
    d: "M37.4,57.3c0,0.1-0.1,0.1-0.1,0.2C37.3,57.4,37.4,57.3,37.4,57.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st795",
    d: "M37.1,57.7c0-0.1,0-0.1,0-0.2c0.1,0,0.1,0,0.2,0C37.2,57.6,37.1,57.6,37.1,57.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M23.7,37.5L23.7,37.5l-0.2,0c-0.1-0.3-0.3-0.6-0.2-0.9c0.1-0.2,0.1-0.4,0.3-0.6c0.1-0.1,0.2-0.1,0.2-0.1 c0.2,0,0.3,0.1,0.5,0.2c0.1,0.1,0.2,0.1,0.3,0.2c0.2,0.1,0.3,0.1,0.5,0.1c0.1,0.1,0.2,0.2,0.2,0.3c0,0.1,0,0.2,0,0.3 c0,0.4-0.3,0.5-0.6,0.7c-0.2,0.2-0.4,0.4-0.1,0.7c-0.3,0.4-0.6,0.1-0.8,0c0-0.2,0-0.5,0-0.7C23.9,37.5,23.9,37.3,23.7,37.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st320",
    d: "M24.8,38.3c-0.5-0.1-0.7-0.2-0.3-0.7c0.2-0.3,0.7-0.3,0.7-0.8c0.4,0,0.4,0.3,0.3,0.6 c-0.1,0.2-0.2,0.2-0.4,0.3C24.9,37.8,24.8,38,24.8,38.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M25.2,37.7c0.1-0.1,0.2-0.1,0.2-0.2c0.4-0.1,0.3,0.3,0.4,0.4l0.1,0c-0.1,0.1-0.2,0.3-0.3,0.4 c-0.1,0.1-0.1,0.1-0.2,0C25.4,38.1,25.5,37.8,25.2,37.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st509",
    d: "M25.4,38.3c0.1,0,0.1,0,0.2,0c0,0.1,0,0.3,0,0.4c-0.1,0.1-0.1,0.1-0.2,0c-0.1,0-0.1,0-0.2,0 C25.3,38.6,25.4,38.5,25.4,38.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st796",
    d: "M25.4,38.8c0.1,0,0.1,0,0.2,0c0,0.2,0,0.4,0,0.7c-0.1,0.1-0.1,0.1-0.2,0C25.4,39.2,25.4,39,25.4,38.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st797",
    d: "M25.4,39.4c0.1,0,0.1,0,0.2,0l0.1,0c0,0.1,0.1,0.1,0,0.1c0,0,0,0.1-0.1,0.1c-0.1,0.1-0.1,0.2-0.2,0.2 C25.4,39.7,25.4,39.5,25.4,39.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st798",
    d: "M25.7,39.6c0-0.1,0-0.1,0-0.2c0.1,0,0.1,0,0.2,0c0,0.1,0,0.1,0,0.2C25.8,39.6,25.8,39.6,25.7,39.6L25.7,39.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st799",
    d: "M18.3,15.3c0-0.1,0-0.3,0-0.4c0.2,0.1,0.2,0.3,0.2,0.4c0,0.1,0,0.1,0,0.2l0,0c-0.1,0.1-0.1,0.1-0.2,0 C18.3,15.4,18.3,15.4,18.3,15.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st800",
    d: "M18.3,15.5c0.1,0,0.1,0,0.2,0C18.5,15.6,18.4,15.7,18.3,15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st262",
    d: "M39.9,52.1c-0.1,0-0.2-0.1-0.2-0.2c0.1,0,0.1,0,0.2,0C39.9,52,39.9,52,39.9,52.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st801",
    d: "M19,21.3c-0.2,0-0.4,0-0.5-0.2c0.1-0.1,0.2-0.1,0.4-0.2C18.9,21,19,21.2,19,21.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st755",
    d: "M18.9,20.7c-0.1-0.1-0.1-0.2-0.2-0.3C18.9,20.5,18.9,20.6,18.9,20.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st755",
    d: "M18.8,20c-0.2-0.1-0.2-0.1,0-0.2C18.8,19.9,18.8,19.9,18.8,20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st755",
    d: "M18.8,20.4c-0.2-0.1-0.2-0.1,0-0.2C18.8,20.3,18.8,20.4,18.8,20.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st736",
    d: "M21.4,29.7c0-0.1,0-0.1,0-0.2c-0.1-0.1-0.1-0.3-0.2-0.4c0-0.1,0-0.3,0-0.4c0-0.1-0.1-0.1-0.2-0.2 c0,0,0-0.1-0.1-0.1c0-0.2,0-0.4,0-0.6c0-0.2,0-0.4-0.2-0.5c0-0.2,0-0.4-0.1-0.7c0-0.1,0-0.1,0-0.2c0.1,0,0.1,0,0.2,0 c0,0.1,0.1,0.1,0.1,0.2c0,0.1,0.1,0.1,0.1,0.2c0,0.1,0.1,0.1,0.1,0.2c0,0.1,0.1,0.1,0.1,0.2c0.1,0.1,0.1,0.2,0.2,0.3 c0,0.1,0.1,0.1,0.1,0.2c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0.1,0.1,0.1,0.2c0.1,0,0.1,0.1,0.1,0.2 c0,0.1,0.1,0.1,0.1,0.2c0,0.2,0.1,0.3,0.2,0.5c0,0.1,0,0.2,0.1,0.3c0,0.1,0,0.2,0,0.3c0,0.2-0.1,0.5-0.4,0.6 c-0.2,0-0.3-0.1-0.3-0.2C21.4,30.2,21.5,29.9,21.4,29.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st802",
    d: "M20.9,26.9c0-0.1,0-0.1,0-0.2c0.1,0,0.3,0,0.4,0c0,0.1,0,0.3,0,0.4c-0.1,0.1-0.1,0.1-0.2,0l-0.1,0 C21.1,27,21,27,20.9,26.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st803",
    d: "M22,29.5c-0.2-0.1-0.2-0.3-0.2-0.4c0.1-0.2,0-0.4,0.1-0.6c0-0.2,0.2-0.3,0.3-0.4c0.1-0.1,0.1-0.1,0.2-0.2 c0,0.2,0,0.3,0.2,0.4c0.1,0.1,0.2,0.1,0.4,0.1c0.1,0,0.1,0.1,0.2,0.2c0.1,0.3-0.1,0.5-0.3,0.6c-0.1,0.1-0.2,0.2-0.2,0.3 c0,0.1-0.1,0.2-0.1,0.3c0,0.1-0.1,0.1-0.1,0.2c0,0-0.1,0-0.1,0.1c0,0-0.1,0-0.1,0c-0.1,0-0.1-0.1-0.1-0.2 C22.1,29.7,22.1,29.6,22,29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st415",
    d: "M22,28.4c0.2,0.3,0.2,0.5-0.2,0.6c0-0.1-0.1-0.1-0.1-0.2c0-0.1-0.1-0.1-0.1-0.2c0-0.2,0.1-0.3,0-0.5 c-0.1-0.1-0.1-0.1-0.2-0.2c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.2-0.3-0.4-0.2-0.7c0.1,0,0.1,0,0.2,0c0.2,0.3,0.6,0.4,0.6,0.9 C22.1,28.1,22.1,28.3,22,28.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st778",
    d: "M22,28.4c0-0.1,0-0.3,0-0.4c0.1,0,0.1,0,0.2,0C22.2,28.2,22.2,28.3,22,28.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st778",
    d: "M23.1,28.4c-0.2,0-0.3,0-0.4-0.2c0.1,0,0.3,0,0.4,0C23.1,28.2,23.1,28.3,23.1,28.4 C23.1,28.4,23.1,28.4,23.1,28.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st803",
    d: "M23.1,28.4c0-0.1,0-0.1,0-0.2c0-0.1,0.1-0.2,0.2-0.2c0,0.1,0,0.3,0,0.4C23.2,28.5,23.1,28.5,23.1,28.4 L23.1,28.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M10.4,29c0.1,0,0.1,0,0.2,0c0,0.1,0,0.1,0,0.2C10.5,29.2,10.4,29.2,10.4,29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st321",
    d: "M23.3,31.4c0.3,0.1,0.5,0.5,0.9,0.4c0.1,0.1,0.1,0.1,0.1,0.2c-0.1,0.1-0.1,0.2-0.1,0.4 c0.1,0.1,0.1,0.2,0.2,0.4c0,0.1,0.1,0.3,0,0.4c0,0.4-0.2,0.7-0.4,1c-0.1,0.2-0.3,0.4-0.5,0.4c-0.1,0-0.2,0-0.3,0 c-0.1-0.7-0.2-1.4-0.3-2.2c0.1-0.1,0.2-0.2,0.3-0.4C23.2,31.9,23.1,31.7,23.3,31.4C23.2,31.5,23.2,31.5,23.3,31.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st781",
    d: "M21.6,33.1c0.1-0.3,0.3-0.4,0.6-0.4c0.1,0.5,0.7,0.9,0.2,1.5c-0.1,0.1-0.2,0.1-0.3,0.1 c-0.2,0-0.3-0.2-0.4-0.4C21.6,33.7,21.6,33.4,21.6,33.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st274",
    d: "M22,32.1c-0.4,0-0.7,0.4-1.1,0c-0.2-0.3,0-0.6,0-0.9c0.1-0.1,0.1-0.1,0.2-0.2c0,0,0.1,0,0.1,0.1 c0.2,0.1,0.3,0.5,0.6,0.6C22,31.7,22,31.9,22,32.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st804",
    d: "M21.6,30.3c0.1,0.1,0.1,0.2,0.2,0.2c0.1,0,0.1,0.1,0.1,0.1c0,0.1,0,0.1-0.1,0.1c0,0.1,0,0.1-0.1,0.2 c-0.2,0.2-0.4,0.2-0.6,0l0,0c0-0.3-0.1-0.4-0.4-0.4c0.2-0.3,0.4-0.2,0.7-0.2C21.4,30.2,21.5,30.2,21.6,30.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st435",
    d: "M21.8,34c0.1,0.1,0.3,0.1,0.4,0.2c0.1,0.1,0.1,0.1,0.2,0.2c0,0.1,0,0.1,0,0.2c-0.1,0.1-0.1,0.1-0.2,0.2 c-0.1,0.1-0.1,0.1-0.2,0c-0.1-0.2-0.3-0.2-0.4-0.2c0-0.2,0-0.4,0-0.6C21.6,33.9,21.7,33.9,21.8,34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st805",
    d: "M22.6,31.9c-0.4-0.3-0.1-0.7-0.2-1.1c0,0,0.1-0.1,0.1-0.1c0.1,0,0.2-0.1,0.3,0c0.1,0,0.2,0.1,0.2,0.2 c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.3-0.1,0.4C22.9,31.6,22.8,31.8,22.6,31.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st356",
    d: "M21.1,31c0.2,0,0.4,0,0.6,0c0,0.2,0.1,0.4,0.1,0.6C21.4,31.7,21.1,31.5,21.1,31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st806",
    d: "M22.6,31.9c0-0.2,0-0.4,0.2-0.4c0.3,0.2,0.3,0.6,0.4,0.9c-0.1,0.2-0.3,0.2-0.4,0.2 C22.6,32.4,22.7,32.1,22.6,31.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st807",
    d: "M23.7,35.9c0,0.3-0.1,0.5-0.4,0.6c0-0.1-0.1-0.3-0.1-0.4c0-0.1,0-0.3,0.1-0.4c0.1-0.1,0.2-0.1,0.3-0.1 c0,0,0.1,0,0.1,0.1C23.8,35.8,23.8,35.9,23.7,35.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st151",
    d: "M23.3,35.5c0-0.1,0-0.3,0-0.4c0-0.1-0.1-0.1-0.1-0.2c0-0.1,0-0.1,0-0.1c0,0,0.1,0,0.1-0.1c0,0,0.1,0,0.1,0 c0.1,0.1,0.2,0.2,0.3,0.3c0,0.1,0,0.2,0,0.3c0,0.1-0.1,0.2-0.2,0.2C23.5,35.6,23.4,35.7,23.3,35.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st764",
    d: "M21.8,30.8c0-0.1,0-0.2,0-0.2c0.3-0.2,0.2-0.4,0.2-0.7c0.1-0.1,0.1-0.1,0.2,0l0,0c0.1,0.1,0.1,0.1,0.2,0.2 c0,0.1,0,0.2,0,0.3c0,0.1-0.1,0.3-0.2,0.4C22.1,30.8,21.9,30.8,21.8,30.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st684",
    d: "M23.3,34.9c0,0.1,0,0.2-0.1,0.2c-0.2-0.1-0.2-0.3-0.1-0.4c0,0,0.1,0,0.1,0C23.3,34.7,23.3,34.7,23.3,34.9 C23.3,34.8,23.3,34.9,23.3,34.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st808",
    d: "M22.2,30.8c0-0.1,0-0.3,0-0.4c0.3,0,0.3,0.2,0.2,0.4l0,0.1C22.3,30.8,22.3,30.8,22.2,30.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st303",
    d: "M22.6,35.3c-0.2-0.1-0.2-0.2,0-0.4C22.6,35,22.6,35.2,22.6,35.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st684",
    d: "M23.3,35.5c0.1,0,0.3,0,0.4,0c0.1,0.1,0.1,0.2,0,0.2c-0.1,0-0.3,0-0.4,0C23.3,35.7,23.3,35.6,23.3,35.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st737",
    d: "M22.4,34.4c-0.1-0.1-0.1-0.1-0.2-0.2c0.1,0,0.1,0,0.2,0C22.4,34.3,22.4,34.4,22.4,34.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st618",
    d: "M22,34.9c0.1,0,0.1,0,0.2,0c-0.1,0.2-0.3,0.2-0.4,0.2c0-0.1,0-0.1,0-0.2C21.8,34.9,21.9,34.9,22,34.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st809",
    d: "M21.8,35.9c0,0,0.1-0.1,0.1-0.1C21.9,35.9,21.9,35.9,21.8,35.9C21.8,35.9,21.8,35.9,21.8,35.9L21.8,35.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st810",
    d: "M23.4,37.5c0,0.1,0,0.3,0,0.4c-0.1,0-0.1,0-0.2,0C23.3,37.7,23.3,37.6,23.4,37.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st811",
    d: "M23.7,34.2c0.1-0.4,0.4-0.7,0.4-1.1c0.4-0.1,0.4,0.3,0.6,0.4c0.1,0.1,0.2,0.1,0.2,0.2l0,0 c-0.1,0.1-0.1,0.3-0.1,0.4c-0.1,0.3-0.3,0.5-0.5,0.7c-0.3,0.2-0.6,0.2-0.8,0l0,0C23.3,34.6,24,34.6,23.7,34.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M24.8,33.6c-0.3,0.1-0.4-0.3-0.6-0.4c0-0.1,0-0.3,0-0.4c0-0.4,0.2-0.4,0.4-0.2C24.8,32.8,24.8,33.2,24.8,33.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M23.9,32.5c-0.4-0.4-0.1-0.4,0.2-0.5c0.1-0.1,0.1-0.1,0.2-0.2c0.1,0,0.1,0,0.2,0c0,0.1,0,0.3,0,0.4 C24.4,32.4,24.1,32.4,23.9,32.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st337",
    d: "M23.9,32.5c0.1-0.3,0.4-0.2,0.7-0.2c0,0.1,0,0.1,0,0.2c-0.2,0-0.4,0-0.4,0.2C24.1,32.7,24,32.6,23.9,32.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st415",
    d: "M22.8,30.8c-0.1,0-0.1,0-0.2,0c-0.2-0.2-0.1-0.5-0.2-0.7c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.2 c0.3-0.2,0.4-0.7,0.9-0.6c0.1,0,0.2,0.1,0.2,0.2c-0.1,0-0.1,0.1-0.1,0.1c0,0,0,0.1,0.1,0.1c0,0.4-0.8,0.3-0.4,0.9 c-0.1,0.1-0.1,0.1-0.2,0.2C22.9,30.6,22.9,30.7,22.8,30.8C22.9,30.8,22.9,30.8,22.8,30.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st610",
    d: "M23.9,29.7c0.1-0.6,0.5-0.4,0.9-0.4c0,0.1,0,0.3,0,0.4c-0.2,0-0.3,0-0.4,0.2C24.2,29.8,24.1,29.8,23.9,29.7z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st651",
    d: "M22.8,30.8c0-0.1,0-0.1,0-0.2c0.4,0.2,0.8,0.3,0.4,0.9l0,0c-0.4,0.1-0.2-0.3-0.4-0.4 C22.9,30.9,22.8,30.9,22.8,30.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st509",
    d: "M24.4,30.1c0,0.2,0,0.4,0,0.7c-0.2,0-0.4-0.1-0.4-0.3C23.9,30.2,24.1,30.1,24.4,30.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st610",
    d: "M24.4,29.9c0.2,0.1,0.2,0.1,0,0.2C24.4,30.1,24.4,30,24.4,29.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st243",
    d: "M24.4,31.9c-0.1,0.1-0.2,0.1-0.2,0.2c0-0.1,0-0.1,0-0.2C24.2,31.9,24.3,31.9,24.4,31.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st770",
    d: "M27.6,28.9c0.1,0,0.3,0,0.4,0c-0.1,0.2,0.3,0.5,0,0.7c-0.2,0.1-0.3-0.1-0.4-0.3C27.6,29.1,27.6,29,27.6,28.9 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st812",
    d: "M28,28.8c0.1-0.2,0.3-0.2,0.4-0.2c0,0.1,0,0.1,0,0.2C28.3,28.8,28.2,28.8,28,28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st773",
    d: "M25.8,37.9c-0.1-0.1-0.3-0.3-0.4-0.4c0-0.2,0.1-0.5-0.2-0.6c0-0.1,0-0.1,0-0.2c0.1-0.1,0.1-0.2,0.2-0.2 c0.1,0,0.3,0,0.4,0c0.1,0.1,0.1,0.1,0.2,0.2c0,0,0,0.1,0,0.1c0,0.1,0,0.2,0,0.2c0,0.1,0,0.2,0.1,0.3c0,0.1,0,0.1-0.1,0.2 C26,37.6,25.9,37.7,25.8,37.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st274",
    d: "M25.4,36.4c-0.1,0.1-0.1,0.2-0.2,0.2c-0.1-0.1-0.2-0.1-0.2-0.2c-0.2-0.1-0.3-0.2-0.3-0.5 c0.1-0.3,0.1-0.6,0.5-0.6l0,0C25.1,35.7,25.4,36,25.4,36.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st545",
    d: "M25.6,34.9c-0.2,0-0.4,0-0.6,0c-0.3-0.2-0.2-0.5-0.1-0.7c0,0,0.1-0.1,0.1-0.1C25.4,34.2,25.7,34.4,25.6,34.9 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M24.8,34c0.1-0.1,0.1-0.1,0.2-0.2c0,0.1,0,0.1,0,0.2l0,0C24.9,34.1,24.9,34.1,24.8,34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st813",
    d: "M26.5,36.6c-0.1,0-0.1,0-0.2,0c0-0.1,0.1-0.1,0.1-0.2C26.5,36.5,26.5,36.5,26.5,36.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st326",
    d: "M24.8,34c0.1,0,0.1,0,0.2,0c0,0.3,0,0.6,0,0.9c0.1,0.1,0.1,0.3,0.2,0.4c-0.3,0.1-0.1,0.5-0.4,0.6 c-0.2-0.1-0.3-0.4-0.3-0.6c0-0.1,0-0.2,0-0.3c0.2-0.2,0.2-0.3-0.1-0.4C24.5,34.4,24.6,34.2,24.8,34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st814",
    d: "M26.1,37.4c0-0.1,0-0.1,0-0.2C26,37.1,26,37,26,36.8c0-0.1,0-0.2,0.1-0.3l0,0c0.1,0,0.1,0,0.2,0 c0,0.2,0,0.4,0,0.6c0,0.1,0,0.1,0,0.2C26.2,37.5,26.1,37.4,26.1,37.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st815",
    d: "M17.7,20.7c0-0.1,0-0.1,0-0.2c0.2,0,0.3,0,0.4,0.2C18,20.7,17.8,20.9,17.7,20.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st545",
    d: "M20,28.8c0-0.4-0.6-0.6-0.4-1c0.1,0,0.3,0,0.4,0c0.2,0.4,0.5,0.4,0.9,0.6l0.1,0c0,0.1,0,0.2,0,0.2 C20.7,28.9,20.4,29.2,20,28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st764",
    d: "M21.6,30.3L21.6,30.3l-0.2,0c0-0.2,0-0.4,0-0.6C21.6,29.9,21.5,30.1,21.6,30.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st764",
    d: "M21.1,29.1c0.2,0.1,0.2,0.2,0.2,0.4C21.2,29.4,21.1,29.2,21.1,29.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st764",
    d: "M20.9,28.6c0-0.1,0-0.1,0-0.2c0.1,0.1,0.2,0.1,0.1,0.3C21,28.6,21,28.6,20.9,28.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st539",
    d: "M19.4,30.3l-0.1,0l-0.1,0c0.1-0.1,0.1-0.1,0.2-0.2C19.4,30.2,19.4,30.3,19.4,30.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st769",
    d: "M20,29.7C20.1,29.7,20.1,29.8,20,29.7C20.1,29.8,20.1,29.8,20,29.7C20.1,29.8,20.1,29.7,20,29.7L20,29.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st816",
    d: "M23.3,29.1c-0.3,0.2-0.4,0.7-0.9,0.6c0-0.1,0-0.3,0-0.4c0.1-0.1,0.1-0.1,0.2-0.2c0.3-0.1,0.4-0.3,0.4-0.6 c0.1,0,0.1,0,0.2,0c0.1,0.1,0.1,0.1,0.2,0.2C23.8,28.9,23.2,28.8,23.3,29.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st533",
    d: "M23.5,29.5c-0.2-0.1-0.2-0.1,0-0.2C23.5,29.3,23.5,29.4,23.5,29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st433",
    d: "M21.8,34c-0.1,0-0.1,0-0.2,0c-0.3,0-0.4-0.2-0.4-0.4c0-0.1,0-0.1,0-0.2c0.1-0.1,0.3-0.1,0.4-0.2 C22,33.3,22,33.6,21.8,34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st458",
    d: "M23.7,35.7c0-0.1,0-0.2,0-0.2l0,0c0.2-0.1,0.1-0.3,0.2-0.4c0.1,0,0.2-0.1,0.2-0.1c0.1,0,0.2,0.1,0.2,0.1 c0.1,0.1,0.1,0.1,0.1,0.2c0.1,0.1,0.1,0.2,0.2,0.4c0,0.1,0,0.2,0,0.2c-0.1,0.1-0.1,0.2-0.3,0.2c-0.2,0-0.3,0-0.4-0.2 C23.8,35.9,23.8,35.8,23.7,35.7L23.7,35.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st418",
    d: "M24.6,35.9c0-0.1,0-0.1,0-0.2c-0.1-0.1-0.1-0.2-0.1-0.4c0,0,0.1-0.1,0.1-0.1c0.3,0.2,0.2,0.4,0.2,0.7 c0.1,0.1,0.1,0.3,0.2,0.4c-0.1,0.2-0.3,0.2-0.4,0C24.4,36.2,24.4,36.1,24.6,35.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st684",
    d: "M24.6,35.9c0,0.1,0,0.3,0,0.4c-0.1-0.1-0.1-0.1-0.2-0.2C24.4,36.1,24.5,36,24.6,35.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st684",
    d: "M23.7,35.7c0.1,0,0.2,0.1,0.2,0.2c-0.1,0-0.1,0-0.2,0C23.7,35.9,23.7,35.8,23.7,35.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st817",
    d: "M21.5,28c0.3,0.1,0.2,0.4,0.2,0.7c0,0-0.1,0-0.1,0.1c0,0-0.1,0-0.1-0.1c-0.1-0.1-0.1-0.2,0-0.2 c0-0.1,0-0.1,0-0.2C21.5,28.1,21.5,28.1,21.5,28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st764",
    d: "M21.6,28.6c0.1,0,0.1,0,0.2,0c0,0.1,0,0.1,0,0.2c-0.1,0-0.1,0-0.2,0C21.5,28.8,21.5,28.7,21.6,28.6 C21.5,28.6,21.5,28.6,21.6,28.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st818",
    d: "M21.6,28.6c0,0.1,0,0.1,0,0.2c-0.1,0-0.2-0.1-0.2-0.2C21.4,28.6,21.5,28.6,21.6,28.6L21.6,28.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st764",
    d: "M21.6,28.6c-0.1,0-0.1,0-0.2,0c0.1-0.1,0.1-0.2,0.2-0.2C21.5,28.5,21.6,28.6,21.6,28.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st764",
    d: "M21.5,28c0,0.1,0,0.1,0,0.2c-0.1-0.1-0.1-0.2-0.2-0.2C21.4,27.9,21.5,27.9,21.5,28L21.5,28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st445",
    d: "M21.6,28l-0.1,0l-0.1,0c0-0.1,0-0.1,0-0.2C21.5,27.8,21.5,27.9,21.6,28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st764",
    d: "M20.9,26.9c0.1,0.1,0.2,0.1,0.2,0.2C21,27.1,20.9,27,20.9,26.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st819",
    d: "M22,29.5c0.1,0,0.2,0.1,0.2,0.2c-0.1,0.1-0.1,0.1-0.2,0C22,29.6,22,29.6,22,29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st808",
    d: "M22,29.7c0.1,0,0.1,0,0.2,0c0,0.1,0,0.2,0,0.2c-0.1,0-0.1,0-0.2,0C22,29.8,22,29.8,22,29.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st415",
    d: "M22.2,30.1c0-0.1,0-0.1,0-0.2c0.1,0,0.2,0,0.2,0l0,0C22.5,30.1,22.4,30.2,22.2,30.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st820",
    d: "M22.6,29.1c0,0.1-0.1,0.2-0.2,0.2C22.5,29.2,22.6,29.1,22.6,29.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st512",
    d: "M22.9,31c0.1,0.1,0.3,0.3,0.4,0.4c-0.1,0.3,0.4,0.6,0,0.9c-0.4-0.2-0.4-0.5-0.4-0.9 C22.8,31.3,22.9,31.1,22.9,31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M23.7,34.2c0.5,0.4-0.2,0.4-0.2,0.6l-0.1,0l-0.1,0c0-0.1,0-0.1-0.1-0.2C23.4,34.5,23.6,34.4,23.7,34.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st315",
    d: "M23.5,33c0,0.1,0,0.2-0.2,0.2c-0.1,0-0.2-0.2-0.1-0.2c0-0.1,0.1-0.2,0.3-0.2C23.6,32.8,23.6,32.9,23.5,33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st821",
    d: "M22.2,30.1c0.1-0.1,0.1-0.1,0.2-0.2c0.3,0.2,0.2,0.6,0.2,0.8c-0.1,0-0.1,0-0.2,0c0-0.2,0-0.3-0.2-0.4 C22.2,30.3,22.2,30.2,22.2,30.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st364",
    d: "M24.1,35.1c-0.1,0-0.1,0-0.2,0c-0.1,0.1-0.2,0.1-0.2,0c-0.1,0-0.2-0.1-0.2-0.2c0.3,0,0.6-0.1,0.9-0.2 c0.4,0,0.3,0.2,0.2,0.4c-0.1,0.1-0.1,0.1-0.2,0.1C24.3,35.2,24.2,35.2,24.1,35.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st684",
    d: "M23.7,35.1c0.1,0,0.1,0,0.2,0c0,0.2,0,0.3-0.2,0.4C23.7,35.4,23.7,35.2,23.7,35.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st787",
    d: "M26.1,36.8c0,0.1,0,0.3,0,0.4c-0.2-0.1-0.2-0.3-0.2-0.4C25.9,36.7,26,36.7,26.1,36.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st750",
    d: "M26.1,36.8c-0.1,0-0.1,0-0.2,0c0-0.1,0.1-0.2,0.2-0.2C26.1,36.7,26.1,36.7,26.1,36.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st418",
    d: "M24.4,35.1c0.1,0,0.1,0,0.2,0c0,0.1,0,0.1,0,0.2l0,0c-0.1,0.1-0.1,0.1-0.2,0l0,0 C24.3,35.3,24.3,35.2,24.4,35.1C24.3,35.1,24.3,35.1,24.4,35.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st684",
    d: "M24.4,35.3c0.1,0,0.1,0,0.2,0c0,0.1,0,0.3,0,0.4C24.4,35.7,24.4,35.5,24.4,35.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st684",
    d: "M24.4,35.1c0,0.1,0,0.1,0,0.2c-0.1-0.1-0.1-0.1-0.2-0.2C24.2,35.1,24.3,35.1,24.4,35.1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeco2);
export default __webpack_public_path__ + "static/media/deco2.b97004cf0bc5f80f129fa329652d690a.svg";
export { ForwardRef as ReactComponent };